﻿// ------------------------------------------------------------------------------------------------
// -- Class: MapSgs -------------------------------------------------------------------------------
// -- File : map.js -------------------------------------------------------------------------------
// ------------------------------------------------------------------------------------------------

import View from 'ol/View.js';
import Map from 'ol/Map.js';
import Cluster from 'ol/source/Cluster.js';
import AnimatedCluster from '../../../lib/ol-ext-master/src/layer/AnimatedCluster';
import SelectCluster from '../../../lib/ol-ext-master/src/interaction/SelectCluster';
import { defaults as defaultControls, Control, ScaleLine } from 'ol/control.js';
import { defaults as defaultInteractions, Modify, Select, Snap } from 'ol/interaction.js';
import MousePosition from 'ol/control/MousePosition.js';
import Projection from 'ol/proj/Projection';
import { Image as ImageLayer } from 'ol/layer.js';
import Geolocation from 'ol/Geolocation.js';
import Feature from 'ol/Feature.js';
import Circle from 'ol/geom/Circle.js';
import OSM from 'ol/source/OSM';
import ImageWMS from 'ol/source/imageWMS.js';
import Polygon from 'ol/geom/Polygon.js';
import TileGrid from 'ol/tilegrid/TileGrid';
import MultiPolygon from 'ol/geom/MultiPolygon.js';
import { WFS as WFSFormat, GML as GMLFormat, WKT, GeoJSON } from 'ol/format';
import Collection from 'ol/Collection.js';
import Vector from 'ol/layer/Vector.js';
import VectorLayer from 'ol/layer/Vector.js';
import VectorSource from 'ol/source/Vector.js';
import { Circle as CircleStyle, Icon, Fill, Stroke, Style, Text } from 'ol/style.js';
import { Settings } from './Settings.js';
import { format as CoordinateFormat } from 'ol/coordinate.js';
import { inherits } from 'ol/index.js';
import { Identify } from './Identify.js';
import { LayerTree } from './layertree.js';
import { Layerbase } from './layerbase.js';
import { Tooltips } from './tooltips.js';
import { Statistics } from './Statistics.js'
import { Shortcuts } from './Shortcuts.js'
import { Utility } from '../Utility.js';
import { PipeProfile } from '../PipeProfile.js';
import Overlay from 'ol/Overlay.js';
import Point from 'ol/geom/Point.js';
import { transform, fromLonLat } from 'ol/proj';
import { get as getProjection } from 'ol/proj';
import { WaterWaste } from '../waterWaste.js';
import { Upload } from '../upload.js';
import { TerritorialManagement } from './territorialManagement.js';
import { RoadBuilderTool } from './roadBuilderTool.js';
import { RailwayTool } from './railwayTool.js';
import { SearchEntityTool } from './searchEntityTool.js';
import { TrafficSignTool } from './trafficSignTool.js';
import { ManagerTrafficSignTool } from './ManagerTrafficSignTool.js';
import { CitizenReport } from './CitizenReport.js';
import { TechnicianReport } from './TechnicianReport.js';
import { PubTool } from './pubTool.js';
import { GreenAreaTool } from './greenAreaTool.js';
import { CivilProtectionTool } from './civilProtectionTool.js';
import { DepositionPointTool } from './depositionPointTool.js';
import { PatrimonyTool } from './PatrimonyTool.js';
import { UrbanismTool } from './urbanismTool.js';
import { ContractorPoloTool } from './contractorPolo.js';
import { NetworkSimulationTool } from './networkSimulationTool.js';
import { NetworkBudgetTool } from './networkBudgetTool.js';
import { OgcLayerTool } from './ogcLayerTool.js';
import { MapStreetView } from './mapStreetView.js';
import { AvimTool } from './avimTool.js';
import { isNumber } from 'util';
import { search } from './search.js';
import { TemplateManager } from './templateManager.js';
import { searchNetworkTool } from './searchNetworkTool.js';
import { NetworkIndicatorTool } from './networkIndicatorTool';
import { GeometryEditorTool } from './geometryEditorTool.js';
import { SearchLocation } from './searchLocation';
import Draw, {
    createBox,
    createRegularPolygon,
} from 'ol/interaction/Draw';
import { posix } from 'path';

// core version + navigation, pagination modules:
import Swiper from 'swiper';
import { Navigation, Pagination } from 'swiper/modules';

export { MapSgs };

/**
 * Class Map SGS
 * @param {object} mapSettings, An object with the map settings
 */
const MapSgs = function (mapSettings) {
    // Define this
    var myMapSgs = this;

    // -- begin private variable ------------------------------------------------------------------

    // Feature info in focus
    this._featureInfoFocus = null;

    // Define bool for Button Info
    this._buttonInfoClick = true;

    // Zoom search
    this._ZoomSearch = 12;

    // Zoom search
    this._ZoomSearchPoint = 15;

    // Settings of the map
    this._settings = new Settings(mapSettings);

    // Has search place toponymy configuration info
    this._hasSearchPlaceToponymyConfigInfo = (myMapSgs._settings._mapSettings.configuration_info.propertyInfo.filter(c => c.cod_group == 'LAYER_TOPONYMY').length > 0) ? true : false;

    // Layer base for the map
    this._layerbase = new Layerbase(this._settings);

    // Template Manager for the map
    this.templateManager = new TemplateManager();

    // Scale line
    if (mapSettings.operation_visible.Scale)
        this._scaleLineControl = new ScaleLine();

    // Resize left off canvas variable
    this.resizeLeftStartX;
    this.resizeLeftStartWidth;
    this.resizeLeftNode;
    this.resizerLeft;

    // Workspace
    var workspace = "";

    var seccaocadastralToSearch = "";

    var ddccffToSearch = "";

    var seccaocadastralToShowBase = "";

    var ddccffToShowBase = "";

    // For kendo grid
    this._gridPageSize = 20;
    this._templateChooseFieldForExport = '<label class="k-column-list-item">' +
        '<input class="k-checkbox" style="position: relative !important; left: 0px !important; opacity: 1 !important;" type="checkbox" title="[TITLE]" data-field="[FIELD]" checked />' +
        '<span class="k-checkbox-label"> [TITLE]</span>' +
        '</label>';
    this._hiddenColumnsForExport = [];

    // Utility
    this._utility = new Utility();

    // Search place toponymy
    this._searchPlaceToponymyConfigInfo = {};

    // Indicate if exist layer tree
    this._existLayerTree = false;

    // Pipe Profile
    if (mapSettings.operation_visible.WaterWasteProfile)
        this._pipeProfile = new PipeProfile();

    // Water waste
    if (mapSettings.operation_visible.WaterWasteUpstream ||
        mapSettings.operation_visible.WaterWasteDownstream ||
        mapSettings.operation_visible.WaterWasteStatistic ||
        mapSettings.operation_visible.WaterWasteStatisticByDdccff)
        this._waterWaste = new WaterWaste();

    // Statistics
    if (mapSettings.operation_visible.Statistics)
        this._statistics = new Statistics();

    // Shortcuts
    if (mapSettings.operation_visible.Shortcuts)
        this._shortcuts = new Shortcuts();

    // OGC layer tool
    if (mapSettings.operation_visible.OgcLayer)
        this._ogcLayerTool = new OgcLayerTool();

    // Search network tool
    if (mapSettings.operation_visible.SearchNetwork)
        this._searchNetworkTool = new searchNetworkTool(myMapSgs);

    // Search network tool
    if (mapSettings.operation_visible.NetworkIndicatorTool)
        this._networkIndicatorTool = new NetworkIndicatorTool();

    // -- Mouse position control variable --
    this._projectionindex = 0;
    this._projectionArray = [];
    this._boolUpdateStartProjection = false;
    this._mousePositionControl = null;
    this._lastPositionCoordinate = null;

    // -- Statistic real time --
    this._statisticRealTimeAllFeature = null;

    // Scroll variable
    this._mcsBool = false;

    //StartCreationEvent on off
    this.StartCreationEvent = true;

    var highlightCircleColor = 'rgba(255, 255, 0, 1)'; // Default
    if (window["searchHighlightCircleColor"] != null && window["searchHighlightCircleColor"] != "") {
        highlightCircleColor = window["searchHighlightCircleColor"];
    }
    var highlightColor = 'rgba(255, 255, 0, 0.7)'; // Default
    if (window["searchHighlightColor"] != null && window["searchHighlightColor"] != "") {
        highlightColor = window["searchHighlightColor"];
    }
    var highlightFillColor = 'rgba(0, 0, 255, 0.2)'; // Default
    if (window["searchHighlightFillColor"] != null && window["searchHighlightFillColor"] != "") {
        highlightFillColor = window["searchHighlightFillColor"];
    }

    // Default highlight style
    this._defaultHighlighStyles = [
        new Style({
            image: new CircleStyle({
                radius: 7,
                stroke: new Stroke({
                    color: highlightCircleColor,
                    width: 2
                }),
                fill: new Fill({
                    color: highlightFillColor
                })
            }),
            stroke: new Stroke({
                color: highlightColor,
                width: 14
            }),
            fill: new Fill({
                color: highlightFillColor
            })
        }),
        new Style({
            image: new CircleStyle({
                radius: 9,
                stroke: new Stroke({
                    color: 'rgba(255, 255, 255, 0.7)',
                    width: 2
                }),
                fill: new Fill({
                    color: 'rgba(255, 255, 255, 0.1)'
                })
            })
        })
    ];

    // Upload object
    if (mapSettings.operation_visible.Upload)
        this._uploadAttachtment = new Upload(mapSettings.user_info.id_user);

    // Water entity type
    this._codWaterEntityType = "";

    // Feature information for edition
    this._featureInfo = {
        id: null,
        feature: null,
        idLayer: null,
        mode: 'write'
    }

    // Search result checkBox
    this._searchResultCheckbox = null;

    // Feature search layer active
    this._arraySearchLayerFeatureActive = [];

    // Hash that contains all reference 
    this._hashReference = {};

    // Hash columns to fill 
    this._hashColumnsReferences = {};

    // Hash columns to fill 
    this._hashColumnsReferencesToFill = {};

    // Hash that contains reference with geometry information
    this._hashReferenceFeature = {}

    // Hash layer reference info
    this._layerReferences = {};

    // Edit layer details name
    this._layerDetailEditName = "";

    // Edit layer details ID
    this._layerDetailEditID = "";

    // Geo location object
    this._geoLocationObj = null;
    this._geoLocationAccuracyFeature = null;
    this._geoLocationPositionFeature = null;
    this._geoLocationVectorGPS = null;
    this._geoLocationVectorGPSSource = null;

    // Get Quota on click
    this._drawPointQuota = null;

    // Zoom to GPS
    this._zoomGPS = false;

    // Quota Value to fill
    this._quotaValueFill = false;

    // Feature quota data
    this._featureQuotaInPointData;

    // Index column filter advanced search
    this._columnFilterAdvancedSearchIndex = 0;


    // Print component
    this._printComponent = {
        reportData: null,
        exportType: 'enq',
        hasLayerTemplate: true,
        partialPdfUrlPath: "/templates/export/map/",
        initialize: async () => {
            return new Promise((resolve, reject) => {
                // Start loader
                myMapSgs._utility.ShowWait('offcanvas-map-spinner', true);

                try {
                    $.ajax({
                        type: 'GET',
                        url: '/rest/app/Service/GetAllLayersByTemplate?idMap=' + myMapSgs._settings._mapSettings.map_info.id + '&idTemplate=' + $('#id-template-chosen').val(),
                        xhrFields: {
                            withCredentials: true
                        },
                        async: true,
                        dataType: "json",
                        contentType: "application/json;",
                        success: function (data) {
                            let result = false;

                            if (data.error || data.result.status == "ERROR") {
                                toastr["error"]("Erro na execução do print");
                            }
                            else {
                                let exportSize = null;
                                let scale = null;
                                switch (data.result.status) {
                                    case "SUCCESS":

                                        myMapSgs._layersTemplateSelectedDatatable = data.result.listLayerMetadataInfo;

                                        // Set chosen template value
                                        myMapSgs.currentTemplateSize = myMapSgs.TemplateIdSelectedDatatable; // Default template A4 Vertical
                                        // Set the template sizes and validate screen sizes
                                        myMapSgs.templateManager.setSizes();
                                        // Update screen for map export
                                        myMapSgs.templateManager.prepareExport($('.ol-viewport'), myMapSgs.TemplateIdSelectedDatatable);
                                        // Activate visible layers on template
                                        myMapSgs.templateLayers = true;
                                        // Activate Route report mode
                                        myMapSgs.templateRoute = false;
                                        // Mark template for direct download
                                        myMapSgs.templateDownload = true;

                                        const getSendDataLayers = (listLayers) => {
                                            return listLayers.map((layer) => {
                                                return {
                                                    geoserver: '/' + layer.geoserver,
                                                    name: layer.pretty_name,
                                                    typeStyleLegend: layer.type_style_legend,
                                                    styleLegend: (layer.type_style_legend == "BASE64") ? layer.img_style_legend_base64 : "/" + layer.url_style_legend,
                                                    workspace: layer.workspace,
                                                }
                                            });
                                        }

                                        // Set the report details
                                        exportSize = myMapSgs.templateManager.getExportSize(myMapSgs.currentTemplateSize);
                                        scale = myMapSgs._settings.scales[myMapSgs.map.getView().getZoom()]

                                        myMapSgs._printComponent.reportData = {
                                            exportSize: exportSize,
                                            template: myMapSgs.TemplateSelectedDatatable[0],
                                            displayMapWidth: Math.ceil(exportSize.width),
                                            displayMapHeight: Math.ceil(exportSize.height),
                                            center: myMapSgs.map.getView().getCenter(),
                                            srid: mapSettings.map_info.srs_srid.toString(),
                                            resolution: myMapSgs._settings.resolutions[myMapSgs._settings.scales.indexOf(scale) + 1],
                                            layerInfoPoint: getSendDataLayers(myMapSgs._layersTemplateSelectedDatatable.filter(c => c.geom_type == 'point')),
                                            layerInfoLine: getSendDataLayers(myMapSgs._layersTemplateSelectedDatatable.filter(c => c.geom_type == 'line')),
                                            layerInfoPolygon: getSendDataLayers(myMapSgs._layersTemplateSelectedDatatable.filter(c => c.geom_type == 'polygon'))
                                        };

                                        result = true;

                                        // Indicate that the template as default layer defined
                                        myMapSgs._printComponent.hasLayerTemplate = true;
                                        break;
                                    case "SEM_LAYER":
                                        myMapSgs._layersTemplateSelectedDatatable = [];

                                        // Set chosen template value
                                        myMapSgs.currentTemplateSize = myMapSgs.TemplateIdSelectedDatatable; // Default template A4 Vertical
                                        // Set the template sizes and validate screen sizes
                                        myMapSgs.templateManager.setSizes();
                                        // Update screen for map export
                                        myMapSgs.templateManager.prepareExport($('.ol-viewport'), myMapSgs.TemplateIdSelectedDatatable);
                                        // Activate visible layers on template
                                        myMapSgs.templateLayers = true;
                                        // Activate Route report mode
                                        myMapSgs.templateRoute = false;
                                        // Mark template for direct download
                                        myMapSgs.templateDownload = true;

                                        // Set the report details
                                        exportSize = myMapSgs.templateManager.getExportSize(myMapSgs.currentTemplateSize);
                                        scale = myMapSgs._settings.scales[myMapSgs.map.getView().getZoom()]

                                        myMapSgs._printComponent.reportData = {
                                            exportSize: exportSize,
                                            template: myMapSgs.TemplateSelectedDatatable[0],
                                            displayMapWidth: Math.ceil(exportSize.width),
                                            displayMapHeight: Math.ceil(exportSize.height),
                                            center: myMapSgs.map.getView().getCenter(),
                                            srid: mapSettings.map_info.srs_srid.toString(),
                                            resolution: myMapSgs._settings.resolutions[myMapSgs._settings.scales.indexOf(scale) + 1],
                                            layerInfoPoint: [],
                                            layerInfoLine: [],
                                            layerInfoPolygon: []
                                        };

                                        result = true;

                                        // Indicate that the template as no default layer defined
                                        myMapSgs._printComponent.hasLayerTemplate = false;
                                        break;
                                    default:
                                        toastr["error"]("Erro na execução do print");
                                        break;
                                }
                            }
                            // Hide loader
                            myMapSgs._utility.ShowWait('offcanvas-map-spinner', false);

                            resolve(result);
                        },
                        error: function (request, status, error) {
                            // Hide loader
                            myMapSgs._utility.ShowWait('offcanvas-map-spinner', false);
                            reject(error);
                        }
                    });
                } catch (error) {
                    // Hide loader
                    myMapSgs._utility.ShowWait('offcanvas-map-spinner', false);
                    reject(error);
                }
            });
        },
        requestExport: async function (data) {
            // Start loader
            myMapSgs._utility.ShowWait('offcanvas-map-spinner', true);

            // calculate extend for image dimensions
            const mapSize = myMapSgs.map.getSize();

            const deltaW = (mapSize[0] - data.displayMapWidth) / 2;
            const deltaH = (mapSize[1] - data.displayMapHeight) / 2;

            let highlightExtent = myMapSgs.map.getCoordinateFromPixel([deltaW, deltaH]).map((value) => value.toFixed(2));
            highlightExtent = highlightExtent.concat(myMapSgs.map.getCoordinateFromPixel([mapSize[0] - deltaW, mapSize[1] - deltaH]).map((value) => value.toFixed(2)));
            // const highlightExtent = myMapSgs.templateManager.getHighlightExtent($('.ol-viewport'), myMapSgs.map.getView().calculateExtent());

            const GetDataLayersForTemplate = (listLayers) => {
                return listLayers.map((layer) => {
                    return {
                        geoserver: '/' + layer.geoserver,
                        name: layer.pretty_name,
                        typeStyleLegend: (layer.imageBase64 != null) ? "BASE64" : "IMAGE_URL",
                        styleLegend: (layer.imageBase64 != null) ? layer.imageBase64.replace("data:data", "data").replace(" base64,", "base64,") : "/" + layer.legendUrl,
                        workspace: layer.workspace,
                    }
                });
            }

            switch (myMapSgs._printComponent.exportType) {
                case 'enq':
                    // data.scale = myMapSgs._scaleLineControl.valueOf().renderedHTML_;
                    data.scale = myMapSgs._settings.scales[myMapSgs.map.getView().getZoom()];
                    // Get the url image directly from canvas
                    if (!$('#id-modal-Group-template-config-content input[type=checkbox]')[0].checked) {
                        data.mapURL = await myMapSgs._GetMapDataString().catch(() => {
                            myMapSgs._utility.ShowWait('offcanvas-map-spinner', false);
                            toastr["error"]("Erro na exporta\u00E7\u00E3o do mapa");
                            return;
                        });
                        // Get layer visible to add to template
                        var arrayLayerTemplate = [];
                        myMapSgs.map.getLayers().getArray().filter(c => c.getVisible() == true).forEach(layerObj => {
                            // Get layer info
                            var layerInfo = null;
                            if (layerObj.get("gpId")) {
                                var layerInfoObj = myMapSgs._settings._mapSettings.tree_map.dict_layer_info[layerObj.get("gpId")];
                                if (layerInfoObj && layerInfoObj.layer_info)
                                    layerInfo = layerInfoObj.layer_info;
                            }
                            if (layerInfo) {
                                arrayLayerTemplate.push(layerInfo);
                            }
                        });
                        data.layerInfoLine = [];
                        data.layerInfoPoint = [];
                        data.layerInfoPolygon = [];
                        if (arrayLayerTemplate.length > 0) {
                            data.layerInfoLine = GetDataLayersForTemplate(arrayLayerTemplate.filter(c => c.geomType == 'line'));
                            data.layerInfoPoint = GetDataLayersForTemplate(arrayLayerTemplate.filter(c => c.geomType == 'point'));
                            data.layerInfoPolygon = GetDataLayersForTemplate(arrayLayerTemplate.filter(c => c.geomType == 'polygon'));
                        }
                    }
                    else {
                        // generate map service url to get image
                        data.mapImage = myMapSgs._GetMapUrlTemplate(
                            myMapSgs._layersTemplateSelectedDatatable,
                            myMapSgs._settings._mapSettings.map_info.srs_srid,
                            data.scale,
                            myMapSgs.map.getView().getCenter(),
                            myMapSgs.TemplateSelectedDatatable[0].width_img,
                            myMapSgs.TemplateSelectedDatatable[0].height_img
                        );
                    }
                    break;
                case 'scale':
                    data.scale = parseInt($('#id-modal-Group-template-config-scale option:selected').val());
                    // generate map service url to get image
                    data.mapImage = myMapSgs._GetMapUrlTemplate(
                        myMapSgs._layersTemplateSelectedDatatable,
                        myMapSgs._settings._mapSettings.map_info.srs_srid,
                        data.scale,
                        myMapSgs.map.getView().getCenter(),
                        myMapSgs.TemplateSelectedDatatable[0].width_img,
                        myMapSgs.TemplateSelectedDatatable[0].height_img
                    );
                    break;
                default:
                    break;
            }

            // Map Data
            data.host = typeof window["absoluteHost"] != 'undefined' ? window["absoluteHost"] : "";

            const host = data.host;

            var mapInfo = {
                "mapImageDataString": data.mapURL,
                "layerLineList": data.layerInfoLine,
                "layerPointList": data.layerInfoPoint,
                "layerPolygonList": data.layerInfoPolygon,
                "legendTable": data.legendTable,
                "routeTableList": data.routeTableList,
                "routeSummaryTableList": data.routeSummaryTableList,
                "pathTotalLengthList": data.pathTotalLengthList,
                "pathTotalDiscontinuityLengthList": data.pathTotalDiscontinuityLengthList,
                "freguesia": data.freguesia,
                "concelho": data.concelho,
                "mapScale": data.scale,
                "template": data.template.template,
                "top_left_extent_y": highlightExtent[3],
                "top_left_extent_x": highlightExtent[0],
                "bottom_right_extent_y": highlightExtent[1],
                "bottom_right_extent_x": highlightExtent[2],
                "mapImage": data.mapImage
            };

            $.ajax({
                type: 'POST',
                url: '/Maps/ExportPartialMapTemplate',
                xhrFields: {
                    withCredentials: true
                },
                data: JSON.stringify(mapInfo),
                dataType: 'json',
                contentType: "application/json",
                success: function (data) {

                    if (myMapSgs.templateDownload) {
                        var a = document.createElement('a');
                        document.body.appendChild(a);
                        a.download = name;
                        a.href = host + myMapSgs._printComponent.partialPdfUrlPath + data.result.fileName;
                        a.click();
                    } else {
                        window.open(host + myMapSgs._printComponent.partialPdfUrlPath + data.result.fileName);
                    }
                    myMapSgs._utility.ShowWait('offcanvas-map-spinner', false);
                },
                error: function (request, status, error) {
                    myMapSgs._utility.ShowWait('offcanvas-map-spinner', false);
                    toastr["error"]("Erro na exporta\u00E7\u00E3o do mapa");
                }
            });
        },
        triggerExport: function () {

            try {
                const originData = myMapSgs._printComponent.reportData;

                if (myMapSgs.templateRoute) {

                    var descontinuityExists = [false, false, false];
                    var descontinuityStyleList = ["Trajeto_one_Descontinuidade", "Trajeto_two_Descontinuidade", "Trajeto_three_Descontinuidade"];
                    var descontinuityLengthList = [];

                    for (var e = 0; e < myMapSgs.templateExportData.path.length; e++) {
                        var discontinueEdgeList = myMapSgs.templateExportData.path[e].edgeList.filter(ed => ed.entityOrigin == "");
                        if (discontinueEdgeList.length) {
                            descontinuityExists[e] = true;
                            descontinuityLengthList.push(discontinueEdgeList.reduce((a, b) => a + (b['length'] || 0), 0));
                            continue;
                        } else {
                            descontinuityLengthList.push(0);
                        }
                    }

                    originData.pathTotalDiscontinuityLengthList = descontinuityLengthList;

                    // Route Map Legend
                    originData.legendTable = {
                        "rowList": [
                            {
                                "columnList": [
                                    { "type": "image", "imageData": { "type": "IMAGE_URL", "image": window["absoluteHost"] + "/geoserver/10/wms?REQUEST=GetLegendGraphic&VERSION=1.0.0&FORMAT=image/png&WIDTH=24&HEIGHT=24&LAYER=legend:legend_polygon&STYLE=teste_ANACOM:Trajeto_one&legend_options=fontColor:0xffffff;fontSize:1&FORMAT=image/png&TRANSPARENT=TRUE", "placeholder": "trajeto_style" }, "justification": "right", "backgroundColor": "FFFFFF" },
                                    { "type": "text", "value": "Troço 1", "justification": "left", "backgroundColor": "FFFFFF" }
                                ]
                            }
                        ]
                    };

                    if (myMapSgs.templateExportData.path.length > 1) {

                        var legendName = myMapSgs.templateExportData.path.length > 2 ? "Troços 2, 3" : "Troço 2";
                        originData.legendTable.rowList.push(
                            {
                                "columnList": [
                                    { "type": "image", "imageData": { "type": "IMAGE_URL", "image": window["absoluteHost"] + "/geoserver/10/wms?REQUEST=GetLegendGraphic&VERSION=1.0.0&FORMAT=image/png&WIDTH=24&HEIGHT=24&LAYER=legend:legend_polygon&STYLE=teste_ANACOM:Trajeto_two&legend_options=fontColor:0xffffff;fontSize:1&FORMAT=image/png&TRANSPARENT=TRUE", "placeholder": "trajeto_style" }, "justification": "right", "backgroundColor": "FFFFFF" },
                                    { "type": "text", "value": legendName, "justification": "left", "backgroundColor": "FFFFFF" }
                                ]
                            });
                    }

                    var discontinuityAdded = false;
                    for (var d = 0; d < descontinuityExists.length; d++) {

                        if (descontinuityExists[d]) {

                            var legendName = "Descontinuidade Troço 1";
                            var legendValid = true;
                            if (d == 1 || d == 2) {
                                if (descontinuityExists[1] && descontinuityExists[2] && !discontinuityAdded) {
                                    legendName = "Descontinuidade Troços 2, 3";
                                    discontinuityAdded = true;
                                } else if (!discontinuityAdded) {
                                    legendName = "Descontinuidade Troço " + (d + 1);
                                } else {
                                    legendValid = false;
                                }
                            }

                            if (legendValid) {
                                originData.legendTable.rowList.push({
                                    "columnList": [
                                        { "type": "image", "imageData": { "type": "IMAGE_URL", "image": window["absoluteHost"] + "/geoserver/10/wms?REQUEST=GetLegendGraphic&VERSION=1.0.0&FORMAT=image/png&WIDTH=24&HEIGHT=24&LAYER=legend:legend_polygon&STYLE=teste_ANACOM:" + descontinuityStyleList[d] + "&legend_options=fontColor:0xffffff;fontSize:1&FORMAT=image/png&TRANSPARENT=TRUE", "placeholder": "trajeto_style" }, "justification": "right", "backgroundColor": "FFFFFF" },
                                        { "type": "text", "value": legendName, "justification": "left", "backgroundColor": "FFFFFF" }
                                    ]
                                });
                            }
                        }
                    }

                    // Route Detail Report Pages
                    var routeTableHeaderList = [];
                    originData.routeTableList = [];
                    originData.routeSummaryTableList = [];
                    originData.pathTotalLengthList = [];
                    for (var p = 0; p < myMapSgs.templateExportData.path.length; p++) {
                        routeTableHeaderList.push({
                            "rowList": [
                                {
                                    "columnList": [
                                        { "type": "text", "value": "Entidade", "justification": "center", "backgroundColor": "000000" },
                                        { "type": "text", "value": "Distância do Segmento", "justification": "center", "backgroundColor": "000000" },
                                        { "type": "text", "value": "Capacidade Disponível", "justification": "center", "backgroundColor": "000000" },
                                        { "type": "text", "value": "Contato Telefónico", "justification": "center", "backgroundColor": "000000" }
                                    ]
                                }
                            ]
                        });

                        originData.routeTableList.push(JSON.parse(JSON.stringify(routeTableHeaderList[p])));

                        originData.routeSummaryTableList.push(JSON.parse(JSON.stringify(routeTableHeaderList[p])));

                        // Path Table
                        for (var i = 0; i < myMapSgs.templateExportData.path[p].edgeList.length; i++) {

                            var edge = myMapSgs.templateExportData.path[p].edgeList[i];

                            originData.routeTableList[p].rowList.push({
                                "columnList": [
                                    { "type": "text", "value": edge.entityOrigin == "" ? "Descontinuidade" : edge.entityOrigin, "justification": "center", "backgroundColor": "FFFFFF" },
                                    { "type": "text", "value": edge.length, "justification": "center", "backgroundColor": "FFFFFF" },
                                    { "type": "text", "value": edge.occupation == null ? "-" : 100 - edge.occupation, "justification": "center", "backgroundColor": "FFFFFF" },
                                    { "type": "text", "value": edge.phoneOrigin == null || edge.phoneOrigin == "" ? "-" : edge.phoneOrigin, "justification": "center", "backgroundColor": "FFFFFF" }
                                ]
                            });

                        }
                        if (typeof myMapSgs.templateExportData.path[p].pathLength != "undefined")
                            originData.pathTotalLengthList.push(myMapSgs.templateExportData.path[p].pathLength.toString());
                        else
                            originData.pathTotalLengthList.push("");

                        // Entity Summary Table
                        for (var e = 0; e < myMapSgs.templateExportData.path[p].entityLength.length; e++) {

                            // When entity name is empty, it represents discontinuity, do not show
                            if (myMapSgs.templateExportData.path[p].entityLength[e].name != "") {

                                var entityEdges = myMapSgs.templateExportData.path[p].edgeList.filter(ed => ed.entityOrigin == myMapSgs.templateExportData.path[p].entityLength[e].name);
                                var occupationSum = entityEdges.reduce((a, b) => a + (b['occupation'] || 0), 0);
                                var occupationAvg = Math.round(occupationSum / entityEdges.length);

                                originData.routeSummaryTableList[p].rowList.push({
                                    "columnList": [
                                        { "type": "text", "value": myMapSgs.templateExportData.path[p].entityLength[e].name, "justification": "center", "backgroundColor": "FFFFFF" },
                                        { "type": "text", "value": myMapSgs.templateExportData.path[p].entityLength[e].length, "justification": "center", "backgroundColor": "FFFFFF" },
                                        { "type": "text", "value": occupationAvg == null || occupationAvg == 0 ? "-" : (100 - occupationAvg), "justification": "center", "backgroundColor": "FFFFFF" },
                                        { "type": "text", "value": myMapSgs.templateExportData.path[p].entityLength[e].phone == null ? "-" : myMapSgs.templateExportData.path[p].entityLength[e].phone, "justification": "center", "backgroundColor": "FFFFFF" }
                                    ]
                                });
                            }
                        }
                    }

                    // Call geoserver to get the region feature
                    var getFeature = $.ajax({
                        method: "GET",
                        async: true,
                        url: "/geoserver/10/wfs",
                        data: {
                            "service": 'wfs',
                            "version": '2.0.0',
                            "request": 'GetFeature',
                            "typeNames": 'teste_ANACOM:CAOP_FREGUESIA_total',
                            "cql_filter": "INTERSECTS(the_geom,POINT(" + myMapSgs.templateStartRegionCoords[1] + " " + myMapSgs.templateStartRegionCoords[0] + "))",
                            "outputFormat": 'application/json'
                        }
                    });

                    // Response from the server
                    getFeature.done(function (data, textStatus, jqXHR) {

                        var getSecondFeature = $.ajax({
                            method: "GET",
                            async: true,
                            url: "/geoserver/10/wfs",
                            data: {
                                "service": 'wfs',
                                "version": '2.0.0',
                                "request": 'GetFeature',
                                "typeNames": 'teste_ANACOM:CAOP_FREGUESIA_total',
                                "cql_filter": "INTERSECTS(the_geom,POINT(" + myMapSgs.templateEndRegionCoords[1] + " " + myMapSgs.templateEndRegionCoords[0] + "))",
                                "outputFormat": 'application/json'
                            }
                        });

                        getSecondFeature.done(function (secondData, textStatus, jqXHR) {

                            originData.freguesia = data.features[0].properties.Freguesia;
                            originData.concelho = data.features[0].properties.Concelho;
                            if (secondData.features[0].properties.Freguesia != originData.freguesia) {
                                originData.freguesia = originData.freguesia + ", " + secondData.features[0].properties.Freguesia;
                            }
                            if (secondData.features[0].properties.Concelho != originData.concelho) {
                                originData.concelho = originData.concelho + ", " + secondData.features[0].properties.Concelho;
                            }

                            myMapSgs._printComponent.requestExport(originData);

                            // Hide loader
                            myMapSgs._utility.ShowWait('offcanvas-map-spinner', false);
                        });
                    });

                } else {
                    myMapSgs._printComponent.requestExport(originData);
                }
            } catch (e) {
                toastr["error"]("Erro na exporta\u00E7\u00E3o do mapa");
            }
        },
        handleSubmit: function () {

            // Reset tooltips
            if (myMapSgs.tooltips) {
                if (!myMapSgs.map.hasListener('singleclick', myMapSgs.tooltips.BuildInfoTooltips))
                    myMapSgs.map.on('singleclick', async (e) => { await myMapSgs.tooltips.BuildInfoTooltips(e); });
            }

            // Hide confirm bottom menu
            $('#menubar-export-bottom-pl').hide();

            // Clear Export Highlight
            myMapSgs.templateManager.toggleHighlight(false);

            // Start loader
            myMapSgs._utility.ShowWait('offcanvas-map-spinner', true);

            // Get chosen template type
            var template = myMapSgs.currentTemplateSize;

            // Update Sizes and Screen Size Validation
            myMapSgs.templateManager.setSizes();

            // Check if screen size is valid for each template size
            var screenSizeValidation = myMapSgs.templateManager.sizeValidation;

            myMapSgs._printComponent.triggerExport();
        },
        handleClose: function () {

            // Clear reportData
            myMapSgs._printComponent.reportData = null;

            // Hide confirm bottom menu
            $('#menubar-export-bottom-pl').toggle('ol-hidden');

            // Clear Export Highlight
            myMapSgs.templateManager.toggleHighlight();

            // Reset tooltips
            if (myMapSgs.tooltips) {
                if (!myMapSgs.map.hasListener('singleclick', myMapSgs.tooltips.BuildInfoTooltips))
                    myMapSgs.map.on('singleclick', async (e) => { await myMapSgs.tooltips.BuildInfoTooltips(e); });
            }
        }
    }

    // Territorial management
    if (mapSettings.operation_visible.LocationPlant ||
        mapSettings.operation_visible.CartographyExtract ||
        mapSettings.operation_visible.LocationPlantPdm ||
        mapSettings.operation_visible.LocationPlantPdmRuido ||
        mapSettings.operation_visible.LocationPlantPdmPp ||
        mapSettings.operation_visible.PDMAnalyze) {
        this._territorialManagement = new TerritorialManagement();
    }

    // Road builder tool
    if (mapSettings.operation_visible.RoadBuilderTool) {
        this._roadBuilderTool = new RoadBuilderTool();
    }

    // Geometry Editor tool
    if (mapSettings.operation_visible.GeometryEditorTool) {
        this._geometryEditorTool = new GeometryEditorTool();
    }

    // Railway tool
    if (mapSettings.operation_visible.RailwayTool) {
        this._railwayTool = new RailwayTool();
    }

    // Search entity tool
    if (mapSettings.operation_visible.SearchEntityAddress) {
        this._searchEntityTool = new SearchEntityTool();
    }

    // TrafficSign tool
    if (mapSettings.operation_visible.TrafficSignTool) {
        this._trafficSignTool = new TrafficSignTool();
    }

    // TrafficSign tool
    if (mapSettings.operation_visible.ManagerTrafficSignTool) {
        this._managerTrafficSignTool = new ManagerTrafficSignTool();
    }

    // Citizen report
    if (mapSettings.operation_visible.CitizenReport) {
        this._citizenReport = new CitizenReport();
    }

    // Technician report
    if (mapSettings.operation_visible.TechnicianReport) {
        this._technicianReport = new TechnicianReport();
    }

    // Pub tool
    if (mapSettings.operation_visible.PubTool) {
        this._pubTool = new PubTool();
    }

    // Green area tool
    if (mapSettings.operation_visible.GreenAreaTool) {
        this._greenAreaTool = new GreenAreaTool();
    }

    // Civil protection tool
    if (mapSettings.operation_visible.CivilProtectionTool) {
        this._civilProtectionTool = new CivilProtectionTool();
    }

    // Deposition point tool
    if (mapSettings.operation_visible.DepositionPointTool || mapSettings.operation_visible.PubTool || mapSettings.operation_visible.UrbanismTool) {
        this._depositionPointTool = new DepositionPointTool();
    }

    // Deposition point tool
    if (mapSettings.operation_visible.PatrimonyTool) {
        this._patrimonyTool = new PatrimonyTool();
    }

    // Urbanism tool
    if (mapSettings.operation_visible.UrbanismTool) {
        this._urbanismTool = new UrbanismTool();
    }

    // Urbanism tool
    if (mapSettings.operation_visible.GoToCodObraCadastro) {
        this._ContractorPoloTool = new ContractorPoloTool();
    }

    // Network simulation tool
    if (mapSettings.operation_visible.NetworkSimulationTool) {
        this._networkSimulationTool = new NetworkSimulationTool();
        this._searchNetworkTool = new searchNetworkTool(myMapSgs);
    }

    // Network Budget tool
    if (mapSettings.operation_visible.NetworkBudgetTool) {
        this._networkBudgetTool = new NetworkBudgetTool();
    }

    // Map street view object
    if (mapSettings.operation_visible.StreetMapView) {
        this._mapStreetView = new MapStreetView();
    }

    // Map avim tool object
    if (mapSettings.operation_visible.AvimTool) {
        this._avimTool = new AvimTool();
    }

    // Feature geometry edit/creation
    this._geomEditCreateNewFeature = [];

    // style buffer
    this._bufferstyle =
        new Style({
            stroke: new Stroke({
                color: 'rgba(255, 255, 255, 1)',
                width: 4
            }),
            fill: new Fill({
                color: 'rgba(255, 255, 255, 0.4)'
            }),
            image: new CircleStyle({
                radius: 5,
                stroke: new Stroke({
                    color: 'rgba(255, 255, 0, 1)',
                    width: 2
                }),
                fill: new Fill({
                    color: 'rgba(255, 255, 0, 0.2)'
                })
            })
        });

    // Layer buffer 
    this._layerBuffer = new VectorLayer({
        source: new VectorSource({
            format: new GeoJSON()
        }),
        style: [
            this._bufferstyle
        ],
        name: 'element_layer_buffer'
    });

    // style buffer (geoserver's Temp_Layer)
    this._tempGeomStyles = [
        new Style({
            stroke: new Stroke({
                color: 'rgba(255, 255, 255, 1)',
                width: 2
            }),
            fill: new Fill({
                color: 'rgba(255, 255, 255, 0.5)'
            }),
            image: new CircleStyle({
                radius: 2,
                stroke: new Stroke({
                    color: 'rgba(255, 255, 0, 1)',
                    width: 1
                }),
                fill: new Fill({
                    color: 'rgba(255, 255, 0, 1)'
                })
            })
        }),
        new Style({
            stroke: new Stroke({
                color: 'rgba(0, 0, 0, 1)',
                width: 1
            }),
            fill: new Fill({
                color: 'rgba(100, 100, 100, 0.2)'
            }),
            image: new CircleStyle({
                radius: 3,
                stroke: new Stroke({
                    color: 'rgba(0, 0, 0, 1)',
                    width: 1
                })
            })
        })
    ];

    // Array of Layer Temp Geom
    this._layersTempGeom = [];

    this._snappingTool = {
        snap: new Snap({ features: new Collection() }), // Snapping tool starts 
        startZoomLevel: 10, // Level from which to start snapping (equal or above)
        /* Adds given features from snapping tool */
        // @param features: Collection of features (ol.Collection of ol.Feature)
        addFeatures: function (features) {
            for (var i = 0; i < features.length; i++)
                myMapSgs._snappingTool.snap.addFeature(features[i]);
        },
        /* Removes given features from snapping tool */
        // @param features: Collection of features (ol.Collection of ol.Feature)
        removeFeatures: function (features) {
            for (var i = 0; i < features.length; i++)
                myMapSgs._snappingTool.snap.removeFeature(features[i]);
        },
        /* Updates the pause status on map (functionality can be active but paused) */
        // @param newPauseStatus - undefined for update according to map zoom; bool to manually set pause
        updatePauseStatus: function (newPauseStatus) {

            // If no pause status given, derive new pause status from zoom level
            // according to start zoom level configured. 
            if (typeof newPauseStatus == "undefined") {
                var curZoom = myMapSgs.map.getView().getZoom(); // Get map current zoom value
                newPauseStatus = curZoom < myMapSgs._snappingTool.startZoomLevel;
            }

            if (newPauseStatus) {
                // Pause the functionality
                myMapSgs._snappingTool._isPaused = true;
                if (myMapSgs._snappingTool._interactionOn)
                    myMapSgs._snappingTool._removeMapInteraction();

            } else if (!newPauseStatus) {
                // Unpause the functionality
                myMapSgs._snappingTool._isPaused = false;
                if (myMapSgs._snappingTool._isActive && !myMapSgs._snappingTool._interactionOn)
                    myMapSgs._snappingTool._addMapInteraction();

            }

        },
        /* Updates the interaction status on map */
        // @param newStatus: boolean. True to activate snapping, false to disable
        update: function (newStatus) {

            // If newStatus not provided, do not perform
            if (typeof newStatus == 'undefined') return;

            // If status to update is true and interaction is not on, activate map
            if (newStatus && !myMapSgs._snappingTool._interactionOn) {

                myMapSgs._snappingTool._isActive = true; // Mark active
                // If tool is not paused, add interaction to map
                if (!myMapSgs._snappingTool._isPaused) {
                    myMapSgs._snappingTool._addMapInteraction();
                }

            } else if (!newStatus && myMapSgs._snappingTool._interactionOn) {

                // If status to update is false and interaction is on 
                myMapSgs._snappingTool._isActive = false; // Mark inactive
                myMapSgs._snappingTool._removeMapInteraction();

            }
        },
        _isActive: false, // Snapping tool starts off inactive
        _isPaused: false,// Snapping tool starts off unpaused
        _interactionOn: false, // Internal variable to store interaction status on ol map
        _addMapInteraction: function () {
            // Add interaction to map and mark as active
            myMapSgs.map.addInteraction(myMapSgs._snappingTool.snap);
            myMapSgs._snappingTool._interactionOn = true; // Mark as ON
        },
        _removeMapInteraction: function () {

            // Get current map interactions
            var interactions = myMapSgs.map.getInteractions().array_;

            // Remove all snapping instances of the tool snap from map interactions
            for (var i = 0; i < interactions.length; i++)
                if (interactions[i] == myMapSgs._snappingTool.snap)
                    myMapSgs.map.removeInteraction(interactions[i]);

            myMapSgs._snappingTool._interactionOn = false; // Mark as OFF
        }
    };

    this._bufferSlide = null;
    // Layer info element information array
    this._layerInfoArray = [];
    this._elementPropertiesInBufferHash = null;

    // types
    this.typeList = [];

    // Localization style pin
    this._styleLocalization = [
        new Style({
            text: new Text({
                text: '\uf276',
                font: 'normal 36px FontAwesome',
                textBaseline: 'bottom',
                fill: new Fill({
                    color: 'red',
                }),
                stroke: new Stroke({
                    color: 'white',
                    width: 2
                })
            })
        })
    ];

    // -- end private variable --------------------------------------------------------------------

    // -- begin public variable -------------------------------------------------------------------

    // Creation Map
    this.map = null;

    // Identifier active
    this.identifierActive = false;

    // Layer base for the map
    this.layerTree = new LayerTree(this._settings);

    // Tooltips
    if (mapSettings.operation_visible.Tooltips)
        this.tooltips = new Tooltips('tooltips-popup', 'map');

    // Search location
    if (mapSettings.operation_visible.SearchLocationApiGoogle)
        this.searchLocation = new SearchLocation();

    //Identifier of the map
    this.identify = new Identify();

    // Highligh feature collection
    this.featureToHighLight = new Collection();

    // Highlight vector layer
    this.layerHighlightOverlay = new VectorLayer({
        source: new VectorSource({ features: this.featureToHighLight, useSpatialIndex: true }),
        id: 'HighlightFeatures'
    });

    // Selected feature
    this.selectedFeature = null;

    // Datatable search result
    this.datatableSearchResult = null;

    // Datatable search result expand
    this.datatableSearchResultExpand = null;

    //Datatable history filter anacom
    this._datatablehistoryanacom = null;

    //Datatable Groups Template
    this._datatablegrouptemplate = null;

    //Datatable search result anacom
    this._datatablesearchresult = null;

    this._historyListAnacom = {};

    // Measure tooltip
    this.measureTooltipElement = null;
    this.measureTooltip = null;

    // Distrito info
    this.hashDistritoInfo = {};

    // Concelho info
    this.hashConcelhoInfo = {};

    // Freguesia info
    this.hashFreguesiaInfo = {};

    // Group Templates info
    this.hashGroupTemplates = {};

    // Templates info
    this.TemplateSelectedDatatable = null;

    // Templates info
    this._layersTemplateSelectedDatatable = null;

    // Img template Url
    this._imageTemplateUrl = null;

    // Templates ID
    this.TemplateIdSelectedDatatable = null;

    // All layers active
    this.__checkBoxActive = null;

    // All layers to disable
    this.__checkBoxToDisable = [];

    // feature nº predio
    this._featureNPredio = null;

    // feature nº seccao
    this._featureSeccao = null;

    this._saveNameFeature = null

    this.VectorPointCota = null

    // -- end public variable ---------------------------------------------------------------------

    // -- begin public method ---------------------------------------------------------------------

    /**
     * Init map
     * @param {object} opts, options
     */
    this.Init = function (opts) {

        workspace = this._settings.searchToponymy.workspaceSearchToponymy;

        var _opts = opts || {};

        // ScrollBar for Canvas
        if (!_opts.disableCustomScrollBar) {
            $(".gp-overflow").mCustomScrollbar({
                axis: "y",
                scrollInertia: 300,
                theme: "rounded-dark",
                scrollButtons: true,
                callbacks: {
                    onOverflowY: function () {
                        $(".form-group").css({ "width": "90% !important" });
                        //change the number mCSB_* if canvas search its deconfigured
                        $("#mCSB_2_scrollbar_vertical").insertAfter(".canvas-search-Overflow");
                        $("#mCSB_2").addClass("gp-overflow-width");
                        $("#mCSB_2_scrollbar_vertical").prependTo(".canvas-search-Overflow");
                    }
                }
            });

            // ScrollBar for Icons Menu 
            $(".footer-buttons").insertAfter(".menubar-scroll-panel");

            $(".menubar-scroll-panel").mCustomScrollbar({
                axis: "y",
                scrollInertia: 300,
                theme: "light",
                scrollButtons: {
                    enable: true
                },

                callbacks: {
                    onOverflowY: function () {
                        $(".header-buttons").prependTo("#menubar");
                        $(".mCSB_buttonUp").prependTo(".header-buttons");
                        $(".mCSB_buttonDown").prependTo(".footer-buttons");
                        if (!this._mcsBool) {
                            $(".mCSB_buttonUp").append("<i class='gpi gpi-scroll-down'> </i>");
                            $(".mCSB_buttonDown").append("<i class='gpi gpi-scroll-up'> </i>");
                            this._mcsBool = true;
                        }
                        $(".mCSB_buttonUp").css({ "visibility": "hidden" });
                        $(".content").css({ "margin-left": "0px", "overflow": "hidden" });
                        $(".mCSB_buttonDown").css({ "visibility": "visible" });
                        $(".menubar-scroll-panel").css({ "min-height": "96%" });
                    },
                    whileScrolling: function () {
                        if (this.mcs.topPct > 5)
                            $(".mCSB_buttonUp").css({ "visibility": "visible" });
                        else if (this.mcs.topPct <= 5)
                            $(".mCSB_buttonUp").css({ "visibility": "hidden" });
                        if (this.mcs.topPct >= 95)
                            $(".mCSB_buttonDown").css({ "visibility": "hidden" });
                        else if (this.mcs.topPct < 95)
                            $(".mCSB_buttonDown").css({ "visibility": "visible" });

                    },
                    onOverflowYNone: function () {
                        $(".mCSB_buttonUp").css({ "visibility": "hidden" });
                        $(".mCSB_buttonDown").css({ "visibility": "hidden" });
                        $(".menubar-scroll-panel").css({ "min-height": "96%" });

                    }
                }
            });
        }

        // Function to adapte canvas Search 
        this.ResizeCanvas = function () {
            // Start Pin MapOccurrence
            var canvasOpen = 'none';

            $('.canvasShow').each(function () {
                if ($(this).hasClass('active')) {
                    canvasOpen = this.id;
                }
            });
            // End Pin MapOccurrence

            if ($('#map-search').hasClass('active')) {
                var sizeWindow = $(window).height() - 220;
                $('.canvas-search-Overflow').css({ 'height': sizeWindow });
                if ($('.canvas-search-Overflow').height() > '750') {
                    $('.canvas-search-Overflow').css({ 'height': '750' });
                }

                if ($(window).width() < '450') {
                    $('#map-search').css({ 'top': '0' });
                    $('#map-search').css({ 'transform': 'translate(320px, 0px)' });
                    $('#map-search').css({ 'width': $(window).width() + 'px' });
                    $('#map-search').css({ 'z-index': '1034' });
                    $('.responsive-map-search').css({ 'line-height': '30px' });
                }

                if ($(window).width() > '450') {
                    $('#map-search').removeAttr('style');
                    $('.responsive-map-search').css({ 'line-height': '54px' });
                }

                if ($('.map-search-class-resize').length == 1) {

                    $('.map-search-class-resize').css({ 'display': 'contents' });

                }

            }
        };

        // Get airc reference
        if (mapSettings.operation_visible.SearchAircSpo) {
            myMapSgs._GetAircReferences();
        }

        // Close canvas search on click
        $('.gseatch-dsmiss-button').on('click', function () {
            myMapSgs._utility.ShowOpenCanvas3('map-search', false);
        });

        // Event on click to adapte canvas Search
        $('#button-open-search').on('click', function () {
            myMapSgs._utility.ShowOpenCanvas3('map-search', true);
            myMapSgs.ResizeCanvas();

            // Set reference
            myMapSgs._GetAllReference();
        });

        // Function to adapte canvas Search every time the size off the screen changes
        $(window).resize(function () {
            myMapSgs.ResizeCanvas();
        });

        // Add draggable to modal
        $("#modal-team-occurrence").draggable({});
        $("#modal-shortcut-content").draggable({});

        var layerType = "";;
        let visibleOperations = myMapSgs._settings.getVisibleOperations();
        if (visibleOperations.Water) {
            if (visibleOperations.Water.WaterSupply && visibleOperations.Water.WaterWaste) layerType = 'Water';
            else if (visibleOperations.Water.WaterSupply) layerType = 'WaterSupply';
            else if (visibleOperations.Water.WaterWaste) layerType = 'WaterWaste';

            if (layerType !== "")
                myMapSgs._GetAllLayerReferences(layerType);
        }

        if (_clientGeoportal.indexOf("PONTA_DELGADA") >= 0)
            myMapSgs._GetLayerRefInfo("GUTIPOPROCESSO", "typeList");

        //-----------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------
        //ANACOM ----------------------------------------------------------------------------------------------------------------------------------------------------------------------------------
        //-----------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------


        var CheckBoxActiveAnacom;

        //Layer Cluster Anacom
        var clusterLayer;

        var selectCluster;



        $("#checkAllEntityAnacom").click(function () {
            $(".checkboxentityAnacom").prop('checked', $(this).prop('checked'));
            $("#id-entity-search .anacom-search-verify").trigger('change');
        });

        $("#checkAllobjectAnacom").click(function () {
            $(".checkboxgroupAnacom").prop('checked', $(this).prop('checked'));
            $("#id-object-search .anacom-search-verify").trigger('change');
        });

        $("#checkAllEntityTypeAnacom").click(function () {
            $(".checkboxentitytypeAnacom").prop('checked', $(this).prop('checked'));
            $("#id-entity-type-search .anacom-search-verify").trigger('change');
        });

        $("#id-form-search-anacom").on('submit', function (e) {
            e.preventDefault();
        });

        $('#id-datatable-entity-anacom').DataTable({
            "destroy": true,
            "language": {
                "search": "Procurar",
                "emptyTable": 'Nenhum estilo encontrado',
                "paginate": {
                    "previous": '<i class="fa fa-caret-left"></i>',
                    "next": '<i class="fa fa-caret-right"></i>',
                    "first": '<i class="fa fa-step-backward"></i>',
                    "last": '<i class="fa fa-step-forward"></i>'
                }
            },
            "fixedHeader": false,
            "filter": true,
            "info": false,
            "scrollCollapse": false,
            "deferRender": false,
            "scroller": false,
            "ordering": false,
            "select": false,
            "bPaginate": false,
            "name": "LayerSource_style",
            "rowId": 'id',
            "searchable": true,
            "lengthChange": false
        });

        $('#id-datatable-object-anacom').DataTable({
            "destroy": true,
            "language": {
                "search": "Procurar",
                "emptyTable": 'Nenhum estilo encontrado',
                "paginate": {
                    "previous": '<i class="fa fa-caret-left"></i>',
                    "next": '<i class="fa fa-caret-right"></i>',
                    "first": '<i class="fa fa-step-backward"></i>',
                    "last": '<i class="fa fa-step-forward"></i>'
                }
            },
            "fixedHeader": false,
            "filter": true,
            "info": false,
            "scrollCollapse": false,
            "deferRender": false,
            "scroller": false,
            "ordering": false,
            "select": false,
            "bPaginate": false,
            "name": "LayerSource_style",
            "rowId": 'id',
            "searchable": true,
            "lengthChange": false
        });

        $('#id-datatable-entity-type-anacom').DataTable({
            "destroy": true,
            "language": {
                "search": "Procurar",
                "emptyTable": 'Nenhum estilo encontrado',
                "paginate": {
                    "previous": '<i class="fa fa-caret-left"></i>',
                    "next": '<i class="fa fa-caret-right"></i>',
                    "first": '<i class="fa fa-step-backward"></i>',
                    "last": '<i class="fa fa-step-forward"></i>'
                }
            },
            "fixedHeader": false,
            "filter": true,
            "info": false,
            "scrollCollapse": false,
            "deferRender": false,
            "scroller": false,
            "ordering": false,
            "select": false,
            "bPaginate": false,
            "name": "LayerSource_style",
            "rowId": 'id',
            "searchable": true,
            "lengthChange": false
        });

        $('#id-datatable-calculate-route').DataTable({
            "destroy": true,
            "language": {
                "search": "Procurar",
                "emptyTable": 'Nenhum estilo encontrado',
                "paginate": {
                    "previous": '<i class="fa fa-caret-left"></i>',
                    "next": '<i class="fa fa-caret-right"></i>',
                    "first": '<i class="fa fa-step-backward"></i>',
                    "last": '<i class="fa fa-step-forward"></i>'
                }
            },
            "fixedHeader": false,
            "filter": false,
            "info": false,
            "scrollCollapse": false,
            "deferRender": false,
            "scroller": false,
            "ordering": false,
            "select": false,
            "bPaginate": false,
            "name": "LayerSource_style",
            "rowId": 'id',
            "searchable": true,
            "lengthChange": false
        });

        $('#id-datatable-result-Descriptive-statistics-anacom').DataTable({
            "destroy": true,
            "language": {
                "search": "Procurar",
                "emptyTable": 'Nenhum estilo encontrado',
                "paginate": {
                    "previous": '<i class="fa fa-caret-left"></i>',
                    "next": '<i class="fa fa-caret-right"></i>',
                    "first": '<i class="fa fa-step-backward"></i>',
                    "last": '<i class="fa fa-step-forward"></i>'
                }
            },
            "fixedHeader": false,
            "filter": false,
            "info": false,
            "scrollCollapse": false,
            "deferRender": false,
            "scroller": false,
            "ordering": false,
            "select": false,
            "bPaginate": false,
            "name": "LayerSource_style",
            "rowId": 'id',
            "searchable": true,
            "lengthChange": false
        });

        $('#id-datatable-result-Frequencies-anacom').DataTable({
            "destroy": true,
            "language": {
                "search": "Procurar",
                "emptyTable": 'Nenhum estilo encontrado',
                "paginate": {
                    "previous": '<i class="fa fa-caret-left"></i>',
                    "next": '<i class="fa fa-caret-right"></i>',
                    "first": '<i class="fa fa-step-backward"></i>',
                    "last": '<i class="fa fa-step-forward"></i>'
                }
            },
            "fixedHeader": false,
            "filter": false,
            "info": false,
            "scrollCollapse": false,
            "deferRender": false,
            "scroller": false,
            "ordering": false,
            "select": false,
            "bPaginate": true,
            "name": "LayerSource_style",
            "rowId": 'id',
            "searchable": true,
            "lengthChange": false,
            //"scrollY": "300px",
            "iDisplayLength": 7
        });

        $('#id-datatable-technical-documentation-anacom').DataTable({
            "destroy": true,
            "language": {
                "search": "Procurar",
                "emptyTable": 'Nenhum estilo encontrado',
                "paginate": {
                    "previous": '<i class="fa fa-caret-left"></i>',
                    "next": '<i class="fa fa-caret-right"></i>',
                    "first": '<i class="fa fa-step-backward"></i>',
                    "last": '<i class="fa fa-step-forward"></i>'
                }
            },
            "fixedHeader": false,
            "filter": true,
            "info": false,
            "scrollCollapse": true,
            "deferRender": false,
            "scroller": false,
            "ordering": false,
            "select": false,
            "bPaginate": true,
            "name": "LayerSource_style",
            "rowId": 'id',
            "searchable": true,
            "lengthChange": false,
            "scrollX": true,
            "scrollY": "300px",
            "autoWidth": true,
            "iDisplayLength": 7
        });

        // -- init column def --
        var columnDefArrayAnacomHistory = [];

        columnDefArrayAnacomHistory.push({
            'data': 'id',
            'type': 'readonly',
            'visible': false
        });

        // Description
        columnDefArrayAnacomHistory.push({
            'id': 'description_detail_history',
            'data': 'description',
            'type': 'readonly',
        });

        // button
        columnDefArrayAnacomHistory.push({
            'name': 'button_config_element',
            'className': 'dt-body-center dt-font',
            'data': null,
            'orderable': false,
            'defaultContent': '<a class="button-config-element open-history-anacom on-button"><i class="gpi gpi-pan" style="color: #ff3d00"></i></a>'
        });

        myMapSgs._datatablehistoryanacom = $('#id-datatable-historico-anacom').DataTable({
            "destroy": true,
            "language": {
                "search": "Procurar",
                "emptyTable": 'Nenhum estilo encontrado',
                "paginate": {
                    "previous": '<i class="fa fa-caret-left"></i>',
                    "next": '<i class="fa fa-caret-right"></i>',
                    "first": '<i class="fa fa-step-backward"></i>',
                    "last": '<i class="fa fa-step-forward"></i>'
                }
            },
            "fixedHeader": false,
            "filter": true,
            "info": false,
            "scrollCollapse": true,
            "deferRender": false,
            "scroller": false,
            "ordering": false,
            "columns": columnDefArrayAnacomHistory,
            "select": false,
            "bPaginate": true,
            "name": "LayerSource_style",
            "rowId": 'id',
            "searchable": true,
            "lengthChange": false,
            "scrollX": true,
            "scrollY": "300px",
            "autoWidth": true,
            "iDisplayLength": 10
        });


        // -- init column def --
        var columnDefArrayAnacomResultSearch = [];

        // button
        columnDefArrayAnacomResultSearch.push({
            'id': 'id',
            'data': 'id',
            'className': 'dt-body-center dt-font',
            'orderable': false,
            'defaultContent': '<a class="goto-anacom-search gpi gpi-ir-para"></a>',
            'visible': false
        });

        // button
        columnDefArrayAnacomResultSearch.push({
            'className': 'dt-body-center dt-font',
            'data': null,
            'orderable': false,
            'defaultContent': '<a class="goto-anacom-search gpi gpi-ir-para"></a>',
            'width': '20px'
        });

        // button
        columnDefArrayAnacomResultSearch.push({
            'className': 'dt-body-center dt-font',
            'data': null,
            'orderable': false,
            'defaultContent': '<a class="object-anacom-search gpi gpi-editar-objeto-cadastro"></a>',
            'width': '20px'
        });

        // button
        columnDefArrayAnacomResultSearch.push({
            'className': 'dt-body-center dt-font',
            'data': null,
            'orderable': false,
            'defaultContent': '<a class="document-anacom-search gpi gpi-word"></a>',
            'width': '20px'
        });

        // Id Objeto
        columnDefArrayAnacomResultSearch.push({
            'id': 'id_object',
            'data': 'id_object',
            'name': 'Id Objeto',
            'title': 'Id Objeto',
            'type': 'readonly',
            'render': function (data, type, row) {
                if (data) {
                    return data;
                } else {
                    return 'Sem descrição';
                }
            }
        });

        // Detenção
        columnDefArrayAnacomResultSearch.push({
            'id': 'detencao',
            'data': 'detencao',
            'name': 'Detenção',
            'title': 'Detenção',
            'type': 'readonly',
            'render': function (data, type, row) {
                if (data) {
                    return data;
                } else {
                    return 'Sem descrição';
                }
            }
        });

        // Detenção
        columnDefArrayAnacomResultSearch.push({
            'id': 'Distrito',
            'data': 'Distrito',
            'name': 'Distrito',
            'title': 'Distrito',
            'type': 'readonly',
            'render': function (data, type, row) {
                if (data) {
                    return data;
                } else {
                    return 'Sem descrição';
                }
            }
        });

        // Detenção
        columnDefArrayAnacomResultSearch.push({
            'id': 'Concelho',
            'data': 'Concelho',
            'name': 'Concelho',
            'title': 'Concelho',
            'type': 'readonly',
            'render': function (data, type, row) {
                if (data) {
                    return data;
                } else {
                    return 'Sem descrição';
                }
            }
        });

        // Detenção
        columnDefArrayAnacomResultSearch.push({
            'id': 'Freguesia',
            'data': 'Freguesia',
            'name': 'Freguesia',
            'title': 'Freguesia',
            'type': 'readonly',
            'render': function (data, type, row) {
                if (data) {
                    return data;
                } else {
                    return 'Sem descrição';
                }
            }
        });

        // Detenção
        columnDefArrayAnacomResultSearch.push({
            'id': 'Traçado',
            'data': 'Traçado',
            'name': 'Traçado',
            'title': 'Traçado',
            'type': 'readonly',
            'render': function (data, type, row) {
                if (data) {
                    return data;
                } else {
                    return 'Sem descrição';
                }
            }
        });

        // Detenção
        columnDefArrayAnacomResultSearch.push({
            'id': 'Afetacao_principal',
            'data': 'Afetacao_principal',
            'name': 'Afetação principal',
            'title': 'Afetação principal',
            'type': 'readonly',
            'render': function (data, type, row) {
                if (data) {
                    return data;
                } else {
                    return 'Sem descrição';
                }
            }
        });

        // Detenção
        columnDefArrayAnacomResultSearch.push({
            'id': 'Diametro',
            'data': 'Diametro',
            'name': 'Diâmetro',
            'title': 'Diâmetro',
            'type': 'readonly',
            'render': function (data, type, row) {
                if (data) {
                    return data;
                } else {
                    return 'Sem descrição';
                }
            }
        });

        // Detenção
        columnDefArrayAnacomResultSearch.push({
            'id': 'Comprimento',
            'data': 'Comprimento',
            'name': 'Comprimento',
            'title': 'Comprimento',
            'type': 'readonly',
            'render': function (data, type, row) {
                if (data) {
                    return data;
                } else {
                    return 'Sem descrição';
                }
            }
        });

        // Detenção
        columnDefArrayAnacomResultSearch.push({
            'id': 'Tipo_de_utilizacao',
            'data': 'Tipo_de_utilizacao',
            'name': 'Tipo de utilizacao',
            'title': 'Tipo de utilizacao',
            'type': 'readonly',
            'render': function (data, type, row) {
                if (data) {
                    return data;
                } else {
                    return 'Sem descrição';
                }
            }
        });


        // Detenção
        columnDefArrayAnacomResultSearch.push({
            'id': 'Estado_operacional',
            'data': 'Estado_operacional',
            'name': 'Estado operacional',
            'title': 'Estado operacional',
            'type': 'readonly',
            'render': function (data, type, row) {
                if (data) {
                    return data;
                } else {
                    return 'Sem descrição';
                }
            }
        });

        // Detenção
        columnDefArrayAnacomResultSearch.push({
            'id': 'Estado_ocupacao',
            'data': 'Estado_ocupacao',
            'name': 'Estado ocupação',
            'title': 'Estado ocupação',
            'type': 'readonly',
            'render': function (data, type, row) {
                if (data) {
                    return data;
                } else {
                    return 'Sem descrição';
                }
            }
        });


        myMapSgs._datatablesearchresult = $('#id-datatable-result-anacom').DataTable({
            "destroy": true,
            "language": {
                "search": "Procurar",
                "emptyTable": 'Nenhum estilo encontrado',
                "paginate": {
                    "previous": '<i class="fa fa-caret-left"></i>',
                    "next": '<i class="fa fa-caret-right"></i>',
                    "first": '<i class="fa fa-step-backward"></i>',
                    "last": '<i class="fa fa-step-forward"></i>'
                }
            },
            "fixedHeader": false,
            "filter": true,
            "info": false,
            "scrollCollapse": true,
            "deferRender": false,
            "scroller": false,
            "ordering": false,
            "select": false,
            "bPaginate": true,
            "columns": columnDefArrayAnacomResultSearch,
            "name": "LayerSource_style",
            "rowId": 'id',
            "searchable": true,
            "lengthChange": false,
            "scrollX": true,
            "scrollY": "300px",
            "autoWidth": true,
            "iDisplayLength": 6
        });

        // Event draw table search occurrence
        myMapSgs._datatablehistoryanacom.on('draw', function () {

            $("#id-history-anacom thead").remove();

            $("#id-history-anacom dataTables_scrollHead").remove();

            $(".open-history-anacom").unbind("click");

            //Get List history filter anacom
            $('.open-history-anacom').on('click', function () {

                var id = $(this).parent().parent()[0].id;

                $('#id-form-search-anacom').find("input[type=checkbox]").prop('checked', false);
                $('#id-form-search-anacom').find("input[type=text]").val('')
                $('#cod_department_team').selectpicker('refresh');
                $('#id-form-search-anacom').find("select").val('');
                $('#id-form-search-anacom').find("select").selectpicker('refresh');
                $('#id-anacom-search .active').removeClass('active');
                $('.remove-search-anacom').remove();

                for (i = 0; i < myMapSgs._historyListAnacom.length; i++) {

                    if (myMapSgs._historyListAnacom[i].id === parseInt(id)) {

                        var json = $.parseJSON(myMapSgs._historyListAnacom[i].search_json);

                        $.each(json, function (key, value) {

                            switch (key) {
                                case 'Type_entidade':
                                    if (value)
                                        for (var k = 0; k < value.length; k++)
                                            $('#id-datatable-entity-type-anacom .checkboxOption:contains("' + value[k] + '")').siblings().find('input').prop("checked", true);
                                    break;
                                case 'entidade':
                                    if (value)
                                        for (var l = 0; l < value.length; l++)
                                            $('#id-datatable-entity-anacom .checkboxOption:contains("' + value[l] + '")').siblings().find('input').prop("checked", true);
                                    break;
                                case 'Objetos':
                                    if (value)
                                        for (var r = 0; r < value.length; r++)
                                            $('#id-datatable-object-anacom .checkboxOption:contains("' + value[r] + '")').siblings().find('input').prop("checked", true);
                                    break;
                                case 'Tipo_Utilizacao_elemento':
                                    if (value)
                                        for (var r = 0; r < value.length; r++)
                                            $('#id-anacom-tipo-utilizacao .checkboxOption:contains("' + value[r] + '")').siblings().find('input').prop("checked", true);
                                    break;
                                default:
                                    $('#id-form-search-anacom [name=' + key + ']').val(value);
                                    $('#id-form-search-anacom [name=' + key + ']').selectpicker("refresh");

                            }

                        });

                    }
                }

                $('.anacom-search-verify').trigger('change');

            });
        });

        // -- init column def --
        var columnDefGroupTemplate = [];

        // id
        columnDefGroupTemplate.push({
            'id': 'id',
            'data': 'id',
            'type': 'readonly',
            'visible': false
        });

        // name
        columnDefGroupTemplate.push({
            'id': 'name',
            'data': 'name',
            'type': 'readonly',
            'width': '300px'
        });

        myMapSgs._datatablegrouptemplate = $('#id-datatable-select-group-template').DataTable({
            "destroy": true,
            "language": {
                "search": "Procurar",
                "emptyTable": 'Nenhum template encontrado',
                "paginate": {
                    "previous": '<i class="fa fa-caret-left"></i>',
                    "next": '<i class="fa fa-caret-right"></i>',
                    "first": '<i class="fa fa-step-backward"></i>',
                    "last": '<i class="fa fa-step-forward"></i>'
                }
            },
            "fixedHeader": false,
            "filter": false,
            "info": false,
            "scrollCollapse": true,
            "deferRender": false,
            "scroller": false,
            "ordering": false,
            "columns": columnDefGroupTemplate,
            "bPaginate": true,
            "name": "LayerSource_style",
            "rowId": 'id',
            "searchable": false,
            "lengthChange": false,
            "scrollX": true,
            "scrollY": "300px",
            "autoWidth": true,
            "select": true,
            "iDisplayLength": 5
        });

        $('#id-datatable-entity-anacom_filter').children().addClass('col-sm-12');

        $('#id-datatable-entity-anacom_filter').parent().addClass('col-sm-12');

        $('#id-datatable-entity-anacom_filter').parent().removeClass('col-sm-6');

        $('#id-datatable-object-anacom_filter').children().addClass('col-sm-12');

        $('#id-datatable-object-anacom_filter').parent().addClass('col-sm-12');

        $('#id-datatable-object-anacom_filter').parent().removeClass('col-sm-6');

        $('#id-datatable-entity-type-anacom_filter').children().addClass('col-sm-12');

        $('#id-datatable-entity-type-anacom_filter').parent().addClass('col-sm-12');

        $('#id-datatable-entity-type-anacom_filter').parent().removeClass('col-sm-6');

        $('#id-data-criação-anacom').datepicker({
            format: 'dd/mm/yyyy'
        });

        $('.anacom-search-verify').on('change', function () {

            var title = '';

            var name = '';

            ////  Get all chekbox
            //// $('#'+this.closest('table').id+ ' tbody tr :checked').length

            if ($(this)[0].type == 'checkbox') {

                name = this.closest('tr').outerText;
                title = $('#id-buttons-head-anacom a[href$="' + this.closest('.gp-overflow').id + '"]')[0].title

                if ($(this).hasClass('anacom-tipo-Utilizacao')) {

                    if ($('.remove-search-anacom:contains(' + name + ')').length > 0) {
                        var fieldsAnacom = $('.remove-search-anacom:contains(' + name + ')');
                        for (i = 0; i < fieldsAnacom.length; i++) {
                            if (fieldsAnacom[i].children[1].innerText.split(':')[1].trim() === name.trim())
                                fieldsAnacom[i].remove();

                        }
                    } else {

                        $('#id-search-text-anacom').append('<div id="checkbox" class="remove-search-anacom search-fields-anacom anacom-tipo-utilizacao-remove"> <div class="remove-anacom-filter ol-hidden" style="text-align: center;" > <div style = "font-size: 12px; color:white;"> Remover </div></div > <div class="anacom-filter-hidde" style = "font-size: 12px;">' + title + ':<span style="font-weight: bold;"</span>' + name + '</div></div >');
                        $('#' + this.closest('table').id).removeClass('removing');
                    }

                } else if ($('#' + this.id + ':checked').length > 0)

                    if ($('#' + this.closest('table').id + ' tbody tr').length == $('#' + this.closest('table').id + ' tbody tr :checked').length) {
                        var confirm;
                        for (i = 0; i < $('.select-all-anacom').length; i++) {
                            if ($('.select-all-anacom')[i].children[0].innerText.split(':')[0].trim() == title)
                                confirm = true;
                        }
                        if (!confirm) {
                            $('.remove-search-anacom:contains(' + title + ')').remove();
                            $('#id-search-text-anacom').append('<div id="checkbox" class="remove-search-anacom search-fields-anacom select-all-anacom"> <div class="remove-anacom-filter ol-hidden" style="text-align: center;" > <div style = "font-size: 12px; color:white;"> Remover </div></div > <div class="anacom-filter-hidde" style = "font-size: 12px;">' + title + ': Todas selecionados </div></div >');
                            $('#' + this.closest('table').id).removeClass('removing');
                        }
                    }
                    else {
                        $('#id-search-text-anacom').append('<div id="checkbox" class="remove-search-anacom search-fields-anacom"> <div class="remove-anacom-filter ol-hidden" style="text-align: center;" > <div style = "font-size: 12px; color:white;"> Remover </div></div > <div class="anacom-filter-hidde" style = "font-size: 12px;">' + title + ': <span style="font-weight: bold;"</span>' + name + '</div></div >');
                        if ($($(this).closest('table')[0]).find(':checkbox').length - 1 == $($(this).closest('table')[0]).find(':checked').length && $($(this).closest('table')[0]).find('.check-all-search-anacom').closest('tr').find(':checked').length == 0) {
                            $(this).closest('table').find('.check-all-search-anacom').prop('checked', true);
                            $(this).closest('table').find('td').find('.anacom-search-verify').trigger('change');
                        }
                    }

                else if ($('.remove-search-anacom:contains(' + name + ')').length > 0) {
                    var fieldsAnacom = $('.remove-search-anacom:contains(' + name + ')');
                    for (i = 0; i < fieldsAnacom.length; i++) {
                        if (fieldsAnacom[i].children[1].innerText.split(':')[1].trim() === name.trim())
                            fieldsAnacom[i].remove();

                    }
                }

                else if ($('.remove-search-anacom:contains(Todas selecionados)').length > 0) {
                    var fieldsAnacom = $('.remove-search-anacom:contains(Todas selecionados)');
                    for (i = 0; i < fieldsAnacom.length; i++) {
                        if (fieldsAnacom[i].children[1].innerText.split(':')[0].trim() === title.trim())
                            fieldsAnacom[i].remove();

                    }
                    if (!$('#' + this.closest('table').id).hasClass('removing')) {
                        $('#' + this.closest('table').id).addClass('removing');
                        $('#' + this.closest('table').id + ' .anacom-search-verify').trigger('change');
                    }

                    $(this).closest('table').find('.check-all-search-anacom').prop('checked', false);
                }

            }
            else if ($(this).hasClass('element-anacom-options')) {

                name = $(this)[0].value;
                title = $($(this.parentElement.parentElement)[0]).children()[0].innerHTML;

                if ($(this).closest('.anacom-search-fields-margin').children()[2].value != null)

                    if ($(this).closest('.anacom-search-fields-margin').children()[2].value == "") {

                        $('.remove-search-anacom:contains(' + title + ')').remove();

                    } else {

                        $('.remove-search-anacom:contains(' + title + ')').remove();
                        $('#id-search-text-anacom').append('<div id="number-select" class="remove-search-anacom search-fields-anacom"> <div class="remove-anacom-filter ol-hidden" style="text-align: center;" > <div style = "font-size: 12px; color:white;"> Remover </div></div > <div  class="anacom-filter-hidde" style = "font-size: 12px;">' + title + ': <span style="font-weight: bold;"</span>' + name + ' ' + $(this).closest('.anacom-search-fields-margin').children()[2].value + '</div></div >');

                    }
            }
            else if ($(this).hasClass('element-anacom-number')) {

                name = $(this)[0].value;
                title = this.parentElement.children[0].innerText;

                if (name == "") {

                    $('.remove-search-anacom:contains(' + title + ')').remove();

                } else {

                    $('.remove-search-anacom:contains(' + title + ')').remove();
                    $('#id-search-text-anacom').append('<div id="number-select" class="remove-search-anacom search-fields-anacom"> <div class="remove-anacom-filter ol-hidden" style="text-align: center;" > <div style = "font-size: 12px; color:white;"> Remover </div></div > <div class="anacom-filter-hidde" style = "font-size: 12px;">' + title + ': <span style="font-weight: bold;"</span>' + $(this).parent().find('.element-anacom-options')[1].value + ' ' + name + '</div></div >');
                }

            }
            else if ($(this).hasClass('anacom-search-verify') && !$(this).hasClass('text-search-anacom')) {

                name = $(this)[0].value;
                title = $(this).parent().siblings().html();

                if (name == "") {

                    $('.remove-search-anacom:contains(' + title + ')').remove();

                } else {

                    $('.remove-search-anacom:contains(' + title + ')').remove();
                    $('#id-search-text-anacom').append('<div id="data" class="remove-search-anacom search-fields-anacom"> <div class="remove-anacom-filter ol-hidden" style="text-align: center;" > <div style = "font-size: 12px; color:white;"> Remover </div></div > <div class="anacom-filter-hidde" style = "font-size: 12px;">' + title + ': <span style="font-weight: bold;"</span>' + name + '</div></div >');

                }

            }
            else if (this.children.length > 0) {

                name = $(this)[0].value;
                title = $($(this.parentElement.parentElement)[0]).children()[0].innerHTML;

                if (name == "") {

                    $('.remove-search-anacom:contains(' + title + ')').remove();

                } else {

                    $('.remove-search-anacom:contains(' + title + ')').remove();
                    $('#id-search-text-anacom').append('<div id="select" class="remove-search-anacom search-fields-anacom"> <div class="remove-anacom-filter ol-hidden" style="text-align: center;" > <div style = "font-size: 12px; color:white;"> Remover </div></div > <div class="anacom-filter-hidde" style = "font-size: 12px;">' + title + ': <span style="font-weight: bold;"</span>' + name + '</div></div >');

                }

            }
            else if (this.children.length == 0) {

                name = $(this)[0].value;
                title = $(this).parent()[0].innerText;

                if (name == "") {

                    $('.remove-search-anacom:contains(' + title + ')').remove();

                } else {

                    $('.remove-search-anacom:contains(' + title + ')').remove();
                    $('#id-search-text-anacom').append('<div id="text" class="remove-search-anacom search-fields-anacom"> <div class="remove-anacom-filter ol-hidden" style="text-align: center;" > <div  style="font-size: 12px; color:white;"> Remover </div></div > <div class="anacom-filter-hidde" style = "font-size: 12px;">' + title + ':<span style="font-weight: bold;"</span> ' + name + '</div></div >');

                }
            }

            myMapSgs.connectRemoveButtonToFilter();

        });

        $('#id-button-desmiss-search-anacom').on('click', function () {

            for (i = 0; i < $('#id-form-search-anacom').find('table').length; i++) {
                if ($('#id-form-search-anacom').find('table')[i].id != "")
                    $('#' + $('#id-form-search-anacom').find('table')[i].id).removeClass('removing');
            }

            $('#id-anacom-search .active').removeClass('active');
            $('#id-elemento-caraterizacao-search [type="number"]').val('')
            $('#id-form-search-anacom').find("input[type=checkbox]").prop('checked', false);
            $('#id-form-search-anacom').find("input[type=text]").val('')
            $('#cod_department_team').selectpicker('refresh');
            $('#id-form-search-anacom').find("select").val('');
            $('#id-form-search-anacom').find("select").selectpicker('refresh');

            $('.remove-search-anacom').remove();

        });

        $('#id-anacom-search .tabs-anacom').on('click', function () {
            $('#anacom-search-result').removeClass('active');
        })

        $('#button-close-open-search-anacom').on('click', function () {

            $('#id-anacom-search .active').removeClass('active');

            if ($('#button-close-open-search-anacom').hasClass('gpi-scroll-down')) {
                $('#button-close-open-search-anacom').removeClass('gpi-scroll-down')
                $('#button-close-open-search-anacom').addClass('gpi-scroll-up')
                $('#anacom-search-result').addClass('active')
            } else {
                $('#button-close-open-search-anacom').removeClass('gpi-scroll-up')
                $('#button-close-open-search-anacom').addClass('gpi-scroll-down')
                $('#anacom-search-result').removeClass('active')
            }


        })

        $('#id-button-result-active').on('click', function () {

            $('.hide-datatable-anacom-search').removeClass('ol-hidden');

            myMapSgs._utility.ShowWait('spinner-search-anacom', true);

            var SearchAnacomObject = myMapSgs.getSearchAnacomObject();

            var stringObjet = JSON.stringify(SearchAnacomObject);

            $.ajax({
                type: 'POST',
                url: '/rest/app/Anacom/SearchByObjectAnacom',
                data: stringObjet,
                async: true,
                dataType: 'json',
                contentType: "application/json",
                success: function (data) {

                    if (data.result.length > 0) {

                        var GotoCaop = "";
                        var GotoCaopLayer = "";

                        if ($('#id-anacom-freguesia').val() != "") {
                            GotoCaop = "Freguesia ilike " + "'" + $('#id-anacom-freguesia').val() + "'";
                            GotoCaopLayer = 'CAOP_FREGUESIA_total';
                        }
                        if ($('#id-anacom-concelho').val() != "" && GotoCaop == "") {
                            GotoCaop = "Concelho ilike " + "'" + $('#id-anacom-concelho').val() + "'";
                            GotoCaopLayer = 'CAOP_CONCELHO_total';
                        }
                        if ($('#id-anacom-distrito').val() != "" && GotoCaop == "") {
                            GotoCaop = "Distrito ilike " + "'" + $('#id-anacom-distrito').val() + "'";
                            GotoCaopLayer = 'CAOP_DISTRITO_total';
                        }
                        //myMapSgs.layerTree.FindLayerNameKey("freguesia_cont");

                        var cqlFilter = GotoCaop;

                        myMapSgs.SetFeaturesHighlightByCqlFilter('teste_ANACOM', GotoCaopLayer, '/geoserver/10', true, cqlFilter, null, 'the_geom');

                        //myMapSgs.SetFeaturesHighlightConvertProjection('teste_ANACOM', 'vw_SIGObjetoCadastro', '/geoserver/10', false, cqlObjectAnacom, null, 'geom', '4326', '3763');


                        myMapSgs._datatablesearchresult.clear();

                        // Set history list
                        var countElement = data.result.length;
                        for (let i = 0; i < countElement; i++) {
                            var objEvent = data.result[i];
                            myMapSgs._datatablesearchresult.row.add({
                                id: objEvent.id,
                                id_object: objEvent.idObjeto,
                                detencao: objEvent.nomeEntidade,
                                Distrito: objEvent.distrito,
                                Concelho: objEvent.concelho,
                                Freguesia: objEvent.freguesia,
                                Traçado: objEvent.nomeTipoTracado,
                                Afetacao_principal: objEvent.nomeTipoAfetacaoPrincipal,
                                Diametro: objEvent.diametro,
                                Comprimento: objEvent.comprimento,
                                Tipo_de_utilizacao: objEvent.tipoUtilizacao,
                                Estado_operacional: objEvent.estadoOperacional,
                                Estado_ocupacao: objEvent.estadoOcupacao,
                            });
                        }

                        myMapSgs._datatablesearchresult.draw();

                        myMapSgs._utility.ShowWait('spinner-search-anacom', false);

                        $('#anacom-search-result').addClass('active');

                        $('body').css({ 'height': '100vh' })

                        $($.fn.dataTable.tables(true)).DataTable().columns.adjust();

                    } else {

                        toastr["warning"]("Nenhum objeto encontrado");

                        myMapSgs._utility.ShowWait('spinner-search-anacom', false);

                    }


                },
                error: function (request, status, error) {

                    toastr["error"]("Erro ao pesquisar");

                    myMapSgs._utility.ShowWait('spinner-search-anacom', false);

                }
            });


            $('#id-anacom-search .active').removeClass('active');

            $($.fn.dataTable.tables(true)).DataTable().columns.adjust();



        });

        $('#id-button-save-filter-anacom').on('click', function () {

            $('#id-modal-save-filter-name-anacom').modal('show');

        })

        $('#id-cancel-new-filter-anacom').on('click', function () {

            $('#id-modal-save-filter-name-anacom').modal('hide');

        })


        $('#id-confirm-new-filter-anacom').on('click', function () {

            var searchObject = myMapSgs.getSearchAnacomObject();

            var stringObjet = JSON.stringify(searchObject);

            $.ajax({
                type: 'POST',
                url: '/rest/app/Anacom/SaveSearchAnacom?user_id=' + myMapSgs._settings.userInfo.userId + '&map_id=' + myMapSgs._settings._mapSettings.map_info.id + '&description=' + $('#id-input-filter-name-anacom').val(),
                data: stringObjet,
                async: true,
                dataType: "json",
                contentType: "application/json;",
                success: function (data) {
                    if (data.error) {
                        toastr["error"]("Erro na realização da pesquisa");
                    }
                    else {

                        myMapSgs._datatablehistoryanacom.clear();

                        myMapSgs._historyListAnacom = data.result;

                        // Set history list
                        var countElement = data.result.length;
                        for (let i = 0; i < countElement; i++) {
                            var objEvent = data.result[i];
                            objEvent.date_state = myMapSgs._utility.TransformDateServerInDateII(objEvent.date_state);
                            myMapSgs._datatablehistoryanacom.row.add({
                                id: objEvent.id,
                                description: objEvent.description
                            });
                        }
                        myMapSgs._datatablehistoryanacom.draw();

                    }
                },
                error: function (request, status, error) {
                }
            });

            $('#id-modal-save-filter-name-anacom').modal('hide');

        })


        $('#id-button-open-chart-anacom').on('click', function () {

            if ($('#id-button-open-chart-anacom').hasClass('gpi-grafico-barras')) {

                var myChart = new Chart(document.getElementById("myChartAnacom").getContext('2d'));

                var ctx = document.getElementById('myChartAnacom').getContext('2d');

                var myChart = new Chart(ctx, {
                    type: 'bar',
                    data: {
                        labels: ['Em projeto', 'Objeto em desinstalação', 'Objeto instalado'],
                        datasets: [{
                            data: [57, 19, 212],
                            backgroundColor: [
                                'rgba(255, 99, 132, 0.2)',
                                'rgba(54, 162, 235, 0.2)',
                                'rgba(255, 206, 86, 0.2)',
                                'rgba(75, 192, 192, 0.2)',
                                'rgba(153, 102, 255, 0.2)',
                                'rgba(255, 159, 64, 0.2)'
                            ],
                            borderColor: [
                                'rgba(255, 99, 132, 1)',
                                'rgba(54, 162, 235, 1)',
                                'rgba(255, 206, 86, 1)',
                                'rgba(75, 192, 192, 1)',
                                'rgba(153, 102, 255, 1)',
                                'rgba(255, 159, 64, 1)'
                            ],
                            borderWidth: 1
                        }]
                    },
                    options: {
                        maintainAspectRatio: false,
                        scales: {
                            yAxes: [{
                                stacked: true,
                                ticks: {
                                    beginAtZero: true
                                }
                            }]
                        }
                    }
                });

                if ($('#id-datatable-result-anacom-div').is(':visible'))
                    $('#id-datatable-result-anacom-div').toggle('ol-hidden');

                $('.chart-anacom-container').toggle('ol-hidden');

                $('#id-button-open-chart-anacom').removeClass('gpi gpi-grafico-barras')

                $('#id-button-open-chart-anacom').addClass('fa fa-list')

                if ($('#datatable-anacom-statistics-result').is(':visible'))
                    $('#datatable-anacom-statistics-result').toggle('ol-hidden')

            } else if ($('#id-button-open-chart-anacom').hasClass('fa-list')) {

                $('#id-button-open-chart-anacom').removeClass('fa fa-list')

                $('#id-button-open-chart-anacom').addClass('gpi gpi-grafico-barras')

                if ($('.chart-anacom-container').is(':visible'))
                    $('.chart-anacom-container').toggle('ol-hidden');

                $('#id-datatable-result-anacom-div').toggle('ol-hidden');

                if ($('#datatable-anacom-statistics-result').is(':visible'))
                    $('#datatable-anacom-statistics-result').toggle('ol-hidden')

                $($.fn.dataTable.tables(true)).DataTable().columns.adjust();
            }

            if ($('#id-datatable-result-technical-documentation-anacom-div').is(':visible')) {
                $('#id-datatable-result-technical-documentation-anacom-div').toggle('ol-hidden');
                $('#id-button-open-list-anacom').addClass('ol-hidden');
            }


        });

        $('#id-button-open-list-anacom').on('click', function () {
            $('#id-button-open-list-anacom').addClass('ol-hidden');
            $('#id-datatable-result-technical-documentation-anacom-div').toggle('ol-hidden');
            $('#id-datatable-result-anacom-div').toggle('ol-hidden');
        })

        $('#id-button-export-statistics').on('click', function () {

            //$('#datatable-anacom-statistics-result .table').css({ 'width': '50%' })

            if (!$('#datatable-anacom-statistics-result').is(':visible'))
                $('#datatable-anacom-statistics-result').toggle('ol-hidden')

            if ($('#id-datatable-result-anacom-div').is(':visible'))
                $('#id-datatable-result-anacom-div').toggle('ol-hidden');


            if ($('#id-chart-anacom-container').is(':visible'))
                $('#id-chart-anacom-container').toggle('ol-hidden');

            $('#id-datatable-result-Frequencies-anacom').DataTable().columns.adjust();
            $('#id-datatable-result-Descriptive-statistics-anacom').DataTable().columns.adjust();

        });

        //MOBILE ANACOM

        if (myMapSgs._utility.mobilecheck()) {

            var heightWindow = $(window).height();

            var heightCanvas = heightWindow * 60 / 100;

            //$('#anacom-search-result').css({ 'height': heightCanvas + 'px' });

            $('#id-datatable-result-Descriptive-statistics-anacom').css({ 'width': '100%' });

            $('#id-datatable-result-Descriptive-statistics-anacom_wrapper').css({ 'width': '100%' });

            $('#id-datatable-result-Frequencies-anacom_wrapper').css({ 'width': '100%' });

            $('#id-anacom-search-data-options-chart').css({ 'width': '100%' });

            $('#id-anacom-search-data-options-chart').css({ 'margin-top': '-30px' });

            $('#id-anacom-search-data-options-statistic').css({ 'width': '100%' });

            $('#id-anacom-search-data-options-chart').css({ 'margin-left': '0px' });

            $('#id-anacom-search-data-options-statistic').css({ 'margin-left': '0px' });

            $('#id-datatable-result-Descriptive-statistics-anacom').css({ 'padding-right': '0px' });

            $('#id-datatable-result-Descriptive-statistics-anacom').css({ 'padding-left': '0px' });

            $('#id-datatable-result-Descriptive-statistics-anacom').css({ 'height': '250px' });

            $('#id-datatable-result-Frequencies-anacom').css({ 'height': '250px' });

            $('#id-datatable-result-Descriptive-statistics-anacom_wrapper').css({ 'height': '280px' });

            $('#id-anacom-search').removeClass('map-anacom-search').addClass('map-anacom-search-mobile');

            $('#id-buttons-head-anacom li').removeClass('col-xs-1').addClass('col-xs-3').addClass('Anacom-li-mobile')

            $('#id-button-anacom-search button').addClass('Button-mobile-anacom');

            $('#id-search-text-anacom').css({ 'margin-top': '5px' })

            var viewportmeta = document.querySelector('meta[name="viewport"]');

            viewportmeta.content = 'user-scalable=NO, width=device-width, initial-scale=1.0';

            $('#id-filter-map-anacom').css({ 'left': '10px' });

            $('#id-filter-map-anacom').css({ 'bottom': '140px ' });

            $('.anacom-filter-button-style').css({ 'margin-top': '45px' });

            $('.anacom-filter-list-map-style').css({ 'bottom': '60px' });

            $('.anacom-result-map-style').css({ 'bottom': '70px' });

            $('#id-body-search-anacom').css({ 'width': '100%' });

            $('.unit-scale-line').css({ 'bottom': '8vh' });

            $('#unitscaleline-id').addClass('col-xs-12');

            $('#unitscaleline-id').removeClass('col-sm-12');

            //$('#unitscaleline-id').css({ 'width': '80%' });

            $('#scalezoom').css({ 'margin-right': 'unset', 'margin-left': 'unset' });

            $('#projectionchoise').css({ 'margin-left': 'unset' });

            $('.unit-scale-line').css({ 'flex-direction': 'unset' });

            $('#unitscaleline-id').css({ 'width': '100%' });

            $('#id-filter-map-anacom').on('click', function () {
                if (!$('#id-filter-list-map-anacom').hasClass('ol-hidden'))
                    $('#id-filter-list-map-anacom').addClass('ol-hidden')
                else
                    $('#id-filter-list-map-anacom').removeClass('ol-hidden')
            });

        } else {

            $('#id-filter-map-anacom').mouseover(function () {

                $('#id-filter-list-map-anacom').removeClass('ol-hidden');

            });

            $('#id-filter-list-map-anacom').mouseleave(function () {

                $('#id-filter-list-map-anacom').addClass('ol-hidden');

            });
        }

        //END MOBILE ANACOM

        //$('.remove-search-anacom').mouseover(function () {
        //    var a = this;
        //});

        $('.document-anacom-search').on('click', function () {

            if ($('#id-datatable-result-anacom-div').is(':visible'))
                $('#id-datatable-result-anacom-div').toggle('ol-hidden');

            $('#id-datatable-result-technical-documentation-anacom-div').toggle('ol-hidden');

            $('#id-button-open-list-anacom').removeClass('ol-hidden');

            $('#id-datatable-technical-documentation-anacom').DataTable().columns.adjust();

        });

        $('.open-document-technical').on('click', function () {
            window.open(this.id);
        })


        $('#id-datatable-result-anacom').on('click', '.goto-anacom-search', function () {

            $('#button-close-open-search-anacom').trigger('click');

            var cqlFilter = "ID = '" + this.closest('tr').id + "'";

            myMapSgs.SetFeaturesHighlightConvertProjection('teste_ANACOM', 'vw_SIGObjetoCadastro', '/geoserver/10', true, cqlFilter, null, 'geom', '4326', '3763');



            //$('#anacom-search-result').removeClass('active');

            //var GotoX = -89420.26546365;
            //var GotoY = -100228.25792343;

            //myMapSgs.map.getView().animate({
            //    center: [GotoX, GotoY],
            //    zoom: 11,
            //    duration: 1000
            //});

        });

        $('#id-button-filter-anacom').on('click', function () {

            $('#id-filter-list-map-anacom .remove-search-anacom').remove();

            $('#id-filter-map-anacom').appendTo('#map .ol-viewport');

            $('#id-anacom-search').removeClass('active');

            $('#id-filter-map-anacom').removeClass('ol-hidden');

            $('#id-search-text-anacom .remove-search-anacom').clone().appendTo('#id-filter-list-map-anacom');

            $('#id-filter-list-map-anacom .remove-search-anacom').addClass('col-xs-12');

            $('#id-filter-list-map-anacom .material-icons').appendTo('#id-filter-list-map-anacom');

            $('#id-filter-list-map-anacom .remove-search-anacom').css({ 'width': '' });

            myMapSgs.connectRemoveButtonToFilter();

            if ($('html').scrollTop() > 0)
                $('body').css({ 'height': '100vh' });
            else
                $('body').css({ 'height': '100%' });

        })

        $('#id-button-remove-filter-anacom').on('click', function () {

            for (i = 0; i < $('#id-form-search-anacom').find('table').length; i++) {
                $('#' + $('#id-form-search-anacom').find('table')[i].id).removeClass('removing');
            }

            $('#id-form-search-anacom').find("input[type=checkbox]").prop('checked', false);
            $('#id-form-search-anacom').find("input[type=text]").val('')
            $('#cod_department_team').selectpicker('refresh');
            $('#id-form-search-anacom').find("select").val('');
            $('#id-form-search-anacom').find("select").selectpicker('refresh');
            $('#id-anacom-search .active').removeClass('active');

            $('.remove-search-anacom').remove();

            $('#id-filter-list-map-anacom .remove-search-anacom').remove();

            $('#id-filter-map-anacom').addClass('ol-hidden');

            $('#id-filter-list-map-anacom').trigger('mouseleave');

            $('#id-filter-map-anacom').trigger('click');

        });

        $('#button-open-anacom-search').on('click', function () {

            if (!$('#id-filter-map-anacom').hasClass('ol-hidden')) {
                $('#id-filter-map-anacom').addClass('ol-hidden');
                $('#id-filter-list-map-anacom').addClass('ol-hidden')
            }

            $.ajax({
                type: 'GET',
                url: '/rest/app/Anacom/GetSearchAnacomByUser?user_id=' + myMapSgs._settings.userInfo.userId,
                async: true,
                dataType: "json",
                contentType: "application/json;",
                success: function (data) {

                    myMapSgs._datatablehistoryanacom.clear();

                    myMapSgs._historyListAnacom = data.result;

                    // Set history list
                    var countElement = data.result.length;
                    for (let i = 0; i < countElement; i++) {
                        var objEvent = data.result[i];
                        objEvent.date_state = myMapSgs._utility.TransformDateServerInDateII(objEvent.date_state);
                        myMapSgs._datatablehistoryanacom.row.add({
                            id: objEvent.id,
                            description: objEvent.description
                        });
                    }
                    myMapSgs._datatablehistoryanacom.draw();

                },
                error: function (request, status, error) {
                }
            });

        });

        this.connectRemoveButtonToFilter = function () {

            $(".remove-search-anacom").unbind('mouseenter');

            $(".remove-search-anacom").unbind('mouseleave');

            $(".remove-search-anacom").unbind('click');

            if (!myMapSgs._utility.mobilecheck()) {

                $('#id-search-text-anacom .remove-search-anacom').mouseenter(function () {
                    var widthFilter = $(this).outerWidth();
                    $(this).find('.remove-anacom-filter').removeClass('ol-hidden')
                    $(this).find('.anacom-filter-hidde').addClass('ol-hidden');
                    $(this).css({ 'width': widthFilter + 'px' });
                });

                $('.remove-search-anacom').mouseleave(function () {
                    $(this).find('.remove-anacom-filter').addClass('ol-hidden');
                    $(this).find('.anacom-filter-hidde').removeClass('ol-hidden');
                });

                $('#id-filter-list-map-anacom .remove-search-anacom').mouseenter(function () {
                    var widthFilter = $(this).outerWidth();
                    var heightFilter = $(this).outerHeight();
                    var lineHeightfilter = $(this).height();
                    $(this).find('.remove-anacom-filter').removeClass('ol-hidden')
                    $(this).find('.anacom-filter-hidde').addClass('ol-hidden');
                    $(this).css({ 'width': widthFilter + 'px', 'height': heightFilter + 'px' });
                    $(this).find('.remove-anacom-filter').css({ 'line-height': lineHeightfilter + 'px' });

                });
            }

            $('.remove-search-anacom').on('click', function () {


                if (myMapSgs._utility.mobilecheck()) {

                    if (!$(this).find('.remove-anacom-filter').hasClass('ol-hidden')) {

                        var option = $(this).find('span')[0].innerHTML;

                        if (this.id == 'select')
                            $('.anacom-search-verify:contains(' + $(this).find('span')[0].innerHTML + ')').find("select").val('').selectpicker('refresh');
                        else if (this.id == 'text')
                            $('.anacom-search-fields-margin:contains(' + $(this).find('.anacom-filter-hidde')[0].innerHTML.split(':')[0] + ')').find('input').val('')
                        else if (this.id == 'number-select') {
                            $('.anacom-search-fields-margin:contains(' + $(this).find('.anacom-filter-hidde')[0].innerHTML.split(':')[0] + ')').find("select").val('').selectpicker('refresh');
                            $('.anacom-search-fields-margin:contains(' + $(this).find('.anacom-filter-hidde')[0].innerHTML.split(':')[0] + ')').find('input').val('')
                        }
                        else if (this.id == 'checkbox') {
                            var idCheckBox = $("#id-buttons-head-anacom a[title='" + $(this).find('.anacom-filter-hidde')[0].innerHTML.split(':')[0] + "']")[0].hash;

                            for (i = 0; i < $(idCheckBox).find('table td:contains(' + $(this).find('span')[0].innerHTML.trim() + ')').length; i++) {
                                if ($(idCheckBox).find('table td:contains(' + $(this).find('span')[0].innerHTML.trim() + ')')[i].innerHTML == option.trim())
                                    $($(idCheckBox).find('table td:contains(' + $(this).find('span')[0].innerHTML.trim() + ')')[i].closest('tr')).find('input:checkbox').prop('checked', false)
                            }
                        }

                        if ($('.remove-anacom-filter').closest('#id-filter-list-map-anacom').length > 0) {
                            $('#id-anacom-search .remove-search-anacom:contains(' + $(this).find('.anacom-filter-hidde')[0].innerText + ')').remove()
                        }

                        $(this).remove();

                    }

                    for (i = 0; i < $('.remove-anacom-filter').length; i++) {
                        if (!$($('.remove-anacom-filter')[i]).hasClass('ol-hidden')) {
                            $($('.remove-anacom-filter')[i]).addClass('ol-hidden')
                            $($('.anacom-filter-hidde')[i]).removeClass('ol-hidden');
                        }
                    }

                    var widthFilter = $(this).outerWidth();
                    var heightFilter = $(this).outerHeight();
                    var lineHeightfilter = $(this).height();
                    $(this).find('.remove-anacom-filter').removeClass('ol-hidden')
                    $(this).find('.anacom-filter-hidde').addClass('ol-hidden');
                    $(this).css({ 'width': widthFilter + 'px', 'height': heightFilter + 'px' });
                    $(this).find('.remove-anacom-filter').css({ 'line-height': lineHeightfilter + 'px' });



                } else {

                    var option = "";

                    var optionSelectAll = "";

                    if ($(this).hasClass('select-all-anacom')) {
                        optionSelectAll = $(this).find('.anacom-filter-hidde')[0].innerHTML;
                    }
                    else {
                        option = $(this).find('span')[0].innerHTML;
                    }

                    if (option != "") {

                        if (this.id == 'select')
                            $('.anacom-search-verify:contains(' + $(this).find('span')[0].innerHTML + ')').find("select").val('').selectpicker('refresh');
                        else if (this.id == 'text')
                            $('.anacom-search-fields-margin:contains(' + $(this).find('.anacom-filter-hidde')[0].innerHTML.split(':')[0] + ')').find('input').val('')
                        else if (this.id == 'number-select') {
                            $('.anacom-search-fields-margin:contains(' + $(this).find('.anacom-filter-hidde')[0].innerHTML.split(':')[0] + ')').find("select").val('').selectpicker('refresh');
                            $('.anacom-search-fields-margin:contains(' + $(this).find('.anacom-filter-hidde')[0].innerHTML.split(':')[0] + ')').find('input').val('')
                        }
                        else if (this.id == 'checkbox') {
                            var idCheckBox = $("#id-buttons-head-anacom a[title='" + $(this).find('.anacom-filter-hidde')[0].innerHTML.split(':')[0] + "']")[0].hash;

                            for (i = 0; i < $(idCheckBox).find('table td:contains(' + $(this).find('span')[0].innerHTML.trim() + ')').length; i++) {
                                if ($(idCheckBox).find('table td:contains(' + $(this).find('span')[0].innerHTML.trim() + ')')[i].innerHTML == option.trim())
                                    $($(idCheckBox).find('table td:contains(' + $(this).find('span')[0].innerHTML.trim() + ')')[i].closest('tr')).find('input:checkbox').prop('checked', false)
                            }
                        }
                        else if (this.id == 'data') {
                            $($('#id-elemento-caraterizacao-search [data-provide="datepicker"]')[0]).val("")
                        }


                    } else if (optionSelectAll != "") {

                        var idCheckBox = $("#id-buttons-head-anacom a[title='" + $(this).find('.anacom-filter-hidde')[0].innerHTML.split(':')[0].trim() + "']")[0].hash;

                        $(idCheckBox).find(':checkbox').prop('checked', false);

                    }

                    if ($('.remove-anacom-filter').closest('#id-filter-list-map-anacom').length > 0) {
                        $('#id-anacom-search .remove-search-anacom:contains(' + $(this).find('.anacom-filter-hidde')[0].innerText + ')').remove()
                    }

                    $(this).remove();

                }

            });

        }

        //Cluster
        $('#id-button-cluster-active').on('click', function () {


            $('#spinner-Cluster-background').removeClass('ol-hidden');

            if ($('#id-button-cluster-active')[0].innerHTML == 'Ligar') {
                CheckBoxActiveAnacom = $('#layer-tree').find(':checked')
                for (i = 0; i < CheckBoxActiveAnacom.length; i++)
                    $(CheckBoxActiveAnacom[i]).prop('checked', false).trigger('change');

                $('#id-button-cluster-active')[0].innerHTML = 'Desligar';

                $.when(!$('#spinner-Cluster-background').hasClass('ol-hidden')).then(function loadClusters() {
                    //function loadClusters() {

                    if (!$('#offcanvas-Cluster-body [type="radio"]:checked')[0]) {
                        $('#spinner-Cluster-background').addClass('ol-hidden');
                        $('#id-button-cluster-active')[0].innerHTML = 'Ligar';

                        return toastr["warning"]("Escolha uma opção");
                    }

                    var idObjectChecked = $('#offcanvas-Cluster-body [type="radio"]:checked')[0].id

                    var object = myMapSgs.layerTree.layerInfo.dict_layer_info[idObjectChecked];

                    $.ajax('https://demo-anacom.ambisig.com/geoserver/10/teste_ANACOM/wfs', {
                        type: 'GET',
                        data: {
                            service: 'WFS',
                            version: '2.0.0',
                            request: 'GetFeature',
                            typename: 'teste_ANACOM:' + object.layer_info.layerName,
                            srsname: 'EPSG:3763',
                            outputFormat: 'application/json',
                            //crossOrigin: 'anonymous',
                            bbox: myMapSgs.map.getView().calculateExtent().join(',') + ',EPSG:3763'
                        },
                        async: false
                    }).done(function (response) {

                        //$.ajax('http://10.0.4.54:8080/geoserver/wfs', {
                        //    type: 'GET',
                        //    data: {
                        //        service: 'WFS',
                        //        version: '2.0.0',
                        //        request: 'GetFeature',
                        //        typename: 'GP_DEMO:TMP_GP_Imoveis_Habitacao_S',
                        //        srsname: 'EPSG:3763',
                        //        outputFormat: 'application/json',
                        //        bbox: myMapSgs.map.getView().calculateExtent().join(',') + ',EPSG:3763'
                        //    },
                        //    async: false
                        //}).done(function (response) {

                        //console.log(response);

                        // Addfeatures to the cluster
                        function addFeatures() {
                            var ext = myMapSgs.map.getView().calculateExtent(myMapSgs.map.getSize());
                            var features = [];
                            let totalFeatures = response.totalFeatures;
                            for (var i = 0; i < totalFeatures; ++i) {
                                let lat = response.features[i].geometry["coordinates"][0];
                                let lng = response.features[i].geometry["coordinates"][1];
                                features[i] = new Feature(new Point([lat, lng]));
                                features[i].set('id', i);
                            }
                            clusterSource.getSource().clear();
                            clusterSource.getSource().addFeatures(features);
                        }

                        // Style for the clusters
                        var styleCache = {};
                        function getStyle(feature, resolution) {
                            var size = feature.get('features').length;
                            var style = styleCache[size];
                            if (!style) {
                                var color = size > 25 ? "192,0,0" : size > 8 ? "255,128,0" : "0,128,0";
                                var radius = Math.max(8, Math.min(size * 0.75, 20));
                                var dash = 2 * Math.PI * radius / 6;
                                var dash = [0, dash, dash, dash, dash, dash, dash];
                                style = styleCache[size] = new Style({
                                    image: new CircleStyle({
                                        radius: radius,
                                        stroke: new Stroke({
                                            color: "rgba(" + color + ",0.5)",
                                            width: 10,
                                            //lineDash: dash,
                                            lineCap: "butt"
                                        }),
                                        fill: new Fill({
                                            color: "rgba(" + color + ",1)"
                                        })
                                    }),
                                    text: new Text({
                                        text: size.toString(),
                                        fill: new Fill({
                                            color: '#fff'
                                        })
                                    })
                                });
                            }
                            return style;
                        }

                        // Cluster Source
                        var clusterSource = new Cluster({
                            distance: parseInt(distance.value, 10),
                            source: new VectorSource()
                        });

                        // Animated cluster layer
                        clusterLayer = new AnimatedCluster({
                            name: 'Cluster',
                            source: clusterSource,
                            animationDuration: 500,
                            // Cluster style
                            style: getStyle
                        });

                        myMapSgs.map.addLayer(clusterLayer);

                        addFeatures();

                        // Style for selection
                        var img = new CircleStyle({
                            radius: 5,
                            stroke: new Stroke({
                                color: "rgba(0,255,255,1)",
                                width: 1
                            }),
                            fill: new Fill({
                                color: "rgba(0,255,255,0.3)"
                            })
                        });

                        var style0 = new Style({
                            image: img
                        });

                        var style1 = new Style({
                            image: img,
                            // Draw a link beetween points (or not)
                            stroke: new Stroke({
                                color: "#fff",
                                width: 1
                            })
                        });

                        // Select interaction to spread cluster out and select features
                        selectCluster = new SelectCluster({
                            // Point radius: to calculate distance between the features
                            pointRadius: 7,
                            animate: $("#animatesel").prop('checked'),
                            // Feature style when it springs apart
                            featureStyle: function () {
                                return [$("#haslink").prop('checked') ? style1 : style0]
                            },
                            // selectCluster: false,        // disable cluster selection
                            // Style to draw cluster when selected
                            style: function (f, res) {
                                var cluster = f.get('features');
                                if (cluster.length > 1) {
                                    var s = getStyle(f, res);
                                    if ($("#convexhull").prop("checked") && ol.coordinate.convexHull) {
                                        var coords = [];
                                        for (i = 0; i < cluster.length; i++) coords.push(cluster[i].getGeometry().getFirstCoordinate());
                                        var chull = ol.coordinate.convexHull(coords);
                                        s.push(new Style({
                                            stroke: new Stroke({ color: "rgba(0,0,192,0.5)", width: 2 }),
                                            fill: new Fill({ color: "rgba(0,0,192,0.3)" }),
                                            geometry: new Polygon([chull]),
                                            zIndex: 1
                                        }));
                                    }
                                    return s;
                                } else {
                                    return [
                                        new Style({
                                            image: new CircleStyle({
                                                stroke: new Stroke({ color: "rgba(0,0,192,0.5)", width: 2 }),
                                                fill: new Fill({ color: "rgba(0,0,192,0.3)" }),
                                                radius: 5
                                            })
                                        })];
                                }
                            }
                        });

                        myMapSgs.map.addInteraction(selectCluster);

                        // On selected => get feature in cluster and show info
                        selectCluster.getFeatures().on(['add'], function (e) {
                            var c = e.element.get('features');
                            if (c.length == 1) {
                                var feature = c[0];
                                $(".infos").html("One feature selected...<br/>(id=" + feature.get('id') + ")");
                            } else {
                                $(".infos").text("Cluster (" + c.length + " features)");
                            }
                        })

                        selectCluster.getFeatures().on(['remove'], function (e) {
                            $(".infos").html("");
                        })

                        distance.addEventListener('input', function () {
                            clusterSource.setDistance(parseInt(distance.value, 10));
                        });

                    });

                    $('#form-cliuster-distance').removeClass('ol-hidden');

                    myMapSgs._utility.ShowWait('spinner-Cluster-background', false);

                });

                //loadClusters();

            } else {
                if (CheckBoxActiveAnacom) {
                    for (i = 0; i < CheckBoxActiveAnacom.length; i++)
                        $(CheckBoxActiveAnacom[i]).prop('checked', true).trigger('change');
                }
                $('#id-button-cluster-active')[0].innerHTML = 'Ligar';
                myMapSgs.map.removeInteraction(selectCluster);
                myMapSgs.map.removeLayer(clusterLayer);
                $('#form-cliuster-distance').addClass('ol-hidden');
                myMapSgs._utility.ShowWait('spinner-Cluster-background', false);
            }



        });

        //HeatMap
        var layerCamaraVisita;
        $('#id-button-heatmap-active').on('click', function () {

            if ($('#id-button-heatmap-active')[0].innerHTML == 'Desligar') {
                $('#id-button-heatmap-active')[0].innerHTML = 'Ligar';
                for (i = 0; i < CheckBoxActiveAnacom.length; i++)
                    $(CheckBoxActiveAnacom[i]).prop('checked', true).trigger('change');
                myMapSgs.map.removeLayer(layerCamaraVisita);
                layerCamaraVisita = null;
            } else {

                CheckBoxActiveAnacom = $('#layer-tree').find(':checked')
                for (i = 0; i < CheckBoxActiveAnacom.length; i++)
                    $(CheckBoxActiveAnacom[i]).prop('checked', false).trigger('change');

                if (layerCamaraVisita == null) {
                    var extendTranfor = transform([myMapSgs.map.getView().calculateExtent()[0], myMapSgs.map.getView().calculateExtent()[1], myMapSgs.map.getView().calculateExtent()[2], myMapSgs.map.getView().calculateExtent()[3]], 'EPSG:4326', 'EPSG:4326');

                    //$($('#id-HeatMap').find('i')[0]).removeClass();
                    //$($('#id-HeatMap').find('i')[0]).addClass('zmdi-hc-li zmdi zmdi-refresh zmdi-hc-spin');

                    $('#spinner-Heatmap-background').removeClass('ol-hidden');

                    $('#id-button-heatmap-active')[0].innerHTML = 'Desligar';

                    if (!$('#offcanvas-heatmap-body [type="radio"]:checked')[0]) {
                        for (i = 0; i < CheckBoxActiveAnacom.length; i++)
                            $(CheckBoxActiveAnacom[i]).prop('checked', true).trigger('change');
                        $('#spinner-Cluster-background').addClass('ol-hidden');
                        $('#id-button-heatmap-active')[0].innerHTML = 'Ligar';

                        return toastr["warning"]("Escolha uma opção");
                    }

                    var idObjectChecked = $('#offcanvas-heatmap-body [type="radio"]:checked')[0].id

                    var object = myMapSgs.layerTree.layerInfo.dict_layer_info[idObjectChecked];

                    layerCamaraVisita = new ImageLayer({
                        //extent: extendTranfor,
                        source: new ImageWMS({
                            url: 'https://demo-anacom.ambisig.com/geoserver/10/teste_ANACOM/wms',
                            params: {
                                'LAYERS': 'teste_ANACOM:' + object.layer_info.layerName,
                                'STYLES': 'teste_ANACOM:heatmap'
                            },
                            ratio: 1,
                            serverType: 'geoserver',
                            crossOrigin: 'anonymous'
                        })
                    });

                    $(layerCamaraVisita).on('postcompose', function () {
                        $('#spinner-Heatmap-background').addClass('ol-hidden');
                    });

                    myMapSgs.map.addLayer(layerCamaraVisita);

                } else {
                    myMapSgs.map.removeLayer(layerCamaraVisita);
                    layerCamaraVisita = null;
                }
            }
        });

        /**
         * Create Object register
         */
        $('.object-anacom-search').on('click', function () {

            $('#id-anacom-search').removeClass('active');

            myMapSgs._utility.ShowOpenCanvas3('offcanvas-creation-object-register-form', true);


            if ($('#id-buttons-create-object-register').is(':visible')) {
                $('#id-buttons-create-object-register').toggle('ol-hidden');
                $('#id-buttons-edit-object-register').toggle('ol-hidden');
            }

            if (!$('#form-create-object-register').is(':visible')) {

                $('#form-object-register-options').toggle('ol-hidden');

                $('#form-create-object-register').toggle('ol-hidden');

                $('#id-buttons-options-create-object-register').toggle('ol-hidden');

                $('#id-buttons-edit-object-register').toggle('ol-hidden');
            }

            $('#offcanvas-creation-object-register-form header')[0].innerText = 'Editar objeto de cadastro';

            $('#form-create-object-register [name=objeto_cadastro-elemento]').val('123456987');

            $('#form-create-object-register [name=distrito]').val('Lisboa').selectpicker("refresh");

            $('#form-create-object-register [name=concelho]').val('Lisboa').selectpicker("refresh");

            $('#form-create-object-register [name=freguesia]').val('Saldanha').selectpicker("refresh");

            $('#form-create-object-register [name=freguesia]').val('Saldanha').selectpicker("refresh");

            $('#form-create-object-register [name=Afetacao-principal-elemento]').val('Rede de comunicações eletrónicas').selectpicker("refresh");

            $('#form-create-object-register [name=Comprimento-elemento]').val('3000');

            $('#form-create-object-register [name=Largura-elemento]').val('3000');

            $('#form-create-object-register [name=Altura-elemento]').val('3000');

            $('#form-create-object-register [name=Tipo_Utilizacao-elemento]').val('Acomodação de Equipamentos').selectpicker("refresh");

            $('#form-create-object-register [name=Estado_operacional-elemento]').val('Objeto instalado e disponível').selectpicker("refresh");

            $('#form-create-object-register [name=Ocupação-elemento]').val('25');

            $('#form-create-object-register [name=Documentação-elemento]').val('CDT1').selectpicker("refresh");

        })

        $('#creation-object-register-submite').on('click', function () {

            if ($('#form-object-register-options input:checked').length == 0) {

                toastr["warning"]("Escolha uma opção");

            } else {

                $('#form-object-register-options').toggle('ol-hidden');

                $('#form-create-object-register').toggle('ol-hidden');

                $('#id-buttons-create-object-register').toggle('ol-hidden');

                $('#id-buttons-options-create-object-register').toggle('ol-hidden');

                if ($('#id-buttons-edit-object-register').is(':visible'))
                    $('#id-buttons-edit-object-register').toggle('ol-hidden');
            }

        });

        $('#id-button-export-excel').on('click', function () {

            var cqlObjectAnacom = myMapSgs.getCqlFilterAnacomSearch();

            myMapSgs.GetFormatByCqlFilter('teste_ANACOM', 'vw_SIGObjetoCadastro', '/geoserver/10', true, cqlObjectAnacom, null, 'geom', 'excel2007')
        })

        $('#id-button-export-shp').on('click', function () {

            var cqlObjectAnacom = myMapSgs.getCqlFilterAnacomSearch();

            myMapSgs.GetFormatByCqlFilter('teste_ANACOM', 'vw_SIGObjetoCadastro', '/geoserver/10', true, cqlObjectAnacom, null, 'geom', 'SHAPE-ZIP')
        })

        $('#calculate-route').on('click', function () {

            $('#id-datatable-result-calculate-route').toggle('ol-hidden');

        });


        $('#id-button-create-new-map-anacom').on('click', function () {

            $('#id-modal-save-new-name-map-anacom').modal('show');

        });

        $('#id-confirm-new-map-name-anacom').on('click', function () {

            $('#id-modal-save-new-name-map-anacom').modal('hide');

            var searchObject = myMapSgs.layerTree.layerInfo.list_layer_tree_info

            $.ajax({
                type: 'POST',
                url: '/rest/app/Anacom/DuplicateMapAnacom?&map_id=' + myMapSgs._settings._mapSettings.map_info.id + '&map_name=' + $('#id-input-name-map-anacom').val() + '&description_name=' + $('#id-input-description-map-anacom').val(),
                async: true,
                dataType: "json",
                contentType: "application/json;",
                success: function (data) {

                    searchObject[0].idmap = data.result.toString();

                    var listLayerInfo = JSON.stringify(searchObject);

                    var cqlfilter = myMapSgs.getCqlFilterAnacomSearch();

                    $.ajax({
                        type: 'POST',
                        url: '/rest/app/Anacom/DuplicateLayerTree?&cqlFilter=' + cqlfilter,
                        data: listLayerInfo,
                        dataType: 'json',
                        contentType: "application/json",
                        async: true,
                        success: function (data) {
                            if (data.error) {
                                toastr["error"]("Erro na criação do mapa");
                            }
                            else {
                                switch (data.result.status) {
                                    case "SUCCESS":
                                        location.reload();
                                        toastr["success"]("Mapa Criado com Sucesso");
                                        break;
                                    default:
                                        toastr["error"]("Erro na criação do mapa");
                                }
                            }

                            // Stop Spinner
                            $('#spinner-layertree-details').addClass('ol-hidden')
                        },
                        error: function (request, status, error) {
                            toastr["error"]("Erro na criação do mapa");
                            // Stop Spinner
                            $('#spinner-layertree-details').addClass('ol-hidden')
                        }
                    });

                },
                error: function (request, status, error) {
                }
            });
        });

        $('#id-toponymy-search-place-clean').on('click', function () {
            $('#id-search-toponymy-place').val(null).trigger("change");
        });


        /**
         * Go to choose print option
         */
        $('#id-modal-Group-template-print').on('click', function () {

            myMapSgs.TemplateSelectedDatatable = myMapSgs._datatablegrouptemplate.rows('.selected').data();

            var DataSelect = [];
            for (var i = 0; i < myMapSgs._datatablegrouptemplate.rows('.selected').data().length; i++) {
                DataSelect.push(myMapSgs._datatablegrouptemplate.rows('.selected').data()[i])
            }

            $('#id-template-chosen').val(DataSelect[0].id);

            myMapSgs.TemplateIdSelectedDatatable = DataSelect[0];

            myMapSgs._checkBoxActive = $('#layer-tree').find(':checked');

            //for (var ii = 0; ii < myMapSgs._checkBoxActive.length; ii++)
            //    $(myMapSgs._checkBoxActive[ii]).prop('checked', false).trigger('change');

            ////$($("#layer-tree span:contains('Quotas Entidade Freguesia')").siblings('span[data-role="checkbox"]')[0]).find('input[type="checkbox"]').prop('checked', true).trigger('change');
            //for (var iii = 0; iii < myMapSgs.TemplateIdSelectedDatatable.layer_source.split(',').length; iii++) {

            //    myMapSgs.__checkBoxToDisable.push($($('#layer-tree [id_source = ' + myMapSgs.TemplateIdSelectedDatatable.layer_source.split(',')[iii] + ']').siblings('span[data-role="checkbox"]')[0]).find('input[type="checkbox"]'));

            //    $($('#layer-tree [id_source = ' + myMapSgs.TemplateIdSelectedDatatable.layer_source.split(',')[iii] + ']').siblings('span[data-role="checkbox"]')[0]).find('input[type="checkbox"]').prop('checked', true).trigger('change');
            //}

            $('#id-modal-Group-template-config-scale').find('option').remove().end();

            $("#id-modal-Group-template-config-scale").selectpicker("refresh");

            if (myMapSgs.TemplateIdSelectedDatatable.scale) {


                $.each(myMapSgs.TemplateIdSelectedDatatable.scale.split(','), function (key, value) {

                    $('#id-modal-Group-template-config-scale').append('<option value="' + value + '"> 1:' + value + '</option>');

                    $("#id-modal-Group-template-config-scale").selectpicker("refresh");
                });
            }

            // Hide Modal
            $('#id-modal-Group-template').modal('hide');

            // Remove option layer
            $('#id-modal-Group-template-layer-option-zone').addClass("invisible-option");
            $('#id-modal-Group-template-config-content input[type=checkbox]')[0].checked = false;

            // Show Modal
            $('#id-modal-Group-template-config').modal('show');

            $('#id-modal-Group-template-config-content input[type=radio]').prop('checked', false);

            $('#id-modal-Group-template-config-print').prop('disabled', true);

            if ($('#id-scale-new-print').is(':visible')) {
                $('#id-scale-new-print').toggle('ol-hidden');
            }

        });


        $('#id-modal-Group-template-config-print').on('click', async function () {

            // Hide Modal
            $('#id-modal-Group-template-config').modal('hide');

            // Start loader
            myMapSgs._utility.ShowWait('offcanvas-map-spinner', true);

            const initializePrint = await myMapSgs._printComponent.initialize();

            if (initializePrint) {

                // End loader
                myMapSgs._utility.ShowWait('offcanvas-map-spinner', false);

                if ($('#id-modal-Group-template-config-print i').hasClass('fa-arrow-right')) {
                    myMapSgs._printComponent.exportType = 'enq';

                    // If no layer in template and active option to use template layer then cancel
                    if ($('#id-modal-Group-template-config-content input[type=checkbox]')[0].checked && !myMapSgs._printComponent.hasLayerTemplate) {

                        toastr["warning"]("Template selecionado não contém camadas por defeito");
                        myMapSgs._printComponent.handleClose();
                        return;
                    }
                } else {

                    // If no layer in template and active option to use template layer then cancel
                    if (!myMapSgs._printComponent.hasLayerTemplate) {

                        toastr["warning"]("Template selecionado não contém camadas por defeito");
                        myMapSgs._printComponent.handleClose();
                        return;
                    }

                    myMapSgs._printComponent.exportType = 'scale';

                    // Hide confirm bottom menu
                    $('#menubar-export-bottom-pl').hide();

                    // Clear Export Highlight
                    myMapSgs.templateManager.toggleHighlight(false);

                    // Update Sizes and Screen Size Validation
                    myMapSgs.templateManager.setSizes();

                    // Check if screen size is valid for each template size
                    var screenSizeValidation = myMapSgs.templateManager.sizeValidation;

                    myMapSgs._printComponent.triggerExport();
                }
            } else {
                // End loader
                myMapSgs._utility.ShowWait('offcanvas-map-spinner', false);
            }
        });

        /**
         * On change print option
         */
        $('#id-modal-Group-template-config-content input[type=radio]').change(function () {

            $('#id-modal-Group-template-config-print').prop('disabled', false);

            if (this.id == "id-new-print-scale") {
                $('#id-scale-new-print').toggle('ol-hidden');

                $('#id-modal-Group-template-config-print i').removeClass('fa-arrow-right').addClass('fa-file-pdf-o');
                $('#id-modal-Group-template-config-print').prop('title', 'Imprimir');

                // Remove option layer
                $('#id-modal-Group-template-layer-option-zone').addClass("invisible-option");
                $('#id-modal-Group-template-config-content input[type=checkbox]')[0].checked = false;
            } else {
                if ($('#id-scale-new-print').is(':visible')) {
                    $('#id-scale-new-print').toggle('ol-hidden');
                }

                $('#id-modal-Group-template-config-print i').removeClass('fa-file-pdf-o').addClass('fa-arrow-right');
                $('#id-modal-Group-template-config-print').prop('title', 'Seguinte');

                // View option layer
                $('#id-modal-Group-template-layer-option-zone').removeClass("invisible-option");
                $('#id-modal-Group-template-config-content input[type=checkbox]')[0].checked = false;
            }
        });

        $('#id-modal-Group-template-config-close').on('click', function () {

            for (var ii = 0; ii < myMapSgs._checkBoxActive.length; ii++)
                $(myMapSgs._checkBoxActive[ii]).prop('checked', true).trigger('change');

            for (var ii = 0; ii < myMapSgs.__checkBoxToDisable.length; ii++)
                $(myMapSgs.__checkBoxToDisable[ii]).prop('checked', false).trigger('change');
        })


        ///////////////////////////////////////////////////////////////////////////////////////////TESTE///////////////////////////////////////////////////////////////////////////////////////////////

        this._GetMapUrlTemplate = function (arrayLayer, sridMap, scale, center, displayMapWidth, displayMapHeight, useInternalGeoserver, formatType) {
            var geoserverUrl = (useInternalGeoserver) ? arrayLayer[0].internalGeoserver : arrayLayer[0].geoserver;
            //var getMapUrl = geoserverUrl + arrayLayer[0].workspace + "/wms?service=WMS&version=1.1.1&request=GetMap";
            var getMapUrl = "/" + geoserverUrl + "/wms?service=WMS&version=1.1.1&request=GetMap";
            var layers = "";
            var layerInfo = [];
            var styles = "";
            var cqlFilter = "";
            for (var k = 0; k < arrayLayer.length; k++) {
                layers += arrayLayer[k].workspace + ":" + arrayLayer[k].layer_name + ",";
                cqlFilter += (arrayLayer[k].cql_filter || "INCLUDE") + ";";
                styles += ((arrayLayer[0].sld_style_name_legend === undefined) ? "" : arrayLayer[k].sld_style_name_legend.replace('.sld', '')) + ",";
            }

            const resolution = myMapSgs._settings.resolutions[myMapSgs._settings.scales.indexOf(scale)]

            // Center the map on the area to export
            /*const view = myMapSgs.map.getView();
            view.setCenter(center);
            view.setResolution(resolution);*/

            // Get Map Request parameters
            getMapUrl += "&layers=" + layers.slice(0, -1);
            getMapUrl += "&styles=" + styles.slice(0, -1);
            getMapUrl += "&srs=EPSG:" + sridMap;
            getMapUrl += "&format=image/" + ((formatType !== undefined) ? formatType : "png");
            getMapUrl += "&tiled=true";
            getMapUrl += "&bbox=" + myMapSgs._utility.GetBounds(center, resolution, displayMapWidth, displayMapHeight)
            getMapUrl += "&transparent=true";
            getMapUrl += "&width=" + displayMapWidth;
            getMapUrl += "&height=" + displayMapHeight;
            getMapUrl += "&cql_filter=" + cqlFilter.slice(0, -1);
            getMapUrl += "&scale=" + scale;

            return getMapUrl;
        }

        ///////////////////////////////////////////////////////////////////////////////////////////TESTE///////////////////////////////////////////////////////////////////////////////////////////////



        this.getSearchAnacomObject = function () {

            var _formDataSearchAnacom = $('#id-form-search-anacom').serializeJSON();

            //Tipo Entidade Anacom
            var type_entitdade = [];
            for (i = 0; i < $('.checkboxentitytypeAnacom:checkbox:checked').length; i++)
                type_entitdade.push($($('.checkboxentitytypeAnacom:checkbox:checked')[i]).closest('tr').find('.checkboxOption').html())

            if (type_entitdade.length > 0)
                _formDataSearchAnacom.Type_entidade = type_entitdade;

            else
                _formDataSearchAnacom.Type_entidade = null;

            //Entidade Anacom
            var entidade = [];
            for (i = 0; i < $('.checkboxentityAnacom:checkbox:checked').length; i++)
                entidade.push($($('.checkboxentityAnacom:checkbox:checked')[i]).closest('tr').find('.checkboxOption').html())

            if (entidade.length > 0)
                _formDataSearchAnacom.entidade = entidade;
            else
                _formDataSearchAnacom.entidade = null;

            //Objeto Anacom
            var Objeto = [];
            for (i = 0; i < $('.checkboxgroupAnacom:checkbox:checked').length; i++)
                Objeto.push($($('.checkboxgroupAnacom:checkbox:checked')[i]).closest('tr').find('.checkboxOption').html())

            if (Objeto.length > 0)
                _formDataSearchAnacom.Objetos = Objeto;
            else
                _formDataSearchAnacom.Objetos = null;


            //Tipo utilização anacom
            var Tipo_Utilizacao_elemento = [];
            for (i = 0; i < $('.checkboxtipoutilizacao:checkbox:checked').length; i++)
                Tipo_Utilizacao_elemento.push($($('.checkboxtipoutilizacao:checkbox:checked')[i]).closest('tr').find('.checkboxOption').html())

            if (Tipo_Utilizacao_elemento.length > 0)
                _formDataSearchAnacom.Tipo_Utilizacao_elemento = Tipo_Utilizacao_elemento;
            else
                _formDataSearchAnacom.Tipo_Utilizacao_elemento = null;



            if (_formDataSearchAnacom.Diametro_option_elemento != null)
                _formDataSearchAnacom.Diametro_option_elemento = myMapSgs.tranformtextTosymbology(_formDataSearchAnacom.Diametro_option_elemento)

            if (_formDataSearchAnacom.Comprimento_option_elemento != null)
                _formDataSearchAnacom.Comprimento_option_elemento = myMapSgs.tranformtextTosymbology(_formDataSearchAnacom.Comprimento_option_elemento)

            if (_formDataSearchAnacom.Largura_option_elemento != null)
                _formDataSearchAnacom.Largura_option_elemento = myMapSgs.tranformtextTosymbology(_formDataSearchAnacom.Largura_option_elemento)

            if (_formDataSearchAnacom.Altura_option_elemento != null)
                _formDataSearchAnacom.Altura_option_elemento = myMapSgs.tranformtextTosymbology(_formDataSearchAnacom.Altura_option_elemento)

            if (_formDataSearchAnacom.Cota_option_elemento != null)
                _formDataSearchAnacom.Cota_option_elemento = myMapSgs.tranformtextTosymbology(_formDataSearchAnacom.Cota_option_elemento)

            if (_formDataSearchAnacom.Estado_Ocupacao_option_elemento != null)
                _formDataSearchAnacom.Estado_Ocupacao_option_elemento = myMapSgs.tranformtextTosymbology(_formDataSearchAnacom.Estado_Ocupacao_option_elemento)

            return _formDataSearchAnacom;

        }

        this.tranformtextTosymbology = function (text) {

            if (text === 'Maior que') {

                return '>'

            } else if (text === 'Menor que') {

                return '<'

            } else if (text === 'Igual a') {

                return '='

            }

        }

        this.getCqlFilterAnacomSearch = function () {

            var ObjectSearchAnacom = myMapSgs.getSearchAnacomObject();

            var cqlObjectAnacom = "";

            var typeentidade = "";

            var entidade = "";

            var Objetos = "";

            //Type_entidade
            if (ObjectSearchAnacom.Type_entidade != null)
                for (var t = 0; t < ObjectSearchAnacom.Type_entidade.length; t++) {
                    typeentidade = (typeentidade == "" ? " TipoEntidade ilike '" + ObjectSearchAnacom.Type_entidade[t] + "' and" : typeentidade + " TipoEntidade ilike '" + ObjectSearchAnacom.Type_entidade[t] + "' and"); //'TipoEntidade
                }

            //entidade
            if (ObjectSearchAnacom.entidade != null)
                for (var e = 0; e < ObjectSearchAnacom.entidade.length; e++) {
                    entidade = (entidade == "" ? " NomeEntidade ilike '" + ObjectSearchAnacom.entidade[e] + "' and" : entidade + " NomeEntidade ilike '" + ObjectSearchAnacom.entidade[e] + "' and"); //'TipoEntidade'
                }

            //Objetos
            if (ObjectSearchAnacom.Objetos != null)
                for (var o = 0; o < ObjectSearchAnacom.Objetos.length; o++) {
                    Objetos = (Objetos == "" ? " Nome ilike '" + ObjectSearchAnacom.Objetos[o] + "' and" : Objetos + " Nome ilike '" + ObjectSearchAnacom.Objetos[o] + "' and"); //'TipoEntidade'
                }



            cqlObjectAnacom = (typeentidade == "" ? '' : typeentidade) +
                (entidade == "" ? '' : entidade) +
                (Objetos == "" ? '' : Objetos) +
                (ObjectSearchAnacom.Diametro_option_elemento == undefined ? '' : " Diametro " + ObjectSearchAnacom.Diametro_option_elemento + " '" + ObjectSearchAnacom.Diametro_elemento + "' and") +
                (ObjectSearchAnacom.Comprimento_option_elemento == undefined ? '' : " Comprimento " + ObjectSearchAnacom.Comprimento_option_elemento + " '" + ObjectSearchAnacom.Comprimento_elemento + "' and") +
                (ObjectSearchAnacom.Largura_option_elemento == undefined ? '' : " Largura " + ObjectSearchAnacom.Largura_option_elemento + " '" + ObjectSearchAnacom.Largura_elemento + "' and") +
                (ObjectSearchAnacom.Altura_option_elemento == undefined ? '' : " Altura " + ObjectSearchAnacom.Altura_option_elemento + " '" + ObjectSearchAnacom.Altura_elemento + "' and") +
                (ObjectSearchAnacom.Cota_option_elemento == undefined ? '' : " Cota " + ObjectSearchAnacom.Cota_option_elemento + " '" + ObjectSearchAnacom.Cota_elemento + "' and") +
                (ObjectSearchAnacom.Estado_Ocupacao_option_elemento == undefined ? '' : " EstadoOcupacao " + ObjectSearchAnacom.Estado_Ocupacao_option_elemento + " '" + ObjectSearchAnacom.Estado_Ocupacao_elemento + "' and") +
                (ObjectSearchAnacom.distrito == "" ? '' : " Distrito ilike '" + ObjectSearchAnacom.distrito + "' and") +
                (ObjectSearchAnacom.concelho == "" ? '' : " Concelho ilike '" + ObjectSearchAnacom.concelho + "' and") +
                (ObjectSearchAnacom.freguesia == "" ? '' : " Freguesia ilike '" + ObjectSearchAnacom.freguesia + "' and") +
                (ObjectSearchAnacom.localizacao_rua == "" ? '' : " Arruamento ilike '" + ObjectSearchAnacom.localizacao_rua + "' and") +
                (ObjectSearchAnacom.localizacao_Npolicia == "" ? '' : " Npolicia ilike '" + ObjectSearchAnacom.localizacao_Npolicia + "' and") +
                (ObjectSearchAnacom.Base_instalacao_elemento == "" ? '' : " BaseInstalacao ilike '" + ObjectSearchAnacom.Base_instalacao_elemento + "' and") +
                (ObjectSearchAnacom.Tracado_elemento == "" ? '' : " BaseInstalacao ilike '" + ObjectSearchAnacom.Tracado_elemento + "' and") +
                (ObjectSearchAnacom.Afetacao_principal_elemento == "" ? '' : " NomeTipoAfetacaoPrincipal ilike '" + ObjectSearchAnacom.Afetacao_principal_elemento + "' and") +
                (ObjectSearchAnacom.Date_Criação_objeto == "" ? '' : " DataCriacao ilike '" + ObjectSearchAnacom.Date_Criação_objeto + "' and") +
                (ObjectSearchAnacom.objeto_cadastro_elemento == "" ? '' : " IDObjeto ilike '" + ObjectSearchAnacom.objeto_cadastro_elemento + "' and");

            cqlObjectAnacom = cqlObjectAnacom.slice(0, -4)

            return cqlObjectAnacom;
        }

        //-----------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------
        // FIM ANACOM -----------------------------------------------------------------------------------------------------------------------------------------------------------------------------
        //-----------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------
    };

    /**
     * Get settings
     * @return {object} settings, the settings
     */
    this.getSettings = function () {
        return myMapSgs._settings;
    };

    this._transformAssociatedValues = function (layerName, columns, values) {

        var layer_references = myMapSgs._layerReferences[layerName];
        if (layer_references === null) return;
        var newColumns = [];
        var newValueArray = [];

        for (var i = 0; i < values.length; i++) {

            let valueObj = values[i];

            for (var j = 0; j < columns.length; j++) {

                let objColumn = columns[j];
                var newValues = [];

                if (objColumn.visible != 'false' && objColumn.type != 'readonly') { // Exclude non visible columns
                    let isRefCol = objColumn.data ? objColumn.data.substr(0, 6).toUpperCase() === 'ID_REF' : false;
                    let isIdCol = objColumn.data && !isRefCol ? objColumn.data.substr(0, 2).toUpperCase() === 'ID' : false;
                    let value = objColumn.data ? valueObj[objColumn.data] : "";
                    if (!isIdCol) { // Do not include id_ cols

                        if (isRefCol && value) {
                            var layerRef = layer_references[objColumn.data];
                            var newVal = Object.keys(layerRef[value])[0];
                            valueObj[objColumn.data] = newVal;
                        }
                        if (i == 0) {
                            newColumns.push(columns[j]); // Include all other columns
                        }

                    }
                }
            }
            newValueArray.push(valueObj);
        }

        return { values: newValueArray, columns: newColumns };
    }

    /**
     * Init search result table
     * @param {string} workspace, workspace
     * @param {string} layerName, layer name
     * @param {int} idLayer, layer id
     * @param {object} featureHash, feature
     * @param {array} columnDefArrayInput, array of column
     * @param {array} columDefArrayExpandInput, array of column for expand table
     * @param {array} columnValueArray, array of value
     * @param {function} gotoEntityDetailCallback, goto entity callback function
     */
    this.InitSearchResultTable = function (worksapce, layerName, idLayer, featureHash, columnDefArrayInput, columDefArrayExpandInput, columnValueArray, gotoEntityDetailCallback, showTitle, titleText) {
        var columnDefArray = columnDefArrayInput;
        var columnDefArrayExpand = columDefArrayExpandInput;

        // Show title
        if (showTitle) {
            $('.offcanvas-search-result-table-zone-title').removeClass('ol-hidden');
            $('.offcanvas-search-result-table-zone-title label').html(titleText);
        }
        else {
            $('.offcanvas-search-result-table-zone-title').addClass('ol-hidden');
        }

        // Number of result
        $('#id-search-result-detail-info-number-result span')[0].innerHTML = columnValueArray.length;

        // Go to detail
        var objDef = {
            'name': 'button_goto_detail',
            'data': null,
            'orderable': false,
            'className': 'dt-body-center btn-goto-detail btn-column',
            'defaultContent': '<a class="button-goto-detail-search-result" title="Ir para o detalhe do elemento"><i class="gpi gpi-info" style="color: #ff3d00"></i></a>',
            'width': '2px'
        };
        columnDefArray.unshift(objDef);
        columnDefArrayExpand.unshift(objDef);
        // Goto to location
        objDef = {
            'name': 'button_goto_location',
            'data': null,
            'orderable': false,
            'className': 'dt-body-center btn-goto-location btn-column',
            'defaultContent': '<a class="button-goto-location-search-result" title="Ir para a posição do elemento"><i class="zmdi zmdi-gps-dot" style="color: #ff3d00"></i></a>',
            'width': '2px'
        };
        columnDefArray.unshift(objDef);
        columnDefArrayExpand.unshift(objDef);

        var gpSigredes = app.sgs.Map.getSettings()._mapSettings.search_toponymy.workspaceSearchToponymy == 'GP_MEALHADA';
        if (gpSigredes) {
            var transformedValues = myMapSgs._transformAssociatedValues(layerName, columnDefArrayExpand, columnValueArray)
            columnDefArrayExpand = transformedValues.columns;
            columnValueArray = transformedValues.values;
        }
        // -- Table search result -----------------------------------------------------------------

        // Destroy if exists
        if (myMapSgs.datatableSearchResult != null) {
            // Destroy mCustomScrollbar
            // $('#' + idElementDatatable + '_scroll').mCustomScrollbar("destroy");
            //$('#offcanvas-search-result-table-zone.mCustomScrollbar').mCustomScrollbar('destroy');

            // Destroy table
            myMapSgs.datatableSearchResult.destroy();

            // Empty table zone
            $('#offcanvas-search-result-table-zone').empty();

            // Recreate table node
            var tableSearch = $('<table id="offcanvas-search-result-table" class="search-tool-table" cellspacing="0""></table>');
            tableSearch.appendTo($('#offcanvas-search-result-table-zone'));
        }

        // -- Table definition --
        myMapSgs.datatableSearchResult = $('#offcanvas-search-result-table').DataTable({
            "dom": 'frtp',
            "destroy": true,
            "buttons": [
                'copy', 'excel', 'pdf' //, 'print'
            ],
            "language": {
                "search": "",
                "searchPlaceholder": "Procurar",
                "emptyTable": 'Nenhum elemento',
                "paginate": {
                    "previous": '<i class="fa fa-caret-left"></i>',
                    "next": '<i class="fa fa-caret-right"></i>',
                    "first": '<i class="fa fa-step-backward"></i>',
                    "last": '<i class="fa fa-step-forward"></i>'
                }
            },
            "fixedHeader": true,
            "info": false,
            //"scrollY": $('#offcanvas-search-result-table-zone').height() - 27,
            "scrollCollapse": false,
            "deferRender": false,
            "scroller": false,
            "pagingType": "full",
            "paging": true,
            "pageLength": 15,
            "ordering": false,
            "autoWidth": false,
            "columns": columnDefArray,
            "data": columnValueArray,
            "select": false,
            "name": "search_result",
            "rowId": "id_primary_key",
            "initComplete": function (settings, json) {

                // If table had a custom horizontal scroll, add new one
                //$('#offcanvas-search-result-table-zone.mCS_destroyed').mCustomScrollbar({ axis: 'yx' });
            },
            "drawCallback": function (settings) {
                // Add count number
                var tableId = 'offcanvas-search-result-table';
                $("#" + tableId + "-page-info").remove();
                $("#" + tableId + "_paginate").prepend($('<span id="' + tableId + '-page-info" class="table-page-number">' + ($('#' + tableId).DataTable().page.info().page + 1) + "/" + ($('#' + tableId).DataTable().page.info().pages) + '</span>'));
                $("#" + tableId + "-row-number").remove();
                $("#" + tableId + "_paginate").prepend($('<span id="' + tableId + '-row-number" class="table-row-number">Registos: ' + $('#' + tableId).DataTable().rows({ search: 'applied' }).count() + '</span>'));
                $("#" + tableId + "_filter").css("text-align", "left");

                // Goto element detail
                $('#offcanvas-search-result-table').on('click', '.button-goto-detail-search-result', function () {
                    var id = $(this).parent().parent()[0].id;

                    // Get info element element
                    var featureInfo = null;
                    if (featureHash)
                        featureInfo = {
                            id: id,
                            layer_name: layerName,
                            idLayer: idLayer,
                            feature: featureHash[id],
                            mode: 'read',
                            fromMap: false
                        };
                    else
                        featureInfo = {
                            id: id,
                            layer_name: layerName,
                            idLayer: idLayer,
                            mode: 'read',
                            fromMap: false
                        };

                    // Set Detail occurrence
                    gotoEntityDetailCallback(featureInfo);
                });

                // Goto element search in map 
                $('.button-goto-location-search-result').on('click', function () {
                    // Get id element
                    var id = $(this).parent().parent()[0].id;
                    var idFeature = layerName + "." + id;

                    // Remove highlight
                    myMapSgs.layerHighlightOverlay.getSource().clear();

                    //Go to event
                    myMapSgs.SetFeaturesHighlightByArray(worksapce, layerName, false, [idFeature]);

                    var VerifyClass = $('#id-search-result-detail-info-number-result').hasClass('hide-highlight');

                    if (!VerifyClass)
                        $('#id-search-result-detail-info-number-result').addClass('hide-highlight');
                });
            }
        });
        myMapSgs.datatableSearchResult.draw();

        // -- Table search result expand ----------------------------------------------------------

        var listColumnDef = JSON.parse(JSON.stringify(myMapSgs.layerTree.layerInfo.dict_layer_info[idLayer].list_column.filter(c => c.visible == true)));
        listColumnDef.forEach(columnInfo => {
            if (columnInfo.id_rel_layer_column_ref_metadata != null) {
                columnInfo["values"] = myMapSgs._settings._mapSettings.column_table_reference_data.table_reference_data[columnInfo.id_rel_layer_column_ref_metadata].map(c => { return { value: c.id, text: c.value }; });
            }
        });
        listColumnDef.sort((a, b) => (a["column_pos"] > b["column_pos"]) ? 1 : ((b["column_pos"] > a["column_pos"]) ? -1 : 0));

        myMapSgs.InitSearchResultTableExtend(columnValueArray, listColumnDef);

        //// Destroy if exists
        //if (myMapSgs.datatableSearchResultExpand != null) {
        //    // Destroy mCustomScrollbar
        //    // $('#' + idElementDatatable + '_scroll').mCustomScrollbar("destroy");

        //    // Destroy table
        //    myMapSgs.datatableSearchResultExpand.destroy();
        //}

        ////if (myMapSgs.datatableSearchResultExpand != null) {
        //// Empty table zone
        //$('#offcanvas-map-list-search-result-table-zone').empty();

        //// Recreate table node
        //var tableSearch = $('<table id="offcanvas-map-list-search-result-table" cellspacing="0" width="100%"></table>');
        //tableSearch.appendTo($('#offcanvas-map-list-search-result-table-zone'));
        ////}

        //// -- Table definition --
        //myMapSgs.datatableSearchResultExpand = $('#offcanvas-map-list-search-result-table').DataTable({
        //    "dom": '<"top"ifp>rt',
        //    "destroy": true,
        //    "language": {
        //        "emptyTable": 'Nenhum elemento'
        //    },
        //    //"fixedHeader": false,
        //    "info": false,
        //    "scrollY": $('#offcanvas-map-list-search-result-table-zone').height() - 80,
        //    "scrollX": true,
        //    "scrollCollapse": false,
        //    "deferRender": false,
        //    "scroller": true,
        //    "paging": true,
        //    "ordering": false,
        //    "columns": columnDefArrayExpand,
        //    "data": columnValueArray,
        //    "select": false,
        //    "name": "search_result_expand",
        //    "rowId": 'id_primary_key',
        //    "initComplete": function (settings, json) {
        //        // Goto element detail
        //        $('#offcanvas-map-list-search-result-table').on('click', '.button-goto-detail-search-result', function () {
        //            var id = $(this).parent().parent()[0].id;

        //            // Get info element element
        //            var featureInfo = null;
        //            if (featureHash)
        //                featureInfo = { id: id, layer_name: layerName, idLayer: idLayer, feature: featureHash[id] };
        //            else
        //                featureInfo = { id: id, layer_name: layerName, idLayer: idLayer };

        //            // Set Detail occurrence
        //            gotoEntityDetailCallback(featureInfo);
        //        });

        //        // Goto element search in map 
        //        $('.button-goto-location-search-result').on('click', function () {
        //            // Get id element
        //            var id = $(this).parent().parent()[0].id;
        //            var idFeature = layerName + "." + id;

        //            // Remove highlight
        //            myMapSgs.layerHighlightOverlay.getSource().clear();

        //            //Go to event
        //            myMapSgs.SetFeaturesHighlightByArray(worksapce, layerName, false, [idFeature]);
        //        });
        //    }
        //});
    }

    /**
     * Init search result extend table
     * @param {any} worksapce
     * @param {any} layerName
     * @param {any} idLayer
     * @param {any} columnValueArray
     * @param {any} columnDefArrayExpand
     */
    this.InitSearchResultTableExtend = function (columnValueArray, columnDefArrayExpand, title, openOffCanvas = false) {

        // -- Table search result expand ----------------------------------------------------------
        const idMapListElement = 'offcanvas-map-list';
        const mapListElement = $(`#${idMapListElement}`);
        const gridSelector = '#offcanvas-map-list-result';// offcanvas-map-list-search-result-table-zone

        if (title) {
            const titleElement = mapListElement.find('li.active a');

            if (titleElement.length) {
                titleElement.text(title);
                titleElement.attr("title", title);
            }
        }

        const exportSelectorFieldZoneSelector = '#id-kendo-grid-choose-export-field-zone'
        const exportSelectorFieldZoneElement = $(exportSelectorFieldZoneSelector);

        const exportSelectorFieldSelector = '#id-kendo-grid-choose-export-field';
        const exportSelectorFieldElement = $(exportSelectorFieldSelector);

        const hideSelectorFieldZone = (e) => {
            if (e && buttonSelectFieldsExportElement.length && e.target.id != buttonSelectFieldsExportElement[0].id) {
                exportSelectorFieldZoneElement.hide();
            }
        }

        mapListElement.off("remove", hideSelectorFieldZone);

        $(document).off('click', hideSelectorFieldZone);

        // reset height
        mapListElement.height($('#map').height() * 0.55);

        let resizeWindow = () => {
            if (mapListElement.width() != $("#map").width()) {
                mapListElement.width($("#map").width());

                const elemPosition = mapListElement[0].getBoundingClientRect();

                if (elemPosition.x + 1 < $("#map").width() && elemPosition.x - 1 < $("#map").width()) {
                    app.sgs.Map._utility.ShowOpenCanvas3(idMapListElement, true);
                }
                hideSelectorFieldZone();
            }
        }

        window.removeEventListener('resize', resizeWindow);

        const cardHeadElement = mapListElement.find('.offcanvas-head');
        const cardBodyElement = mapListElement.find('.offcanvas-body');

        let panelHeight = mapListElement.height();
        const gridHeight = cardHeadElement.length ? panelHeight - cardHeadElement.height() : panelHeight - 20;

        if (cardBodyElement.length) {
            cardBodyElement.css('padding', '0px');
            const tabContentElement = cardBodyElement.find('.card-body.tab-content');

            if (tabContentElement.length) {
                tabContentElement.css('padding', '0px');
            }
        }

        // Empty table zone
        $(gridSelector).empty();
        // Empty field selector to export excel
        exportSelectorFieldElement.empty();

        let fields = {};
        let listColumns = [];

        // create columns config
        columnDefArrayExpand.map((column, index) => {

            let typeField = "string";

            switch (column.column_type) {
                case "xsd:int":
                case "xsd:double":
                    typeField = "number"
                    break
                default:
                    break
            }

            fields[column.column_name] = { type: typeField };

            if (column.visible) {
                var columnInfo = {
                    field: column.column_name,
                    title: column.pretty_name,
                    groupable: false,
                    width: 150
                };
                if (column.values) {
                    columnInfo["values"] = column.values;
                }

                listColumns.push(columnInfo);

                $(myMapSgs._templateChooseFieldForExport.replaceAll("[TITLE]", column.pretty_name).replaceAll("[FIELD]", column.column_name)).appendTo(exportSelectorFieldSelector);
            }
        });

        // Grid
        $(gridSelector).kendoGrid({
            noRecords: {
                template: '<div style="text-align:center;min-height:40px;width: 100%;align-content:center;"><span>Não existem resultados</span></div>'
            },
            excel: {
                allPages: true,
                filterable: true
            },
            columnMenu: {
                componentType: "modern",
                columns: true
            },
            columnMenuOpen: (e) => {
                const listCheckbox = e.container.find('.k-column-list-item .k-checkbox');

                if (listCheckbox.length) {
                    listCheckbox.css("position", 'relative')
                    listCheckbox.css("left", '0px')
                    listCheckbox.css("opacity", '1')
                }
            },
            filterable: true,
            height: gridHeight,
            columns: listColumns,
            dataSource: {
                data: columnValueArray,
                schema: {
                    model: {
                        fields: fields
                    }
                },
                pageSize: myMapSgs._gridPageSize
            },
            toolbar: [
                { name: "excel", text: "Excel", iconClass: "k-icon k-i-file-excel" },
                { template: '<a role="button" id="id-button-select-fields-to-export" class="k-button k-button-icontext" href="\\#" title="Selecionar campos para exportação"><span class="k-icon k-i-columns"></span>Selecionar Campos</a>' },
                { template: '<a role="button" id="id-button-clear-filters" class="k-button k-button-icontext" href="\\#" title="Limpar os filtros"><i class="fa fa-filter" aria-hidden="true" style="margin-right: 5px;"></i>Limpar os filtros</a>' }
            ],
            pageable: true,
            scrollable: true,
            sortable: true,
            groupable: false,
            // editable: "inline",
            pageable: {
                pageSizes: [5, 10, 20, 50, "all"],
                input: true,
                numeric: true
            },
            excelExport: function (e) {

                var sheet = e.workbook.sheets[0];

                BuildHiddenColumnsForExport();

                if (myMapSgs._hiddenColumnsForExport.length > 0) {
                    const filterColumns = [];

                    sheet.columns.map((column, index) => {
                        if (myMapSgs._hiddenColumnsForExport.indexOf(listColumns[index].field) > -1) {
                            filterColumns.push(index);
                        };
                    });

                    filterColumns.sort((a, b) => b - a);

                    sheet.rows.map((row, index) => {
                        filterColumns.map(position => row.cells.splice(position, 1));
                        if (index == 0) {
                            filterColumns.map(position => sheet.columns.splice(position, 1));
                        }
                    });
                }
            }
        });

        // Data grid
        let xgrid = $(gridSelector).data("kendoGrid");

        // Reset position of grid elements
        const topPosition = "-65px";
        let deltaHeight = 40;

        // Reset position of grid toolbar
        const toolbarElement = $(gridSelector).find('.k-toolbar.k-grid-toolbar');
        if (toolbarElement.length) {
            deltaHeight += toolbarElement.height();
            toolbarElement.css({
                "width": "100%",
                "top": topPosition
            })
        }

        // Reset position of grid header
        const headerElement = $(gridSelector).find('.k-grid-header');
        if (headerElement.length) {
            deltaHeight += headerElement.height();
            headerElement.css({
                "position": "relative",
                "top": topPosition
            })
        }

        // Reset position of grid pagination
        const paginationElement = $(gridSelector).find('.k-pager-wrap.k-grid-pager.k-widget.k-floatwrap');
        if (paginationElement.length) {
            deltaHeight += paginationElement.height();
            paginationElement.css({
                "top": topPosition,
                "position": "relative"
            })
        }

        // Reset position of grid content
        const contentElement = $(gridSelector).find('.k-grid-content');
        if (contentElement.length) {
            contentElement.css({
                "max-height": `${gridHeight - deltaHeight}px`,
                "top": topPosition
            });
        }

        const buttonSelectFieldsExportElement = $("#id-button-select-fields-to-export");

        /**
         * Grid - Event show field to choose to export 
         */
        buttonSelectFieldsExportElement.click((e) => {

            if (exportSelectorFieldZoneElement.is(':visible')) {
                exportSelectorFieldZoneElement.hide();
            }
            else {

                const panelPosicion = mapListElement.position();
                const headerPosicion = headerElement.position();
                const botonPosicion = buttonSelectFieldsExportElement.position();

                exportSelectorFieldZoneElement.css({
                    "top": panelPosicion.top + headerPosicion.top + botonPosicion.top + buttonSelectFieldsExportElement.outerHeight() + 20 + "px",
                    "left": panelPosicion.left + botonPosicion.left + "px",
                    "max-height": contentElement.height()
                });

                exportSelectorFieldZoneElement.show();
            }
        });

        /**
         * Grid - Event clean all filter
         */
        $("#id-button-clear-filters").click(() => {
            let gridDataSource = $(gridSelector).data("kendoGrid").dataSource;
            gridDataSource.filter({});
        });

        resizeWindow();

        // register resize event
        window.addEventListener('resize', resizeWindow);

        mapListElement.on("remove", hideSelectorFieldZone);

        $(document).on('click', hideSelectorFieldZone);

        exportSelectorFieldZoneElement.on('click', function (event) {
            event.stopPropagation();
        });

        // Show canvas search result
        if (openOffCanvas)
            myMapSgs._utility.ShowOpenCanvas3('offcanvas-map-list', true);

        /**
         * Build hidden column for export
         */
        let BuildHiddenColumnsForExport = function () {
            for (var i = 0; i < $('#id-kendo-grid-choose-export-field input').length; i++) {
                var fieldName = $($('#id-kendo-grid-choose-export-field input')[i]).attr("data-field");
                var indexFieldNameInArray = myMapSgs._hiddenColumnsForExport.indexOf(fieldName);

                // Remove from array if field is check and field is on the array
                if ($($('#id-kendo-grid-choose-export-field input')[i]).is(":checked") && indexFieldNameInArray >= 0) {
                    // Remove from array
                    myMapSgs._hiddenColumnsForExport.splice(indexFieldNameInArray, 1);
                }

                // Add to array if field is not check and field is not in the array
                if (!$($('#id-kendo-grid-choose-export-field input')[i]).is(":checked") && indexFieldNameInArray == -1) {
                    // Remove from array
                    myMapSgs._hiddenColumnsForExport.push(fieldName);
                }
            }
        }
    }

    /**
     * Fill feature to any layer highlight
     * @param {string} workspace, workspace
     * @param {string} layerName, layer name
     * @param {boolean} async, true for async geoserver call
     * @param {array} idsArray, array ids
     * @paran {VectorLayer} layerHighlight, layer high light
     * @param {VectorSource} vectorSourceHighlight, vector source layer high light
     * @param {ol.Style} style, style
     */
    this.SetFeaturesAnyHighlightByArray = function (workspace, layerName, async, idsArray, layerHighlight, vectorSourceHighlight, style) {
        // Get layer info
        var layerInfo = myMapSgs.layerTree.FindLayerInfo(layerName);

        // Array to string
        var idsString = idsArray.toString();

        var getFeatureUrl = layerInfo.geoserver + "/wfs";

        // Call geoserver to get the feature of the layer
        var getFeature = $.ajax({
            method: "GET",
            async: async,
            url: getFeatureUrl,
            data: {
                "service": 'wfs',
                "version": '2.0.0',
                "request": 'GetFeature',
                "typeNames": workspace + ':' + layerName,
                "featureID": idsString,
                "propertyName": layerInfo.geomColumnName,
                'srsName': myMapSgs._settings.projection.code_,
                "outputFormat": 'application/json'
            }
        });

        // Response from the server
        getFeature.done(function (data, textStatus, jqXHR) {
            if (data.features) {
                if (data.features.length > 0) {
                    for (var i = 0; i < data.features.length; i++) {
                        vectorSourceHighlight.addFeature((new GeoJSON()).readFeatures(data)[i]);
                        vectorSourceHighlight.getFeatures()[vectorSourceHighlight.getFeatures().length - 1].setStyle(style);
                    }
                    // Go to Feature
                    myMapSgs.map.getView().fit(layerHighlight.getSource().getExtent(), { size: myMapSgs.map.getSize() });
                }
            }
        });
    };

    /**
     * Fill feature to layer highlight
     * @param {string} workspace, workspace
     * @param {string} layerName, layer name
     * @param {boolean} async, true for async geoserver call
     * @param {array} idsArray, array ids
     * @param {ol.Style} style, style
     */
    this.SetFeaturesHighlightByArray = function (workspace, layerName, async, idsArray, style, gotoFeature) {
        // Get layer info
        var layerInfo = myMapSgs.layerTree.FindLayerInfo(layerName);

        // Array to string
        var idsString = idsArray.toString();

        var getFeatureUrl = layerInfo.geoserver + "/wfs";

        // Call geoserver to get the feature of the layer
        var getFeature = $.ajax({
            method: "GET",
            async: async,
            url: getFeatureUrl,
            data: {
                "service": 'wfs',
                "version": '2.0.0',
                "request": 'GetFeature',
                "typeNames": workspace + ':' + layerName,
                "featureID": idsString,
                "propertyName": layerInfo.geomColumnName,
                'srsName': myMapSgs._settings.projection.code_,
                "outputFormat": 'application/json'
            }
        });
        var searchColor = 'rgba(255,255,0,0.6)'; // Default
        if (window["searchHighlightColor"] != null && window["searchHighlightColor"] != "") {
            searchColor = window["searchHighlightColor"];
        }
        var searchFillColor = 'rgba(0, 0, 255, 0.2)'; // Default
        if (window["searchHighlightFillColor"] != null && window["searchHighlightFillColor"] != "") {
            searchColor = window["searchHighlightFillColor"];
        }
        // Response from the server
        getFeature.done(function (data, textStatus, jqXHR) {
            if (data.features) {
                if (data.features.length > 0) {
                    var feature = null;
                    for (var i = 0; i < data.features.length; i++) {
                        feature = (new GeoJSON()).readFeatures(data)[i];
                        var styleElement = myMapSgs._defaultHighlighStyles;
                        if (style)
                            styleElement = style;
                        feature.setStyle(styleElement);
                        myMapSgs.featureToHighLight.push(feature);
                    }
                    // Set current features in overlay
                    myMapSgs.layerHighlightOverlay.setSource(new VectorSource({ features: myMapSgs.featureToHighLight, useSpatialIndex: true }));
                    // Go to Feature
                    if (gotoFeature === undefined || gotoFeature) {
                        myMapSgs.map.getView().fit(myMapSgs.layerHighlightOverlay.getSource().getExtent(), { size: myMapSgs.map.getSize() });
                        if (data.features.length == 1) {
                            var typeGeom = feature.getGeometry().getType();
                            myMapSgs.map.getView({
                                center: [myMapSgs.layerHighlightOverlay.getSource().getExtent()[0], myMapSgs.layerHighlightOverlay.getSource().getExtent()[1]]
                            });
                            if (mapSettings.operation_visible.ManagerTrafficSignTool) {
                                myMapSgs.map.getView().setZoom(myMapSgs._managerTrafficSignTool._ZoomSearch);
                            }
                            else {
                                switch (typeGeom) {
                                    case "MultiPoint":
                                    case "Point":
                                        myMapSgs.map.getView().setZoom(myMapSgs._ZoomSearchPoint);
                                        break;
                                    default:
                                    //myMapSgs.map.getView().setZoom(myMapSgs._ZoomSearch);
                                }
                            }
                        }
                    }
                }
            }
        });
    };

    /**
     * Fill feature to layer highlight
     * @param {string} workspace, workspace
     * @param {string} layerName, layer name
     * @param {string} geoserver, geoserver name
     * @param {boolean} async, true for async geoserver call
     * @param {array} idsArray, array ids
     * @param {ol.Style} style, style
     * @param {string} geomColumnName, geom column name
     */
    this.SetFeaturesHighlightByArray2 = function (workspace, layerName, geoserver, async, idsArray, style, geomColumnName, gotoFeature, clearHighlight) {
        // Clear last highligh
        if (clearHighlight)
            myMapSgs.featureToHighLight.clear();

        // Array to string
        var idsString = idsArray.toString();

        var getFeatureUrl = geoserver + "/wfs";

        // Call geoserver to get the feature of the layer
        var getFeature = $.ajax({
            method: "GET",
            async: async,
            url: getFeatureUrl,
            data: {
                "service": 'wfs',
                "version": '2.0.0',
                "request": 'GetFeature',
                "typeNames": workspace + ':' + layerName,
                "featureID": idsString,
                "propertyName": (geomColumnName == null ? 'geom' : geomColumnName),
                'srsName': myMapSgs._settings.projection.code_,
                "outputFormat": 'application/json'
            }
        });

        // Response from the server
        getFeature.done(function (data, textStatus, jqXHR) {
            if (data.features) {
                if (data.features.length > 0) {
                    for (var i = 0; i < data.features.length; i++) {
                        myMapSgs.featureToHighLight.push((new GeoJSON()).readFeatures(data)[i]);
                        var styleElement = myMapSgs._defaultHighlighStyles;
                        if (style)
                            styleElement = style;
                        myMapSgs.featureToHighLight.getArray()[myMapSgs.featureToHighLight.getArray().length - 1].setStyle(styleElement);
                    }
                    // Set current features in overlay
                    myMapSgs.layerHighlightOverlay.setSource(new VectorSource({ features: myMapSgs.featureToHighLight, useSpatialIndex: true }));

                    // Go to Feature
                    if (gotoFeature) {
                        if (myMapSgs.layerHighlightOverlay.getSource().getFeatures().length == 1) {
                            var feature = myMapSgs.layerHighlightOverlay.getSource().getFeatures()[0];
                            var featureType = feature.getGeometry().getType();
                            switch (featureType) {
                                case "Point":
                                    myMapSgs.map.getView().fit(myMapSgs.layerHighlightOverlay.getSource().getExtent(), { size: myMapSgs.map.getSize(), maxZoom: 12, duration: 1000 });
                                    break;
                                default:
                                    myMapSgs.map.getView().fit(myMapSgs.layerHighlightOverlay.getSource().getExtent(), { size: myMapSgs.map.getSize(), duration: 1000 });
                            }

                        }
                        else
                            myMapSgs.map.getView().fit(myMapSgs.layerHighlightOverlay.getSource().getExtent(), { size: myMapSgs.map.getSize(), duration: 1000 });
                    }
                }
            }
        });
    };

    /**
     * Fill feature to layer highlight
     * @param {Feature} featureIn, feature to highlight
     * @param {boolean} gotoFeature, goto feature
     * @param {ol.Style} style, style
     */
    this.SetFeaturesHighlightByArray3 = function (featureIn, gotoFeature, style) {
        myMapSgs.featureToHighLight.clear();

        var styleElement = myMapSgs._defaultHighlighStyles;

        var feature = featureIn.clone();

        myMapSgs.featureToHighLight.push(feature);
        if (style)
            styleElement = style;
        myMapSgs.featureToHighLight.getArray()[myMapSgs.featureToHighLight.getArray().length - 1].setStyle(styleElement);

        // Set current features in overlay
        myMapSgs.layerHighlightOverlay.setSource(new VectorSource({ features: myMapSgs.featureToHighLight, useSpatialIndex: true }));
        // Go to Feature
        if (gotoFeature) {
            myMapSgs.map.getView().fit(myMapSgs.layerHighlightOverlay.getSource().getExtent(), { size: myMapSgs.map.getSize() });
            var featureType = feature.getGeometry().getType();
            switch (featureType) {
                case "Point":
                    myMapSgs.map.getView().fit(myMapSgs.layerHighlightOverlay.getSource().getExtent(), { size: myMapSgs.map.getSize(), maxZoom: 12, duration: 1000 });
                    break;
                default:
                    myMapSgs.map.getView().fit(myMapSgs.layerHighlightOverlay.getSource().getExtent(), { size: myMapSgs.map.getSize(), duration: 1000 });
            }
        }
    };

    /**
     * Fill feature to layer highlight by cql filter
     * @param {string} workspace, workspace
     * @param {string} layerName, layer name
     * @param {string} geoserver, geoserver name
     * @param {boolean} async, true for async geoserver call
     * @param {string} cqlFilter, array ids
     * @param {ol.Style} style, style
     * @param {string} geomColumnName, geom column name
     * @param {string} msgNotFound, message in case of not found
     */
    this.SetFeaturesHighlightByCqlFilter = function (workspace, layerName, geoserver, async, cqlFilter, style, geomColumnName, msgNotFound, saveName) {

        myMapSgs._saveNameFeature = saveName;

        var getFeatureUrl = geoserver + "/wfs";

        // Call geoserver to get the feature of the layer
        var getFeature = $.ajax({
            method: "GET",
            async: async,
            url: getFeatureUrl,
            data: {
                "service": 'wfs',
                "version": '2.0.0',
                "request": 'GetFeature',
                "typeNames": workspace + ':' + layerName,
                "cql_filter": cqlFilter,
                "propertyName": (geomColumnName == null ? 'geom' : geomColumnName),
                'srsName': myMapSgs._settings.projection.code_,
                "outputFormat": 'application/json'
            }
        });

        // Response from the server
        getFeature.done(function (data, textStatus, jqXHR) {

            //myMapSgs.layerHighlightOverlay.getSource().clear();
            // Clear last highligh
            if (myMapSgs.featureToHighLight.getArray().length > 0)
                myMapSgs.featureToHighLight.clear();
            if (data.features) {
                if (data.features.length > 0) {
                    for (var i = 0; i < data.features.length; i++) {

                        if (data.features[0].id.split(".")[0] == "PDL_LIM_SECCOES") {
                            myMapSgs._featureSeccao = data.features;
                        }

                        if (myMapSgs._saveNameFeature)
                            myMapSgs._featureNPredio = data.features[i];

                        var featureGeoJson = (new GeoJSON()).readFeatures(data)[i];
                        var geometryType = featureGeoJson.getGeometry().getType();
                        myMapSgs.featureToHighLight.push(featureGeoJson);
                        var styleElement = myMapSgs._defaultHighlighStyles;
                        if (style)
                            styleElement = style;
                        myMapSgs.featureToHighLight.getArray()[myMapSgs.featureToHighLight.getArray().length - 1].setStyle(styleElement);
                    }
                    // Go to Feature
                    if (myMapSgs.layerHighlightOverlay.getSource().getFeatures().length == 1) {
                        var feature = myMapSgs.layerHighlightOverlay.getSource().getFeatures()[0];
                        var featureType = feature.getGeometry().getType();
                        switch (featureType) {
                            case "Point":
                                myMapSgs.map.getView().fit(myMapSgs.layerHighlightOverlay.getSource().getExtent(), { size: myMapSgs.map.getSize(), duration: 1000, maxZoom: 12 });
                                break;
                            case "MultiPoint":
                                myMapSgs.map.getView().fit(myMapSgs.layerHighlightOverlay.getSource().getExtent(), { size: myMapSgs.map.getSize(), duration: 1000, maxZoom: 12 });
                                break;
                            default:
                                myMapSgs.map.getView().fit(myMapSgs.layerHighlightOverlay.getSource().getExtent(), { size: myMapSgs.map.getSize(), duration: 1000 });
                        }

                    }
                    else
                        myMapSgs.map.getView().fit(myMapSgs.layerHighlightOverlay.getSource().getExtent(), { size: myMapSgs.map.getSize(), duration: 1000 });

                    //Enable button to hide feature highligth
                    $('#id-button-hide-seccao').prop('disabled', false);

                }
                else
                    toastr["warning"](msgNotFound);
            }
            else {
                toastr["warning"](msgNotFound);
            }
        });
    };

    /**
     * Fill feature to layer highlight by cql filter
     * @param {string} workspace, workspace
     * @param {string} layerName, layer name
     * @param {string} geoserver, geoserver name
     * @param {boolean} async, true for async geoserver call
     * @param {string} cqlFilter, array ids
     * @param {ol.Style} style, style
     */
    this.GetFormatByCqlFilter = function (workspace, layerName, geoserver, async, cqlFilter, style, geomColumnName, format) {

        var getFeatureUrl = geoserver + "/wfs";

        document.location.href = 'http://localhost:50487/' + getFeatureUrl + '?service=wfs&version=1.1.0&request=GetFeature&typeNames=' + workspace + '%3A' + layerName + '&outputFormat=' + format + '&cql_filter=' + cqlFilter;

    };

    /**
     * Fill feature to layer highlight by cql filter
     * @param {string} workspace, workspace
     * @param {string} layerName, layer name
     * @param {string} geoserver, geoserver name
     * @param {boolean} async, true for async geoserver call
     * @param {string} cqlFilter, array ids
     * @param {ol.Style} style, style
     */
    this.SetFeaturesHighlightConvertProjection = function (workspace, layerName, geoserver, async, cqlFilter, style, geomColumnName, ProjectionLayer, ProjectionMap) {
        var getFeatureUrl = geoserver + "/wfs";

        // Call geoserver to get the feature of the layer
        var getFeature = $.ajax({
            method: "GET",
            async: async,
            url: getFeatureUrl,
            data: {
                "service": 'wfs',
                "version": '2.0.0',
                "request": 'GetFeature',
                "typeNames": workspace + ':' + layerName,
                "cql_filter": cqlFilter,
                "propertyName": (geomColumnName == null ? 'geom' : geomColumnName),
                'srsName': myMapSgs._settings.projection.code_,
                "outputFormat": 'application/json',
            }
        });

        // Response from the server
        getFeature.done(function (data, textStatus, jqXHR) {
            myMapSgs.layerHighlightOverlay.getSource().clear();
            if (data.features) {
                if (data.features.length > 0) {
                    for (var i = 0; i < data.features.length; i++) {

                        if (data.features[i].geometry.type == "Point") {
                            data.features[i].geometry.coordinates = transform([data.features[i].geometry.coordinates[0], data.features[i].geometry.coordinates[1]], 'EPSG:' + ProjectionLayer, 'EPSG:' + ProjectionMap);
                        } else {
                            for (var g = 0; g < data.features[g].geometry.coordinates[0].length; g++) {
                                data.features[i].geometry.coordinates[0][g] = transform(data.features[i].geometry.coordinates[0][g], 'EPSG:' + ProjectionLayer, 'EPSG:' + ProjectionMap);
                            }
                        }

                        myMapSgs.featureToHighLight.push((new GeoJSON()).readFeatures(data)[i]);
                        var styleElement = myMapSgs._defaultHighlighStyles;
                        if (style)
                            styleElement = style;
                        myMapSgs.featureToHighLight.getArray()[myMapSgs.featureToHighLight.getArray().length - 1].setStyle(styleElement);
                    }
                    // Go to Feature
                    myMapSgs.map.getView().fit(myMapSgs.layerHighlightOverlay.getSource().getExtent(), { size: myMapSgs.map.getSize(), duration: 1000, maxZoom: 13 });
                }
            }
        });
    };

    /**
     * Fill feature to layer highlight
     * @param {array} featureArray, feature array
     * @param {bool} gotoFeature, goto feature option
     * @param {ol.Style} style, style
     */
    this.SetFeaturesHighlightByFeatureCol = function (featureArray, gotoFeature, style) {

        if (featureArray && featureArray.length > 0) {
            // Fill collection
            for (var i = 0; i < featureArray.length; i++) {
                myMapSgs.featureToHighLight.push(featureArray[i]);
                //var styleElement = myMapSgs._defaultHighlighStyles;
                //if (style)
                //    styleElement = style;
                //myMapSgs.featureToHighLight.getArray()[myMapSgs.featureToHighLight.getArray().length - 1].setStyle(styleElement);
            }

            // Go to Feature
            if (gotoFeature)
                myMapSgs.map.getView().fit(myMapSgs.layerHighlightOverlay.getSource().getExtent(), { size: myMapSgs.map.getSize() });
        }
    };

    /**
     * Get feature from layer and id
     * @param {string} workspace, workspace
     * @param {string} layerName, layer name
     * @param {string} idFeature, idFeature
     */
    this.GetFeatureByIdSync = function (workspace, layerName, idFeature) {
        // Get layer info
        var layerInfo = myMapSgs.layerTree.FindLayerInfo(layerName);

        var getFeatureUrl = layerInfo.geoserver + "/wfs";
        var feature = null;

        // Call geoserver to get the feature of the layer
        var getFeature = $.ajax({
            method: "GET",
            async: false,
            url: getFeatureUrl,
            data: {
                "service": 'wfs',
                "version": '2.0.0',
                "request": 'GetFeature',
                "typeNames": workspace + ':' + layerName,
                "featureID": idFeature,
                'srsName': myMapSgs._settings.projection.code_,
                "outputFormat": 'application/json'
            }
        });

        // Response from the server
        getFeature.done(function (data, textStatus, jqXHR) {
            if (data.features) {
                if (data.features.length > 0) {
                    feature = (new GeoJSON()).readFeatures(data)[0];
                }
            }
        });

        return feature;
    };

    /**
     * Open detail info element
     * @param {object} featureInfo, Feature info
     */
    this.DetailElement = function (featureInfo) {
        var signInfo;
        var layerSignName;

        // Get feature Info view
        myMapSgs._featureInfoFocus = featureInfo;

        $("#id-offcanvas-body-layer-detail-field select").unbind("change.bs.select");

        if (mapSettings.operation_visible.ManagerTrafficSignTool) {
            // Hide select sign
            $('#id-offcanvas-body-manager-traffice-sign-add-type-sign').hide();
            $('#id-offcanvas-body-manager-traffice-sign-add-not-in-prumo').hide();
            $(this).attr("status-select", "off");
        }

        var codElement = "";
        var hasButtonDelete = false;

        // If delete layer then delete button exist
        if (myMapSgs._settings._mapSettings.operation_visible.DeleteLayers) {
            hasButtonDelete = true;
        }

        // If permission to edit then transform read on update
        if (myMapSgs._settings._mapSettings.operation_visible.EditLayers || myMapSgs._settings._mapSettings.operation_visible.EditDetailsLayers) {
            if (featureInfo.idLayer) {
                var layerInfo = myMapSgs.layerTree.layerInfo.dict_layer_info[featureInfo.idLayer].layer_info
                if (layerInfo && layerInfo.editable && featureInfo.mode === 'read') {
                    featureInfo.mode = 'update';
                }
            }

            // Get object signInfo
            var signInfoObj = myMapSgs._utility.GetPropertyInfoInConfigArray(myMapSgs._settings.configurationInfo.propertyInfo, "TRAFFIC_SIGNAL_CONFIG", "LAYER_TRAFFIC_SIGN", "SIGN_INFO");
            if (signInfoObj && signInfoObj.value) {
                signInfo = JSON.parse(signInfoObj.value);
            }

            // Get layer name sign
            var layerSignNameObj = myMapSgs._utility.GetPropertyInfoInConfigArray(myMapSgs._settings.configurationInfo.propertyInfo, "TRAFFIC_SIGNAL_CONFIG", "LAYER_TRAFFIC_SIGN", "SIGN_LAYER_NAME");
            if (layerSignNameObj && layerSignNameObj.value) {
                layerSignName = layerSignNameObj.value;
            }
        }

        // Get layer info
        var layerInfo = myMapSgs._settings.treeMap.dict_layer_info[featureInfo.idLayer].layer_info;

        // Set street map view coordinate
        if (myMapSgs._mapStreetView !== undefined) {
            myMapSgs._mapStreetView.SetCoordinate(featureInfo.feature.getGeometry().getCoordinates());
        }

        // Manager Traffic Sign - Detail element especific for Layer sign only
        if (mapSettings.operation_visible.ManagerTrafficSignTool && myMapSgs._managerTrafficSignTool.signInfo.layerName == layerInfo.layerName) {
            featureInfo.mode = 'update';
            //myMapSgs._managerTrafficSignTool.DetailElementSign(featureInfo);
            //return;
        }

        // Call specific detail
        switch (layerInfo.layerName) {
            case "PUBPAINEL":
                if (mapSettings.operation_visible.PubTool) {
                    myMapSgs._pubTool.DetailElement(featureInfo);
                    return;
                }
                break;
            case "GEVESPACOVERDE":
                if (mapSettings.operation_visible.GreenAreaTool) {
                    myMapSgs._greenAreaTool.DetailElement(featureInfo);
                    return;
                }
                break;
            case "VW_PCOCORRENCIA":
                if (mapSettings.operation_visible.CivilProtectionTool) {
                    myMapSgs._civilProtectionTool.DetailElement(featureInfo);
                    return;
                }
                break;
            case "VW_PONTODEPOSICAO":
                if (mapSettings.operation_visible.DepositionPointTool) {
                    myMapSgs._depositionPointTool.DetailElement(featureInfo);
                    return;
                }
                break;
            case "TERRENOS":
            case "EDIFICIOS":
            case "TERRENOSALIENADOS":
            case "EDIFICIOSALIENADOS":
                if (mapSettings.operation_visible.PatrimonyTool) {
                    myMapSgs._patrimonyTool.DetailElement(featureInfo);
                    return;
                }
                break;
            case "VW_NPOLICIA_III":
                if (mapSettings.operation_visible.RoadBuilderTool) {
                    featureInfo.mode = 'update';
                    hasButtonDelete = false;
                }
                break;
            //case "V_ESTRADAS":
            //    if (mapSettings.operation_visible.RoadBuilderTool) {
            //        $('#id-offcanvas-body-layer-history-detail').show();
            //        myMapSgs._roadBuilderTool.DetailElement(featureInfo) ;
            //    }
            //    break;
            default:
            // do nothing
        }

        // Start wait
        myMapSgs._utility.ShowWait('id-offcanvas-layer-detail-spinner', true);

        // Clean Number of file
        if (!myMapSgs._settings._mapSettings.operation_visible.LocationPlantConsultaPublica)
            $('.offcanvas-body-layer-detail-attachment-info-td span')[0].innerHTML = "-";

        // Define according to mode
        var readOnly = "readonly";
        var hiddenCol = false;
        switch (featureInfo.mode) {
            case 'update':
                // ajust button
                $('#id-offcanvas-body-layer-detail-button').removeClass('ol-hidden');
                if (hasButtonDelete) {
                    $('#id-save-feature-submit').removeClass('col-md-12');
                    $('#id-save-feature-submit').addClass('col-md-6');
                    $('#id-save-feature-submit').addClass('col-xs-6');
                    $('#id-delete-feature-submit-zone').removeClass('ol-hidden');
                }
                else {
                    $('#id-save-feature-submit').removeClass('col-md-6');
                    $('#id-save-feature-submit').removeClass('col-xs-6');
                    $('#id-save-feature-submit').addClass('col-md-12');
                    $('#id-delete-feature-submit-zone').addClass('ol-hidden');
                }

                // Event on save feature
                $('#id-save-feature-submit').off('click').on('click', function () {
                    var feature = (app.Select.getFeatures().getArray().length === 0) ? featureInfo.feature : app.Select.getFeatures().getArray()[0];

                    myMapSgs._SaveFeature('update', feature, featureInfo.idLayer);
                });

                // Event delete feature
                if (hasButtonDelete) {
                    $('#id-delete-feature-submit').off('click').on('click', function () {
                        myMapSgs._ShowConfirmationForDeleteFromForms(featureInfo.feature, featureInfo.idLayer);
                    });
                }

                readOnly = "";
                break;
            case 'create':
                // Ajust button
                $('#id-offcanvas-body-layer-detail-button').removeClass('ol-hidden');
                $('#id-save-feature-submit').removeClass('col-md-6');
                $('#id-save-feature-submit').removeClass('col-xs-6');
                $('#id-save-feature-submit').addClass('col-md-12');
                $('#id-delete-feature-submit-zone').addClass('ol-hidden');

                // Event on create feature
                $('#id-save-feature-submit').off('click').on('click', function () {
                    myMapSgs._SaveFeature('insert', featureInfo.feature, featureInfo.idLayer);
                });

                readOnly = "";
                break;
            default: // read
                if (mapSettings.operation_visible.EditDetailsLayers) {
                    $('#id-offcanvas-body-layer-detail-button').removeClass('ol-hidden');
                    // Event on save feature
                    $('#id-save-feature-submit').off('click').on('click', function () {
                        var feature = (app.Select.getFeatures().getArray().length === 0) ? featureInfo.feature : app.Select.getFeatures().getArray()[0];
                        myMapSgs._SaveFeature('update', feature, featureInfo.idLayer);
                    });
                }
                else {
                    $('#id-offcanvas-body-layer-detail-button').addClass('ol-hidden');
                }
        }

        // Show canvas
        myMapSgs._utility.ShowOpenCanvas3('id-offcanvas-layer-detail', true);

        // Layer info
        var layerObj = myMapSgs.layerTree.layerInfo.dict_layer_info[featureInfo.idLayer];
        var layerName = layerObj.layer_info.layerName;

        // Get codElement
        if (featureInfo.feature.getProperties().import_code)
            codElement = featureInfo.feature.getProperties().import_code;

        // Build title
        $('#id-offcanvas-head-title-element')[0].innerHTML = layerObj.layer_info.pretty_name;
        $('#id-offcanvas-head-code-element')[0].innerHTML = codElement;

        // -- Field -------------------------------------------------------------------------------

        // Clean info field
        $('#id-offcanvas-body-layer-detail-field div').remove();
        if ($('#id-form-edit-layer-detail-field').length === 0) {
            $('#id-offcanvas-body-layer-detail-field').append($('<form id="id-form-edit-layer-detail-field"></form>'));
        }

        var gpName = app.sgs.Map.getSettings()._mapSettings.search_toponymy.workspaceSearchToponymy;

        // Clean deposition if exists
        if (mapSettings.operation_visible.DepositionPointTool) {
            myMapSgs._depositionPointTool.CleanDetail();
        }

        // Clean pub if exists
        if (mapSettings.operation_visible.PubTool) {
            myMapSgs._pubTool.CleanDetail();
        }

        // Clean civil protection if exists
        if (mapSettings.operation_visible.CivilProtectionTool) {
            myMapSgs._civilProtectionTool.CleanDetail();
        }

        // Clean green area if exists
        if (mapSettings.operation_visible.GreenAreaTool) {
            myMapSgs._greenAreaTool.CleanDetail();
        }

        // Clean sign
        if (mapSettings.operation_visible.ManagerTrafficSignTool) {
            myMapSgs._managerTrafficSignTool.CleanDetail(layerInfo.layerName, featureInfo.mode);
        }

        // Build Info field
        var arrayColumn = layerObj.list_column.sort((a, b) => (a.column_pos > b.column_pos) ? 1 : -1);

        // OrderBy position_mobile - TODO - do not use cliente name
        if (_clientGeoportal.indexOf("DOUROGAS") >= 0 && myMapSgs._utility.mobilecheck() && featureInfo.mode != "create") {
            arrayColumn = layerObj.list_column.sort((a, b) => (a.position_mobile > b.position_mobile) ? 1 : -1);
            arrayColumn = arrayColumn.filter(c => c.visible_mobile == true);
        }

        // -- Alarm for Manager traffic sign ------------------------------------------------------

        // Manager Traffic Sign - Detail element especific for Layer sign only
        $('#id-offcanvas-body-layer-detail-alarm-zone').hide();
        $('#id-offcanvas-layer-detail-qrcopde-zone').hide();
        $('#id-offcanvas-head-title-element-zone .manager-traffic-sign-title').remove();
        $('#id-offcanvas-head-title-element').show();
        if (mapSettings.operation_visible.ManagerTrafficSignTool && myMapSgs._managerTrafficSignTool.signInfo.layerName == layerInfo.layerName) {
            if (featureInfo.mode != "create") {
                // Alarm info
                $('#id-offcanvas-body-layer-detail-alarm-zone').show();
                $('#id-offcanvas-body-layer-detail-alarm-manually-zone').hide();

                // clean alarms list
                $('#id-offcanvas-body-layer-detail-alarm-list').empty();

                const showDetailAlarmManuallyBtnAdd = () => {

                    $('input[name="alarm_manually_name"]').val("");
                    $('textArea[name="alarm_manually_description"]').val("");

                    $('#id-offcanvas-body-layer-detail-alarm-manually-btn-remove').attr('data-id-alarm', null);
                    $('#id-offcanvas-body-layer-detail-alarm-manually-btn-save').attr('data-id-alarm', null);

                    $('#id-offcanvas-body-layer-detail-alarm-manually-btn-remove').hide();

                    $('#id-offcanvas-body-layer-detail-alarm-manually-zone').toggle('ol-hidden');
                }

                const updateLayers = () => {
                    // layer sign
                    const layerSign = myMapSgs._utility.GetLayerById(myMapSgs.map, 'T' + layerInfo.id);

                    if (layerSign && layerSign.getSource() instanceof VectorSource) {

                        // info layer prumo
                        const layerInfoPrumo = myMapSgs.layerTree.GetLayerAllInfoArrayByLayerSourceName(myMapSgs._managerTrafficSignTool.prumoInfo.layerName)[0].layer_info;

                        // refresh layer prumo
                        const layerPrumo = myMapSgs._utility.GetLayerById(myMapSgs.map, 'T' + layerInfoPrumo.id);
                        if (layerPrumo && layerPrumo.getSource() instanceof VectorSource) {
                            layerPrumo.getSource().clear();
                            layerPrumo.getSource().refresh();
                        }

                        const vectorSource = layerSign.getSource();

                        // reset feature style
                        const idLayerSign = `${myMapSgs._managerTrafficSignTool._mapSgs._featureInfoFocus.feature.getId()}_`;

                        for (const key in myMapSgs.layerTree._cacheStyleLayerSign) {
                            if (key.startsWith(idLayerSign) && myMapSgs.layerTree._cacheStyleLayerSign.hasOwnProperty(key)) {
                                delete myMapSgs.layerTree._cacheStyleLayerSign[key]
                            }
                        }

                        const refreshDetailElement = () => {

                            if (vectorSource.getFeatures().length > 0) {
                                const featureSignAlarm = vectorSource.getFeatureById(myMapSgs._managerTrafficSignTool._mapSgs._featureInfoFocus.feature.getId());

                                if (featureSignAlarm) {
                                    const idLayer = myMapSgs._managerTrafficSignTool._mapSgs.layerTree.GetLayerInfoArrayByLayerSourceName(layerInfo.layerName)[0].id;

                                    // open detail panel with feature updated
                                    myMapSgs._managerTrafficSignTool._mapSgs.DetailElement({
                                        id: featureInfo.id,
                                        feature: featureSignAlarm,
                                        idLayer: idLayer,
                                        mode: 'update',
                                        fromMap: true
                                    });
                                }

                                vectorSource.un('change', refreshDetailElement);
                                myMapSgs._utility.ShowWait('offcanvas-map-spinner', false);
                            }
                        };

                        vectorSource.on('change', refreshDetailElement);

                        // refresh layer sign
                        vectorSource.clear();
                        vectorSource.refresh();
                    }
                };

                /**
                 * 
                 * */
                const saveAlarmManually = () => {

                    // ShowWait 
                    myMapSgs._utility.ShowWait('offcanvas-map-spinner', true);

                    const nameAlarm = $('input[name="alarm_manually_name"]').val();
                    const descriptionAlarm = $('textArea[name="alarm_manually_description"]').val();

                    if (nameAlarm.trim() != '' && descriptionAlarm.trim() != '') {

                        const idAlarm = $("#id-offcanvas-body-layer-detail-alarm-manually-btn-save").attr("data-id-alarm");

                        const action = idAlarm ? 'SaveAlarmManually' : 'RegisterAlarmManually';
                        const actionText = idAlarm ? 'atualizado' : 'criado';

                        const sendData = {
                            layerName: layerInfo.layerName,
                            name: nameAlarm,
                            description: descriptionAlarm,
                            idElement: featureInfo.feature.getProperties().id
                        }

                        if (idAlarm) {
                            sendData.id = parseInt(idAlarm);
                        }

                        $.ajax({
                            url: `/rest/app/ManagerAlarmTool/${action}`,
                            type: 'POST',
                            async: false,
                            contentType: 'application/json',
                            dataType: 'json',
                            data: JSON.stringify(sendData),
                            success: function (response) {
                                if (response.result.status) {
                                    toastr["success"](`Alarme manual ${actionText} com sucesso`);
                                    updateLayers();
                                } else {
                                    toastr["error"](`Alarme manual não pôde ser ${actionText}`);
                                }
                            },
                            error: function (xhr, status, error) {
                                toastr["error"](`Alarme manual não pôde ser ${actionText}`);
                                myMapSgs._utility.ShowWait('offcanvas-map-spinner', false);
                            }
                        });
                    } else {
                        myMapSgs._utility.ShowWait('offcanvas-map-spinner', false);
                    }
                }

                /**
                 * 
                 * */
                const removeAlarmManually = () => {

                    myMapSgs._utility.ShowWait('offcanvas-map-spinner', true);

                    const idAlarm = $("#id-offcanvas-body-layer-detail-alarm-manually-btn-remove").attr("data-id-alarm");

                    $.ajax({
                        url: `/rest/app/ManagerAlarmTool/GetDeleteAlarmManually?idAlarm=${idAlarm}`,
                        type: 'GET',
                        async: false,
                        success: function (response) {
                            if (response.result.status) {
                                toastr["success"]("Alarme manual fechado com sucesso");
                                updateLayers();
                            } else {
                                toastr["error"]('Alarme manual não pôde ser fechado');
                                myMapSgs._utility.ShowWait('offcanvas-map-spinner', false);
                            }
                        },
                        error: function (xhr, status, error) {
                            toastr["error"]('Alarme manual não pôde ser fechado');
                            myMapSgs._utility.ShowWait('offcanvas-map-spinner', false);
                        }
                    });
                };

                // Event Collapse/open info in element detail
                $('#id-offcanvas-body-layer-detail-alarm-manually-btn-add').off('click').on('click', showDetailAlarmManuallyBtnAdd);
                // $('#id-offcanvas-body-layer-detail-alarm-manually-btn-edit').off('click').on('click', showDetailAlarmManuallyBtnEdit);
                $('#id-offcanvas-body-layer-detail-alarm-manually-btn-remove').off('click').on('click', removeAlarmManually);
                $('#id-offcanvas-body-layer-detail-alarm-manually-btn-save').off('click').on('click', saveAlarmManually);

                // QrCode Img
                $('#id-offcanvas-layer-detail-qrcopde-zone').show();
                $('#id-offcanvas-body-layer-detail-generate-qrcode').attr('mode', featureInfo.mode);
                $('#id-offcanvas-body-layer-detail-generate-qrcode').attr('sign-id', featureInfo.id);
                // Unlink init btn
                $('#id-offcanvas-body-layer-detail-unlink-sign').attr('mode', featureInfo.mode);
                $('#id-offcanvas-body-layer-detail-unlink-sign').attr('sign-id', featureInfo.id);

                // Build Header
                $('#id-offcanvas-head-title-element').hide();
                var idTypeSign = featureInfo.feature.getProperties()[myMapSgs._managerTrafficSignTool.signInfo.signInfoConfig.column_name_type_sign];
                var urlImageSign = featureInfo.feature.getProperties()[myMapSgs._managerTrafficSignTool.signInfo.signInfoConfig.column_name_url_img];
                var typeSignDescription = myMapSgs._managerTrafficSignTool._hashReference.listTipoSinal.find(c => c.id == idTypeSign).description;

                const maxWidth = 54;
                const maxHeight = 34;

                const width = featureInfo.feature.getProperties().width || 30;
                const height = featureInfo.feature.getProperties().height || 30;

                const maxValue = width > height ? (width < maxWidth ? width : maxWidth) : (height < maxHeight ? height : maxHeight);

                let nWidth = 30;
                let nHeight = 30;

                const aspectRatio = width / height;

                if (aspectRatio != 1) {
                    if (width > height) {
                        nWidth = maxValue;
                        nHeight = maxValue / aspectRatio;
                    } else {
                        nWidth = maxValue * aspectRatio;
                        nHeight = maxValue;
                    }
                }

                $('#id-offcanvas-head-title-element-zone').append($('<div class="manager-traffic-sign-title">' +
                    '<div class="offcanvas-collapse" style="height: 50px;text-align: center;">' +
                    '<div class="col-md-2" style="padding:0;margin-left: 10px;">' +
                    '<img src="' + urlImageSign + '" alt="" width="' + nWidth + '" height="' + nHeight + '" style="position: relative;top: 4px;">' +
                    '</div>' +
                    '<div class="col-md-8" style="padding:0">' +
                    '<label style="padding-left: 20px;font-size: 14px;margin-bottom: 0px;color: black;font-weight: 100;">' + typeSignDescription + '</label>' +
                    '<label style="padding-left: 20px;font-size: 14px;margin-bottom: 0px;font-weight: bold;color: black;">' + featureInfo.id.toString().padStart(5, '0') + '</label>' +
                    '</div>' +
                    '</div>' +
                    '</div>'));
            }
        }

        // -- For all column ----------------------------------------------------------------------
        var hashNodeElement = {};
        for (var i = 0; i < arrayColumn.length; i++) {
            var objColumn = arrayColumn[i];
            var type = "text";

            // Only for traffic sign tool then user BuildDetailElement in this tool for this column
            if (mapSettings.operation_visible.TrafficSignTool) {
                if (myMapSgs._trafficSignTool.BuildDetailElement(objColumn, featureInfo))
                    continue;
            };

            // Show only if field marked as visible
            if (!objColumn.visible) {
                if (mapSettings.operation_visible.ManagerTrafficSignTool && myMapSgs._managerTrafficSignTool.signInfo.layerName == layerName) {
                    // Show alarm if exists
                    var valueJsonAlarm = featureInfo.feature.getProperties()[objColumn.column_name];
                    if (featureInfo.mode != "create" && myMapSgs._managerTrafficSignTool.signInfo.signInfoConfig.column_name_json_alarm == objColumn.column_name) {

                        $('#id-offcanvas-body-layer-detail-alarm-manually-btn-add').show();
                        $('#id-offcanvas-body-layer-detail-alarm-manually-btn-edit').hide();
                        $('#id-offcanvas-body-layer-detail-alarm-manually-btn-remove').hide();

                        $('textArea[name="alarm_manually_description"]').val('');

                        $("#id-offcanvas-body-layer-detail-alarm-manually-btn-remove").attr("data-id-alarm", null);
                        $("#id-offcanvas-body-layer-detail-alarm-manually-btn-save").attr("data-id-alarm", null);

                        if (valueJsonAlarm != undefined && valueJsonAlarm != "") {
                            myMapSgs._managerTrafficSignTool.BuildAlarmInfo(valueJsonAlarm, "");
                        }
                    }
                }

                // Add id road on prumo
                if (mapSettings.operation_visible.ManagerTrafficSignTool && myMapSgs._managerTrafficSignTool.prumoInfo.layerName == layerName && objColumn.column_name == myMapSgs._managerTrafficSignTool.prumoInfo.prumoInfoConfig.id_road_column_name && featureInfo.idRoad && featureInfo.idRoad != -1) {
                    hashNodeElement[objColumn.column_name] = {
                        column_name: objColumn.column_name,
                        node: $('<div class="form-group offcanvas-body-layer-detail-row hidden">'
                            + '<input name="' + objColumn.column_name + '" class="feature-field form-control ' + objColumn.column_type + '" data-name="' + objColumn.column_name + '" type="number" id="prop_' + objColumn.column_name + '" value="' + featureInfo.idRoad + '" readonly/>'
                            + '</div> '),
                        position: i
                    };
                }
                continue;
            }

            // Only for manager traffic tool
            if (mapSettings.operation_visible.ManagerTrafficSignTool) {
                // Add id prumo to button add sign
                var columnNameIdPrumo = myMapSgs._utility.GetPropertyInfoInConfigArray(myMapSgs._settings.configurationInfo.propertyInfo, "TRAFFIC_SIGNAL_CONFIG", "LAYER_TRAFFIC_SIGN", "PRUMO_LAYER_ID_COLUMN_NAME").value;
                var layerNamePrumo = myMapSgs._utility.GetPropertyInfoInConfigArray(myMapSgs._settings.configurationInfo.propertyInfo, "TRAFFIC_SIGNAL_CONFIG", "LAYER_TRAFFIC_SIGN", "PRUMO_LAYER_NAME").value;
                if (layerNamePrumo == layerName && objColumn.column_name == columnNameIdPrumo) {
                    $('#id-offcanvas-body-manager-traffic-sign-tool-add-sign').attr("id-prumo", featureInfo.feature.getProperties()[objColumn.column_name]);
                    $('#id-offcanvas-body-manager-traffic-sign-tool-create-sign').attr("id-prumo", featureInfo.feature.getProperties()[objColumn.column_name]);
                }
            }

            // Show only if field marked as visible
            if (!objColumn.visible) continue;

            // Show only if field marked as editable for creations
            if (!objColumn.editable && featureInfo.mode == 'create') continue;

            // Mark read only
            if (objColumn.editable && (featureInfo.mode == 'update' || featureInfo.mode == 'create')) {
                // Only for sigredes use
                readOnly = '';
                if (featureInfo.mode == 'update' && (objColumn.column_name == 'zone' || objColumn.column_name == 'id_zone'))
                    readOnly = 'readonly'; // Cannot update zone in model (Update DB procedures to change this)
            }
            else
                readOnly = 'readonly';

            let isIdCol = objColumn.column_name.substr(0, 2).toUpperCase() === 'ID';
            let isRefCol = objColumn.column_name.substr(0, 6).toUpperCase() === 'ID_REF' || (gpName == 'GP_PONTA_DELGADA' && objColumn.column_name == 'TIPO' && layerInfo.layerName != "PDL_IMOVEIS_CLASSIFICADOS"); // TODO: Add to layer_column_metadata, field that indicate if column is ref column
            let value = featureInfo.feature.getProperties()[objColumn.column_name];

            // If manager traffic sign tool then user BuildDetailElement in this tool for this column
            if (mapSettings.operation_visible.ManagerTrafficSignTool) {
                switch (objColumn.column_name) {
                    case "id_prumo":
                        readOnly = 'readonly';
                        if (value === null || value === undefined) {
                            value = featureInfo.feature.getId().split('.')[1];
                        }
                        break;
                    //case "dicofre":
                    //    myMapSgs._managerTrafficSignTool.BuildFreguesiaField(layerInfo.layerName, objColumn, featureInfo, "", value);
                    //    continue;
                    //    break;
                    case "id_troco":
                        myMapSgs._managerTrafficSignTool.BuildTrocoField(layerInfo.layerName, objColumn, featureInfo, "", value);
                        continue;
                        break;
                    case "id_arruamento":
                        myMapSgs._managerTrafficSignTool.BuildArruamentoField(layerInfo.layerName, objColumn, featureInfo, "", value);
                        continue;
                        break;
                    case "qrcode":
                        if (featureInfo.mode !== 'create')
                            myMapSgs._managerTrafficSignTool.GetQrcodeById(value, "");
                        break;
                    case "cod_sinal":
                        myMapSgs._managerTrafficSignTool.BuildTypeSignZone(layerInfo.layerName, objColumn, featureInfo, "", value);
                        continue;
                    case "installed":
                        if (featureInfo.mode == 'create' && layerName == myMapSgs._managerTrafficSignTool.prumoInfo.layerName) {
                            value = true;
                            readOnly = 'readonly';
                        }
                        break;
                    default:
                    // do nothing
                }

                if (layerName == myMapSgs._managerTrafficSignTool.prumoInfo.layerName && objColumn.column_name == myMapSgs._managerTrafficSignTool.prumoInfo.prumoInfoConfig.road_column_name && featureInfo.roadName && featureInfo.roadName != "") {
                    value = featureInfo.roadName;
                    readOnly = 'readonly';
                }
            };

            // Hide column - TODO - Do not use workspace
            if (gpName == 'GP_PONTA_DELGADA' && objColumn.column_name == 'DATA') {
                hiddenCol = true; // Hide column DATA for PONTA DELGADA creations
                value = myMapSgs._utility.getNewDateForServer();
            }
            else
                hiddenCol = false;

            // Set value if null
            if (value === null || value === undefined)
                value = '';

            // Act according column type
            switch (objColumn.column_type) {
                case "xsd:timestamp2":
                case "xsd:date-time":
                    value = myMapSgs._utility.TransformDateServerInDateII(value);
                    type = "date";
                    break;
                case "xsd:date":
                    if (value != "") {
                        var valueDate = new Date(value);
                        value = valueDate.getFullYear() + "-" + (valueDate.getMonth() + 1).toString().padStart(2, "0") + "-" + valueDate.getDate().toString().padStart(2, "0");
                    }
                    type = "date";
                    break;
                case "xsd:number":
                case "xsd:int":
                case "xsd:double":
                case "xsd:bigint":
                    type = "number";
                    break;
                case "xsd:bool":
                    type = "checkbox";
                    break;
                default:
                // do nothing
            }

            // Verify if column as ref table
            var layerRef = "";
            var typeOfLayerRef = "";
            if (objColumn.has_ref_table) // -- New table reference method --
            {
                isRefCol = true;
                layerRef = myMapSgs._settings.columnTableReferenceData.table_reference_data[objColumn.id_rel_layer_column_ref_metadata];
                typeOfLayerRef = "array";
            }
            else // -- Old table reference method --
            {
                // Get reference for combo box if column is id
                var layer_references = myMapSgs._layerReferences[layerName];
                if (layer_references && (layer_references['id_' + objColumn.column_name] || layer_references[objColumn.column_name])) {
                    layerRef = !isIdCol ? layer_references['id_' + objColumn.column_name] : layer_references[objColumn.column_name];
                }

                // Get layer 
                var prefix = "id_";
                if (isRefCol) {
                    if (myMapSgs.typeList.length > 0) {
                        layerRef = myMapSgs.typeList;
                        typeOfLayerRef = "list";
                    }
                    else {
                        layerRef = layer_references[objColumn.column_name];
                        typeOfLayerRef = "hash";
                    }
                    prefix = "";
                }
            }

            // Build combo box if reference data found
            if ((featureInfo.mode != 'read' || isRefCol) && typeof layerRef != 'undefined' && layerRef != '') {
                // Put in combo array
                var comboArray = [];
                switch (typeOfLayerRef) {
                    case "array":
                        comboArray = layerRef;
                        break;
                    case "list":
                        for (var k = 0; k < layerRef.length; k++) comboArray.push({ 'id': layerRef[k], 'value': layerRef[k] });
                        break;
                    case "hash":
                        comboArray = Object.keys(layerRef).map(function (key) {
                            return { 'id': Number(key), 'value': Object.keys(layerRef[key])[0] };
                        });
                        break;
                    default:
                    // do nothing
                }

                // Get value default for combo
                var defValue = "";
                if (value != "") {
                    var defValueObj = comboArray.filter(function (ob) { return ob.id == value; })[0];
                    if (defValueObj) {
                        if (isRefCol) {
                            if (featureInfo.mode == 'read')
                                defValue = defValueObj.value;
                            else
                                defValue = defValueObj.id;
                        }
                        else
                            defValue = defValueObj.id;
                    }
                }

                // In read mode, add text box and not combo box
                if (featureInfo.mode == 'read' && isRefCol) {
                    hashNodeElement[objColumn.column_name] = {
                        reference_info: {
                            has_reference_info: false
                        },
                        column_name: objColumn.column_name,
                        node: $('<div class="form-group offcanvas-body-layer-detail-row' + (hiddenCol ? ' hidden' : '') + '">'
                            + '<label for="prop_' + objColumn.column_name + '">' + objColumn.pretty_name + '</label>'
                            + '<input class="feature-field form-control ' + objColumn.column_type + '" data-name="' + prefix + objColumn.column_name + '" type="text" id="prop_' + prefix + objColumn.column_name + '" value="' + defValue + '" ' + readOnly + '/>'
                            + '</div>'),
                        position: i
                    };
                }
                else {
                    var disabled = readOnly == 'readonly' ? 'disabled' : '';

                    // Manager traffic sign tool for type of element column
                    if (mapSettings.operation_visible.ManagerTrafficSignTool && layerSignName == layerName && signInfo.column_name_type_sign == objColumn.column_name) {

                        // Add select box with associated entity possible values
                        var idselect2 = "prop_assoc_" + objColumn.column_name;
                        var idToAppendSelect2 = idselect2 + "_append";
                        hashNodeElement[objColumn.column_name] = {
                            reference_info: {
                                has_reference_info: true
                            },
                            column_name: objColumn.column_name,
                            node: $('<div id="' + idToAppendSelect2 + '" class="form-group offcanvas-body-layer-detail-row manager-traffic-sign-select2-type-sign' + (hiddenCol ? ' hidden' : '') + ((readOnly !== 'readonly') ? ' write' : '') + '">'
                                + '<label for="prop_' + objColumn.column_name + '">' + objColumn.pretty_name + '</label>'
                                + '</div>'),
                            position: i
                        };

                        // Add combo box type sign
                        myMapSgs._managerTrafficSignTool.BuildTypeSignSelection(idToAppendSelect2, idselect2, objColumn.column_name, "REFRESH_TITLE_SIGN", defValue, "", "", 'data-name= "' + objColumn.column_name + '" data-destination-field="prop_' + prefix + objColumn.column_name + '" ' + disabled);
                        continue;
                    };

                    hashNodeElement[objColumn.column_name] = {
                        reference_info: {
                            has_reference_info: true,
                            id_column: "prop_assoc_" + objColumn.column_name,
                            list_reference: comboArray,
                            key_column: 'id',
                            description_column: "value",
                            default_value: defValue
                        },
                        column_name: objColumn.column_name,
                        node: $('<div class="form-group offcanvas-body-layer-detail-row' + (hiddenCol ? ' hidden' : '') + ((readOnly !== 'readonly') ? ' write' : '') + '">'
                            + '<label for="prop_' + objColumn.column_name + '">' + objColumn.pretty_name + '</label>'
                            + '<select class="feature-field form-control ' + objColumn.column_type + '" id="prop_assoc_' + objColumn.column_name + '" name="' + objColumn.column_name + '" data-name= "' + objColumn.column_name + '" data-destination-field="prop_' + prefix + objColumn.column_name + '" ' + disabled + '><option></option></select>'
                            + '</div>'),
                        position: i
                    };

                    //myMapSgs._utility.FillSelect("prop_assoc_" + objColumn.column_name, comboArray, 'value', 'id');

                    //$('#' + 'prop_assoc_' + objColumn.column_name).selectpicker('val', defValue);
                }
            }
            else {
                // Edition on mobile
                if (_clientGeoportal.indexOf("DOUROGAS") >= 0 && myMapSgs._utility.mobilecheck() && featureInfo.mode != "create") {
                    if (objColumn.edit_mobile == true)
                        readOnly = "";
                    else
                        readOnly = 'readonly';
                }

                // Reference automatics for this column
                if (myMapSgs._hashColumnsReferences[objColumn.column_name]) {
                    // One value only
                    if (myMapSgs._hashColumnsReferences[objColumn.column_name].length == 1 || $.isNumeric(myMapSgs._hashColumnsReferences[objColumn.column_name])) {
                        if ($.isNumeric(myMapSgs._hashColumnsReferences[objColumn.column_name])) {
                            hashNodeElement[objColumn.column_name] = {
                                reference_info: {
                                    has_reference_info: false
                                },
                                column_name: objColumn.column_name,
                                node: $('<div class="form-group offcanvas-body-layer-detail-row' + (hiddenCol ? ' hidden' : '') + '">'
                                    + '<label for="prop_' + objColumn.column_name + '">' + objColumn.pretty_name + '</label>'
                                    + '<input name="' + objColumn.column_name + '" class=" feature-field form-control ' + objColumn.column_type + '" data-name="' + objColumn.column_name + '" type="' + type + '" id="prop_' + objColumn.column_name + '" value="' + myMapSgs._hashColumnsReferences[objColumn.column_name] + '" readOnly/>'
                                    + '</div>'),
                                position: i
                            };
                        }
                        else {
                            var KeyLayerDesc = myMapSgs._hashColumnsReferencesToFill[objColumn.column_name].layer_source_column_name_key;

                            hashNodeElement[objColumn.column_name] = {
                                reference_info: {
                                    has_reference_info: false
                                },
                                column_name: objColumn.column_name,
                                node: $('<div class="form-group offcanvas-body-layer-detail-row' + (hiddenCol ? ' hidden' : '') + '">'
                                    + '<label for="prop_' + objColumn.column_name + '">' + objColumn.pretty_name + '</label>'
                                    + '<input name="' + objColumn.column_name + '" class=" feature-field form-control ' + objColumn.column_type + '" data-name="' + objColumn.column_name + '" type="' + type + '" id="prop_' + objColumn.column_name + '" value="' + myMapSgs._hashColumnsReferences[objColumn.column_name][0][KeyLayerDesc] + '" readOnly/>'
                                    + '</div>'),
                                position: i
                            };
                        }
                    }

                    // Combobox for multiple value
                    if (myMapSgs._hashColumnsReferences[objColumn.column_name].length > 1) {
                        hashNodeElement[objColumn.column_name] = {
                            reference_info: {
                                has_reference_info: true,
                                id_column: 'prop_' + objColumn.column_name,
                                list_reference: null,
                                key_column: KeyLayerDesc,
                                description_column: KeyLayerDesc,
                                default_value: null
                            },
                            column_name: objColumn.column_name,
                            node: $('<div class="form-group offcanvas-body-layer-detail-row' + (hiddenCol ? ' hidden' : '') + ((readOnly !== 'readonly') ? ' write' : '') + '">'
                                + '<label for="prop_' + objColumn.column_name + '">' + objColumn.pretty_name + '</label>'
                                + ' <select id="prop_' + objColumn.column_name + '" name="' + objColumn.column_name + '" class="form-control"><option></option></select>' +
                                + '</div>'),
                            position: i
                        };

                        //var KeyLayerDesc = myMapSgs._hashColumnsReferencesToFill[objColumn.column_name].layer_source_column_name_key;

                        //myMapSgs._utility.FillSelect('prop_' + objColumn.column_name, myMapSgs._hashColumnsReferences[objColumn.column_name], KeyLayerDesc, KeyLayerDesc);
                    }
                }
                else // All other situation
                {
                    switch (objColumn.column_type) {
                        case "xsd:text":
                            hashNodeElement[objColumn.column_name] = {
                                reference_info: {
                                    has_reference_info: false
                                },
                                column_name: objColumn.column_name,
                                node: $('<div class="form-group offcanvas-body-layer-detail-row' + (hiddenCol ? ' hidden' : '') + ((readOnly !== 'readonly') ? ' write' : '') + '">'
                                    + '<label for="prop_' + objColumn.column_name + '">' + objColumn.pretty_name + '</label>'
                                    + '<textarea  rows="2" name="' + objColumn.column_name + '" class="feature-field form-control ' + objColumn.column_type + '" data-name="' + objColumn.column_name + '" type="' + type + '" id="prop_' + objColumn.column_name + '"' + readOnly + '>' + value + '</textarea>'
                                    + '</div>'),
                                position: i
                            };
                            break;
                        case "xsd:link":
                            hashNodeElement[objColumn.column_name] = {
                                reference_info: {
                                    has_reference_info: false
                                },
                                column_name: objColumn.column_name,
                                node: $('<div class="form-group offcanvas-body-layer-detail-row' + (hiddenCol ? ' hidden' : '') + ((readOnly !== 'readonly') ? ' write' : '') + '">'
                                    + '<label for="prop_' + objColumn.column_name + '">' + objColumn.pretty_name + '</label>'
                                    + '<a target="_blank" href="' + value + '" style="color:blue;">' + objColumn.description + '</a>' +
                                    + '</div>'),
                                position: i
                            };
                            break;
                        case "xsd:bool":
                            hashNodeElement[objColumn.column_name] = {
                                reference_info: {
                                    has_reference_info: false
                                },
                                column_name: objColumn.column_name,
                                node: $('<div class="form-group offcanvas-body-layer-detail-row' + (hiddenCol ? ' hidden' : '') + ((readOnly !== 'readonly') ? ' write' : '') + '">'
                                    + '<input name="' + objColumn.column_name + '" class="feature-field filled-in ' + objColumn.column_type + '" data-name="' + objColumn.column_name + '" type="' + type + '" id="prop_' + objColumn.column_name + '" value="' + value + '" ' + (value ? 'checked':'') +  ' ' + ((readOnly == 'readonly') ? ' disabled' : '') + '/>'
                                    + '<label for="prop_' + objColumn.column_name + '" class="form-label">' + objColumn.pretty_name + '</label>'
                                    + '</div>'),
                                position: i
                            };
                            break;
                        default:
                            hashNodeElement[objColumn.column_name] = {
                                reference_info: {
                                    has_reference_info: false
                                },
                                column_name: objColumn.column_name,
                                node: $('<div class="form-group offcanvas-body-layer-detail-row' + (hiddenCol ? ' hidden' : '') + ((readOnly !== 'readonly') ? ' write' : '') + '">'
                                    + '<label for="prop_' + objColumn.column_name + '">' + objColumn.pretty_name + '</label>'
                                    + '<input name="' + objColumn.column_name + '" class="feature-field form-control ' + objColumn.column_type + '" data-name="' + objColumn.column_name + '" type="' + type + '" id="prop_' + objColumn.column_name + '" value="' + value + '" ' + readOnly + '/>'
                                    + '</div>'),
                                position: i
                            };
                    }
                }
            }
        }

        // -- For simplified view -----------------------------------------------------------------
        if (layerInfo.simplified_form) {
            $('#id-offcanvas-body-layer-detail-image-simplify').show(); // Show image viewer
            $('[target-id="id-offcanvas-body-layer-detail-field"]').hide(); // Hide close/open field
            $('#id-offcanvas-body-layer-detail-field').show(); // Show field information;
            $('.hide-on-creation').hide(); // Hide attachment file

            const swipper = new Swiper('.swiper', {
                //slidesPerView: 3,
                //spaceBetween: 10,
                // configure Swiper to use modules
                modules: [Navigation, Pagination],

                // If we need pagination
                pagination: {
                    el: '.swiper-pagination',
                },
                navigation: {
                    nextEl: '.swiper-button-next',
                    prevEl: '.swiper-button-prev',
                },
                loop: true,
            });
        }
        else {
            $('#id-offcanvas-body-layer-detail-image-simplify').hide(); // Hide image viewer
            $('[target-id="id-offcanvas-body-layer-detail-field"]').show(); // Show close/open field
            $('#id-offcanvas-body-layer-detail-field').hide(); // Hide field information;
            $('.hide-on-creation').show(); // Show attachment file
        }

        // -- Layout ------------------------------------------------------------------------------

        // Get layer from layout
        var layoutLayer = null;
        var layoutLayerObj = myMapSgs._utility.GetPropertyInfoInConfigArray(myMapSgs._settings.configurationInfo.propertyInfo, "LAYER_FORM", "LAYOUT_JSON", layerInfo.layerName);
        if (layoutLayerObj && layoutLayerObj.value != "") {
            layoutLayer = JSON.parse(layoutLayerObj.value);
        }

        // Build form with layout
        if (layoutLayer && layoutLayer.layer_name == layerInfo.layerName) {
            // Change with of the offcanvas
            if (layoutLayer.class_with_offcanvas) {
                $('#id-offcanvas-layer-detail').toggleClass("width-9 " + layoutLayer.class_with_offcanvas);
            }

            // For each tab
            layoutLayer.tab_info.forEach(tabInfo => {
                var idTab = "id-offcanvas-body-layer-detail-field-" + tabInfo.tab_cod;
                $('#id-form-edit-layer-detail-field').append($('<div class="offcanvas-layer-detail-tab"><div target-id="' + idTab + '" class="offcanvas-collapse" style="margin: 10px;"><i class= "fa fa-chevron-down option-title-go-right-open"></i><label>' + tabInfo.tab_title + '</label></div>' +
                    '<div id="' + idTab + '" class="offcanvas-block" style="display: none;margin: 10px;"></div></div>'));

                // Build tab content
                tabInfo.tab_content.forEach(tabContentInfo => {
                    switch (tabContentInfo.type) {
                        case "sub_tab":
                            // Sub tab title
                            var classCollapse = (tabContentInfo.sub_tab_collapse) ? "open" : "close";
                            var idSubTab = idTab + "-" + tabContentInfo.sub_tab_cod;
                            $('#' + idTab).append($('<div id="' + idSubTab + '" style="margin-bottom: 25px;"><div class="sub-tab" target-id="' + idSubTab + '"><label>' + tabContentInfo.sub_tab_title + '</label></div><div class="sub-tab-content ' + classCollapse + '"></div></div>'));

                            // Hide sub tab if the case
                            if (!tabContentInfo.sub_tab_collapse) {
                                $('#' + idSubTab + ' div.sub-tab-content').hide();
                                $('#' + idSubTab + ' div.sub-tab').find("label").addClass("close");
                            }

                            // Add style to sub tab content
                            if (tabContentInfo.sub_tab_style_list) {
                                tabContentInfo.sub_tab_style_list.forEach(style => {
                                    $('#' + idSubTab + style.to_subclass).css(style.property, style.value);
                                });
                            }

                            // Create event to close/open sub tab
                            $('#' + idSubTab + ' div.sub-tab').off('click').on('click', function (e) {
                                e.preventDefault();
                                var targetId = $(this).attr("target-id");

                                if ($('#' + targetId + ' div.sub-tab-content').hasClass("open")) {
                                    $('#' + targetId + ' div.sub-tab-content').hide();
                                    $('#' + targetId + ' div.sub-tab-content').removeClass("open");
                                    $(this).find("label").addClass("close");
                                }
                                else {
                                    $('#' + targetId + ' div.sub-tab-content').show();
                                    $('#' + targetId + ' div.sub-tab-content').addClass("open");
                                    $('#' + targetId + ' div.sub-tab-content').removeClass("close");
                                    $(this).find("label").removeClass("close");
                                }
                            });

                            // Columns sub tab content
                            myMapSgs._AddColumnInColumnZone('#' + idSubTab + ' .sub-tab-content', tabContentInfo.sub_tab_type, tabContentInfo.sub_tab_content, hashNodeElement);
                            break;
                        case "no-sub-tab":
                            // Zone column
                            var idColumnZone = idTab + "-" + tabContentInfo.cod_zone;
                            $('#' + idTab).append($('<div id="' + idColumnZone + '" class="sub-tab-content open" style="margin-bottom: 25px;"></div>'));

                            // Add style to sub tab content
                            if (tabContentInfo.style_list) {
                                tabContentInfo.style_list.forEach(style => {
                                    $('#' + idColumnZone).css(style.property, style.value);
                                });
                            }

                            // Columns zone content
                            myMapSgs._AddColumnInColumnZone('#' + idColumnZone, tabContentInfo.column_type_layout, tabContentInfo.content, hashNodeElement);
                            break;
                        default:
                        // do nothing
                    }
                });
            });
        }
        else {
            // No layout
            var arrayNodeElement = Object.keys(hashNodeElement).map((key) => hashNodeElement[key]).sort((a, b) => a.position - b.position);
            for (var p = 0; p < arrayNodeElement.length; p++) {
                var nodeElementInfo = arrayNodeElement[p];

                $('#id-form-edit-layer-detail-field').append(nodeElementInfo.node);

                // Fill reference info
                if (nodeElementInfo && nodeElementInfo.reference_info && nodeElementInfo.reference_info.has_reference_info) {
                    myMapSgs._AddRefenceInfoToComboColumn(nodeElementInfo.column_name, nodeElementInfo.reference_info);
                }
            }
        }

        // -- Add new option ----------------------------------------------------------------------

        // -- Add Citizen report --
        if (mapSettings.operation_visible.CitizenReport) {
            if (featureInfo.mode == "create") {
                $('#id-offcanvas-body-layer-detail-citizen-zone').hide();
            }
            else {
                // Get citizen report layer info
                var layerInfoCitizenReport = myMapSgs._citizenReport._arrayLayerInfo.find(c => c.layer_name == layerInfo.layerName)

                // Check if layer if on citizen report
                if (layerInfoCitizenReport) {
                    $('#id-offcanvas-body-layer-detail-citizen-zone').show()

                    // Init citizen report information
                    myMapSgs._citizenReport.BuildCitizenReportEntity(layerInfoCitizenReport);
                }
            }
        }

        // -- Add Technician report --
        if (mapSettings.operation_visible.TechnicianReport) {
            if (featureInfo.mode == "create") {
                $('#id-offcanvas-body-layer-detail-technician-report-zone').hide();
            }
            else {
                // Get technician report layer info
                var layerInfoTechnicianReport = myMapSgs._technicianReport._arrayLayerInfo.find(c => c.layer_name == layerInfo.layerName)

                // Check if layer if on technician report
                if (layerInfoTechnicianReport) {
                    $('#id-offcanvas-body-layer-detail-technician-report-zone').show()

                    var idEntity = featureInfo.feature.getProperties()[layerInfoTechnicianReport.id_column_name];

                    // Init technician report information
                    myMapSgs._technicianReport.BuildTechnicianReportEntity(idEntity, layerInfoTechnicianReport.layer_name);
                }
            }
        }

        // -- Add Manager traffic sign tool --
        if (mapSettings.operation_visible.ManagerTrafficSignTool) {
            // Add all sign of prumo
            var layerPrumoNameObj = myMapSgs._utility.GetPropertyInfoInConfigArray(myMapSgs._settings.configurationInfo.propertyInfo, "TRAFFIC_SIGNAL_CONFIG", "LAYER_TRAFFIC_SIGN", "PRUMO_LAYER_NAME");
            if (layerPrumoNameObj && layerPrumoNameObj.value && layerInfo.layerName == layerPrumoNameObj.value) {
                if (featureInfo.mode !== 'create') {
                    // Get all sign of prumo
                    myMapSgs._managerTrafficSignTool.GetAllSignPrumo(featureInfo.feature);
                }
            }

            // Save featureInfo
            myMapSgs._managerTrafficSignTool._featureInfo = featureInfo;
        };

        // -- Event -------------------------------------------------------------------------------

        // Collapse/open info in element detail
        $('.offcanvas-collapse').off('click').on('click', function () {
            var idNodeToCollapse = this.getAttribute('target-id');
            $(this).find('i').toggleClass('fa-chevron-down fa-chevron-up');
            // Close all other info

            $('#' + idNodeToCollapse).toggle('ol-hidden');
        });

        //Event to change all SubType when user select
        $('#id-offcanvas-body-layer-detail-field select').on('change.bs.select', function (e) {
            if (myMapSgs._hashColumnsReferencesToFill[this.id.split('_')[1]]) {

                var RefColumn = myMapSgs._hashColumnsReferencesToFill[this.id.split('_')[1]].layer_relation

                if (RefColumn) {

                    RefColumn = JSON.parse(RefColumn);

                    var DataFilter = [];

                    for (var i = 0; i < myMapSgs._hashColumnsReferences[RefColumn.layer_source_relation].length; i++) {
                        if (myMapSgs._hashColumnsReferences[RefColumn.layer_source_relation][i][RefColumn.layer_column_relation] == this.value) {
                            DataFilter.push(myMapSgs._hashColumnsReferences[RefColumn.layer_source_relation][i])
                        }
                    }

                    myMapSgs._utility.FillSelect('prop_' + RefColumn.layer_source_relation, DataFilter, RefColumn.layer_column_to_relation, RefColumn.layer_column_to_relation);
                }
            }
        });

        // Add values and behaviours to combo boxes
        $('select.feature-field').each(function () {
            var comboBox = $(this);
            var destinationText = comboBox.data('destination-field');
            comboBox.on('change', function () {
                $('#' + destinationText).val($(this).val()); // Update respective id field for db update
            });
        });

        // -- Fill image info ---------------------------------------------------------------------

        // Add Sign qrcode info
        if (mapSettings.operation_visible.ManagerTrafficSignTool) {
            // Add qrcode
            if (layerInfo.layerName == myMapSgs._managerTrafficSignTool.signInfo.layerName && featureInfo.mode != "create") {
                myMapSgs._managerTrafficSignTool.GetQrcodeById(featureInfo.id, "");
            }
        };

        // -- File --------------------------------------------------------------------------------

        // Init Upload for entity
        if (myMapSgs._uploadAttachtment && featureInfo.mode !== 'create' && !layerInfo.simplified_form) {
            myMapSgs._uploadAttachtment.LoadAttachment(featureInfo.id, layerName, 'id-offcanvas-body-layer-detail-attachment-zone', 'id-offcanvas-body-layer-detail-attachment-form', 'id-offcanvas-body-layer-detail-attachment-add', 'offcanvas-body-layer-detail-attachment-info-td', 'id-offcanvas-body-layer-detail-attachment-spinner');
            $('.hide-on-creation').show();
        }
        else {
            $('.hide-on-creation').hide();
        }

        // Stop wait
        myMapSgs._utility.ShowWait('id-offcanvas-layer-detail-spinner', false);
    };

    /**
     * Add column in column zone of layout
     * @param {any} nodeQuery, node query where the column wiil be append
     * @param {any} typeColumnLayout, column type layout
     * @param {any} contentInfo, content column information
     * @param {any} hashNodeElement, layout definition
     */
    this._AddColumnInColumnZone = function (nodeQuery, typeColumnLayout, contentInfo, hashNodeElement) {
        // Sub tab content
        switch (typeColumnLayout) {
            case "column":
                contentInfo.forEach(columnInfo => {
                    var nodeElementInfo = hashNodeElement[columnInfo.column_name];

                    // Add node
                    if (nodeElementInfo && nodeElementInfo.node) {
                        $(nodeQuery).append(nodeElementInfo.node);

                        // Fill reference info
                        if (nodeElementInfo.reference_info.has_reference_info) {
                            myMapSgs._AddRefenceInfoToComboColumn(columnInfo.column_name, nodeElementInfo.reference_info);
                        }
                    }
                });
                break;
            case "multi-column":
                contentInfo.forEach(columnInfo => {
                    var nodeElementInfo = hashNodeElement[columnInfo.column_name];

                    if (nodeElementInfo && nodeElementInfo.node) {
                        // Add class name
                        if (columnInfo.class_name_list) {
                            columnInfo.class_name_list.forEach(className => {
                                nodeElementInfo.node.addClass(className);
                            });
                        }

                        // Add node
                        $(nodeQuery).append(nodeElementInfo.node);

                        // Fill reference info
                        if (nodeElementInfo.reference_info.has_reference_info) {
                            myMapSgs._AddRefenceInfoToComboColumn(columnInfo.column_name, nodeElementInfo.reference_info);
                        }
                    }
                });
                break;
            default:
            // do nothing
        }
    }

    /**
     * Add reference information to combo column
     * @param {any} columnName, name of the column
     * @param {any} referenceInfo, reference column information
     */
    this._AddRefenceInfoToComboColumn = function (columnName, referenceInfo) {
        // Fill reference info
        if (referenceInfo.has_reference_info) {
            var listReference = referenceInfo.list_reference;
            if (listReference == null) {
                listReference = myMapSgs._hashColumnsReferences[columnName];
            }
            myMapSgs._utility.FillSelect(referenceInfo.id_column, listReference, referenceInfo.description_column, referenceInfo.key_column);

            // Select default value
            if (referenceInfo.default_value != null && referenceInfo.default_value != "") {
                $('#' + referenceInfo.id_column).selectpicker('val', referenceInfo.default_value);
            }
        }
    }

    /**
     * Build detail info field
     * @param {any} featureInfo
     * @param {any} suffix
     */
    this.DetailElementField = function (featureInfo, suffix) {
        var idElementField = 'id-offcanvas-body-layer-detail-field' + suffix;
        var idFormField = 'id-form-edit-layer-detail-field' + suffix;

        // Get layer info
        var layerInfo = myMapSgs._settings.treeMap.dict_layer_info[featureInfo.idLayer].layer_info;

        // Clean info field
        $('#' + idElementField + ' div').remove();
        if ($('#' + idFormField).length === 0) {
            $('#' + idElementField).append($('<form id="' + idFormField + '"></form>'));
        }

        var gpName = myMapSgs._settings._mapSettings.search_toponymy.workspaceSearchToponymy;

        // Define according to mode
        var readOnly = "readonly";
        var hiddenCol = false;
        switch (featureInfo.mode) {
            case 'update':
                readOnly = "";
                break;
            case 'create':
                readOnly = "";
                break;
            default: // read
        }

        // Only for traffic sign
        var signInfo = "";
        var layerSignName;
        if (mapSettings.operation_visible.ManagerTrafficSignTool) {
            var signInfoObj = myMapSgs._utility.GetPropertyInfoInConfigArray(myMapSgs._settings.configurationInfo.propertyInfo, "TRAFFIC_SIGNAL_CONFIG", "LAYER_TRAFFIC_SIGN", "SIGN_INFO");
            if (signInfoObj && signInfoObj.value) {
                signInfo = JSON.parse(signInfoObj.value);
            }

            // Get layer name sign
            layerSignName = myMapSgs._utility.GetPropertyInfoInConfigArray(myMapSgs._settings.configurationInfo.propertyInfo, "TRAFFIC_SIGNAL_CONFIG", "LAYER_TRAFFIC_SIGN", "SIGN_LAYER_NAME").value;
        }

        // Layer info
        var layerObj = myMapSgs.layerTree.layerInfo.dict_layer_info[featureInfo.idLayer];
        var layerName = layerObj.layer_info.layerName;

        // Build Info field
        var arrayColumn = layerObj.list_column.sort((a, b) => (a.column_pos > b.column_pos) ? 1 : -1);

        // -- For all column ----------------------------------------------------------------------
        for (var i = 0; i < arrayColumn.length; i++) {
            var objColumn = arrayColumn[i];
            var type = "text";
            var idElementColumn = "id-field-" + objColumn.column_name + suffix;

            // If traffic sign tool then user BuildDetailElement in this tool for this column
            if (mapSettings.operation_visible.TrafficSignTool) {
                if (myMapSgs._trafficSignTool.BuildDetailElement(objColumn, featureInfo))
                    continue;
            };

            // Show only if field marked as visible
            if (!objColumn.visible) {
                if (mapSettings.operation_visible.ManagerTrafficSignTool && layerSignName == layerName) {
                    // Add id prumo info to sign
                    if (featureInfo.mode == "create" && layerSignName == layerName) {
                        var columnNameIdPrumo = myMapSgs._utility.GetPropertyInfoInConfigArray(myMapSgs._settings.configurationInfo.propertyInfo, "TRAFFIC_SIGNAL_CONFIG", "LAYER_TRAFFIC_SIGN", "PRUMO_ID_COLUMN_NAME").value;

                        if (columnNameIdPrumo == objColumn.column_name) {
                            $('#' + idFormField).append($(
                                '<div class="form-group offcanvas-body-layer-detail-row hidden">'
                                + '<input class="feature-field form-control ' + objColumn.column_type + '" name="' + objColumn.column_name + '" data-name="' + prefix + objColumn.column_name + '" type="hidden" id="' + idElementColumn + '" value="' + featureInfo.idPrumo + '"/>'
                                + '</div > '
                            ));
                        }
                    }

                    // Show alarm if exists
                    var valueJsonAlarm = featureInfo.feature.getProperties()[objColumn.column_name];
                    if (featureInfo.mode != "create" && signInfo.column_name_json_alarm == objColumn.column_name && valueJsonAlarm != undefined && valueJsonAlarm != "") {
                        myMapSgs._managerTrafficSignTool.BuildAlarmInfo(valueJsonAlarm, suffix);
                    }
                }
                continue;
            }

            // Mark read only
            if (objColumn.editable && (featureInfo.mode == 'update' || featureInfo.mode == 'create')) {
                // Only for sigredes use
                readOnly = '';
                if (featureInfo.mode == 'update' && (objColumn.column_name == 'zone' || objColumn.column_name == 'id_zone'))
                    readOnly = 'readonly'; // Cannot update zone in model (Update DB procedures to change this)
            }
            else
                readOnly = 'readonly';

            // -- Create column - If column not geometry and not identifier (exception ID_REF) --
            //if (
            //    (
            //        (
            //            objColumn.column_name !== 'geom' &&
            //            objColumn.column_name !== 'GEOMETRY ' &&
            //            (objColumn.column_name.substr(0, 2).toUpperCase() !== 'ID' || objColumn.column_name.substr(0, 6).toUpperCase() === 'ID_REF')
            //        )
            //    ) ||
            //    (
            //        objColumn.column_name !== 'geom' &&
            //        objColumn.column_name !== 'GEOMETRY ' &&
            //        objColumn.column_name.substr(0, 2).toUpperCase() !== 'ID' &&
            //        objColumn.visible === true
            //    )
            //) {
            let isIdCol = objColumn.column_name.substr(0, 2).toUpperCase() === 'ID';
            let isRefCol = objColumn.column_name.substr(0, 6).toUpperCase() === 'ID_REF' || (gpName == 'GP_PONTA_DELGADA' && objColumn.column_name == 'TIPO'); // TODO: Add to layer_column_metadata, field that indicate if column is ref column
            let value = featureInfo.feature.getProperties()[objColumn.column_name];

            // If manager traffic sign tool then user BuildDetailElement in this tool for this column
            var visibleOnCreate = false;
            if (mapSettings.operation_visible.ManagerTrafficSignTool) {
                switch (objColumn.column_name) {
                    case "id_prumo":
                        visibleOnCreate = true;
                        readOnly = 'readonly';
                        if (value === null || value === undefined) {
                            value = myMapSgs._featureInfoFocus.feature.getId().split('.')[1];
                        }
                        break;
                    //case "dicofre":
                    //    myMapSgs._managerTrafficSignTool.BuildFreguesiaField(layerInfo.layerName, objColumn, featureInfo, suffix, value);
                    //    continue;
                    //    break;
                    case "id_troco":
                        myMapSgs._managerTrafficSignTool.BuildTrocoField(layerInfo.layerName, objColumn, featureInfo, suffix, value);
                        continue;
                        break;
                    case "id_arruamento":
                        myMapSgs._managerTrafficSignTool.BuildArruamentoField(layerInfo.layerName, objColumn, featureInfo, suffix, value);
                        continue;
                        break;
                    case "qrcode":
                        if (featureInfo.mode !== 'create')
                            myMapSgs._managerTrafficSignTool.GetQrcodeById(value, suffix);
                        break;
                    case "installed":
                        if (featureInfo.mode == 'create' && layerInfo.layerName == myMapSgs._managerTrafficSignTool.signInfo.layerName) {
                            value = true;
                            readOnly = 'readonly';
                        }
                        break;
                    case "cod_sinal":
                        myMapSgs._managerTrafficSignTool.BuildTypeSignZone(layerInfo.layerName, objColumn, featureInfo, suffix, value);
                        continue;
                        break;
                    default:
                    // do nothing
                }
            };

            // Show only if field marked as editable for creations
            if (!objColumn.editable && !visibleOnCreate && featureInfo.mode == 'create') continue;

            // Hide column - TODO - Do not use workspace
            if (gpName == 'GP_PONTA_DELGADA' && objColumn.column_name == 'DATA') {
                hiddenCol = true; // Hide column DATA for PONTA DELGADA creations
                value = myMapSgs._utility.getNewDateForServer();
            }
            else
                hiddenCol = false;

            // Set value if null
            if (value === null || value === undefined)
                value = '';

            // Act according column type
            switch (objColumn.column_type) {
                case "xsd:date-time":
                    value = myMapSgs._utility.TransformDateServerInDateII(value);
                    type = "date";
                    break;
                case "xsd:date":
                    var valueDate = new Date(value);
                    value = valueDate.getFullYear() + "-" + (valueDate.getMonth() + 1).toString().padStart(2, "0") + "-" + valueDate.getDate().toString().padStart(2, "0");
                    type = "date";
                    break;
                case "xsd:number":
                case "xsd:int":
                case "xsd:double":
                case "xsd:bigint":
                    type = "number";
                    break;
                case "xsd:bool":
                    type = "checkbox";
                    break;
                default:
                // do nothing
            }

            // Verify if column as ref table
            var layerRef = "";
            var typeOfLayerRef = "";
            if (objColumn.has_ref_table) // -- New table reference method --
            {
                isRefCol = true;
                layerRef = myMapSgs._settings.columnTableReferenceData.table_reference_data[objColumn.id_rel_layer_column_ref_metadata];
                typeOfLayerRef = "array";
            }
            else // -- Old table reference method --
            {
                // Get reference for combo box if column is id
                var layer_references = myMapSgs._layerReferences[layerName];
                if (layer_references && (layer_references['id_' + objColumn.column_name] || layer_references[objColumn.column_name])) {
                    layerRef = !isIdCol ? layer_references['id_' + objColumn.column_name] : layer_references[objColumn.column_name];
                }

                // Get layer 
                var prefix = "id_";
                if (isRefCol) {
                    if (myMapSgs.typeList.length > 0) {
                        layerRef = myMapSgs.typeList;
                        typeOfLayerRef = "list";
                    }
                    else {
                        layerRef = layer_references[objColumn.column_name];
                        typeOfLayerRef = "hash";
                    }
                    prefix = "";
                }
            }

            // Build combo box if reference data found
            if ((featureInfo.mode != 'read' || isRefCol) && typeof layerRef != 'undefined' && layerRef != '') {
                // Put in combo array
                var comboArray = [];
                switch (typeOfLayerRef) {
                    case "array":
                        comboArray = layerRef;
                        break;
                    case "list":
                        for (var k = 0; k < layerRef.length; k++) comboArray.push({ 'id': layerRef[k], 'value': layerRef[k] });
                        break;
                    case "hash":
                        comboArray = Object.keys(layerRef).map(function (key) {
                            return { 'id': Number(key), 'value': Object.keys(layerRef[key])[0] };
                        });
                        break;
                    default:
                    // do nothing
                }

                // Get value default for combo
                var defValue = "";
                if (value != "") {
                    if (isRefCol) {
                        defValue = comboArray.filter(function (ob) { return ob.id == value; })[0]
                        if (featureInfo.mode == 'read')
                            defValue = defValue.value;
                        else
                            defValue = defValue.id;
                    }
                    else
                        defValue = comboArray.filter(function (ob) { return ob.value == value; })[0].id;
                }

                // In read mode, add text box and not combo box
                if (featureInfo.mode == 'read' && isRefCol) {
                    $('#' + idFormField).append($(
                        '<div class="form-group offcanvas-body-layer-detail-row' + (hiddenCol ? ' hidden' : '') + '">'
                        + '<label for="' + idElementColumn + '">' + objColumn.pretty_name + '</label>'
                        + '<input class="feature-field form-control ' + objColumn.column_type + '" data-name="' + prefix + objColumn.column_name + '" type="' + type + '" id="' + idElementColumn + '" value="' + defValue + '" ' + readOnly + '/>'
                        + '</div > '
                    ));
                }
                else {
                    var disabled = readOnly == 'readonly' ? 'disabled' : '';

                    // Only for traffic sign
                    if (mapSettings.operation_visible.ManagerTrafficSignTool) {
                        // if column is type sign
                        if (signInfo.column_name_type_sign == objColumn.column_name && layerSignName == layerName) {

                            // Add select box with associated entity possible values
                            var idToAppendSelect2 = idElementColumn + "_append";

                            $('#' + idFormField).append($(
                                '<div id="' + idToAppendSelect2 + '" class="form-group offcanvas-body-layer-detail-row manager-traffic-sign-select2-type-sign' + (hiddenCol ? ' hidden' : '') + ((readOnly !== 'readonly') ? ' write' : '') + '">'
                                + '<label id="' + idToAppendSelect2 + '" for="' + idElementColumn + '">' + objColumn.pretty_name + '</label>'
                                + '</div > '
                            ));

                            // Add combo box type sign
                            myMapSgs._managerTrafficSignTool.BuildTypeSignSelection(idToAppendSelect2, idElementColumn, objColumn.column_name, "REFRESH_TITLE_SIGN_IN_PRUMO", defValue, "", "", ' suffix="' + suffix + '" data-name= "' + objColumn.column_name + '" data-destination-field="prop_' + prefix + objColumn.column_name + '" ' + disabled);
                            continue;
                        }
                    }

                    // Add select box with associated entity possible values
                    $('#' + idFormField).append($(
                        '<div class="form-group offcanvas-body-layer-detail-row' + (hiddenCol ? ' hidden' : '') + ((readOnly !== 'readonly') ? ' write' : '') + '">'
                        + '<label for="' + idElementColumn + '">' + objColumn.pretty_name + '</label>'
                        + '<select class="feature-field form-control ' + objColumn.column_type + '" suffix="' + suffix + '" id="' + idElementColumn + '" name= "' + objColumn.column_name + '" data-name= "' + objColumn.column_name + '" data-destination-field="prop_' + prefix + objColumn.column_name + '" ' + disabled + '><option></option></select>'
                        + '</div > '
                    ));

                    myMapSgs._utility.FillSelect(idElementColumn, comboArray, 'value', 'id');

                    $('#' + idElementColumn).selectpicker('val', defValue);
                }
            }
            else {
                // Edition on mobile
                if (_clientGeoportal.indexOf("DOUROGAS") >= 0 && myMapSgs._utility.mobilecheck() && featureInfo.mode != "create") {
                    if (objColumn.edit_mobile == true)
                        readOnly = "";
                    else
                        readOnly = 'readonly';
                }

                // Reference automatics for this column
                if (myMapSgs._hashColumnsReferences[objColumn.column_name]) {
                    // One value only
                    if (myMapSgs._hashColumnsReferences[objColumn.column_name].length == 1 || $.isNumeric(myMapSgs._hashColumnsReferences[objColumn.column_name])) {
                        if ($.isNumeric(myMapSgs._hashColumnsReferences[objColumn.column_name])) {
                            $('#' + idFormField).append($(
                                '<div class="form-group offcanvas-body-layer-detail-row' + (hiddenCol ? ' hidden' : '') + '">'
                                + '<label for="' + idElementColumn + '">' + objColumn.pretty_name + '</label>'
                                + '<input name="' + objColumn.column_name + '" class=" feature-field form-control ' + objColumn.column_type + '" data-name="' + objColumn.column_name + '" type="' + type + '" id="' + idElementColumn + '" value="' + myMapSgs._hashColumnsReferences[objColumn.column_name] + '" readOnly/>'
                                + '</div > '
                            ));
                        }
                        else {
                            var KeyLayerDesc = myMapSgs._hashColumnsReferencesToFill[objColumn.column_name].layer_source_column_name_key;

                            $('#' + idFormField).append($(
                                '<div class="form-group offcanvas-body-layer-detail-row' + (hiddenCol ? ' hidden' : '') + '">'
                                + '<label for="' + idElementColumn + '">' + objColumn.pretty_name + '</label>'
                                + '<input name="' + objColumn.column_name + '" class=" feature-field form-control ' + objColumn.column_type + '" data-name="' + objColumn.column_name + '" type="' + type + '" id="' + idElementColumn + '" value="' + myMapSgs._hashColumnsReferences[objColumn.column_name][0][KeyLayerDesc] + '" readOnly/>'
                                + '</div > '
                            ));
                        }
                    }

                    // Combobox for multiple value
                    if (myMapSgs._hashColumnsReferences[objColumn.column_name].length > 1) {
                        $('#' + idFormField).append($(
                            '<div class="form-group offcanvas-body-layer-detail-row' + (hiddenCol ? ' hidden' : '') + ((readOnly !== 'readonly') ? ' write' : '') + '">'
                            + '<label for="' + idElementColumn + '">' + objColumn.pretty_name + '</label>'
                            + ' <select id="' + idElementColumn + '" name="' + objColumn.column_name + '" class="form-control"><option></option></select>' +
                            + '</div>'
                        ));

                        var KeyLayerDesc = myMapSgs._hashColumnsReferencesToFill[objColumn.column_name].layer_source_column_name_key;

                        myMapSgs._utility.FillSelect(idElementColumn, myMapSgs._hashColumnsReferences[objColumn.column_name], KeyLayerDesc, KeyLayerDesc);
                    }
                }
                else // All other situation
                {
                    switch (objColumn.column_type) {
                        case "xsd:text":
                            $('#' + idFormField).append($(
                                '<div class="form-group offcanvas-body-layer-detail-row' + (hiddenCol ? ' hidden' : '') + ((readOnly !== 'readonly') ? ' write' : '') + '">'
                                + '<label for="' + idElementColumn + '">' + objColumn.pretty_name + '</label>'
                                + '<textarea  rows="2" name="' + objColumn.column_name + '" class="feature-field form-control ' + objColumn.column_type + '" data-name="' + objColumn.column_name + '" type="' + type + '" id="' + idElementColumn + '"' + readOnly + '>' + value + '</textarea>'
                                + '</div > '
                            ));
                            break;
                        case "xsd:link":
                            $('#' + idFormField).append($(
                                '<div class="form-group offcanvas-body-layer-detail-row' + (hiddenCol ? ' hidden' : '') + ((readOnly !== 'readonly') ? ' write' : '') + '">'
                                + '<label for="' + idElementColumn + '">' + objColumn.pretty_name + '</label>'
                                + '<a target="_blank" href="' + value + '" style="color:blue;">' + objColumn.description + '</a>' +
                                + '</div > '
                            ));
                            break;
                        case "xsd:bool":
                            $('#' + idFormField).append($(
                                '<div class="form-group offcanvas-body-layer-detail-row' + (hiddenCol ? ' hidden' : '') + ((readOnly !== 'readonly') ? ' write' : '') + '">'
                                + '<input name="' + objColumn.column_name + '" class="feature-field filled-in ' + objColumn.column_type + '" data-name="' + objColumn.column_name + '" type="' + type + '" id="' + idElementColumn + '" value="' + value + '" ' + (value?'checked':'') +  ' ' + ((readOnly == 'readonly') ? ' disabled' : '') + '/>'
                                + '<label for="' + idElementColumn + '" class="form-label">' + objColumn.pretty_name + '</label>'
                                + '</div > '
                            ));
                            break;
                        default:
                            $('#' + idFormField).append($(
                                '<div class="form-group offcanvas-body-layer-detail-row' + (hiddenCol ? ' hidden' : '') + ((readOnly !== 'readonly') ? ' write' : '') + '">'
                                + '<label for="' + idElementColumn + '">' + objColumn.pretty_name + '</label>'
                                + '<input name="' + objColumn.column_name + '" class="feature-field form-control ' + objColumn.column_type + '" data-name="' + objColumn.column_name + '" type="' + type + '" id="' + idElementColumn + '" value="' + value + '" ' + readOnly + '/>'
                                + '</div > '
                            ));
                    }
                }
            }
            //}
        }

        // -- Fill image info ---------------------------------------------------------------------

        // Sign
        if (mapSettings.operation_visible.ManagerTrafficSignTool) {
            var layerSignNameObj = myMapSgs._utility.GetPropertyInfoInConfigArray(myMapSgs._settings.configurationInfo.propertyInfo, "TRAFFIC_SIGNAL_CONFIG", "LAYER_TRAFFIC_SIGN", "SIGN_LAYER_NAME");

            // Add qrcode
            if (layerSignNameObj && layerSignNameObj.value && layerInfo.layerName == layerSignNameObj.value && featureInfo.mode != "create") {
                myMapSgs._managerTrafficSignTool.GetQrcodeById(featureInfo.id, suffix);
            }

            // Add attachment
            if (myMapSgs._uploadAttachtment && featureInfo.mode != "create") {
                myMapSgs._uploadAttachtment.LoadAttachment(featureInfo.id, layerName, 'id-offcanvas-body-layer-detail-attachment-zone' + suffix, 'id-offcanvas-body-layer-detail-attachment-form' + suffix, 'id-offcanvas-body-layer-detail-attachment-add' + suffix, 'offcanvas-body-layer-detail-attachment-info-td' + suffix, 'id-offcanvas-body-layer-detail-attachment-spinner' + suffix);
                $('.hide-on-creation').show();
            }
        };
    }

    /**
     * Search toponymy
     */
    this.SearchToponymy = function () {

        // Search place toponymy
        var placeValue = $('#id-search-toponymy-place').val();
        if (myMapSgs._hasSearchPlaceToponymyConfigInfo) { // With configuration
            if (placeValue != undefined && placeValue != null && placeValue != "") {
                var placeCql = myMapSgs._searchPlaceToponymyConfigInfo.idColumn + " = " + $('#id-search-toponymy-place').val();

                myMapSgs.SetFeaturesHighlightByCqlFilter(myMapSgs._searchPlaceToponymyConfigInfo.workspace, myMapSgs._searchPlaceToponymyConfigInfo.layerName, myMapSgs._searchPlaceToponymyConfigInfo.geoserver, true, placeCql, null, myMapSgs._searchPlaceToponymyConfigInfo.geomColumn, "Local não encontrado");

                return;
            }
        }
        else { // With no configuration
            if ($('#select2-id-search-toponymy-place-container').length > 0 && $('#select2-id-search-toponymy-place-container')[0].innerHTML != "Nenhum escolhido") {

                var freguesiaCql = "poi_name = '" + $('#select2-id-search-toponymy-place-container')[0].innerHTML + "'";

                var layerInfo = myMapSgs.layerTree.FindLayerInfo(_freguesiaLayer);

                myMapSgs.SetFeaturesHighlightByCqlFilter(layerInfo.workspace, 'named_plc', layerInfo.geoserver, true, freguesiaCql, null, _freguesiaLayerGeomColumn, "Local não encontrado");

                return;
            }
        }

        // Get Distrito
        var ddToSearch = $('#id-toponymy-search-select-distrito').val();

        // Get concelho
        var ddccToSearch = $('#id-toponymy-search-select-concelho').val();

        // Get freguesia
        var ddccffToSearch = $('#id-toponymy-search-select-freguesia').val();
        var idFreguesia = ($('#id-toponymy-search-select-freguesia option:selected').attr('value') === undefined) ? "" : $('#id-toponymy-search-select-freguesia option:selected').attr('value');

        // Get place
        var placeToSearch = $('#id-toponymy-search-place').val();
        var idPlaceToSearch = $('#id-toponymy-search-place-id').val();

        // Get nPolicia
        var nPolicia = $('#id-toponymy-search-npolicia').val();

        // -- By police Number --
        if (nPolicia != '' && nPolicia) {
            // Sql filter
            var nPoliceCql = _nPoliciaInfo.columnFilter + " == '" + $('#id-toponymy-search-npolicia').val() + "'" +
                ((idFreguesia === "") ? "" : " AND " + _nPoliciaInfo.columnIdFreguesia + " == '" + idFreguesia + "'") +
                ((idPlaceToSearch === "") ? "" : " AND " + _nPoliciaInfo.columnIdAddress + " == '" + idPlaceToSearch + "'");

            // Layer name
            var layerInfoPolicia = myMapSgs.layerTree.FindLayerInfo(_nPoliciaInfo.layerName);
            var nPoliciaWorkspace = "";
            var nPoliciaGeoserver = "";
            if (layerInfoPolicia) {
                nPoliciaWorkspace = layerInfoPolicia.workspace;
                nPoliciaGeoserver = layerInfoPolicia.geoserver;
            }
            else {
                nPoliciaWorkspace = _nPoliciaInfo.workspace;
                nPoliciaGeoserver = _nPoliciaInfo.geoserver;
            }

            myMapSgs.SetFeaturesHighlightByCqlFilter(nPoliciaWorkspace, _nPoliciaInfo.layerName, nPoliciaGeoserver, true, nPoliceCql, null, _nPoliciaInfo.geomColumn, "Número de polícia não encontrado");
        }
        // -- By place --
        //else if (placeToSearch != "") {
        //    myMapSgs.searchToponymyMap.CreateSearchToponymy(true);
        //}
        else {
            // search distrito
            if (
                (ddToSearch !== undefined && ddToSearch !== "") &&
                (ddccToSearch === undefined || ddccToSearch === "")
            ) {
                var distritoCql = myMapSgs.hashDistritoInfo.dd_column + " == '" + ddToSearch + "'";
                var layerInfo = myMapSgs.layerTree.FindLayerInfo(myMapSgs.hashDistritoInfo.layer_name);

                if (layerInfo)
                    myMapSgs.SetFeaturesHighlightByCqlFilter(layerInfo.workspace, layerInfo.layerName, layerInfo.geoserver, true, distritoCql, null, myMapSgs.hashDistritoInfo.geom_column, "Distrito não encontrada");
                else
                    toastr["warning"]("Distrito não encontrada");

                return;
            }

            // Search concelho
            if (
                (ddToSearch !== undefined && ddToSearch !== "") &&
                (ddccToSearch !== undefined && ddccToSearch !== "") &&
                (ddccffToSearch === undefined || ddccffToSearch === "")
            ) {
                var concelhoCql = myMapSgs.hashConcelhoInfo.ddcc_column + " == '" + ddccToSearch + "'";
                var layerInfo = myMapSgs.layerTree.FindLayerInfo(myMapSgs.hashConcelhoInfo.layer_name);

                if (layerInfo)
                    myMapSgs.SetFeaturesHighlightByCqlFilter(layerInfo.workspace, layerInfo.layerName, layerInfo.geoserver, true, concelhoCql, null, myMapSgs.hashConcelhoInfo.geom_column, "Concelho não encontrada");
                else
                    toastr["warning"]("Concelho não encontrada");

                return;
            }

            // Search freguesia
            if (idFreguesia !== "") {
                var freguesiaCql = _freguesiaToponymyColumnId + " == '" + idFreguesia + "'";
                var layerInfo = myMapSgs.layerTree.FindLayerInfo(_freguesiaLayer);

                if (layerInfo)
                    myMapSgs.SetFeaturesHighlightByCqlFilter(layerInfo.workspace, layerInfo.layerName, layerInfo.geoserver, true, freguesiaCql, null, _freguesiaLayerGeomColumn, "Freguesia não encontrada");
                else
                    toastr["warning"]("Freguesia não encontrada");
            }
        }
    }

    /**
     * Search toponymy
     */
    this.SearchSeccao = function () {

        if ($('#id-button-hide-seccao').hasClass('fa-eye-slash')) {

            $('#id-button-hide-seccao').removeClass('fa-eye-slash').addClass('fa-eye').prop('title', 'Desligar visualização')
        }

        //Disable button to hide feature highligth
        $('#id-button-hide-seccao').prop('disabled', true);

        if (ddccffToShowBase != "" && seccaocadastralToSearch != "") {

            // Set invisible last layer base
            var layer = null;
            var idLayerArray = 'base_' + ddccffToShowBase + '_' + seccaocadastralToSearch;
            layer = myMapSgs._utility.GetLayerById(myMapSgs.map, idLayerArray);

            layer.setVisible(false);

            myMapSgs.map.renderSync();

        }

        // Get freguesia
        ddccffToSearch = $('#id-SeccaoCadastralSearch option:selected').html();

        ddccffToShowBase = ddccffToSearch.toLowerCase();
        ddccffToShowBase = ddccffToShowBase.replaceAll(" ", "_");
        ddccffToShowBase = ddccffToShowBase.normalize("NFD").replace(/[\u0300-\u036f]/g, "")

        // Get place
        seccaocadastralToSearch = $('#id-seccaocadastral-number').val();

        // Get nº predio
        var npredioToSearch = $('#id-seccaocadastral-number-predio').val();

        var cqlFilter = "";

        // Search freguesia
        if (ddccffToSearch != "" && seccaocadastralToSearch != "" && npredioToSearch == "") {

            cqlFilter = _seccaoLayerSeccaoFilter + " == '" + seccaocadastralToSearch + "' AND " + _seccaoLayerfreguesiaFilter + " == '" + ddccffToSearch + "'";

            var layerInfo = myMapSgs.layerTree.FindLayerInfo(_seccaoLayer);

            if (layerInfo)
                myMapSgs.SetFeaturesHighlightByCqlFilter(layerInfo.workspace, layerInfo.layerName, layerInfo.geoserver, true, cqlFilter, null, _seccaoLayerGeomColumn, "Secção Cadastral não encontrada", true);
            else
                toastr["warning"]("Camada" + _seccaoLayer + " não encontrada");
        } else if (ddccffToSearch != "" && seccaocadastralToSearch != "" && npredioToSearch != "") {

            cqlFilter = _seccaoLayerSeccaoFilter + " == '" + seccaocadastralToSearch + "' AND " + _seccaoLayerfreguesiaFilter + " == '" + ddccffToSearch + "' AND " + _seccaoLayerNpredioFilter + " == '" + npredioToSearch + "'";

            var layerInfo = myMapSgs.layerTree.FindLayerInfo(_seccaoLayerNpredio);

            if (layerInfo)
                myMapSgs.SetFeaturesHighlightByCqlFilter(layerInfo.workspace, layerInfo.layerName, layerInfo.geoserver, true, cqlFilter, null, _seccaoLayerNpredioGeomColumn, "Matriz não encontrada", true);
            else
                toastr["warning"]("Camada" + _seccaoLayerNpredio + " não encontrada");
        }

        //Geoserver Base Layer
        var GeoServerBaseLayer = myMapSgs._utility.GetPropertyInfoInConfigArray(myMapSgs._settings.configurationInfo.propertyInfo, "BASE_LAYER", "LAYER_DEFINITION", "GEOSERVER");

        myMapSgs._layerbase._AddGeoserverWMSBaseLayerToMap(myMapSgs.map, GeoServerBaseLayer.value, workspace, ddccffToShowBase + '_' + seccaocadastralToSearch, '', '', 'base_' + ddccffToShowBase + '_' + seccaocadastralToSearch, myMapSgs._settings.scales[myMapSgs._settings.scales.length - 1], myMapSgs._settings.scales[0]);

        // Set invisible all layer base except selected one
        var layer = null;
        var idLayerArray = 'base_' + ddccffToShowBase + '_' + seccaocadastralToSearch;
        layer = myMapSgs._utility.GetLayerById(myMapSgs.map, idLayerArray);

        layer.setVisible(true);

        myMapSgs.map.renderSync();

    }

    /**
     * Search toponymy
     */
    this.SearchRegistosImoveis = function () {

        if ($('#id-registo-imoveis-inventario').val() === "") {

            return toastr["warning"]("Preencha o n.º de inventário");

        }

        var LayerJSON = myMapSgs._utility.GetPropertyInfoInConfigArray(myMapSgs._settings.configurationInfo.propertyInfo, "PATRIMONY", "SEARCH", "LAYER_JSON");

        var LayerParse = JSON.parse(LayerJSON.value).LAYER_JSON

        var getFeatureUrl = myMapSgs._settings.searchToponymy.geoserverSearchToponymy + "/wfs";

        var LayerFound = false;

        var countLength = 0;

        for (var i = 0; i < LayerParse.length; i++) {

            countLength = i + 1;

            if (!LayerFound) {

                // Call geoserver to get the feature of the layer
                var getFeature = $.ajax({
                    method: "GET",
                    async: false,
                    url: getFeatureUrl,
                    data: {
                        "service": 'wfs',
                        "version": '2.0.0',
                        "request": 'GetFeature',
                        "typeNames": LayerParse[i].layer,
                        "cql_filter": "INVENTARIO == " + $('#id-registo-imoveis-inventario').val(),
                        "propertyName": LayerParse[i].Geom,
                        "outputFormat": 'application/json',
                    }
                });

                // Response from the server
                getFeature.done(function (data, textStatus, jqXHR) {
                    myMapSgs.layerHighlightOverlay.getSource().clear();
                    if (data.features) {
                        if (data.features.length > 0) {

                            LayerFound = true;

                            for (var i = 0; i < data.features.length; i++) {

                                myMapSgs.featureToHighLight.push((new GeoJSON()).readFeatures(data)[i]);
                                var styleElement = myMapSgs._defaultHighlighStyles;
                                myMapSgs.featureToHighLight.getArray()[myMapSgs.featureToHighLight.getArray().length - 1].setStyle(styleElement);
                            }
                            // Go to Feature
                            myMapSgs.map.getView().fit(myMapSgs.layerHighlightOverlay.getSource().getExtent(), { size: myMapSgs.map.getSize(), duration: 1000, maxZoom: 13 });

                            if (myMapSgs._utility.mobilecheck()) {

                                $('#map-search').removeClass('active');
                                $('#map-search').css({ 'transform': 'none' });

                            }

                        } else {

                            if (countLength == LayerParse.length)
                                toastr["warning"]("Nenhum objeto encontrado");

                        }
                    }
                });
            }
        }
    }

    /**
     * Get the bounding box of a layer and zoom out/in to this bounding box
     * @param {string} geoserver
     * @param {string} workspace
     * @param {string} layerName
     */
    this.getLayerBoundingBox = function (geoserver, workspace, layerName) {


        let urlString = geoserver + "/wfs";
        let layerString = workspace + ':' + layerName;

        let getBB = $.ajax({
            method: "GET",
            //async: async,
            url: urlString,
            data: {
                "service": 'wfs',
                "version": '2.0.0',
                "request": 'GetCapabilities',
                "layer": layerString,
                //"featureID": idsString,
                "propertyName": 'WGS84BoundingBox',
                "outputFormat": 'application/json'
            }

        });


        getBB.done(function (data) {
            let count = data.childNodes[0].childNodes[3].childElementCount;
            for (let i = 0; i < count; i++) {
                let name = data.childNodes[0].childNodes[3].childNodes[i].childNodes[0].childNodes[0].textContent;
                if (layerString === name) {
                    var lowerCorner = data.childNodes[0].childNodes[3].childNodes[i].childNodes[5].childNodes[0].childNodes[0].textContent;
                    var upperCorner = data.childNodes[0].childNodes[3].childNodes[i].childNodes[5].childNodes[1].childNodes[0].textContent;
                }
            }
            let minlonWGS84 = parseFloat(lowerCorner.split(" ")[0]);
            let minlatWGS84 = parseFloat(lowerCorner.split(" ")[1]);
            let maxlonWGS84 = parseFloat(upperCorner.split(" ")[0]);
            let maxlatWGS84 = parseFloat(upperCorner.split(" ")[1]);
            let extentWGS84 = [minlonWGS84, minlatWGS84, maxlonWGS84, maxlatWGS84];

            var projectionMap = mapSettings.map_info.srs_srid.toString();

            const positionXYmin = transform([extentWGS84[0], extentWGS84[1]], 'EPSG:4326', 'EPSG:' + projectionMap);
            const positionXYmax = transform([extentWGS84[2], extentWGS84[3]], 'EPSG:4326', 'EPSG:' + projectionMap);

            let positionXYXY = [positionXYmin[0], positionXYmin[1], positionXYmax[0], positionXYmax[1]];

            app.sgs.Map.map.getView().fit(positionXYXY, { size: app.sgs.Map.map.getSize() });


        });
    };

    /**
     * Check if feature point is in feature polygon
     * @param {ol.feature} featurePoint, feature point
     * @param {ol.feature} featurePolygon, feature polygon
     */
    this.CheckFeaturePointInFeaturePolygon = function (featurePoint, featurePolygon) {
        // Get point geojson
        var featurePointGeoJson = null;
        if (featurePoint.getGeometry().getCoordinates()[0] instanceof Array)
            featurePointGeoJson = turf.point(featurePoint.getGeometry().getCoordinates()[0]);
        else
            featurePointGeoJson = turf.point(featurePoint.getGeometry().getCoordinates());

        // Get polygon geojson
        var featurePolygonGeoJson = (new GeoJSON()).writeFeatureObject(featurePolygon);

        // Check if point in polygon
        return turf.booleanPointInPolygon(featurePointGeoJson, featurePolygonGeoJson)
    };

    /**
     * Get distance in meters between a point and a line
     * @param {ol.feature} featurePoint, feature point
     * @param {ol.feature} featureLine, feature polygon
     */
    this.GetDistanceBetweenPointAndLine = function (featurePoint, featureLine) {
        // Transform system coordinate to wgs84
        var featurePointWgs84 = featurePoint.clone();
        featurePointWgs84.getGeometry().transform(myMapSgs._settings.projection.code_, myMapSgs._settings.projectionWgs84.code_);
        var featureLineWgs84 = featureLine.clone();
        featureLineWgs84.getGeometry().transform(myMapSgs._settings.projection.code_, myMapSgs._settings.projectionWgs84.code_);


        // Get point geojson
        var featurePointGeoJson = null;
        if (featurePointWgs84.getGeometry().getCoordinates()[0] instanceof Array)
            featurePointGeoJson = turf.point(featurePointWgs84.getGeometry().getCoordinates()[0]);
        else
            featurePointGeoJson = turf.point(featurePointWgs84.getGeometry().getCoordinates());

        // Get line geojson
        var featureLineGeoJson = (new GeoJSON()).writeFeatureObject(featureLineWgs84);

        // Calculate distance between point and line
        return (turf.pointToLineDistance(featurePointGeoJson, featureLineGeoJson, { units: 'kilometers' })) / 0.001;
    };

    /**
     * Get distance in meters between two points
     * @param {ol.feature} featurePointSource, feature point source
     * @param {ol.feature} featurePointTarget, feature point target
     */
    this.GetDistanceBetween2Point = function (featurePointSource, featurePointTarget) {
        // Transform system coordinate to wgs84
        var featurePointSourceWgs84 = featurePointSource.clone();
        featurePointSourceWgs84.getGeometry().transform(myMapSgs._settings.projection.code_, myMapSgs._settings.projectionWgs84.code_);
        var featurePointTargetWgs84 = featurePointTarget.clone();
        featurePointTargetWgs84.getGeometry().transform(myMapSgs._settings.projection.code_, myMapSgs._settings.projectionWgs84.code_);

        // Get point source geojson
        var featurePointSourceGeoJson = null;
        if (featurePointSourceWgs84.getGeometry().getCoordinates()[0] instanceof Array)
            featurePointSourceGeoJson = turf.point(featurePointSourceWgs84.getGeometry().getCoordinates()[0]);
        else
            featurePointSourceGeoJson = turf.point(featurePointSourceWgs84.getGeometry().getCoordinates());

        // Get point target geojson
        var featurePointTargetGeoJson = null;
        if (featurePointTargetWgs84.getGeometry().getCoordinates()[0] instanceof Array)
            featurePointTargetGeoJson = turf.point(featurePointTargetWgs84.getGeometry().getCoordinates()[0]);
        else
            featurePointTargetGeoJson = turf.point(featurePointTargetWgs84.getGeometry().getCoordinates());

        // Calculate distance between two point
        return (turf.distance(featurePointSourceGeoJson, featurePointTargetGeoJson, { units: 'kilometers' })) / 0.001;
    };

    this.GetQuotaByCoord = function (LayerMdtWorkspace, LayerMdtName, LayerMdtGeoserver, flatCoordinates) {

        var BBox1 = flatCoordinates[0] + 100

        var BBox2 = flatCoordinates[1] + 100

        var getFeature = $.ajax({
            method: "GET",
            async: false,
            url: LayerMdtGeoserver.value + '/wms',
            data: {
                "service": 'wms',
                "version": '1.1.1',
                "request": 'GetFeatureInfo',
                "LAYERS": LayerMdtWorkspace.value + ':' + LayerMdtName.value,
                "info_format": 'application/json',
                "outputFormat": 'application/json',
                "X": 50,
                "Y": 50,
                "WIDTH": 101,
                "HEIGHT": 101,
                "query_layers": LayerMdtWorkspace.value + ':' + LayerMdtName.value,
                "bbox": flatCoordinates[0] + ',' + flatCoordinates[1] + ',' + BBox1 + ',' + BBox2
            }
        });

        // Response from the server
        getFeature.done(function (data, textStatus, jqXHR) {
            if (data.features) {
                if (data.features.length > 0) {
                    myMapSgs._quotaValueFill = data;
                }
            }
        });

    };

    /**
     * Clear all feature of a vector layer
     * @param {VectorLayer} vectorLayer,  vector layer to clear all feature
     */
    this.ClearSource = function (vectorLayer) {
        var features = vectorLayer.getSource().getFeatures();
        features.forEach((feature) => {
            vectorLayer.getSource().removeFeature(feature);
        });
    }

    /**
     * Build layer filter from layer column 
     * @param {any} layerInfo
     * @param {any} columnName
     * @param {any} columnPrettyName
     * @param {any} idFilterZone
     */
    this.BuildLayerFilterFromLayerColumn = function (layerInfo, columnName, columnPrettyName, idFilterZone) {
        var indexColumn = myMapSgs._columnFilterAdvancedSearchIndex++;

        // Get filter element
        var filterZoneElement = $('#' + idFilterZone)[0];

        // Get column info
        var idLayer = layerInfo.id;
        var layerName = layerInfo.layerName;
        var columnInfo = myMapSgs._settings.treeMap.dict_layer_info[idLayer].list_column.find(c => c.column_name === columnName);
        var placeholder = "Introduza um valor";

        // Adjust for reference columns
        let isRefCol = (columnName ? columnName.substr(0, 6).toUpperCase() === 'ID_REF' : false) || columnInfo.id_rel_layer_column_ref_metadata != null;
        // Manager traffic sign - prumo array sinal
        if (mapSettings.operation_visible.ManagerTrafficSignTool && myMapSgs._managerTrafficSignTool.prumoInfo.layerName == layerName && myMapSgs._managerTrafficSignTool.prumoInfo.prumoInfoConfig.column_name_array_type_sign == columnName) {
            isRefCol = true;
        }
        let isIdCol = columnName && !isRefCol ? columnName.substr(0, 2).toUpperCase() === 'ID' : false;

        var arrayOperador = [];
        switch (columnInfo.column_type) {
            case "xsd:number":
            case "xsd:int":
            case "xsd:double":
            case "xsd:bigint":
                placeholder = "Introduza um número";
                arrayOperador = [
                    {
                        ref: '=',
                        description: '='
                    },
                    {
                        ref: '<>',
                        description: '<>'
                    },
                    {
                        ref: '>',
                        description: '>'
                    },
                    {
                        ref: '>=',
                        description: '>='
                    },
                    {
                        ref: '<',
                        description: '<'
                    },
                    {
                        ref: '<=',
                        description: '<='
                    }
                ];
                break;
            case "xsd:date-time":
            case "xsd:date":
                placeholder = "seleccione uma data";
                arrayOperador = [
                    {
                        ref: '=',
                        description: '='
                    },
                    {
                        ref: '<>',
                        description: '<>'
                    },
                    {
                        ref: '>',
                        description: '>'
                    },
                    {
                        ref: '>=',
                        description: '>='
                    },
                    {
                        ref: '<',
                        description: '<'
                    },
                    {
                        ref: '<=',
                        description: '<='
                    }
                ];
                break;
            default:
                arrayOperador = [
                    {
                        ref: '=',
                        description: '='
                    },
                    {
                        ref: 'ilike',
                        description: 'contido'
                    }
                ];
        }

        // Id
        var idColumn = "id-layer-search-input-column-" + columnName + "-" + indexColumn;
        var idDivColumn = "id-layer-search-div-column-" + columnName + "-" + indexColumn;
        var idOperator = "id-layer-search-operator-column-" + columnName + "-" + indexColumn;
        var nameColumnIndex = columnName + "-" + indexColumn;
        // Filter
        var filterElement = document.createElement('div');
        filterElement.id = idDivColumn;
        filterElement.className = "form-group";
        filterElement.setAttribute('name-column-index', nameColumnIndex);
        filterElement.setAttribute('column_name', columnName);
        filterZoneElement.appendChild(filterElement);
        // Remove column select
        var removeFilterElement = document.createElement('a');
        removeFilterElement.className = "layer-search-filter-remove";
        removeFilterElement.setAttribute('title', 'Remover filtro');
        filterElement.appendChild(removeFilterElement);
        var removeFilterIconElement = document.createElement('i');
        removeFilterIconElement.className = "fa fa-trash";
        removeFilterElement.appendChild(removeFilterIconElement);
        // Title column
        var labelFilterElement = document.createElement('label');
        labelFilterElement.className = "layer-search-filter-title";
        labelFilterElement.innerHTML = columnPrettyName;
        filterElement.appendChild(labelFilterElement);
        // Column with reference value
        if (isRefCol) {
            // Manager traffic sign tool for type of element column
            var done = false;
            if (mapSettings.operation_visible.ManagerTrafficSignTool) {
                // Filter for type sign in sign
                if (myMapSgs._managerTrafficSignTool.signInfo.layerName == layerName && myMapSgs._managerTrafficSignTool.signInfo.signInfoConfig.column_name_type_sign == columnName) {
                    // Add combo box type sign
                    myMapSgs._managerTrafficSignTool.BuildTypeSignSelection(idDivColumn, idColumn, nameColumnIndex + "[]", "", "", 'multiple="multiple"', "", 'column_type="' + columnInfo.column_type + '" column_name="' + columnName + '" column_pretty_name="' + columnPrettyName + '" column_valid="1"');
                    done = true;
                }
                // Filter for type sign in prumo
                if (myMapSgs._managerTrafficSignTool.prumoInfo.layerName == layerName && myMapSgs._managerTrafficSignTool.prumoInfo.prumoInfoConfig.column_name_array_type_sign == columnName) {
                    // Add combo box type sign
                    myMapSgs._managerTrafficSignTool.BuildTypeSignSelection(idDivColumn, idColumn, nameColumnIndex + "[]", "", "", 'multiple="multiple"', "", 'column_type="' + columnInfo.column_type + '" column_name="' + columnName + '" column_pretty_name="' + columnPrettyName + '" column_valid="1"');
                    done = true;
                }
            }

            if (!done) {
                // Create html select2
                var $select = $('<select id="' + idColumn + '" name="' + nameColumnIndex + '"multiple="multiple" class="form-control feature-field" title="Nenhum sinal escolhido" style="width: 100%" column_type="' + columnInfo.column_type + '" column_name="' + columnName + '" column_pretty_name="' + columnPrettyName + '" column_valid="1"></select>');
                var $option = $("<option></option>");

                // Create array with value
                var gpName = myMapSgs.getSettings()._mapSettings.search_toponymy.workspaceSearchToponymy;
                var gpSigredes = gpName == 'GP_MEALHADA' || gpName == 'GP_PONTA_DELGADA';
                var layerRef = myMapSgs._settings.columnTableReferenceData.table_reference_data[columnInfo.id_rel_layer_column_ref_metadata];;
                if (gpSigredes && myMapSgs._layerReferences) {
                    var layer_references = myMapSgs._layerReferences[layerName];

                    if (layer_references && (layer_references['id_' + columnName] || layer_references[columnName])) {
                        layerRef = !isIdCol ? layer_references['id_' + columnName] : layer_references[columnName];
                    }
                    var prefix = "id_";
                    if (gpSigredes && isRefCol) {
                        if (gpName == 'GP_PONTA_DELGADA')
                            layerRef = myMapSgs.typeList;
                        else
                            layerRef = layer_references[columnName];
                        prefix = "";
                    }
                }
                var comboArray = [];
                if (gpName == 'GP_PONTA_DELGADA') {
                    for (var k = 0; k < layerRef.length; k++) comboArray.push({ 'id': layerRef[k], 'value': layerRef[k] });
                } else {
                    comboArray.push({ 'id': '', 'value': '' });
                    for (let [key, row] of Object.entries(layerRef)) {
                        comboArray.push({ 'id': row.id, 'value': row.value });
                    }
                }

                // Fill select2 array
                for (var u = 0; u < comboArray.length; u++) {
                    var elementObj = comboArray[u];
                    var $option = $("<option></option>", {
                        "text": elementObj.value,
                        "value": elementObj.id
                    });
                    $select.append($option);
                }
                $('#' + idDivColumn).append($select);
                $('#' + idColumn).select2({
                    width: 'resolve'
                });
            }
        }
        else { // Column with value only
            // Operator Select
            var divColSelectOperatorFilterElement = document.createElement('div');
            divColSelectOperatorFilterElement.className = "operator";
            filterElement.appendChild(divColSelectOperatorFilterElement);
            var selectOperatorFilterElement = document.createElement('select');
            selectOperatorFilterElement.id = idOperator;
            selectOperatorFilterElement.className = "form-control operator-select";
            selectOperatorFilterElement.setAttribute('data-container', "body");
            divColSelectOperatorFilterElement.appendChild(selectOperatorFilterElement);

            // Fill operator select
            myMapSgs._utility.FillSelect(idOperator, arrayOperador, 'description', 'ref');

            // Value zone
            var divFilterElement = document.createElement('div');
            filterElement.appendChild(divFilterElement);

            // Field value
            var divColInputFilterElement = document.createElement('div');
            divColInputFilterElement.className = "field";
            divFilterElement.appendChild(divColInputFilterElement);
            //var idInput = "layer-search-input-column-" + columnName;
            var inputFilterElement = document.createElement('input');
            inputFilterElement.id = idColumn;
            inputFilterElement.setAttribute('type', 'text');
            inputFilterElement.className = 'form-control search-input';
            inputFilterElement.setAttribute('placeholder', placeholder);
            inputFilterElement.setAttribute('column_name', columnName);
            inputFilterElement.setAttribute('column_pretty_name', columnPrettyName);
            inputFilterElement.setAttribute('column_type', columnInfo.column_type);
            inputFilterElement.setAttribute('column_valid', "1");
            inputFilterElement.setAttribute('id-operator', idOperator);
            divColInputFilterElement.appendChild(inputFilterElement);

            // Transform input if that the case
            switch (columnInfo.column_type) {
                case "xsd:date-time":
                case "xsd:date":
                    $('#' + idColumn).datepicker({ uiLibrary: 'bootstrap', format: 'yyyy-mm-dd' });
                    break;
                default:
                // do nothing
            }
        }

        // Event remove filter
        $('#' + idFilterZone + ' .layer-search-filter-remove').on('click', function () {
            $(this).parent().remove();
        });

        // Event valid search layer filter value on key up
        $('#' + idFilterZone + ' input').on('keyup', function () {
            var columnType = this.getAttribute('column_type');
            var value = $(this).val();

            switch (columnType) {
                case "xsd:number":
                case "xsd:int":
                    if (!myMapSgs._utility.ValidNumber(value)) {
                        $(this).addClass("invalid");
                        this.setAttribute("column_valid", "0")
                    }
                    else {
                        $(this).removeClass("invalid");
                        this.setAttribute("column_valid", "1")
                    }
                    break;
                default:
                // Do nothing
            }
        });
    }

    /**
     * Build filter from layer type
     * @param {any} idFilterZone
     * @param {any} serviceType
     * @param {any} layerName
     */
    this.GenerateLayerFilter = function (idFilterZone, serviceType, layerName) {
        // Build Filter
        var filter = "";
        var filterField = "";

        // Input filter
        var $inputFilter = $('#' + idFilterZone + ' input:not([class="select2-search__field"])');
        for (var i = 0; i < $inputFilter.length; i++) {
            var value = $inputFilter[i].value;
            var columnName = $inputFilter[i].getAttribute('column_name');
            var columnValid = $inputFilter[i].getAttribute('column_valid');
            if (columnValid === "0") {
                var columnPrettyName = $inputFilter[i].getAttribute('column_pretty_name');
                toastr["warning"]("Atenção, campo '" + columnPrettyName + "' Inválido");
                return;
            }
            if (value === "") {
                var columnPrettyName = $inputFilter[i].getAttribute('column_pretty_name');
                toastr["warning"]("Atenção, campo '" + columnPrettyName + "' vazio");
                return;
            }
            var columnType = $inputFilter[i].getAttribute('column_type');
            var idOperator = $($inputFilter[i]).attr("id-operator")
            var operator = $("#" + idOperator).val();
            switch (columnType) {
                case "xsd:number":
                case "xsd:int":
                    filterField = columnName + "  " + operator + " " + value;
                    break;
                case "xsd:date-time":
                case "xsd:date":
                    filterField = columnName + "  " + operator + " '" + value + "'";
                    break;
                default:
                    if (operator === "ilike")
                        filterField = columnName + " " + operator + " '%" + value.toLowerCase() + "%'";
                    else
                        filterField = "strToLowerCase(" + columnName + ") " + operator + " '" + value.toLowerCase() + "'";
            }

            if (i === 0)
                filter = filterField
            else
                filter += " And " + filterField
        }

        // Select2 filter
        var $select2Filter = $('#' + idFilterZone + ' select:not(.operator-select)');
        for (var j = 0; j < $select2Filter.length; j++) {
            var value = $($select2Filter[j]).val().toString();
            var columnName = $select2Filter[j].getAttribute('column_name');
            var columnValid = $select2Filter[j].getAttribute('column_valid');
            if (columnValid === "0") {
                var columnPrettyName = $select2Filter[j].getAttribute('column_pretty_name');
                toastr["warning"]("Atenção, campo '" + columnPrettyName + "' Inválido");
                return;
            }
            if (value === "") {
                var columnPrettyName = $select2Filter[j].getAttribute('column_pretty_name');
                toastr["warning"]("Atenção, campo '" + columnPrettyName + "' vazio");
                return;
            }

            if (mapSettings.operation_visible.ManagerTrafficSignTool && myMapSgs._managerTrafficSignTool.prumoInfo.layerName == layerName && myMapSgs._managerTrafficSignTool.prumoInfo.prumoInfoConfig.column_name_array_type_sign == columnName) {
                var cqlFilterTypeSign = "";
                var arrayTypeSignSelected = $($select2Filter[j]).val();
                for (var i = 0; i < arrayTypeSignSelected.length; i++) {
                    var idTypeSign = arrayTypeSignSelected[i];
                    if (i != 0)
                        cqlFilterTypeSign += ' and ';
                    cqlFilterTypeSign += columnName + " ilike '%[" + idTypeSign + "]%'";
                }
                filterField = cqlFilterTypeSign;
            }
            else {
                filterField = columnName + "  in (" + value + ")";
            }

            var columnType = $select2Filter[j].getAttribute('column_type');

            if (j === 0) {
                if (filter == "")
                    filter = filterField
                else
                    filter += " And " + filterField
            }
            else
                filter += " And " + filterField
        }

        if (filter === "") {
            toastr["warning"]("Nenhum filtro seleccionado");
            return;
        }

        return filter;
    }


    // -- end public method -----------------------------------------------------------------------

    // -- begin private method --------------------------------------------------------------------

    /**
     * Wait for distrito combo
     * @param {bool} wait, true for wait
     */
    this.SelectSearchDistritoWait = function (wait) {
        if (wait) {
            $('#id-toponymy-search-select-distrito-spin').show();
            $('#id-toponymy-search-select-distrito').prop('disabled', true);
        }
        else {
            $('#id-toponymy-search-select-distrito-spin').hide();
            $('#id-toponymy-search-select-distrito').prop('disabled', false);
        }
        $('#id-toponymy-search-select-distrito').selectpicker('refresh');
    }

    /**
     * Wait for concelho combo
     * @param {bool} wait, true for wait
     */
    this.SelectSearchConcelhoWait = function (wait) {
        if (wait) {
            $('#id-toponymy-search-select-concelho-spin').show();
            $('#id-toponymy-search-select-concelho').prop('disabled', true);
        }
        else {
            $('#id-toponymy-search-select-concelho-spin').hide();
            $('#id-toponymy-search-select-concelho').prop('disabled', false);
        }
        $('#id-toponymy-search-select-concelho').selectpicker('refresh');
    }

    /**
     * Wait for freguesia combo
     * @param {bool} wait, true for wait
     */
    this.SelectSearchFreguesiaWait = function (wait) {
        if (wait) {
            $('#id-toponymy-search-select-freguesia-spin').show();
            $('#id-toponymy-search-select-freguesia').prop('disabled', true);
        }
        else {
            $('#id-toponymy-search-select-freguesia-spin').hide();
            $('#id-toponymy-search-select-freguesia').prop('disabled', false);
        }
        $('#id-toponymy-search-select-freguesia').selectpicker('refresh');
    }

    /**
     * Control off canvas
     * @param {any} opt_options, option control
     */
    this._ControlOffCanvas = function (opt_options) {

        const element = document.createElement('div');

        const options = opt_options || {};

        const contentAccount = document.createElement('div');
        contentAccount.className = 'dropdown';

        // -- Acount left button ------------------------------------------------------------------
        if (mapSettings.operation_visible.AccountMenuButton && mapSettings.operation_visible.Anacom == null) {
            const buttonAccount = document.createElement('a');
            buttonAccount.id = "accountMenu";
            buttonAccount.className = 'btn floating-action';
            //buttonAccount.setAttribute('data-target', '#');
            buttonAccount.setAttribute('data-toggle', 'dropdown');
            //buttonAccount.setAttribute('aria-haspopup', 'true');
            //buttonAccount.setAttribute('aria-expanded', 'false');

            const buttonAccountContent = document.createElement('i');
            buttonAccountContent.className = 'zmdi zmdi-account';

            buttonAccount.appendChild(buttonAccountContent);

            contentAccount.appendChild(buttonAccount);

            const menuAccount = document.createElement('ul');
            menuAccount.className = 'dropdown-menu';
            menuAccount.setAttribute('aria-labelledby', 'accountMenu');

            const menuAccountHeader = document.createElement('li');
            menuAccountHeader.className = 'header';
            menuAccountHeader.innerHTML = '<h1>Utilizador</h1><p>sessão</p>';

            menuAccount.appendChild(menuAccountHeader);

            //const menuAccountChangePassword = document.createElement('li');
            //menuAccountChangePassword.innerHTML = '<a href="javascript:void(0)"><i class="zmdi zmdi-lock-outline text-primary"></i> Alterar password</a>';

            //menuAccount.appendChild(menuAccountChangePassword);

            const menuAccountLogout = document.createElement('li');
            menuAccountLogout.innerHTML = '<a href="/Account/Logout"><i class="zmdi zmdi-power text-primary"></i> Terminar sessão</a>';

            menuAccount.appendChild(menuAccountLogout);

            contentAccount.appendChild(menuAccount);

            element.appendChild(contentAccount);
        };

        // -- Search google api location ----------------------------------------------------------
        if (mapSettings.operation_visible.SearchLocationApiGoogle) {

            const buttonGoto = document.createElement('a');
            buttonGoto.className = 'btn floating-action';
            buttonGoto.id = 'button-localtion-api-google';
            buttonGoto.setAttribute('title', 'Ir para');

            const buttonGotoContent = document.createElement('i');
            buttonGotoContent.className = 'btn-floating-action gpi gpi-ir-para quick-action-button-size';
            buttonGotoContent.setAttribute('style', 'position: relative;top: 1px;right: 1px;');

            buttonGoto.appendChild(buttonGotoContent);
            element.appendChild(buttonGoto);
        };

        // -- Search Button left ------------------------------------------------------------------
        if (mapSettings.operation_visible.Search) {
            const buttonSearch = document.createElement('a');
            buttonSearch.setAttribute('href', '#search');
            buttonSearch.className = 'btn btn-primary floating-action';
            buttonSearch.setAttribute('data-toggle', 'gsearch');
            buttonSearch.id = 'button-open-search';

            const buttonSearchContent = document.createElement('i');
            buttonSearchContent.className = 'zmdi zmdi-pin';
            //button.innerHTML = 'N';

            buttonSearch.appendChild(buttonSearchContent);

            element.appendChild(buttonSearch);
        };

        //Button for Anacom Search ----------------------------------------------------------------
        if (mapSettings.operation_visible.Anacom != null) {

            const buttonSearch = document.createElement('a');
            buttonSearch.setAttribute('href', '#id-anacom-search');
            buttonSearch.className = 'btn floating-action';
            buttonSearch.setAttribute('data-toggle', 'id-anacom-search');
            buttonSearch.id = 'button-open-anacom-search';
            buttonSearch.setAttribute('title', 'Pesquisa');

            const buttonSearchContent = document.createElement('i');
            buttonSearchContent.className = 'btn-floating-action gpi gpi-pesquisar quick-action-button-size';
            //button.innerHTML = 'N';

            buttonSearch.appendChild(buttonSearchContent);

            element.appendChild(buttonSearch);
        };

        // -- Shortcut button left ----------------------------------------------------------------
        if (mapSettings.operation_visible.Shortcuts) {
            const buttonFavorites = document.createElement('a');
            buttonFavorites.setAttribute('href', '#offcanvas-favs');
            buttonFavorites.className = 'btn floating-action';
            buttonFavorites.setAttribute('data-toggle', 'offcanvas');
            buttonFavorites.setAttribute('data-backdrop', 'false');
            buttonFavorites.setAttribute('title', 'Locais guardados');
            buttonFavorites.id = 'id-button-favorites';


            const buttonFavoritesContent = document.createElement('i');

            if (mapSettings.operation_visible.Anacom != null)
                buttonFavoritesContent.className = 'btn-floating-action gpi gpi-pontos-interesse quick-action-button-size';
            else
                buttonFavoritesContent.className = 'zmdi zmdi-star';
            //button.innerHTML = 'N';

            buttonFavorites.appendChild(buttonFavoritesContent);

            element.appendChild(buttonFavorites);
        };

        // -- Avim Search button left -------------------------------------------------------------
        if (mapSettings.operation_visible.AvimTool) {
            const buttonAvimSearch = document.createElement('a');
            if (!mapSettings.operation_visible.ControlBar)
                buttonAvimSearch.setAttribute('href', '');
            else
                buttonAvimSearch.setAttribute('href', '#offcanvas-avimsearch');
            buttonAvimSearch.className = 'btn floating-action';
            buttonAvimSearch.setAttribute('data-toggle', 'offcanvas');
            buttonAvimSearch.setAttribute('data-backdrop', 'false');
            buttonAvimSearch.setAttribute('title', 'Pesquisa Imóvel');

            const buttonAvimSearchContent = document.createElement('i');
            buttonAvimSearchContent.className = 'zmdi zmdi-search-for';

            buttonAvimSearch.appendChild(buttonAvimSearchContent);

            element.appendChild(buttonAvimSearch);

            // Only if control bar is not present
            if (!mapSettings.operation_visible.ControlBar) {
                const handleAvimSearch = function () {
                    if ($('#offcanvas-avimsearch').hasClass('active-avim-search')) {
                        $('#offcanvas-avimsearch').removeClass('offcanvas-show');
                        $('#offcanvas-avimsearch').addClass('offcanvas-not-show');
                        $('#offcanvas-avimsearch').removeClass('active-avim-search');
                    }
                    else {
                        $('#offcanvas-avimsearch').addClass('offcanvas-show');
                        $('#offcanvas-avimsearch').removeClass('offcanvas-not-show');
                        $('#offcanvas-avimsearch').addClass('active-avim-search');
                        $('#offcanvas-theme').removeClass('offcanvas-show');
                        $('#offcanvas-theme').addClass('offcanvas-not-show');
                        $('#offcanvas-theme').removeClass('active-layer-tree');
                        $('#offcanvas-basetheme').removeClass('offcanvas-show');
                        $('#offcanvas-basetheme').addClass('offcanvas-not-show');
                        $('#offcanvas-basetheme').removeClass('active-base-layer');
                    };
                };

                buttonAvimSearch.addEventListener('click', handleAvimSearch, false);
                buttonAvimSearch.addEventListener('touchstart', handleAvimSearch, false);
            }
        };

        // -- Create occurrence button ----------------------------------------------------------------
        if (mapSettings.operation_visible.Occurrence != null && mapSettings.operation_visible.Occurrence.taskManagement) {
            const buttonOccurrence = document.createElement('a');
            buttonOccurrence.className = 'btn floating-action gpi gpi-criar-ocorrencia button-create-occurrence-style ';
            buttonOccurrence.setAttribute('data-toggle', 'offcanvas');
            buttonOccurrence.setAttribute('data-backdrop', 'false');
            buttonOccurrence.setAttribute('title', 'Criar ocorrência');
            buttonOccurrence.id = 'CreateOccurrenceButton';

            const buttonOccurrenceContent = document.createElement('i');
            //button.innerHTML = 'N';
            buttonOccurrence.appendChild(buttonOccurrenceContent);

            element.appendChild(buttonOccurrence);

            const handleOccurrence = function () {

                app.sgs.Occurrences._DrawPintoCreateOccurrenceWithoutEvent();

            };

            buttonOccurrence.addEventListener('click', handleOccurrence, false);
        };

        // -- Location plant button left ----------------------------------------------------------
        if (mapSettings.operation_visible.LocationPlant) {
            const buttonLocationPlant = document.createElement('a');
            buttonLocationPlant.setAttribute('href', '');
            buttonLocationPlant.className = 'btn floating-action';
            buttonLocationPlant.setAttribute('data-toggle', 'offcanvas');
            buttonLocationPlant.setAttribute('data-backdrop', 'false');
            buttonLocationPlant.setAttribute('title', 'Gerar Planta de localização');
            buttonLocationPlant.id = 'button-open-location-plant';

            const buttonLocationPlantContent = document.createElement('i');
            buttonLocationPlantContent.className = 'material-icons';
            buttonLocationPlantContent.setAttribute('style', 'position: relative;top: 8px;');
            buttonLocationPlantContent.innerHTML = 'map';

            buttonLocationPlant.appendChild(buttonLocationPlantContent);

            element.appendChild(buttonLocationPlant);

            const handleLocationPlant = function () {
                myMapSgs._GetAllReference();
                $('#id-modal-location-plant').css({ 'display': 'block' });
            };

            buttonLocationPlant.addEventListener('click', handleLocationPlant, false);
            buttonLocationPlant.addEventListener('touchstart', handleLocationPlant, false);
        };

        // -- Road Builder tool button left -------------------------------------------------------
        if (mapSettings.operation_visible.RoadBuilderTool) {
            const buttonRoadBuilderTool = document.createElement('a');
            buttonRoadBuilderTool.setAttribute('href', '');
            buttonRoadBuilderTool.className = 'btn floating-action';
            buttonRoadBuilderTool.setAttribute('data-toggle', 'offcanvas');
            buttonRoadBuilderTool.setAttribute('data-backdrop', 'false');
            buttonRoadBuilderTool.setAttribute('title', 'Ferramenta Ruas e Número de Polícia');
            buttonRoadBuilderTool.id = 'button-open-road-builder-tool';

            const buttonRoadBuilderToolContent = document.createElement('i');
            buttonRoadBuilderToolContent.className = 'material-icons';
            buttonRoadBuilderToolContent.setAttribute('style', 'position: relative;top: 9px;');
            buttonRoadBuilderToolContent.innerHTML = 'linear_scale';

            buttonRoadBuilderTool.appendChild(buttonRoadBuilderToolContent);

            element.appendChild(buttonRoadBuilderTool);

            const handleRoadBuilderTool = function () {
                // Show menu botton bar
                if (!$('#id-menubar-bottom-road-builder-tool').is(':visible'))
                    $('#id-menubar-bottom-road-builder-tool').toggle('ol-hidden');
            };

            buttonRoadBuilderTool.addEventListener('click', handleRoadBuilderTool, false);
            buttonRoadBuilderTool.addEventListener('touchstart', handleRoadBuilderTool, false);
        };

        //-----Geometry tool button left
        if (mapSettings.operation_visible.GeometryEditorTool) {

            const buttonGeometryEditorTool = document.createElement('a');
            buttonGeometryEditorTool.setAttribute('href', '');
            buttonGeometryEditorTool.className = 'btn floating-action';
            buttonGeometryEditorTool.setAttribute('data-toggle', 'offcanvas');
            buttonGeometryEditorTool.setAttribute('data-backdrop', 'false');
            buttonGeometryEditorTool.setAttribute('title', 'Ferramenta de anotações');
            buttonGeometryEditorTool.id = 'button-open-geometry-editor-tool';

            const buttonGeometryEditorToolContent = document.createElement('i');
            buttonGeometryEditorToolContent.className = 'material-icons';
            buttonGeometryEditorToolContent.setAttribute('style', 'position: relative;top: 9px;');
            buttonGeometryEditorToolContent.innerHTML = 'linear_scale';

            buttonGeometryEditorTool.appendChild(buttonGeometryEditorToolContent);

            element.appendChild(buttonGeometryEditorTool);

            const handleGeometryEditorTool = function () {

                // Show menu botton bar
                if (!$('#id-menubar-bottom-geometry-editor-tool').is(':visible'))
                    $('#id-menubar-bottom-geometry-editor-tool').toggle('ol-hidden');
            };

            buttonGeometryEditorTool.addEventListener('click', handleGeometryEditorTool, false);
            buttonGeometryEditorTool.addEventListener('touchstart', handleGeometryEditorTool, false);

        };

        // -- Network Simulation tool button left -------------------------------------------------
        if (mapSettings.operation_visible.NetworkSimulationTool) {
            const buttonNetworkSimulationTool = document.createElement('a');
            buttonNetworkSimulationTool.setAttribute('href', '');
            buttonNetworkSimulationTool.className = 'btn floating-action';
            buttonNetworkSimulationTool.setAttribute('data-toggle', 'offcanvas');
            buttonNetworkSimulationTool.setAttribute('data-backdrop', 'false');
            buttonNetworkSimulationTool.setAttribute('title', 'Ferramenta de simulação de corte');
            buttonNetworkSimulationTool.id = 'button-open-network-simulation-tool';

            const buttonNetworkSimulationToolContent = document.createElement('img');
            buttonNetworkSimulationToolContent.setAttribute('src', '\\images\\icon-gas.svg');
            buttonNetworkSimulationToolContent.setAttribute('width', '28');
            buttonNetworkSimulationToolContent.setAttribute('height', '28');
            buttonNetworkSimulationToolContent.setAttribute('style', 'position: relative;top: 5px;');

            buttonNetworkSimulationTool.appendChild(buttonNetworkSimulationToolContent);

            element.appendChild(buttonNetworkSimulationTool);

            const handleNetworkSimulationTool = function () {
                // Show menu botton bar
                if (!$('#id-menubar-bottom-network-simulation-tool').is(':visible'))
                    $('#id-menubar-bottom-network-simulation-tool').toggle('ol-hidden');
            };

            buttonNetworkSimulationTool.addEventListener('click', handleNetworkSimulationTool, false);
            buttonNetworkSimulationTool.addEventListener('touchstart', handleNetworkSimulationTool, false);
        };

        // -- Network Indicator tool button left --------------------------------------------------
        if (mapSettings.operation_visible.NetworkIndicatorTool) {
            const buttonNetworkIndicatorTool = document.createElement('a');
            buttonNetworkIndicatorTool.setAttribute('href', '');
            buttonNetworkIndicatorTool.className = 'btn floating-action';
            buttonNetworkIndicatorTool.setAttribute('data-toggle', 'offcanvas');
            buttonNetworkIndicatorTool.setAttribute('data-backdrop', 'false');
            buttonNetworkIndicatorTool.setAttribute('title', 'Ferramenta Inficadores ERSAR');
            buttonNetworkIndicatorTool.id = 'button-open-network-budget-tool';

            const buttonNetworkIndicatorToolContent = document.createElement('i');
            buttonNetworkIndicatorToolContent.className = 'material-icons';
            buttonNetworkIndicatorToolContent.setAttribute('style', 'position: relative;top: 9px;');
            buttonNetworkIndicatorToolContent.innerHTML = 'featured_play_list';

            buttonNetworkIndicatorTool.appendChild(buttonNetworkIndicatorToolContent);

            element.appendChild(buttonNetworkIndicatorTool);

            const handleNetworkIndicatorTool = function () {

                myMapSgs._networkIndicatorTool.BuildIndicator();

            };

            buttonNetworkIndicatorTool.addEventListener('click', handleNetworkIndicatorTool, false);
        };

        // -- Network Budget tool button left -------------------------------------------------
        if (mapSettings.operation_visible.NetworkBudgetTool) {
            const buttonNetworkBudgetTool = document.createElement('a');
            buttonNetworkBudgetTool.setAttribute('href', '');
            buttonNetworkBudgetTool.className = 'btn floating-action';
            buttonNetworkBudgetTool.setAttribute('data-toggle', 'offcanvas');
            buttonNetworkBudgetTool.setAttribute('data-backdrop', 'false');
            buttonNetworkBudgetTool.setAttribute('title', 'Ferramenta de orçamentação');
            buttonNetworkBudgetTool.id = 'button-open-network-budget-tool';

            const buttonNetworkBudgetToolContent = document.createElement('i');
            buttonNetworkBudgetToolContent.className = 'material-icons';
            buttonNetworkBudgetToolContent.setAttribute('style', 'position: relative;top: 9px;');
            buttonNetworkBudgetToolContent.innerHTML = 'build';

            //const buttonNetworkBudgetToolContent = document.createElement('img');
            //buttonNetworkBudgetToolContent.setAttribute('src', '\\images\\icon-gas.svg');
            //buttonNetworkBudgetToolContent.setAttribute('width', '28');
            //buttonNetworkBudgetToolContent.setAttribute('height', '28');
            //buttonNetworkBudgetToolContent.setAttribute('style', 'position: relative;top: 5px;');

            buttonNetworkBudgetTool.appendChild(buttonNetworkBudgetToolContent);

            element.appendChild(buttonNetworkBudgetTool);

            const handleNetworkBudgetTool = function () {
                // Show menu botton bar
                if (!$('#id-menubar-bottom-network-budget-tool').is(':visible'))
                    $('#id-menubar-bottom-network-budget-tool').toggle('ol-hidden');
            };

            buttonNetworkBudgetTool.addEventListener('click', handleNetworkBudgetTool, false);
            buttonNetworkBudgetTool.addEventListener('touchstart', handleNetworkBudgetTool, false);
        };

        // -- Railway tool button left ---------------------------------------------------------
        if (mapSettings.operation_visible.RailwayTool) {
            const buttonRailwayTool = document.createElement('a');
            buttonRailwayTool.setAttribute('href', '');
            buttonRailwayTool.className = 'btn floating-action';
            buttonRailwayTool.setAttribute('data-toggle', 'offcanvas');
            buttonRailwayTool.setAttribute('data-backdrop', 'false');
            buttonRailwayTool.setAttribute('title', 'Railway Tool');
            buttonRailwayTool.id = 'button-open-railway-tool';

            const buttonRailwayToolContent = document.createElement('i');
            buttonRailwayToolContent.className = 'material-icons';
            buttonRailwayToolContent.setAttribute('style', 'position: relative;top: 9px;');
            buttonRailwayToolContent.innerHTML = 'directions_railway';

            buttonRailwayTool.appendChild(buttonRailwayToolContent);

            element.appendChild(buttonRailwayTool);

            const handleRailwayTool = function () {
                // Init slider index
                myMapSgs._railwayTool.InitSliderIndex();

                // Show menu botton bar
                $('#id-menubar-bottom-railway-tool').toggle('ol-hidden');
            };

            buttonRailwayTool.addEventListener('click', handleRailwayTool, false);
            buttonRailwayTool.addEventListener('touchstart', handleRailwayTool, false);
        };

        // -- PDM analyze button left -------------------------------------------------------------
        if (mapSettings.operation_visible.PDMAnalyze) {
            const buttonPdmAnalyze = document.createElement('a');
            buttonPdmAnalyze.setAttribute('href', '');
            buttonPdmAnalyze.className = 'btn floating-action';
            buttonPdmAnalyze.setAttribute('data-toggle', 'offcanvas');
            buttonPdmAnalyze.setAttribute('data-backdrop', 'false');
            buttonPdmAnalyze.setAttribute('title', 'Análise de PDM');
            buttonPdmAnalyze.id = 'button-open-pdm-analyze';

            const buttonPdmAnalyzeContent = document.createElement('i');
            buttonPdmAnalyzeContent.className = 'material-icons';
            buttonPdmAnalyzeContent.setAttribute('style', 'position: relative;top: 8px;');
            buttonPdmAnalyzeContent.innerHTML = 'map';

            buttonPdmAnalyze.appendChild(buttonPdmAnalyzeContent);

            element.appendChild(buttonPdmAnalyze);

            const handlePdmAnalyze = function () {
                // Show menu botton bar
                if (!$('#menubar-bottom-pl').is(':visible'))
                    $('#menubar-bottom-pl').toggle('ol-hidden');
            };

            buttonPdmAnalyze.addEventListener('click', handlePdmAnalyze, false);
            buttonPdmAnalyze.addEventListener('touchstart', handlePdmAnalyze, false);
        };

        // -- layer tree --------------------------------------------------------------------------
        if (mapSettings.operation_visible.LocationPlant || mapSettings.operation_visible.LayerTreeBtn) {
            const buttonLayerTree = document.createElement('a');
            buttonLayerTree.className = 'btn floating-action';
            //buttonLayerTree.setAttribute('data-toggle', 'offcanvas');
            //buttonLayerTree.setAttribute('data-backdrop', 'false');
            buttonLayerTree.setAttribute('title', 'Visualização de Camadas');

            const buttonLayerTreeContent = document.createElement('i');
            buttonLayerTreeContent.className = 'gpi gpi-tema';
            buttonLayerTreeContent.setAttribute('style', 'position: relative;top: 9px;');

            buttonLayerTree.appendChild(buttonLayerTreeContent);
            element.appendChild(buttonLayerTree);

            // With control bar active
            //if (mapSettings.operation_visible.ControlBar) {
            //    buttonLayerTree.setAttribute('href', '#offcanvas-theme');
            //}
            //else // With no control bar active
            //{
            buttonLayerTree.setAttribute('href', '');

            const handleLayerTree = function (e) {
                e.preventDefault();
                // Close layer tree offcanvas
                if ($('#offcanvas-theme').hasClass('active')) {
                    _controlOffCanvas.closeOffcanvas();
                }
                else {  // Open layer tree offcanvas
                    _controlOffCanvas.openOffcanvas("#offcanvas-theme");
                };
            };

            buttonLayerTree.addEventListener('click', handleLayerTree, false);
            buttonLayerTree.addEventListener('touchstart', handleLayerTree, false);
            /*            }*/
        };

        // -- base layer --------------------------------------------------------------------------
        if (mapSettings.operation_visible.LocationPlant || mapSettings.operation_visible.LayerBaseTreeBtn) {
            const buttonBaseLayer = document.createElement('a');
            buttonBaseLayer.className = 'btn floating-action';
            //buttonBaseLayer.setAttribute('data-toggle', 'offcanvas');
            //buttonBaseLayer.setAttribute('data-backdrop', 'false');
            buttonBaseLayer.setAttribute('title', 'Visualização das Camadas base');

            const buttonBaseLayerContent = document.createElement('i');
            buttonBaseLayerContent.className = 'gpi gpi-tema-base';
            buttonBaseLayerContent.setAttribute('style', 'position: relative;top: 9px;');

            buttonBaseLayer.appendChild(buttonBaseLayerContent);
            element.appendChild(buttonBaseLayer);

            // With control bar active
            //if (mapSettings.operation_visible.ControlBar) {
            //    buttonBaseLayer.setAttribute('href', '#offcanvas-basetheme');
            //}
            //else // With no control bar active
            //{
            buttonBaseLayer.setAttribute('href', '');

            const handleBaseLayer = function (e) {
                e.preventDefault();
                // Close base layer offcanvas
                if ($('#offcanvas-basetheme').hasClass('active')) {
                    _controlOffCanvas.closeOffcanvas();
                }
                else { // Open base layer offcanvas
                    _controlOffCanvas.openOffcanvas("#offcanvas-basetheme");
                };
            };

            buttonBaseLayer.addEventListener('click', handleBaseLayer, false);
            buttonBaseLayer.addEventListener('touchstart', handleBaseLayer, false);
            /*            }*/
        };

        // -- clean search selection ---------------------------------------------------------------
        if (mapSettings.operation_visible.LocationPlant || mapSettings.operation_visible.SearchLocal || mapSettings.operation_visible.SearchLugar || mapSettings.operation_visible.Search || mapSettings.operation_visible.Search.SearchFreguesia) {
            const buttonCleanSearch = document.createElement('a');
            buttonCleanSearch.setAttribute('href', '');
            buttonCleanSearch.className = 'btn floating-action';
            buttonCleanSearch.setAttribute('data-toggle', 'offcanvas');
            buttonCleanSearch.setAttribute('data-backdrop', 'false');
            buttonCleanSearch.setAttribute('title', 'Limpar selecção pesquisa');

            const buttonCleanSearchContent = document.createElement('i');
            buttonCleanSearchContent.className = 'gpi gpi-apagar';
            buttonCleanSearchContent.setAttribute('style', 'position: relative;top: 9px;');

            buttonCleanSearch.appendChild(buttonCleanSearchContent);

            element.appendChild(buttonCleanSearch);

            const handleCleanSearch = function () {
                // Clear draw polygon
                if (app.layerDraw.getSource()) app.layerDraw.getSource().clear();
                // Clear identify tooltipElement
                $(app.identifyTooltipElement).addClass('hidden');
                app.identifyTooltip.setVisible(false);
                // Clear select element
                app.Select.getFeatures().clear();
                // Clear highlight
                if (app.featureToHighLight.getLength() > 0) app.featureToHighLight.clear();
                if (myMapSgs.featureToHighLight.getLength() > 0) myMapSgs.featureToHighLight.clear();
                // Clear overlay element
                app.featureHighlightOverlay.getSource().clear();
                myMapSgs.layerHighlightOverlay.getSource().clear();
                // Clear Info feature
                $('#offcanvas-info').removeClass('show');
                myMapSgs.handleEditButtonsVisibility();
                myMapSgs._CloseSaveFeature();
            };

            buttonCleanSearch.addEventListener('click', handleCleanSearch, false);
            buttonCleanSearch.addEventListener('touchstart', handleCleanSearch, false);
        };

        // -- Button consulta pública --------------------------------------------------------------
        if (mapSettings.operation_visible.LocationPlantConsultaPublica) {
            const buttonConsultaPublica = document.createElement('a');
            buttonConsultaPublica.setAttribute('href', '');
            buttonConsultaPublica.className = 'btn floating-action';
            buttonConsultaPublica.setAttribute('data-toggle', 'offcanvas');
            buttonConsultaPublica.setAttribute('data-backdrop', 'false');
            buttonConsultaPublica.setAttribute('title', 'Consulta Pública');

            const buttonConsultaPublicaContent = document.createElement('i');
            buttonConsultaPublicaContent.className = 'material-icons';
            buttonConsultaPublicaContent.setAttribute('style', 'position: relative;top: 8px;');
            buttonConsultaPublicaContent.innerHTML = 'arrow_selector_tool';

            buttonConsultaPublica.appendChild(buttonConsultaPublicaContent);

            element.appendChild(buttonConsultaPublica);

            const handleConsultaPublica = function () {
                myMapSgs.layerTree.CreateConsultaPublica();
            };

            buttonConsultaPublica.addEventListener('click', handleConsultaPublica, false);
            buttonConsultaPublica.addEventListener('touchstart', handleConsultaPublica, false);
        };

        // -- help --------------------------------------------------------------------------------
        if (mapSettings.operation_visible.HelpButton) {
            const buttonHelp = document.createElement('a');
            buttonHelp.setAttribute('href', '');
            buttonHelp.className = 'btn floating-action';
            buttonHelp.setAttribute('data-toggle', 'offcanvas');
            buttonHelp.setAttribute('data-backdrop', 'false');
            buttonHelp.setAttribute('title', 'Ajuda');

            const buttonHelpContent = document.createElement('i');
            buttonHelpContent.className = 'zmdi zmdi-help';
            buttonHelpContent.setAttribute('style', 'position: relative;top: 0px;left: 0.2px;font-size: 30px');

            buttonHelp.appendChild(buttonHelpContent);

            element.appendChild(buttonHelp);

            const handleHelp = function () {
                $('#id-modal-help-plant').modal('show')
            };

            buttonHelp.addEventListener('click', handleHelp, false);
            buttonHelp.addEventListener('touchstart', handleHelp, false);
        };

        // -- Extract catography plant button left ----------------------------------------------------------
        if (mapSettings.operation_visible.CartographyExtract) {
            const buttonCartographyExtract = document.createElement('a');
            buttonCartographyExtract.setAttribute('href', '#offcanvas-extract_cartography');
            buttonCartographyExtract.className = 'btn floating-action';
            buttonCartographyExtract.setAttribute('data-toggle', 'offcanvas');
            buttonCartographyExtract.setAttribute('data-backdrop', 'false');

            const buttonCartographyExtractContent = document.createElement('i');
            buttonCartographyExtractContent.className = 'fas fa-globe-europe';

            buttonCartographyExtract.appendChild(buttonCartographyExtractContent);

            //element.appendChild(buttonCartographyExtract);
        };

        // -- Tool bar mobile button left ---------------------------------------------------------
        if (myMapSgs._utility.mobilecheck() && mapSettings.map_info.name !== 'MapOccurrence') {
            const buttonToolBarMobile = document.createElement('a');
            buttonToolBarMobile.setAttribute('href', '');
            buttonToolBarMobile.className = 'btn btn-primary floating-action';
            buttonToolBarMobile.setAttribute('data-toggle', 'offcanvas');
            buttonToolBarMobile.id = 'tools-Bar-Mobile';

            const buttonToolBarMobileContent = document.createElement('i');
            buttonToolBarMobileContent.className = 'fa fa-wrench';

            buttonToolBarMobile.appendChild(buttonToolBarMobileContent);

            element.appendChild(buttonToolBarMobile);
        };

        // -- Event occurrence bar button ---------------------------------------------------------
        if (mapSettings.operation_visible.OccurrenceEvent) {
            const buttonEventMapInfo = document.createElement('a');
            buttonEventMapInfo.setAttribute('href', '#offcanvas-event-occurrence-menu');
            buttonEventMapInfo.className = 'btn floating-action lineHeightButton';
            buttonEventMapInfo.setAttribute('data-toggle', 'offcanvas');
            buttonEventMapInfo.setAttribute('data-backdrop', 'false');

            const buttonEventMapInfoContent = document.createElement('i');
            buttonEventMapInfoContent.className = 'fa fas fa-bars';
            //button.innerHTML = 'N';

            buttonEventMapInfo.appendChild(buttonEventMapInfoContent);

            element.appendChild(buttonEventMapInfo);
        };

        // -- Create GPS go to location button ----------------------------------------------------
        if (mapSettings.operation_visible.ButtonGPS) {
            const buttonEventMapGPS = document.createElement('a');
            buttonEventMapGPS.className = 'btn floating-action lineHeightButton gps-map-location';
            buttonEventMapGPS.setAttribute('data-toggle', 'offcanvas');
            buttonEventMapGPS.setAttribute('data-backdrop', 'false');
            buttonEventMapGPS.setAttribute('title', 'A minha localização');

            const buttonEventMapGPSContent = document.createElement('i');
            buttonEventMapGPSContent.className = 'btn-floating-action gpi gpi-localizacao quick-action-button-size';
            buttonEventMapGPSContent.setAttribute('style', 'position: relative;top: 1px;');

            buttonEventMapGPS.appendChild(buttonEventMapGPSContent);

            element.appendChild(buttonEventMapGPS);

            const handleLocationGps = function () {
                myMapSgs._GetLocationGps();
            };

            buttonEventMapGPS.addEventListener('click', handleLocationGps, false);
            buttonEventMapGPS.addEventListener('touchstart', handleLocationGps, false);
        }

        //Button for Anacom GOTO ----------------------------------------------------------------
        if (mapSettings.operation_visible.Anacom != null) {

            const buttonGOTO = document.createElement('a');
            buttonGOTO.className = 'btn floating-action';
            buttonGOTO.id = 'button-GOTO-anacom';
            buttonGOTO.setAttribute('title', 'Ir para');

            const buttonGOTOContent = document.createElement('i');
            buttonGOTOContent.className = 'btn-floating-action gpi gpi-ir-para quick-action-button-size';
            //button.innerHTML = 'N';

            buttonGOTO.appendChild(buttonGOTOContent);

            element.appendChild(buttonGOTO);
        };

        // -- Event occurrence search button ------------------------------------------------------
        if (mapSettings.operation_visible.OccurrenceEvent) {
            const buttonEventMapSearch = document.createElement('a');
            buttonEventMapSearch.setAttribute('href', '#offcanvas-detail-event-occurrence');
            buttonEventMapSearch.className = 'btn floating-action lineHeightButton';
            buttonEventMapSearch.setAttribute('data-toggle', 'offcanvas');
            buttonEventMapSearch.setAttribute('data-backdrop', 'false');
            buttonEventMapSearch.id = 'buttonEventMapSearch';

            const buttonEventMapSearchContent = document.createElement('i');
            buttonEventMapSearchContent.className = 'gpi gpi-zoom';
            //button.innerHTML = 'N';

            buttonEventMapSearch.appendChild(buttonEventMapSearchContent);

            element.appendChild(buttonEventMapSearch);
        };

        // -- North button ------------------------------------------------------------------------
        const buttonRotateNorth = document.createElement('a');
        buttonRotateNorth.id = 'buttonRotateNorth';
        buttonRotateNorth.style = 'display: none';
        //buttonRotateNorth.setAttribute('href', '#search');
        buttonRotateNorth.className = 'btn floating-action';
        //buttonRotateNorth.setAttribute('data-toggle', 'gsearch');

        const buttonRotateNorthContent = document.createElement('img');
        buttonRotateNorthContent.src = '/images/reset-norte.png';
        //buttonRotateNorthContent.className = 'zmdi zmdi-pin';
        //button.innerHTML = 'N';

        buttonRotateNorth.appendChild(buttonRotateNorthContent);

        const this_ = this;
        const handleRotateNorth = function () {
            this_.getMap().getView().setRotation(0);

            $('#buttonRotateNorth').hide();
        };

        buttonRotateNorth.addEventListener('click', handleRotateNorth, false);
        buttonRotateNorth.addEventListener('touchstart', handleRotateNorth, false);

        element.className = 'map-cta';//'rotate-north ol-unselectable ol-control';
        element.id = 'buttonsMap';

        element.appendChild(buttonRotateNorth);

        Control.call(this, {
            element: element,
            target: options.target
        });

    };
    inherits(this._ControlOffCanvas, Control);

    /**
     * Control menu button bar
     * @param {any} opt_options, option control
     */
    this._ControlBar = null;
    if (mapSettings.operation_visible.ControlBar) {
        this._ControlBar = function (opt_options) {

            const options = opt_options || {};

            let visibleOperations = myMapSgs._settings.getVisibleOperations();

            // -- List Service Button -----------------------------------------------------------------
            const buttonServices = document.createElement('li');

            if (mapSettings.operation_visible.Anacom == null) {
                const buttonServicesContainer = document.createElement('a');
                buttonServicesContainer.setAttribute('href', '#offcanvas-services');
                buttonServicesContainer.setAttribute('data-toggle', 'offcanvas');
                buttonServicesContainer.setAttribute('data-backdrop', 'false');
                buttonServicesContainer.setAttribute('title', 'Lista de Aplicações');

                const buttonServicesContent = document.createElement('div');
                buttonServicesContent.className = 'menu-icon';
                buttonServicesContent.innerHTML = '<i class="gpi gpi-servicos"></i>';

                buttonServicesContainer.appendChild(buttonServicesContent);
                buttonServices.appendChild(buttonServicesContainer);
            }
            // -- Layer Base Theme --------------------------------------------------------------------
            const buttonBaseTheme = document.createElement('li');

            const buttonBaseThemeContainer = document.createElement('a');
            buttonBaseThemeContainer.setAttribute('href', '#offcanvas-basetheme');
            buttonBaseThemeContainer.setAttribute('data-toggle', 'offcanvas');
            buttonBaseThemeContainer.setAttribute('data-backdrop', 'false');
            buttonBaseThemeContainer.setAttribute('title', 'Visualização das Camadas Base');

            const buttonBaseThemeContent = document.createElement('div');
            buttonBaseThemeContent.className = 'menu-icon';
            buttonBaseThemeContent.innerHTML = '<i class="gpi gpi-tema-base"></i>';

            buttonBaseThemeContainer.appendChild(buttonBaseThemeContent);
            buttonBaseTheme.appendChild(buttonBaseThemeContainer);

            // -- Layer tree theme --------------------------------------------------------------------
            const buttonTheme = document.createElement('li');

            const buttonThemeContainer = document.createElement('a');
            buttonThemeContainer.setAttribute('href', '#offcanvas-theme');
            buttonThemeContainer.setAttribute('data-toggle', 'offcanvas');
            buttonThemeContainer.setAttribute('data-backdrop', 'false');
            buttonThemeContainer.setAttribute('title', 'Visualização de Camadas');

            const buttonThemeContent = document.createElement('div');
            buttonThemeContent.className = 'menu-icon';
            buttonThemeContent.innerHTML = '<i class="gpi gpi-tema"></i>';

            buttonThemeContainer.appendChild(buttonThemeContent);
            buttonTheme.appendChild(buttonThemeContainer);

            // -- Layer tree for Edit -----------------------------------------------------------------
            var buttonThemeEdit = undefined;
            if (visibleOperations.EditLayers) {
                buttonThemeEdit = document.createElement('li');

                const buttonThemeEditContainer = document.createElement('a');
                buttonThemeEditContainer.setAttribute('href', '#offcanvas-theme-edit');
                buttonThemeEditContainer.setAttribute('data-toggle', 'offcanvas');
                buttonThemeEditContainer.setAttribute('data-backdrop', 'false');
                buttonThemeEditContainer.setAttribute('title', 'Editar Camadas');

                const buttonThemeEditContent = document.createElement('div');
                buttonThemeEditContent.className = 'menu-icon';
                buttonThemeEditContent.innerHTML = '<i class="gpi gpi-editar-camada"></i>';
                buttonThemeEditContainer.appendChild(buttonThemeEditContent);
                buttonThemeEdit.appendChild(buttonThemeEditContainer);
            }

            // -- Map list result -----------------------------------------------------------------
            const buttonMapList = document.createElement('li');

            const buttonMapListContainer = document.createElement('a');
            buttonMapListContainer.setAttribute('href', '#offcanvas-search-result'); // '#offcanvas-map-list');
            buttonMapListContainer.setAttribute('data-toggle', 'offcanvas');
            buttonMapListContainer.setAttribute('data-backdrop', 'false');
            buttonMapListContainer.setAttribute('title', 'Resultado da Pesquisa');
            //buttonMapListContainer.id = 'open-offcanvas-map-list';

            const buttonMapListContent = document.createElement('div');
            buttonMapListContent.className = 'menu-icon';
            buttonMapListContent.innerHTML = '<i class="material-icons btnCenterMenu" style="left: 15px;">list_alt</i>';

            buttonMapListContainer.appendChild(buttonMapListContent);
            buttonMapList.appendChild(buttonMapListContainer);

            // -- Map list result Expand ----------------------------------------------------------
            const buttonMapListExpand = document.createElement('li');

            const buttonMapListExpandContainer = document.createElement('a');
            buttonMapListExpandContainer.setAttribute('href', '#offcanvas-map-list'); // '#offcanvas-map-list');
            buttonMapListExpandContainer.setAttribute('data-toggle', 'offcanvas');
            buttonMapListExpandContainer.setAttribute('data-backdrop', 'false');
            buttonMapListExpandContainer.setAttribute('title', 'Resultado da Pesquisa detalhado');

            const buttonMapListExpandContent = document.createElement('div');
            buttonMapListExpandContent.className = 'menu-icon';
            buttonMapListExpandContent.innerHTML = '<i class="fa fa-list" style="line-height: 60px"></i>';

            buttonMapListExpandContainer.appendChild(buttonMapListExpandContent);
            buttonMapListExpand.appendChild(buttonMapListExpandContainer);

            // -- Entity form -------------------------------------------------------------------------
            const buttonEntityForm = document.createElement('li');

            const buttonEntityFormContainer = document.createElement('a');
            buttonEntityFormContainer.setAttribute('href', '#offcanvas-entity-form');
            buttonEntityFormContainer.setAttribute('data-toggle', 'offcanvas');
            buttonEntityFormContainer.setAttribute('data-backdrop', 'false');
            buttonEntityFormContainer.setAttribute('title', 'identificar');

            const buttonEntityContent = document.createElement('div');
            buttonEntityContent.className = 'menu-icon';
            buttonEntityContent.innerHTML = '<i class="gpi gpi-info"></i>';

            buttonEntityFormContainer.appendChild(buttonEntityContent);
            buttonEntityForm.appendChild(buttonEntityFormContainer);

            // -- zoom extend --------------------------------------------------------------------
            const buttonZoomExtend = document.createElement('li');

            const buttonZoomExtendContainer = document.createElement('a');
            buttonZoomExtendContainer.setAttribute('href', '#offcanvas-map-extend');
            buttonZoomExtendContainer.setAttribute('data-toggle', 'offcanvas');
            buttonZoomExtendContainer.setAttribute('data-backdrop', 'false');
            buttonZoomExtendContainer.setAttribute('title', 'Enquadramento Inicial');

            const buttonZoomExtendContent = document.createElement('div');
            buttonZoomExtendContent.className = 'menu-icon';
            buttonZoomExtendContent.innerHTML = '<i class="barra-ferramentas-line-height fa fa-home"></i>';

            buttonZoomExtendContainer.appendChild(buttonZoomExtendContent);
            buttonZoomExtend.appendChild(buttonZoomExtendContainer);

            const handleZoomExtend = function () {

                myMapSgs.map.getView().fit(myMapSgs._settings.extent, { "maxZoom": myMapSgs._settings.zoom })

            };

            buttonZoomExtend.addEventListener('click', handleZoomExtend, false);


            // -- Back Office --------------------------------------------------------------------
            const buttonBackOffice = document.createElement('li');

            const buttonBackOfficeContainer = document.createElement('a');
            buttonBackOfficeContainer.setAttribute('href', '#offcanvas-map-extend');
            buttonBackOfficeContainer.setAttribute('data-toggle', 'offcanvas');
            buttonBackOfficeContainer.setAttribute('data-backdrop', 'false');
            buttonBackOfficeContainer.setAttribute('title', 'Gestão de Mapas');

            const buttonBackOfficeContent = document.createElement('div');
            buttonBackOfficeContent.className = 'menu-icon';
            buttonBackOfficeContent.innerHTML = '<i class="barra-ferramentas-line-height fa fa-cogs"></i>';

            buttonBackOfficeContainer.appendChild(buttonBackOfficeContent);
            buttonBackOffice.appendChild(buttonBackOfficeContainer);

            const handleGotoBackoffice = function () {

                window.location.href = _BackofficeUrlkey;

            };

            buttonBackOffice.addEventListener('click', handleGotoBackoffice, false);

            // -- Separator 1 -------------------------------------------------------------------------
            const d1 = document.createElement('li');
            d1.className = 'divider';

            // -- Identifier Button -------------------------------------------------------------------
            const buttonInfo = document.createElement('li');

            const buttonInfoContainer = document.createElement('a');
            //buttonInfoContainer.setAttribute('href', '#target-gpi-identifier');
            buttonInfoContainer.id = 'target-gpi-identifier';
            buttonInfoContainer.className = 'target';

            buttonInfoContainer.setAttribute('title', 'identificar');

            const buttonInfoContent = document.createElement('div');
            buttonInfoContent.className = 'menu-icon';
            buttonInfoContent.innerHTML = '<i class="gpi gpi-info"></i>';

            buttonInfoContainer.appendChild(buttonInfoContent);
            buttonInfo.appendChild(buttonInfoContainer);

            // Slide button bar


            //const buttonIdentifierOption = document.createElement('div');
            //buttonIdentifierOption.className = "identifier-option-button-bar";
            //buttonIdentifierOptionLi.appendChild(buttonIdentifierOption);
            // Point
            const buttonIdentifierPoint = document.createElement('li');
            buttonIdentifierPoint.className = "identifier-button-option";
            buttonIdentifierPoint.setAttribute("style", 'display: none;');
            const buttonIdentifierPointContainer = document.createElement('a');
            buttonIdentifierPointContainer.setAttribute('href', '#target-gpi-identifier-point');
            buttonIdentifierPointContainer.id = 'target-gpi-identifier-point';
            buttonIdentifierPointContainer.className = 'target';
            const buttonIdentifierPointContent = document.createElement('div');
            buttonIdentifierPointContent.className = 'menu-icon';
            buttonIdentifierPointContent.innerHTML = '<i class="gpi gpi-ponto"></i>';
            buttonIdentifierPointContainer.appendChild(buttonIdentifierPointContent);
            buttonIdentifierPoint.appendChild(buttonIdentifierPointContainer);
            // Line
            const buttonIdentifierLine = document.createElement('li');
            buttonIdentifierLine.className = "identifier-button-option";
            buttonIdentifierLine.setAttribute("style", 'display: none;');
            const buttonIdentifierLineContainer = document.createElement('a');
            buttonIdentifierLineContainer.id = 'target-gpi-linha';
            buttonIdentifierLineContainer.className = 'target';
            buttonIdentifierLineContainer.setAttribute('title', 'Medição');
            const buttonIdentifierLineContent = document.createElement('div');
            buttonIdentifierLineContent.className = 'menu-icon';
            buttonIdentifierLineContent.innerHTML = '<i class="gpi gpi-linha"></i>';
            buttonIdentifierLineContainer.appendChild(buttonIdentifierLineContent);
            buttonIdentifierLine.appendChild(buttonIdentifierLineContainer);
            // Circle
            const buttonIdentifierCircle = document.createElement('li');
            buttonIdentifierCircle.className = "identifier-button-option";
            buttonIdentifierCircle.setAttribute("style", 'display: none;');
            const buttonIdentifierCircleContainer = document.createElement('a');
            buttonIdentifierCircleContainer.id = 'target-gpi-linha';
            buttonIdentifierCircleContainer.className = 'target';
            buttonIdentifierCircleContainer.setAttribute('title', 'Medição');
            const buttonIdentifierCircleContent = document.createElement('div');
            buttonIdentifierCircleContent.className = 'menu-icon';
            buttonIdentifierCircleContent.innerHTML = '<i class="gpi gpi-circulo-raio icon-circle-button"></i>';
            buttonIdentifierCircleContainer.appendChild(buttonIdentifierCircleContent);
            buttonIdentifierCircle.appendChild(buttonIdentifierCircleContainer);
            // Polygon
            const buttonIdentifierPolygon = document.createElement('li');
            buttonIdentifierPolygon.className = "identifier-button-option";
            buttonIdentifierPolygon.setAttribute("style", 'display: none;');
            const buttonIdentifierPolygonContainer = document.createElement('a');
            buttonIdentifierPolygonContainer.id = 'target-gpi-linha';
            buttonIdentifierPolygonContainer.className = 'target';
            buttonIdentifierPolygonContainer.setAttribute('title', 'Medição');
            const buttonIdentifierPolygonContent = document.createElement('div');
            buttonIdentifierPolygonContent.className = 'menu-icon';
            buttonIdentifierPolygonContent.innerHTML = '<i class="gpi gpi-poligono"></i>';
            buttonIdentifierPolygonContainer.appendChild(buttonIdentifierPolygonContent);
            buttonIdentifierPolygon.appendChild(buttonIdentifierPolygonContainer);
            // separator
            const sepatorIdentifier = document.createElement('li');
            sepatorIdentifier.className = 'divider identifier-button-option';
            sepatorIdentifier.setAttribute("style", 'display: none;');

            const this_ = this;
            const handleIdentifier = function (e) {

                if ($('#target-gpi-identifier').hasClass('button-selected')) {
                    $('#target-gpi-identifier').removeClass('button-selected');

                    myMapSgs.identify.removeInteractionMap();

                }
                else {

                    $('#target-gpi-identifier').addClass('button-selected');

                    myMapSgs.identify.BuildInfoIndentify('Point');

                    // Show canvas search result
                    myMapSgs._utility.ShowOpenCanvas3('offcanvas-search-result', true);

                }
                $('.identifier-button-option').toggle('ol-hidden');


            };

            buttonInfo.addEventListener('click', handleIdentifier, false);
            //buttonInfo.addEventListener('touchstart', handleIdentifier, false);

            // Handle identifier point
            const handleIdentifierPoint = function () {

                myMapSgs._utility.HoldButtonEffect('main-menu', 'target-gpi-identifier-point');
                myMapSgs._utility.RemoveActiveButton('target-gpi-identifier-point');
                //app.layerDrawLine.getSource().clear();
                //app.layerDraw.getSource().clear();
                //app.Select.setActive(false);
                //app.DrawLine.setActive(false);
                //app.Draw.setActive(false);

                if ($(this).hasClass('active')) {
                    $(this).removeClass('active');
                    //app.DrawPoint.setActive(false);
                    myMapSgs.map.getTargetElement().style.cursor = 'auto';
                    myMapSgs.identifierActive = false;
                    //app.layerDrawPoint.getSource().clear();

                    // Active tooltips
                    if (visibleOperations.Tooltips) {
                        // Remove event layer identifier 
                        //myMapSgs.map.un('singleclick', myMapSgs.identify.BuildInfoIndentifyPoint); // Função não existe

                        // Add event layer tooltips
                        myMapSgs.map.on('singleclick', async (e) => { await myMapSgs.tooltips.BuildInfoTooltips(e); });
                    }
                }
                else {
                    $(this).addClass('active');
                    //app.DrawPoint.setActive(true);
                    myMapSgs.map.getTargetElement().style.cursor = 'crosshair';
                    //myMapSgs.identifierActive = true;

                    // Desactive tooltips
                    if (visibleOperations.Tooltips) {
                        // Remove event layer tooltips
                        myMapSgs.map.un('singleclick', myMapSgs.tooltips.BuildInfoTooltips);

                        // Add event layer identifier 
                        myMapSgs.map.on('singleclick', async (e) => { await myMapSgs.identify.BuildInfoIndentifyPoint(e); });
                    }
                }
            };
            buttonIdentifierPoint.addEventListener('click', handleIdentifierPoint, false);

            // -- Pan Button --------------------------------------------------------------------------
            const buttonPan = document.createElement('li');

            const buttonPanContainer = document.createElement('a');
            buttonPanContainer.setAttribute('href', '#');

            const buttonPanContent = document.createElement('div');
            buttonPanContent.className = 'menu-icon';
            buttonPanContent.innerHTML = '<i class="gpi gpi-pan"></i>';

            buttonPanContainer.appendChild(buttonPanContent);
            buttonPan.appendChild(buttonPanContainer);

            // -- Statistics --------------------------------------------------------------------
            const buttonStatistics = document.createElement('li');
            if (visibleOperations.Statistics) {
                const buttonStatisticsContainer = document.createElement('a');
                buttonStatisticsContainer.setAttribute('href', '#offcanvas-statistics');
                buttonStatisticsContainer.setAttribute('data-toggle', 'offcanvas');
                buttonStatisticsContainer.setAttribute('data-backdrop', 'false');
                buttonStatisticsContainer.setAttribute('title', 'Estatísticas');

                const buttonStatisticsContent = document.createElement('div');
                buttonStatisticsContent.className = 'menu-icon';
                buttonStatisticsContent.innerHTML = '<i class="gpi gpi-estatisticas"></i>';
                //buttonStatisticsContent.innerHTML = '<i class="gpi gpi-elemento-caracterizacao"></i>';

                buttonStatisticsContainer.appendChild(buttonStatisticsContent);
                buttonStatistics.appendChild(buttonStatisticsContainer);
            }


            ///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
            //////////////////////////////////////////////////////////////////////////ANACOM///////////////////////////////////////////////////////////////////////////////////////////
            ///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
            ///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

            const buttonareainfluence = document.createElement('li');
            if (visibleOperations.Anacom != null) {
                const buttonareainfluenceContainer = document.createElement('a');
                buttonareainfluenceContainer.id = 'id-area-influence';
                buttonareainfluenceContainer.setAttribute('data-backdrop', 'false');
                buttonareainfluenceContainer.setAttribute('title', 'Criar Área de influência');

                const buttonareainfluenceContent = document.createElement('div');
                buttonareainfluenceContent.className = 'menu-icon';
                buttonareainfluenceContent.innerHTML = '<i class="gpi gpi-selecionar" style="line-height: 60px"></i>';

                buttonareainfluenceContainer.appendChild(buttonareainfluenceContent);
                buttonareainfluence.appendChild(buttonareainfluenceContainer);
            }
            const handlebuttonareainfluence = function () {
                if ($('.areainfluence-button-option').is(':visible')) {
                    $('#id-area-influence').removeClass('button-selected');
                    $('.areainfluence-button-option').removeClass('button-selected');
                }
                else {
                    $('#id-area-influence').addClass('button-selected');
                    $('.areainfluence-button-option').addClass('button-selected');
                }
                $('.areainfluence-button-option').toggle('ol-hidden');
            };

            buttonareainfluence.addEventListener('click', handlebuttonareainfluence, false);

            const buttongpipoligono = document.createElement('li');
            if (mapSettings.operation_visible.Anacom != null) {

                const buttongpipoligonoContainer = document.createElement('a');
                buttongpipoligonoContainer.className = 'menu-icon';
                buttongpipoligonoContainer.setAttribute('data-toggle', 'offcanvas');
                buttongpipoligonoContainer.className = "areainfluence-button-option";
                buttongpipoligonoContainer.setAttribute("style", 'display: none;');
                buttongpipoligonoContainer.setAttribute('data-backdrop', 'false');
                buttongpipoligonoContainer.setAttribute('title', 'Polígono');

                const buttongpipoligonoContent = document.createElement('i');
                buttongpipoligonoContent.className = 'menu-icon';
                buttongpipoligonoContent.innerHTML = '<i class="gpi gpi-poligono" style="line-height: 60px"></i>';

                buttongpipoligonoContainer.appendChild(buttongpipoligonoContent);
                buttongpipoligono.appendChild(buttongpipoligonoContainer);

            }

            const buttonIdentifierCircleAnacom = document.createElement('li');
            if (mapSettings.operation_visible.Anacom != null) {
                const buttonIdentifierCircleAnacomContainer = document.createElement('a');
                //buttonInfoContainer.setAttribute('href', '#target-gpi-identifier');
                buttonIdentifierCircleAnacomContainer.id = 'target-gpi-identifier-circle';
                buttonIdentifierCircleAnacomContainer.className = 'target';
                buttonIdentifierCircleAnacomContainer.className = "areainfluence-button-option";
                buttonIdentifierCircleAnacomContainer.setAttribute("style", 'display: none;');
                buttonIdentifierCircleAnacomContainer.setAttribute('title', 'identificar');

                const buttonIdentifierCircleAnacomContent = document.createElement('div');
                buttonIdentifierCircleAnacomContent.className = 'menu-icon';
                buttonIdentifierCircleAnacomContent.innerHTML = '<i class="gpi gpi-circulo-raio"></i>';

                buttonIdentifierCircleAnacomContainer.appendChild(buttonIdentifierCircleAnacomContent);
                buttonIdentifierCircleAnacom.appendChild(buttonIdentifierCircleAnacomContainer);
            }

            const buttongpidistanciainterativa = document.createElement('li');
            if (mapSettings.operation_visible.Anacom != null) {

                const buttongpidistanciainterativaContainer = document.createElement('a');
                buttongpidistanciainterativaContainer.className = 'menu-icon';
                buttongpidistanciainterativaContainer.setAttribute('data-toggle', 'offcanvas');
                buttongpidistanciainterativaContainer.className = "areainfluence-button-option";
                buttongpidistanciainterativaContainer.setAttribute("style", 'display: none;');
                buttongpidistanciainterativaContainer.setAttribute('data-backdrop', 'false');
                buttongpidistanciainterativaContainer.setAttribute('title', 'Distancia interativa');

                const buttondistanciainterativaContent = document.createElement('i');
                buttondistanciainterativaContent.className = 'menu-icon';
                buttondistanciainterativaContent.innerHTML = '<i class="gpi gpi-distancia-interativa" style="line-height: 60px"></i>';

                buttongpidistanciainterativaContainer.appendChild(buttondistanciainterativaContent);
                buttongpidistanciainterativa.appendChild(buttongpidistanciainterativaContainer);

            }

            const buttonlineinfluence = document.createElement('li');
            if (mapSettings.operation_visible.Anacom != null) {

                const buttonlineinfluenceContainer = document.createElement('a');
                buttonlineinfluenceContainer.className = 'menu-icon';
                buttonlineinfluenceContainer.setAttribute('data-toggle', 'offcanvas');
                buttonlineinfluenceContainer.setAttribute('data-backdrop', 'false');
                buttonlineinfluenceContainer.setAttribute('title', 'Linha');
                buttonlineinfluenceContainer.className = "areainfluence-button-option";
                buttonlineinfluenceContainer.setAttribute("style", 'display: none;');

                const buttonlineinfluenceContent = document.createElement('i');
                buttonlineinfluenceContent.className = 'menu-icon';
                buttonlineinfluenceContent.innerHTML = '<i class="gpi gpi-area-linha" style="line-height: 60px"></i>';

                buttonlineinfluenceContainer.appendChild(buttonlineinfluenceContent);
                buttonlineinfluence.appendChild(buttonlineinfluenceContainer);

            }


            // -- ANACOM Cluster --------------------------------------------------------------------
            const buttonAnacomCluster = document.createElement('li');
            if (visibleOperations.Anacom != null) {
                const buttonAnacomClusterContainer = document.createElement('a');
                buttonAnacomClusterContainer.setAttribute('href', '#offcanvas-Cluster');
                buttonAnacomClusterContainer.setAttribute('data-toggle', 'offcanvas');
                buttonAnacomClusterContainer.setAttribute('data-backdrop', 'false');
                buttonAnacomClusterContainer.setAttribute('title', 'Cluster');

                const buttonAnacomClusterContent = document.createElement('div');
                buttonAnacomClusterContent.className = 'menu-icon';
                buttonAnacomClusterContent.innerHTML = '<i class="gpi gpi-clusters" style="line-height: 60px"></i>';

                buttonAnacomClusterContainer.appendChild(buttonAnacomClusterContent);
                buttonAnacomCluster.appendChild(buttonAnacomClusterContainer);
            }

            const handlebuttonAnacomCluster = function () {

                myMapSgs.layerTree.layerInfo.dict_layer_info

                //$.each(myMapSgs.layerTree.layerInfo.dict_layer_info, function (index, value) { })

                $('#offcanvas-Cluster-body [type="radio"]').remove();

                $('#offcanvas-Cluster-body img').parent().remove();

                for (var item in myMapSgs.layerTree.layerInfo.dict_layer_info) {
                    if (myMapSgs.layerTree.layerInfo.dict_layer_info[item].layer_info.has_cluster == true) {
                        myMapSgs.layerTree.layerInfo.dict_layer_info[item].layer_info.layerName

                        //var radioAnacomCluster = $('<input class="remove-Cluster" id="' + myMapSgs.layerTree.layerInfo.dict_layer_info[item].layer_info.id + '" name="base_layer" type="radio" class="cluster-group with-gap radio-col-deep-orange">' +
                        //    '<label class="remove-Cluster" style="width: 300px;" for="' + myMapSgs.layerTree.layerInfo.dict_layer_info[item].layer_info.id + '">' + myMapSgs.layerTree.layerInfo.dict_layer_info[item].layer_info.pretty_name + '</label>');
                        //radioAnacomCluster.appendTo($('#offcanvas-Cluster-body'));

                        //var imageAnacomCluster = $('<img src="' + myMapSgs.layerTree.layerInfo.dict_layer_info[item].layer_info.legendUrl + '"/>');

                        //imageAnacomCluster.appendTo($('[for="' + myMapSgs.layerTree.layerInfo.dict_layer_info[item].layer_info.id+'"]'))

                        var radioAnacomCluster = $('<input type="radio" class="remove-Cluster" style="width: 100%;" id="' + myMapSgs.layerTree.layerInfo.dict_layer_info[item].layer_info.id + '" name="cluster" />' +
                            '<label for="' + myMapSgs.layerTree.layerInfo.dict_layer_info[item].layer_info.id + '"><img src="' + myMapSgs.layerTree.layerInfo.dict_layer_info[item].layer_info.legendUrl + '" />' + myMapSgs.layerTree.layerInfo.dict_layer_info[item].layer_info.pretty_name + '</label >')

                        radioAnacomCluster.appendTo($('#offcanvas-Cluster-body'))

                    }

                }
            };

            buttonAnacomCluster.addEventListener('click', handlebuttonAnacomCluster, false);


            // -- ANACOM heatmap --------------------------------------------------------------------
            const buttonAnacomHeatMap = document.createElement('li');
            if (visibleOperations.Anacom != null) {
                const buttonAnacomHeatMapContainer = document.createElement('a');
                //buttonAnacomHeatMapContainer.id = 'id-HeatMap'
                buttonAnacomHeatMapContainer.setAttribute('href', '#offcanvas-Heatmap');
                buttonAnacomHeatMapContainer.setAttribute('data-toggle', 'offcanvas');
                buttonAnacomHeatMapContainer.setAttribute('data-backdrop', 'false');
                buttonAnacomHeatMapContainer.setAttribute('title', 'Mapa de calor');

                const buttonAnacomHeatMapContent = document.createElement('div');
                buttonAnacomHeatMapContent.className = 'menu-icon';
                buttonAnacomHeatMapContent.innerHTML = '<i class="gpi gpi-heatmap" style="line-height: 60px"></i>';

                buttonAnacomHeatMapContainer.appendChild(buttonAnacomHeatMapContent);
                buttonAnacomHeatMap.appendChild(buttonAnacomHeatMapContainer);
            }
            const handlebuttonAnacomHeatmap = function () {

                myMapSgs.layerTree.layerInfo.dict_layer_info

                //$.each(myMapSgs.layerTree.layerInfo.dict_layer_info, function (index, value) { })

                $('#offcanvas-heatmap-body label').remove()

                $('#offcanvas-heatmap-body input').remove()

                for (var item in myMapSgs.layerTree.layerInfo.dict_layer_info) {
                    if (myMapSgs.layerTree.layerInfo.dict_layer_info[item].layer_info.has_heatmap == true) {
                        myMapSgs.layerTree.layerInfo.dict_layer_info[item].layer_info.layerName

                        //var radioAnacomCluster = $('<input class="remove-heatmap" id="' + myMapSgs.layerTree.layerInfo.dict_layer_info[item].layer_info.id + '" name="heat_map" type="radio" class="cluster-group with-gap radio-col-deep-orange">' +
                        //    '<label class="remove-heatmap" style="width: 300px;" for="' + myMapSgs.layerTree.layerInfo.dict_layer_info[item].layer_info.id + '">' + myMapSgs.layerTree.layerInfo.dict_layer_info[item].layer_info.pretty_name + '</label>');
                        //radioAnacomCluster.appendTo($('#offcanvas-heatmap-body'));

                        var radioAnacomCluster = $('<input type="radio" class="remove-heatmap" style="width: 100%;" id="' + myMapSgs.layerTree.layerInfo.dict_layer_info[item].layer_info.id + '" name="heat_map" />' +
                            '<label for="' + myMapSgs.layerTree.layerInfo.dict_layer_info[item].layer_info.id + '"><img src="' + myMapSgs.layerTree.layerInfo.dict_layer_info[item].layer_info.legendUrl + '" />' + myMapSgs.layerTree.layerInfo.dict_layer_info[item].layer_info.pretty_name + '</label >')

                        radioAnacomCluster.appendTo($('#offcanvas-heatmap-body'))

                        //var imageAnacomCluster = $('<img src="' + myMapSgs.layerTree.layerInfo.dict_layer_info[item].layer_info.legendUrl + '"/>');

                        //imageAnacomCluster.appendTo($('[for="' + myMapSgs.layerTree.layerInfo.dict_layer_info[item].layer_info.id + '"]'))

                    }

                }
            };

            buttonAnacomHeatMap.addEventListener('click', handlebuttonAnacomHeatmap, false);

            // -- Separator anacom -------------------------------------------------------------------------
            const danacom = document.createElement('li');
            danacom.className = 'divider';

            const buttonAllScreen = document.createElement('li');
            if (mapSettings.operation_visible.Anacom != null) {

                const buttonAllScreenContainer = document.createElement('a');
                buttonAllScreenContainer.setAttribute('href', '#offcanvas-all-Screen');
                buttonAllScreenContainer.className = 'menu-icon';
                buttonAllScreenContainer.setAttribute('data-toggle', 'offcanvas');
                buttonAllScreenContainer.setAttribute('data-backdrop', 'false');
                buttonAllScreenContainer.setAttribute('title', 'Ecra Inteiro');


                const buttonAllScreenContent = document.createElement('div');
                buttonAllScreenContent.className = 'menu-icon';
                buttonAllScreenContent.innerHTML = '<i class="gpi gpi-ecra-inteiro" style="line-height: 60px"></i>';

                buttonAllScreenContainer.appendChild(buttonAllScreenContent);
                buttonAllScreen.appendChild(buttonAllScreenContainer);

            }

            const buttonCreateoccurrence = document.createElement('li');
            if (mapSettings.operation_visible.Anacom != null) {

                const buttonCreateoccurrenceContainer = document.createElement('a');
                buttonCreateoccurrenceContainer.setAttribute('href', '#offcanvas-create-occurrence');
                buttonCreateoccurrenceContainer.className = 'menu-icon';
                buttonCreateoccurrenceContainer.setAttribute('data-toggle', 'offcanvas');
                buttonCreateoccurrenceContainer.setAttribute('data-backdrop', 'false');
                buttonCreateoccurrenceContainer.setAttribute('title', 'Criar ocorrência');

                const buttonCreateOccurrenceContent = document.createElement('i');
                buttonCreateOccurrenceContent.className = 'menu-icon';
                buttonCreateOccurrenceContent.innerHTML = '<i class="gpi gpi-ocorrencia" style="line-height: 60px"></i>';

                buttonCreateoccurrenceContainer.appendChild(buttonCreateOccurrenceContent);
                buttonCreateoccurrence.appendChild(buttonCreateoccurrenceContainer);

            }

            const buttoncalculateroute = document.createElement('li');
            if (mapSettings.operation_visible.Anacom != null) {

                const buttoncalculaterouteContainer = document.createElement('a');
                buttoncalculaterouteContainer.className = 'menu-icon';
                buttoncalculaterouteContainer.setAttribute('data-toggle', 'offcanvas');
                buttoncalculaterouteContainer.setAttribute('data-backdrop', 'false');
                buttoncalculaterouteContainer.setAttribute('title', 'Calcular trajeto');

                const buttoncalculaterouteContent = document.createElement('i');
                buttoncalculaterouteContent.className = 'menu-icon';
                buttoncalculaterouteContent.innerHTML = '<i class="gpi gpi-calculo-trajeto" style="line-height: 60px"></i>';

                buttoncalculaterouteContainer.appendChild(buttoncalculaterouteContent);
                buttoncalculateroute.appendChild(buttoncalculaterouteContainer);

            }
            const handlebuttoncalculateroute = function () {

                myMapSgs._utility.ShowOpenCanvas3('offcanvas-calculate-route-form', true);

            };

            buttoncalculateroute.addEventListener('click', handlebuttoncalculateroute, false);

            const buttonregistrationobject = document.createElement('li');
            if (mapSettings.operation_visible.Anacom != null) {

                const buttonregistrationobjectContainer = document.createElement('a');
                buttonregistrationobjectContainer.className = 'menu-icon';
                buttonregistrationobjectContainer.setAttribute('data-toggle', 'offcanvas');
                buttonregistrationobjectContainer.setAttribute('data-backdrop', 'false');
                buttonregistrationobjectContainer.setAttribute('title', 'Criar objeto cadastro');

                const buttonregistrationobjectContent = document.createElement('i');
                buttonregistrationobjectContent.className = 'menu-icon';
                buttonregistrationobjectContent.innerHTML = '<i class="gpi gpi-criar-objeto-cadastro" style="line-height: 60px"></i>';

                buttonregistrationobjectContainer.appendChild(buttonregistrationobjectContent);
                buttonregistrationobject.appendChild(buttonregistrationobjectContainer);

            }
            const handlebuttoncreateObjectRegister = function () {

                $('#id-anacom-search').removeClass('active');

                myMapSgs._utility.ShowOpenCanvas3('offcanvas-creation-object-register-form', true);

                if ($('#form-create-object-register').is(':visible')) {
                    $('#form-object-register-options').toggle('ol-hidden');

                    $('#form-create-object-register').toggle('ol-hidden');

                    if ($('#id-buttons-create-object-register').is(':visible'))
                        $('#id-buttons-create-object-register').toggle('ol-hidden');

                    $('#id-buttons-options-create-object-register').toggle('ol-hidden');

                    if ($('#id-buttons-edit-object-register').is(':visible'))
                        $('#id-buttons-edit-object-register').toggle('ol-hidden');
                }

                $('#offcanvas-creation-object-register-form header')[0].innerText = 'Criar objeto de cadastro';

                $('#form-create-object-register [name=objeto_cadastro-elemento]').val('');

                $('#form-create-object-register [name=distrito]').val('').selectpicker("refresh");

                $('#form-create-object-register [name=concelho]').val('').selectpicker("refresh");

                $('#form-create-object-register [name=freguesia]').val('').selectpicker("refresh");

                $('#form-create-object-register [name=freguesia]').val('').selectpicker("refresh");

                $('#form-create-object-register [name=Afetacao-principal-elemento]').val('').selectpicker("refresh");

                $('#form-create-object-register [name=Comprimento-elemento]').val('');

                $('#form-create-object-register [name=Largura-elemento]').val('');

                $('#form-create-object-register [name=Altura-elemento]').val('');

                $('#form-create-object-register [name=Tipo_Utilizacao-elemento]').val('').selectpicker("refresh");

                $('#form-create-object-register [name=Estado_operacional-elemento]').val('').selectpicker("refresh");

                $('#form-create-object-register [name=Ocupação-elemento]').val('');

                $('#form-create-object-register [name=Documentação-elemento]').val('').selectpicker("refresh");

            };

            buttonregistrationobject.addEventListener('click', handlebuttoncreateObjectRegister, false);


            const buttongpibomapas = document.createElement('li');
            if (mapSettings.operation_visible.Anacom != null) {

                const buttongpibomapasContainer = document.createElement('a');
                buttongpibomapasContainer.className = 'menu-icon';
                buttongpibomapasContainer.setAttribute('data-toggle', 'offcanvas');
                buttongpibomapasContainer.setAttribute('data-backdrop', 'false');
                buttongpibomapasContainer.setAttribute('title', 'Criar mapa');

                const buttongpibomapasContent = document.createElement('i');
                buttongpibomapasContent.className = 'menu-icon';
                buttongpibomapasContent.innerHTML = '<i class="gpi gpi-bo-mapas" style="line-height: 60px"></i>';

                buttongpibomapasContainer.appendChild(buttongpibomapasContent);
                buttongpibomapas.appendChild(buttongpibomapasContainer);

            }

            const buttongpimedicao = document.createElement('li');
            if (mapSettings.operation_visible.Anacom != null) {

                const buttongpimedicaoContainer = document.createElement('a');
                buttongpimedicaoContainer.className = 'menu-icon';
                buttongpimedicaoContainer.setAttribute('data-toggle', 'offcanvas');
                buttongpimedicaoContainer.id = 'target-gpi-medicao';
                buttongpimedicaoContainer.setAttribute('data-backdrop', 'false');
                buttongpimedicaoContainer.setAttribute('title', 'Medição');

                const buttongpimedicaoContent = document.createElement('i');
                buttongpimedicaoContent.className = 'menu-icon';
                buttongpimedicaoContent.innerHTML = '<i class="gpi gpi-medicao" style="line-height: 60px"></i>';

                buttongpimedicaoContainer.appendChild(buttongpimedicaoContent);
                buttongpimedicao.appendChild(buttongpimedicaoContainer);

            }

            const handlebuttongpimedicao = function () {
                if ($('.measurement-button-option').is(':visible')) {
                    $('#target-gpi-medicao').removeClass('button-selected');
                    $('.measurement-button-option').removeClass('button-selected');
                }
                else {
                    $('#target-gpi-medicao').addClass('button-selected');
                    $('.measurement-button-option').addClass('button-selected');
                }
                $('.measurement-button-option').toggle('ol-hidden');
            };

            buttongpimedicao.addEventListener('click', handlebuttongpimedicao, false);

            const buttongpiarea = document.createElement('li');
            if (mapSettings.operation_visible.Anacom != null) {

                const buttongpiareaContainer = document.createElement('a');
                buttongpiareaContainer.className = 'menu-icon';
                buttongpiareaContainer.setAttribute('data-toggle', 'offcanvas');
                buttongpiareaContainer.setAttribute('data-backdrop', 'false');
                buttongpiareaContainer.setAttribute('title', 'Área');
                buttongpiareaContainer.className = "measurement-button-option";
                buttongpiareaContainer.setAttribute("style", 'display: none;');

                const buttongpiareaContent = document.createElement('i');
                buttongpiareaContent.className = 'menu-icon';
                buttongpiareaContent.innerHTML = '<i class="gpi gpi-area" style="line-height: 60px"></i>';

                buttongpiareaContainer.appendChild(buttongpiareaContent);
                buttongpiarea.appendChild(buttongpiareaContainer);

            }

            const buttongtaxaocupacao = document.createElement('li');
            if (mapSettings.operation_visible.Anacom != null) {

                const buttongtaxaocupacaoContainer = document.createElement('a');
                buttongtaxaocupacaoContainer.className = 'menu-icon';
                buttongtaxaocupacaoContainer.setAttribute('data-toggle', 'offcanvas');
                buttongtaxaocupacaoContainer.setAttribute('data-backdrop', 'false');
                buttongtaxaocupacaoContainer.setAttribute('title', 'Quota de propriedade');
                buttongtaxaocupacaoContainer.className = "taxa-button-option";
                buttongtaxaocupacaoContainer.setAttribute("style", 'display: none;');

                const buttongtaxaocupacaoContent = document.createElement('i');
                buttongtaxaocupacaoContent.className = 'menu-icon';
                buttongtaxaocupacaoContent.innerHTML = '<i class="gpi gpi-taxa-ocupacao" style="line-height: 60px"></i>';

                buttongtaxaocupacaoContainer.appendChild(buttongtaxaocupacaoContent);
                buttongtaxaocupacao.appendChild(buttongtaxaocupacaoContainer);

            }

            const buttontaxacobertura = document.createElement('li');
            if (mapSettings.operation_visible.Anacom != null) {

                const buttontaxacoberturaContainer = document.createElement('a');
                buttontaxacoberturaContainer.className = 'menu-icon';
                buttontaxacoberturaContainer.setAttribute('data-toggle', 'offcanvas');
                buttontaxacoberturaContainer.setAttribute('data-backdrop', 'false');
                buttontaxacoberturaContainer.setAttribute('title', 'Quota de cobertura');
                buttontaxacoberturaContainer.className = "taxa-button-option";
                buttontaxacoberturaContainer.setAttribute("style", 'display: none;');

                const buttontaxacoberturaContent = document.createElement('i');
                buttontaxacoberturaContent.className = 'menu-icon';
                buttontaxacoberturaContent.innerHTML = '<i class="gpi gpi-taxa-cobertura" style="line-height: 60px"></i>';

                buttontaxacoberturaContainer.appendChild(buttontaxacoberturaContent);
                buttontaxacobertura.appendChild(buttontaxacoberturaContainer);

            }

            const buttontaxas = document.createElement('li');
            if (mapSettings.operation_visible.Anacom != null) {

                const buttontaxasContainer = document.createElement('a');
                buttontaxasContainer.className = 'menu-icon';
                buttontaxasContainer.setAttribute('data-toggle', 'offcanvas');
                buttontaxasContainer.setAttribute('data-backdrop', 'false');
                buttontaxasContainer.setAttribute('title', 'Quotas');
                buttontaxasContainer.id = "button-gpi-taxas";

                const buttontaxasContent = document.createElement('i');
                buttontaxasContent.className = 'menu-icon';
                buttontaxasContent.innerHTML = '<i class="gpi gpi-taxas" style="line-height: 60px"></i>';

                buttontaxasContainer.appendChild(buttontaxasContent);
                buttontaxas.appendChild(buttontaxasContainer);

            }
            const handlebuttontaxas = function () {
                if ($('.taxa-button-option').is(':visible')) {
                    $('#button-gpi-taxas').removeClass('button-selected');
                    $('.taxa-button-option').removeClass('button-selected');
                }
                else {
                    $('#button-gpi-taxas').addClass('button-selected');
                    $('.taxa-button-option').addClass('button-selected');
                }
                $('.taxa-button-option').toggle('ol-hidden');
            };

            buttontaxas.addEventListener('click', handlebuttontaxas, false);


            const buttonCreateEvent = document.createElement('li');
            if (mapSettings.operation_visible.Anacom != null) {

                const buttonCreateEventContainer = document.createElement('a');
                buttonCreateEventContainer.className = 'menu-icon';
                buttonCreateEventContainer.setAttribute('data-toggle', 'offcanvas');
                buttonCreateEventContainer.setAttribute('data-backdrop', 'false');
                buttonCreateEventContainer.setAttribute('title', 'Criar evento');

                const buttonCreateEventContent = document.createElement('i');
                buttonCreateEventContent.className = 'menu-icon';
                buttonCreateEventContent.innerHTML = '<i class="gpi gpi-enviar-reclamacao" style="line-height: 60px"></i>';

                buttonCreateEventContainer.appendChild(buttonCreateEventContent);
                buttonCreateEvent.appendChild(buttonCreateEventContainer);

            }

            //const buttonsaveimage = document.createElement('li');
            //if (mapSettings.operation_visible.Anacom != null) {

            //    const buttonsaveimageContainer = document.createElement('a');
            //    buttonsaveimageContainer.className = 'menu-icon';
            //    buttonsaveimageContainer.setAttribute('data-toggle', 'offcanvas');
            //    buttonsaveimageContainer.setAttribute('data-backdrop', 'false');
            //    buttonsaveimageContainer.setAttribute('title', 'Guardar imagem');

            //    const buttonsaveimageContent = document.createElement('i');
            //    buttonsaveimageContent.className = 'menu-icon';
            //    buttonsaveimageContent.innerHTML = '<i class="gpi gpi-snapshot" style="line-height: 60px"></i>';

            //    buttonsaveimageContainer.appendChild(buttonsaveimageContent);
            //    buttonsaveimage.appendChild(buttonsaveimageContainer);

            //}

            const buttonzoomarea = document.createElement('li');
            if (mapSettings.operation_visible.Anacom != null) {

                const buttonzoomareaContainer = document.createElement('a');
                buttonzoomareaContainer.className = 'menu-icon';
                buttonzoomareaContainer.setAttribute('data-toggle', 'offcanvas');
                buttonzoomareaContainer.setAttribute('data-backdrop', 'false');
                buttonzoomareaContainer.setAttribute('title', 'Zoom por área');

                const buttonsavebuttonzoomarea = document.createElement('i');
                buttonsavebuttonzoomarea.className = 'menu-icon';
                buttonsavebuttonzoomarea.innerHTML = '<i class="gpi gpi-zoom-area" style="line-height: 60px"></i>';

                buttonzoomareaContainer.appendChild(buttonsavebuttonzoomarea);
                buttonzoomarea.appendChild(buttonzoomareaContainer);

            }

            // -- Identifier Button -------------------------------------------------------------------

            const buttonInfoanacom = document.createElement('li');

            if (mapSettings.operation_visible.Anacom != null) {
                const buttonInfoanacomContainer = document.createElement('a');
                //buttonInfoContainer.setAttribute('href', '#target-gpi-identifier');
                buttonInfoanacomContainer.id = 'target-gpi-identifier';
                buttonInfoanacomContainer.className = 'target';
                buttonInfoanacomContainer.setAttribute('title', 'Informação multi-camada');

                const buttonInfoanacomContent = document.createElement('div');
                buttonInfoanacomContent.className = 'menu-icon';
                buttonInfoanacomContent.innerHTML = '<i class="gpi gpi-info"></i>';

                buttonInfoanacomContainer.appendChild(buttonInfoanacomContent);
                buttonInfoanacom.appendChild(buttonInfoanacomContainer);
            }

            const danacom2 = document.createElement('li');
            danacom2.className = 'divider';

            const danacom3 = document.createElement('li');
            danacom3.className = 'divider';

            const danacom4 = document.createElement('li');
            danacom4.className = 'divider';

            const danacom5 = document.createElement('li');
            danacom5.className = 'divider';

            const danacom6 = document.createElement('li');
            danacom6.className = 'divider';

            ///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
            //////////////////////////////////////////////////////////////////////////ANACOM///////////////////////////////////////////////////////////////////////////////////////////
            ///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
            ///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

            // -- Zoom in -----------------------------------------------------------------------------
            const buttonZoomIn = document.createElement('li');

            const buttonZoomInContainer = document.createElement('a');
            buttonZoomInContainer.setAttribute('href', '#zoom_button_offcanvas');
            buttonZoomInContainer.setAttribute('data-toggle', 'offcanvas');
            buttonZoomInContainer.setAttribute('data-backdrop', 'false');
            buttonZoomInContainer.setAttribute('title', 'Aproximar');

            const buttonZoomInContent = document.createElement('div');
            buttonZoomInContent.className = 'menu-icon';
            buttonZoomInContent.innerHTML = '<i class="gpi gpi-zoom"></i>';
            buttonZoomInContent.id = 'zoom_button';

            buttonZoomInContainer.addEventListener('click', function () {
                myMapSgs.map.getView().setZoom(myMapSgs.map.getView().getZoom() + 1);
            }, false);

            buttonZoomInContainer.appendChild(buttonZoomInContent);

            buttonZoomIn.appendChild(buttonZoomInContainer);

            // -- Zoom Out -----------------------------------------------------------------------------
            const buttonZoomOut = document.createElement('li');

            const buttonZoomOutContainer = document.createElement('a');
            buttonZoomOutContainer.setAttribute('href', '#zoom_button_offcanvas');
            buttonZoomOutContainer.setAttribute('data-toggle', 'offcanvas');
            buttonZoomOutContainer.setAttribute('data-backdrop', 'false');
            buttonZoomOutContainer.setAttribute('title', 'Afastar');

            const buttonZoomOutContent = document.createElement('div');
            buttonZoomOutContent.className = 'menu-icon';
            buttonZoomOutContent.innerHTML = '<i class="gpi gpi-zoom-out"></i>';
            buttonZoomOutContent.id = 'zoom_button';

            buttonZoomOutContainer.addEventListener('click', function () {
                myMapSgs.map.getView().setZoom(myMapSgs.map.getView().getZoom() - 1);
            }, false);

            buttonZoomOutContainer.appendChild(buttonZoomOutContent);

            buttonZoomOut.appendChild(buttonZoomOutContainer);

            // -- Refresh -----------------------------------------------------------------------------
            const buttonRefresh = document.createElement('li');

            const buttonRefreshContainer = document.createElement('a');

            const buttonRefreshContent = document.createElement('div');
            buttonRefreshContent.className = 'menu-icon refresh';
            buttonRefreshContent.innerHTML = '<i class="gpi gpi-refresh"></i>';
            buttonRefreshContent.setAttribute('title', 'Atualizar');

            buttonRefreshContainer.appendChild(buttonRefreshContent);
            buttonRefresh.appendChild(buttonRefreshContainer);

            // -- Undo --------------------------------------------------------------------------------
            const buttonUndo = document.createElement('li');

            const buttonUndoContainer = document.createElement('a');

            const buttonUndoContent = document.createElement('div');
            buttonUndoContent.className = 'menu-icon refresh';
            buttonUndoContent.innerHTML = '<i class="gpi gpi-undo"></i>';
            buttonUndoContent.setAttribute('title', 'Desfazer');

            buttonUndoContainer.appendChild(buttonUndoContent);
            buttonUndo.appendChild(buttonUndoContainer);

            // -- Redo --------------------------------------------------------------------------------
            const buttonRedo = document.createElement('li');

            const buttonRedoContainer = document.createElement('a');

            const buttonRedoContent = document.createElement('div');
            buttonRedoContent.className = 'menu-icon refresh';
            buttonRedoContent.innerHTML = '<i class="gpi gpi-redo"></i>';
            buttonRedoContent.setAttribute('title', 'Refazer');

            buttonRedoContainer.appendChild(buttonRedoContent);
            buttonRedo.appendChild(buttonRedoContainer);

            // -- Separator 2 -------------------------------------------------------------------------
            const d2 = document.createElement('li');
            d2.className = 'divider';

            // -- Water Supply - Cut Simulation -------------------------------------------------------
            let hasWaterSupplyCutSimulation = visibleOperations.Water && visibleOperations.Water.WaterSupply && visibleOperations.Water.WaterSupply.CutSimulation;
            var buttonCutSimulation;
            if (hasWaterSupplyCutSimulation) {
                buttonCutSimulation = document.createElement('li');

                const buttonCutSimulationContainer = document.createElement('a');

                const buttonCutSimulationContent = document.createElement('div');
                buttonCutSimulationContent.className = 'menu-icon refresh';
                buttonCutSimulationContent.innerHTML = '<i class="gpi gpi-sem-dados" title="Simulação de um corte"></i>';

                buttonCutSimulationContainer.appendChild(buttonCutSimulationContent);
                buttonCutSimulation.appendChild(buttonCutSimulationContainer);

                /**
                 * Cut Simulation handle
                 */
                const handleCutSimulation = function () {

                    // Check if any pipe is selected
                    if (app.Select.getFeatures().getLength() === 0 ||
                        (
                            app.Select.getFeatures().getLength() > 0 &&
                            !(app.Select.getFeatures().getArray()[0].getId().split(".")[0] === 'vw_ws_pipe_line_1')
                        )
                    ) {
                        toastr["warning"]("Escolha primeiro uma traçado");
                        return;
                    }

                    // ShowWait
                    myMapSgs._utility.ShowWait('offcanvas-map-spinner', true);

                    var idElement = app.Select.getFeatures().getArray()[0].getId().split(".")[1];

                    if (myMapSgs.featureToHighLight.getLength() > 0) myMapSgs.featureToHighLight.clear();

                    $.ajax({
                        type: 'GET',
                        url: '/rest/app/WaterSupply/GetIsolatePipeByZone?pipeId=' + idElement,
                        async: true,
                        success: function (data) {
                            if (data.error) {
                                toastr["error"]("Erro no calculo ");
                            }
                            else {
                                // Pipe selected
                                var stylePipeSelected = [
                                    new Style({
                                        image: new CircleStyle({
                                            radius: 4,
                                            stroke: new Stroke({
                                                color: 'yellow',
                                                width: 2
                                            }),
                                            fill: new Fill({
                                                color: 'rgba(255, 255, 0, 1)'
                                            })
                                        }),
                                        stroke: new Stroke({
                                            color: 'yellow',
                                            width: 3
                                        }),
                                        fill: new Fill({
                                            color: 'rgba(255, 255, 0, 0.5)'
                                        })
                                        ,
                                        text: new Text({
                                            text: '',
                                            font: 'normal 14px Arial',
                                            textBaseline: 'Middle',
                                            offsetY: -10,
                                            backgroundFill: new Fill({ color: 'white' }),
                                            fill: new Fill({
                                                color: 'rgba(0, 0, 0, 1)'
                                            }),
                                            stroke: new Stroke({
                                                color: 'rgba(255, 255, 200, 1)',
                                                width: 8
                                            })
                                        })
                                    })
                                ];

                                var arrayIdPipeSelected = [data.result.pipeId];
                                myMapSgs.SetFeaturesHighlightByArray(workspace, 'vw_ws_pipe_line_1', true, arrayIdPipeSelected, stylePipeSelected);

                                // Pipes
                                var stylePipes = [
                                    new Style({
                                        image: new CircleStyle({
                                            radius: 4,
                                            stroke: new Stroke({
                                                color: 'red',
                                                width: 2
                                            }),
                                            fill: new Fill({
                                                color: 'rgba(255, 255, 0, 1)'
                                            })
                                        }),
                                        stroke: new Stroke({
                                            color: 'red',
                                            width: 3
                                        }),
                                        fill: new Fill({
                                            color: 'rgba(255, 255, 0, 0.5)'
                                        })
                                        ,
                                        text: new Text({
                                            text: '',
                                            font: 'normal 14px Arial',
                                            textBaseline: 'Middle',
                                            offsetY: -10,
                                            backgroundFill: new Fill({ color: 'white' }),
                                            fill: new Fill({
                                                color: 'rgba(0, 0, 0, 1)'
                                            }),
                                            stroke: new Stroke({
                                                color: 'rgba(255, 255, 200, 1)',
                                                width: 8
                                            })
                                        })
                                    })
                                ];
                                var arrayIdPipes = [data.result.pipeId];
                                for (var i = 0; i < data.result.isolatedPipesIds.length; i++) {
                                    arrayIdPipes.push(data.result.isolatedPipesIds[i]);
                                }
                                if (arrayIdPipes.length > 0)
                                    myMapSgs.SetFeaturesHighlightByArray(workspace, 'vw_ws_pipe_line_1', true, arrayIdPipes, stylePipes);

                                // Valves
                                var styleValve = [
                                    new Style({
                                        image: new CircleStyle({
                                            radius: 4,
                                            stroke: new Stroke({
                                                color: 'red',
                                                width: 2
                                            }),
                                            fill: new Fill({
                                                color: 'rgba(255, 255, 0, 1)'
                                            })
                                        }),
                                        stroke: new Stroke({
                                            color: 'red',
                                            width: 3
                                        }),
                                        fill: new Fill({
                                            color: 'rgba(255, 255, 0, 0.5)'
                                        })
                                    })
                                ];
                                var arrayIdValve = [];
                                for (var j = 0; j < data.result.valves2CloseNodeIds.length; j++) {
                                    arrayIdValve.push(data.result.valves2CloseNodeIds[j]);
                                }
                                if (arrayIdValve.length > 0)
                                    myMapSgs.SetFeaturesHighlightByArray(workspace, 'vw_ws_node_point_1', true, arrayIdValve, styleValve);

                                // Water origins
                                var styleWaterOrigin = [
                                    new Style({
                                        image: new CircleStyle({
                                            radius: 4,
                                            stroke: new Stroke({
                                                color: 'blue',
                                                width: 2
                                            }),
                                            fill: new Fill({
                                                color: 'rgba(0, 0, 255, 1)'
                                            })
                                        }),
                                        stroke: new Stroke({
                                            color: 'blue',
                                            width: 3
                                        }),
                                        fill: new Fill({
                                            color: 'rgba(0, 0, 255, 0.5)'
                                        })
                                    })
                                ];
                                var arrayIdWaterOrigin = [];
                                for (var r = 0; r < data.result.waterOriginsForPipe.length; r++) {
                                    arrayIdWaterOrigin.push(data.result.waterOriginsForPipe[r]);
                                }
                                if (arrayIdWaterOrigin.length > 0)
                                    myMapSgs.SetFeaturesHighlightByArray(workspace, 'vw_ws_node_point_1', true, arrayIdWaterOrigin, styleWaterOrigin);
                            }
                            toastr["success"]("Simulação de corte efectuada com sucesso");
                            // ShowWait
                            myMapSgs._utility.ShowWait('offcanvas-map-spinner', false);
                        },
                        error: function (request, status, error) {
                            toastr["error"]("Erro no calculo ");
                            // ShowWait
                            myMapSgs._utility.ShowWait('offcanvas-map-spinner', false);
                        }
                    });
                };

                buttonCutSimulation.addEventListener('click', handleCutSimulation, false);
                buttonCutSimulation.addEventListener('touchstart', handleCutSimulation, false);
            }

            // -- Water Waste - UpStream Analysis -----------------------------------------------------
            //let hasWaterWasteUpStreamAnalysis = visibleOperations.Water && visibleOperations.Water.WaterWaste && visibleOperations.Water.WaterWaste.UpStreamAnalysis;
            let hasWaterWasteUpStreamAnalysis = visibleOperations.WaterWasteUpstream;
            var buttonUpStreamAnalysis;
            if (hasWaterWasteUpStreamAnalysis) {
                buttonUpStreamAnalysis = document.createElement('li');

                const buttonUpStreamAnalysisContainer = document.createElement('a');

                const buttonUpStreamAnalysisContent = document.createElement('div');
                buttonUpStreamAnalysisContent.className = 'menu-icon refresh ajust-button-icon';
                buttonUpStreamAnalysisContent.innerHTML = '<i class="fa fa-arrow-circle-o-up" title="Identificação da rede a montante de um troço de colector"></i>';

                buttonUpStreamAnalysisContainer.appendChild(buttonUpStreamAnalysisContent);
                buttonUpStreamAnalysis.appendChild(buttonUpStreamAnalysisContainer);

                /**
                 * Get UpStream waste water
                 */
                const handleUpStreamAnalysis = function () {
                    // Check if any pipe is selected
                    if (app.Select.getFeatures().getLength() === 0 ||
                        (
                            app.Select.getFeatures().getLength() > 0 &&
                            !(app.Select.getFeatures().getArray()[0].getId().split(".")[0] === 'vw_ww_pipe_line_1')
                        )
                    ) {
                        toastr["warning"]("Escolha primeiro um colector");
                        return;
                    }

                    // ShowWait
                    myMapSgs._utility.ShowWait('offcanvas-map-spinner', true);

                    // Get id pipe
                    var idPipe = app.Select.getFeatures().getArray()[0].getId().split(".")[1];

                    // Get idSystem
                    var idSystem = 1; // Temp, get sistem pipe

                    // Clean high light
                    if (myMapSgs.featureToHighLight.getLength() > 0) myMapSgs.featureToHighLight.clear();

                    // Clean table
                    myMapSgs._waterWaste.datatableWaterWasteElement.clear().draw();
                    myMapSgs._waterWaste.datatableWaterWasteStatistic.clear().draw();

                    // Call UpStream analysis
                    $.ajax({
                        type: 'GET',
                        url: '/rest/app/WaterWaste/GetPipeUpStream?idSystem=' + idSystem + '&idPipe=' + idPipe,
                        async: true,
                        success: function (data) {
                            if (data.error) {
                                toastr["error"]("Erro na identificação da rede a montante");
                            }
                            else {
                                switch (data.result.status) {
                                    case "SUCCESS":
                                        // -- Pipe selected --
                                        var stylePipeSelected = [
                                            new Style({
                                                image: new CircleStyle({
                                                    radius: 4,
                                                    stroke: new Stroke({
                                                        color: 'yellow',
                                                        width: 2
                                                    }),
                                                    fill: new Fill({
                                                        color: 'rgba(255, 255, 0, 0.5)'
                                                    })
                                                }),
                                                stroke: new Stroke({
                                                    color: 'rgba(70,130,180,0.5)',
                                                    width: 2
                                                }),
                                                fill: new Fill({
                                                    color: 'rgba(255, 255, 0, 0)'
                                                })
                                                ,
                                                text: new Text({
                                                    text: '',
                                                    font: 'normal 14px Arial',
                                                    textBaseline: 'Middle',
                                                    offsetY: -10,
                                                    backgroundFill: new Fill({ color: 'white' }),
                                                    fill: new Fill({
                                                        color: 'rgba(0, 0, 0, 1)'
                                                    }),
                                                    stroke: new Stroke({
                                                        color: 'rgba(255, 255, 200, 1)',
                                                        width: 8
                                                    })
                                                })
                                            }),
                                            new Style({
                                                stroke: new Stroke({
                                                    color: 'rgba(255, 255, 0, 0.5)',
                                                    width: 5
                                                }),
                                                fill: new Fill({
                                                    color: 'rgba(255, 255, 0, 0)'
                                                })
                                            })
                                        ];
                                        var arrayIdPipeSelected = [idPipe];
                                        var gpSource = mapSettings.map_info.description.indexOf('Mealhada') != -1 ? 'GP_MEALHADA' : 'GP';
                                        myMapSgs.SetFeaturesHighlightByArray(gpSource, 'vw_ww_pipe_line_1', true, arrayIdPipeSelected, stylePipeSelected);

                                        // -- Pipes --
                                        var stylePipes = [
                                            new Style({
                                                image: new CircleStyle({
                                                    radius: 4,
                                                    stroke: new Stroke({
                                                        color: 'rgba(255,255,0,1)',
                                                        width: 10
                                                    }),
                                                    fill: new Fill({
                                                        color: 'rgba(70,130,180,0.2)'
                                                    })
                                                }),
                                                stroke: new Stroke({
                                                    color: 'rgba(70,130,180,0.5)',
                                                    width: 2
                                                }),
                                                fill: new Fill({
                                                    color: 'rgba(255, 255, 0, 0)'
                                                })
                                                ,
                                                text: new Text({
                                                    text: '',
                                                    font: 'normal 14px Arial',
                                                    textBaseline: 'Middle',
                                                    offsetY: -10,
                                                    backgroundFill: new Fill({ color: 'white' }),
                                                    fill: new Fill({
                                                        color: 'rgba(0, 0, 0, 1)'
                                                    }),
                                                    stroke: new Stroke({
                                                        color: 'rgba(255, 255, 200, 1)',
                                                        width: 8
                                                    })
                                                })
                                            }),
                                            new Style({
                                                stroke: new Stroke({
                                                    color: 'rgba(255, 0, 0, 0.5)',
                                                    width: 5
                                                }),
                                                fill: new Fill({
                                                    color: 'rgba(255, 255, 0, 0)'
                                                })
                                            })
                                        ];
                                        var arrayIds = [];
                                        var idPipeUpStream;
                                        for (let i = 0; i < data.result.list_ww_pipe_upstream_analysis.length; i++) {
                                            idPipeUpStream = data.result.list_ww_pipe_upstream_analysis[i].id_pipe;
                                            if (idPipeUpStream !== idPipe)
                                                arrayIds.push(idPipeUpStream);
                                        }
                                        if (arrayIds.length > 0)
                                            myMapSgs.SetFeaturesHighlightByArray(gpSource, 'vw_ww_pipe_line_1', true, arrayIds, stylePipes);
                                        // Put in table
                                        for (let i = 0; i < data.result.list_pipe.length; i++) {
                                            var pipeObj = data.result.list_pipe[i];
                                            myMapSgs._waterWaste.datatableWaterWasteElement.row.add({
                                                id: pipeObj.id,
                                                workspace: gpSource,
                                                layer_name: 'vw_ww_pipe_line_1',
                                                code: pipeObj.code,
                                                element_type: 'Colector'
                                            });
                                        }

                                        // -- Manhole --
                                        var styleManhole = [
                                            new Style({
                                                image: new CircleStyle({
                                                    radius: 10,
                                                    stroke: new Stroke({
                                                        color: 'rgba(0, 0, 255, 0.2)',
                                                        width: 5
                                                    }),
                                                    fill: new Fill({
                                                        color: 'rgba(0, 0, 255, 0.2)'
                                                    })
                                                }),
                                                stroke: new Stroke({
                                                    color: 'rgba(0, 0, 255, 0.2)',
                                                    width: 14
                                                }),
                                                fill: new Fill({
                                                    color: 'rgba(0, 0, 255, 0.5)'
                                                })
                                            })
                                        ];
                                        arrayIds = [];
                                        for (let i = 0; i < data.result.list_manhole.length; i++) {
                                            var manholeObj = data.result.list_manhole[i];
                                            arrayIds.push(manholeObj.id_manhole);

                                            // Put in table
                                            myMapSgs._waterWaste.datatableWaterWasteElement.row.add({
                                                id: manholeObj.id_manhole,
                                                workspace: gpSource,
                                                layer_name: 'vw_ww_manhole_point_1',
                                                code: manholeObj.code,
                                                element_type: 'Caixa de visita',
                                            });
                                        }
                                        if (arrayIds.length > 0)
                                            myMapSgs.SetFeaturesHighlightByArray(gpSource, 'vw_ww_manhole_point_1', true, arrayIds, styleManhole);

                                        // -- Service pipes --
                                        var styleServicePipes = [
                                            new Style({
                                                stroke: new Stroke({
                                                    color: 'rgba(70,130,180,0.5)',
                                                    width: 2
                                                }),
                                                fill: new Fill({
                                                    color: 'rgba(255, 255, 0, 0)'
                                                })
                                                ,
                                                text: new Text({
                                                    text: '',
                                                    font: 'normal 14px Arial',
                                                    textBaseline: 'Middle',
                                                    offsetY: -10,
                                                    backgroundFill: new Fill({ color: 'white' }),
                                                    fill: new Fill({
                                                        color: 'rgba(0, 0, 0, 1)'
                                                    }),
                                                    stroke: new Stroke({
                                                        color: 'rgba(255, 255, 200, 1)',
                                                        width: 8
                                                    })
                                                })
                                            }),
                                            new Style({
                                                stroke: new Stroke({
                                                    color: 'rgba(255, 100, 0, 0.5)',
                                                    width: 5
                                                }),
                                                fill: new Fill({
                                                    color: 'rgba(255, 255, 0, 0)'
                                                })
                                            })
                                        ];
                                        arrayIds = [];
                                        for (let i = 0; i < data.result.list_service_pipe.length; i++) {
                                            var pipeServiceObj = data.result.list_service_pipe[i];
                                            arrayIds.push(pipeServiceObj.id_service_pipe);

                                            // Put in table
                                            myMapSgs._waterWaste.datatableWaterWasteElement.row.add({
                                                id: pipeServiceObj.id_service_pipe,
                                                workspace: gpSource,
                                                layer_name: 'vw_ww_service_conn_pipe_line_1',
                                                code: pipeServiceObj.code,
                                                element_type: 'Ramal'
                                            });
                                        }
                                        if (arrayIds.length > 0)
                                            myMapSgs.SetFeaturesHighlightByArray(gpSource, 'vw_ww_service_conn_pipe_line_1', true, arrayIds, styleServicePipes);

                                        // Refreh table
                                        myMapSgs._waterWaste.datatableWaterWasteElement.draw();

                                        // Fill statistic
                                        for (let i = 0; i < data.result.list_statistic.length; i++) {
                                            var statisticObj = data.result.list_statistic[i];

                                            // Put in table
                                            myMapSgs._waterWaste.datatableWaterWasteStatistic.row.add({
                                                cod_type: statisticObj.cod_type,
                                                type_description: statisticObj.type_description,
                                                cod_value: statisticObj.cod_value,
                                                value_description: statisticObj.value_description,
                                                value: statisticObj.value
                                            });
                                        }

                                        // Refreh table
                                        myMapSgs._waterWaste.datatableWaterWasteStatistic.draw();

                                        // Alter title of map list
                                        $('#offcanvas-map-list-title')[0].innerHTML = "Análise Montante Nº" + data.result.id_analysis;

                                        // Alter title extend go
                                        //$('#offcanvas-search-event-layer-visible-title')[0].innerHTML = "Enquadrar dos elementos da análise";

                                        // Clear select element
                                        app.Select.getFeatures().clear();

                                        toastr["success"]("Sucesso na identificação da rede a montante");
                                        break;
                                    default:
                                        toastr["error"]("Erro na identificação da rede a montante");
                                }
                            }
                            // ShowWait
                            myMapSgs._utility.ShowWait('offcanvas-map-spinner', false);
                        },
                        error: function (request, status, error) {
                            toastr["error"]("Erro na identificação da rede a montante");
                            // ShowWait
                            myMapSgs._utility.ShowWait('offcanvas-map-spinner', false);
                        }
                    });
                }

                buttonUpStreamAnalysis.addEventListener('click', handleUpStreamAnalysis, false);
                buttonUpStreamAnalysis.addEventListener('touchstart', handleUpStreamAnalysis, false);
            }

            // -- Water Waste - DownStream Analysis -----------------------------------------------------
            //let hasWaterWasteDownStreamAnalysis = visibleOperations.Water && visibleOperations.Water.WaterWaste && visibleOperations.Water.WaterWaste.DownStreamAnalysis;
            let hasWaterWasteDownStreamAnalysis = visibleOperations.WaterWasteDownstream;
            var buttonDownStreamAnalysis;
            if (hasWaterWasteDownStreamAnalysis) {
                buttonDownStreamAnalysis = document.createElement('li');

                const buttonDownStreamAnalysisContainer = document.createElement('a');

                const buttonDownStreamAnalysisContent = document.createElement('div');
                buttonDownStreamAnalysisContent.className = 'menu-icon refresh ajust-button-icon';
                buttonDownStreamAnalysisContent.innerHTML = '<i class="fa fa-arrow-circle-o-down" title="Identificação da rede a jusante de um troço de colector"></i>';

                buttonDownStreamAnalysisContainer.appendChild(buttonDownStreamAnalysisContent);
                buttonDownStreamAnalysis.appendChild(buttonDownStreamAnalysisContainer);

                /**
                 * Get UpStream waste water
                 */
                const handleDownStreamAnalysis = function () {
                    // Check if any pipe is selected
                    if (app.Select.getFeatures().getLength() === 0 ||
                        (
                            app.Select.getFeatures().getLength() > 0 &&
                            !(app.Select.getFeatures().getArray()[0].getId().split(".")[0] === 'vw_ww_pipe_line_1')
                        )
                    ) {
                        toastr["warning"]("Escolha primeiro um colector");
                        return;
                    }

                    // ShowWait
                    myMapSgs._utility.ShowWait('offcanvas-map-spinner', true);

                    // Get id pipe
                    var idPipe = app.Select.getFeatures().getArray()[0].getId().split(".")[1];

                    // Get idSystem
                    var idSystem = 1; // Temp, get sistem pipe

                    // Clean high light
                    if (myMapSgs.featureToHighLight.getLength() > 0) myMapSgs.featureToHighLight.clear();

                    // Clean table
                    myMapSgs._waterWaste.datatableWaterWasteElement.clear().draw();
                    myMapSgs._waterWaste.datatableWaterWasteStatistic.clear().draw();

                    // Call UpStream analysis
                    $.ajax({
                        type: 'GET',
                        url: '/rest/app/WaterWaste/GetPipeDownStream?idSystem=' + idSystem + '&idPipe=' + idPipe,
                        async: true,
                        success: function (data) {
                            if (data.error) {
                                toastr["error"]("Erro na identificação da rede a jusante");
                            }
                            else {
                                switch (data.result.status) {
                                    case "SUCCESS":
                                        // -- Pipe selected --
                                        var stylePipeSelected = [
                                            new Style({
                                                image: new CircleStyle({
                                                    radius: 4,
                                                    stroke: new Stroke({
                                                        color: 'yellow',
                                                        width: 2
                                                    }),
                                                    fill: new Fill({
                                                        color: 'rgba(255, 255, 0, 0.5)'
                                                    })
                                                }),
                                                stroke: new Stroke({
                                                    color: 'rgba(70,130,180,0.5)',
                                                    width: 2
                                                }),
                                                fill: new Fill({
                                                    color: 'rgba(255, 255, 0, 0)'
                                                })
                                                ,
                                                text: new Text({
                                                    text: '',
                                                    font: 'normal 14px Arial',
                                                    textBaseline: 'Middle',
                                                    offsetY: -10,
                                                    backgroundFill: new Fill({ color: 'white' }),
                                                    fill: new Fill({
                                                        color: 'rgba(0, 0, 0, 1)'
                                                    }),
                                                    stroke: new Stroke({
                                                        color: 'rgba(255, 255, 200, 1)',
                                                        width: 8
                                                    })
                                                })
                                            }),
                                            new Style({
                                                stroke: new Stroke({
                                                    color: 'rgba(255, 255, 0, 0.5)',
                                                    width: 5
                                                }),
                                                fill: new Fill({
                                                    color: 'rgba(255, 255, 0, 0)'
                                                })
                                            })
                                        ];
                                        var arrayIdPipeSelected = [idPipe];
                                        var gpSource = mapSettings.map_info.description.indexOf('Mealhada') != -1 ? 'GP_MEALHADA' : 'GP';
                                        myMapSgs.SetFeaturesHighlightByArray(gpSource, 'vw_ww_pipe_line_1', true, arrayIdPipeSelected, stylePipeSelected);

                                        // -- Pipes --
                                        var stylePipes = [
                                            new Style({
                                                image: new CircleStyle({
                                                    radius: 4,
                                                    stroke: new Stroke({
                                                        color: 'rgba(255,255,0,1)',
                                                        width: 10
                                                    }),
                                                    fill: new Fill({
                                                        color: 'rgba(70,130,180,0.2)'
                                                    })
                                                }),
                                                stroke: new Stroke({
                                                    color: 'rgba(70,130,180,0.5)',
                                                    width: 2
                                                }),
                                                fill: new Fill({
                                                    color: 'rgba(255, 255, 0, 0)'
                                                })
                                                ,
                                                text: new Text({
                                                    text: '',
                                                    font: 'normal 14px Arial',
                                                    textBaseline: 'Middle',
                                                    offsetY: -10,
                                                    backgroundFill: new Fill({ color: 'white' }),
                                                    fill: new Fill({
                                                        color: 'rgba(0, 0, 0, 1)'
                                                    }),
                                                    stroke: new Stroke({
                                                        color: 'rgba(255, 255, 200, 1)',
                                                        width: 8
                                                    })
                                                })
                                            }),
                                            new Style({
                                                stroke: new Stroke({
                                                    color: 'rgba(255, 0, 0, 0.5)',
                                                    width: 5
                                                }),
                                                fill: new Fill({
                                                    color: 'rgba(255, 255, 0, 0)'
                                                })
                                            })
                                        ];
                                        var arrayIds = [];
                                        var idPipeDownStream;
                                        for (let i = 0; i < data.result.list_ww_pipe_downstream_analysis.length; i++) {
                                            idPipeDownStream = data.result.list_ww_pipe_downstream_analysis[i].id_pipe;
                                            if (idPipeDownStream !== idPipe)
                                                arrayIds.push(idPipeDownStream);
                                        }
                                        if (arrayIds.length > 0)
                                            myMapSgs.SetFeaturesHighlightByArray(gpSource, 'vw_ww_pipe_line_1', true, arrayIds, stylePipes);
                                        // Put in table
                                        for (let i = 0; i < data.result.list_pipe.length; i++) {
                                            var pipeObj = data.result.list_pipe[i];
                                            myMapSgs._waterWaste.datatableWaterWasteElement.row.add({
                                                id: pipeObj.id,
                                                workspace: gpSource,
                                                layer_name: 'vw_ww_pipe_line_1',
                                                code: pipeObj.code,
                                                element_type: 'Colector'
                                            });
                                        }

                                        // -- Manhole --
                                        var styleManhole = [
                                            new Style({
                                                image: new CircleStyle({
                                                    radius: 10,
                                                    stroke: new Stroke({
                                                        color: 'rgba(0, 0, 255, 0.2)',
                                                        width: 5
                                                    }),
                                                    fill: new Fill({
                                                        color: 'rgba(0, 0, 255, 0.2)'
                                                    })
                                                }),
                                                stroke: new Stroke({
                                                    color: 'rgba(0, 0, 255, 0.2)',
                                                    width: 14
                                                }),
                                                fill: new Fill({
                                                    color: 'rgba(0, 0, 255, 0.5)'
                                                })
                                            })
                                        ];
                                        arrayIds = [];
                                        for (let i = 0; i < data.result.list_manhole.length; i++) {
                                            var manholeObj = data.result.list_manhole[i];
                                            arrayIds.push(manholeObj.id_manhole);

                                            // Put in table
                                            myMapSgs._waterWaste.datatableWaterWasteElement.row.add({
                                                id: manholeObj.id_manhole,
                                                workspace: gpSource,
                                                layer_name: 'vw_ww_manhole_point_1',
                                                code: manholeObj.code,
                                                element_type: 'Caixa de visita',
                                            });
                                        }
                                        if (arrayIds.length > 0)
                                            myMapSgs.SetFeaturesHighlightByArray(gpSource, 'vw_ww_manhole_point_1', true, arrayIds, styleManhole);

                                        // -- Service pipes --
                                        var styleServicePipes = [
                                            new Style({
                                                stroke: new Stroke({
                                                    color: 'rgba(70,130,180,0.5)',
                                                    width: 2
                                                }),
                                                fill: new Fill({
                                                    color: 'rgba(255, 255, 0, 0)'
                                                })
                                                ,
                                                text: new Text({
                                                    text: '',
                                                    font: 'normal 14px Arial',
                                                    textBaseline: 'Middle',
                                                    offsetY: -10,
                                                    backgroundFill: new Fill({ color: 'white' }),
                                                    fill: new Fill({
                                                        color: 'rgba(0, 0, 0, 1)'
                                                    }),
                                                    stroke: new Stroke({
                                                        color: 'rgba(255, 255, 200, 1)',
                                                        width: 8
                                                    })
                                                })
                                            }),
                                            new Style({
                                                stroke: new Stroke({
                                                    color: 'rgba(255, 100, 0, 0.5)',
                                                    width: 5
                                                }),
                                                fill: new Fill({
                                                    color: 'rgba(255, 255, 0, 0)'
                                                })
                                            })
                                        ];
                                        arrayIds = [];
                                        for (let i = 0; i < data.result.list_service_pipe.length; i++) {
                                            var pipeServiceObj = data.result.list_service_pipe[i];
                                            arrayIds.push(pipeServiceObj.id_service_pipe);

                                            // Put in table
                                            myMapSgs._waterWaste.datatableWaterWasteElement.row.add({
                                                id: pipeServiceObj.id_service_pipe,
                                                workspace: gpSource,
                                                layer_name: 'vw_ww_service_conn_pipe_line_1',
                                                code: pipeServiceObj.code,
                                                element_type: 'Ramal'
                                            });
                                        }
                                        if (arrayIds.length > 0)
                                            myMapSgs.SetFeaturesHighlightByArray(gpSource, 'vw_ww_service_conn_pipe_line_1', true, arrayIds, styleServicePipes);

                                        // Refreh table
                                        myMapSgs._waterWaste.datatableWaterWasteElement.draw();

                                        // Fill statistic
                                        for (let i = 0; i < data.result.list_statistic.length; i++) {
                                            var statisticObj = data.result.list_statistic[i];

                                            // Put in table
                                            myMapSgs._waterWaste.datatableWaterWasteStatistic.row.add({
                                                cod_type: statisticObj.cod_type,
                                                type_description: statisticObj.type_description,
                                                cod_value: statisticObj.cod_value,
                                                value_description: statisticObj.value_description,
                                                value: statisticObj.value
                                            });
                                        }

                                        // Refreh table
                                        myMapSgs._waterWaste.datatableWaterWasteStatistic.draw();

                                        // Alter title of map list
                                        $('#offcanvas-map-list-title')[0].innerHTML = "Análise Montante Nº" + data.result.id_analysis;

                                        // Alter title extend go
                                        //$('#offcanvas-search-event-layer-visible-title')[0].innerHTML = "Enquadrar dos elementos da análise";

                                        // Clear select element
                                        app.Select.getFeatures().clear();

                                        toastr["success"]("Sucesso na identificação da rede a jusante");
                                        break;
                                    default:
                                        toastr["error"]("Erro na identificação da rede a jusante");
                                }
                            }
                            // ShowWait
                            myMapSgs._utility.ShowWait('offcanvas-map-spinner', false);
                        },
                        error: function (request, status, error) {
                            toastr["error"]("Erro na identificação da rede a jusante");
                            // ShowWait
                            myMapSgs._utility.ShowWait('offcanvas-map-spinner', false);
                        }
                    });
                }

                buttonDownStreamAnalysis.addEventListener('click', handleDownStreamAnalysis, false);
                buttonDownStreamAnalysis.addEventListener('touchstart', handleDownStreamAnalysis, false);
            }

            // -- Water Waste - Profile Analysis -----------------------------------------------------
            //let hasWaterWasteProfileAnalysis = visibleOperations.Water && visibleOperations.Water.WaterWaste && visibleOperations.Water.WaterWaste.ProfileAnalysis;
            let hasWaterWasteProfileAnalysis = visibleOperations.WaterWasteProfile;
            var buttonProfileAnalysis;
            if (hasWaterWasteProfileAnalysis) {
                buttonProfileAnalysis = document.createElement('li');

                const buttonProfileAnalysisContainer = document.createElement('a');

                const buttonProfileAnalysisContent = document.createElement('div');
                buttonProfileAnalysisContent.className = 'menu-icon refresh ajust-button-icon';
                buttonProfileAnalysisContent.innerHTML = '<i id="button-profile-analysis" class="fa fa-code-fork" title="Identificação do perfil de um troço de colector"></i>';

                buttonProfileAnalysisContainer.appendChild(buttonProfileAnalysisContent);
                buttonProfileAnalysis.appendChild(buttonProfileAnalysisContainer);

                /**
                 * Get Profile waste water
                 */
                const handleProfileAnalysis = function () {

                    // Check if two manholes are selected
                    var isManholePath =
                        typeof window['tooltip-profile'] == 'undefined' &&
                        app.Select.getFeatures().getLength() == 2 &&
                        (
                            app.Select.getFeatures().getArray()[0].getId().split(".")[0] === 'vw_ww_manhole_point_1'
                            &&
                            app.Select.getFeatures().getArray()[1].getId().split(".")[0] === 'vw_ww_manhole_point_1'
                        );

                    // Check if two pipes are selected
                    var isPipePath =
                        typeof window['tooltip-profile'] == 'undefined' &&
                        app.Select.getFeatures().getLength() == 2 &&
                        (
                            app.Select.getFeatures().getArray()[0].getId().split(".")[0] === 'vw_ww_pipe_line_1'
                            &&
                            app.Select.getFeatures().getArray()[1].getId().split(".")[0] === 'vw_ww_pipe_line_1'
                        );

                    // Check if a single pipe is selected, or whether it is called from tooltip
                    var isSinglePipe = (
                        (app.Select.getFeatures().getLength() == 1 && app.Select.getFeatures().getArray()[0].getId().split(".")[0] === 'vw_ww_pipe_line_1')
                        ||
                        typeof window['tooltip-profile'] != 'undefined');

                    // Return error if no valid combination of elements is selected
                    if (!(isSinglePipe || isManholePath || isPipePath)) {
                        toastr["warning"]("Escolha um colector ou duas câmaras de visita");
                        return;
                    }

                    // ShowWait
                    myMapSgs._utility.ShowWait('offcanvas-map-spinner', true);

                    // Initialize Get parameters
                    var idPipe1, idPipe2, idManhole1, idManhole2, idSystem1, idSystem2, idPipeCode1;
                    idPipe1 = idPipe2 = idManhole1 = idManhole2 = idSystem1 = idSystem2 = idPipeCode1 = 0;
                    var idPipeCode1 = '';

                    // Clean high light
                    if (myMapSgs.featureToHighLight.getLength() > 0) myMapSgs.featureToHighLight.clear();

                    var callURLParams = '';

                    if (isSinglePipe) {
                        if (typeof window['tooltip-profile'] != 'undefined') {
                            idPipeCode1 = window['tooltip-profile'];
                            idSystem1 = window['tooltip-profile-system'];
                            delete window['tooltip-profile'];
                            delete window['tooltip-profile-system'];
                        } else {
                            idPipe1 = app.Select.getFeatures().getArray()[0].getId().split(".")[1];
                            idSystem1 = app.Select.getFeatures().getArray()[0].values_.id_system;
                        }
                    }

                    if (isManholePath) {
                        idManhole1 = app.Select.getFeatures().getArray()[0].getId().split(".")[1];
                        idManhole2 = app.Select.getFeatures().getArray()[1].getId().split(".")[1];
                        idSystem1 = app.Select.getFeatures().getArray()[0].values_.id_system;
                        idSystem2 = app.Select.getFeatures().getArray()[1].values_.id_system;
                    }

                    if (isPipePath) {
                        idPipe1 = app.Select.getFeatures().getArray()[0].getId().split(".")[1];
                        idPipe2 = app.Select.getFeatures().getArray()[1].getId().split(".")[1];
                        idSystem1 = app.Select.getFeatures().getArray()[0].values_.id_system;
                        idSystem2 = app.Select.getFeatures().getArray()[1].values_.id_system;
                    }


                    callURLParams += 'idPipe1=' + idPipe1;
                    callURLParams += '&idPipe2=' + idPipe2;
                    callURLParams += '&idManhole1=' + idManhole1;
                    callURLParams += '&idManhole2=' + idManhole2;
                    callURLParams += '&idSystem1=' + idSystem1;
                    callURLParams += '&idSystem2=' + idSystem2;
                    callURLParams += '&idPipeCode1=' + idPipeCode1;
                    callURLParams += '&idPrevAnalysis=0';

                    // Call Profile analysis
                    myMapSgs._pipeProfile.getProfileAnalysis({ callURLParams: callURLParams, utility: myMapSgs._utility, toastr: toastr });

                }

                buttonProfileAnalysis.addEventListener('click', handleProfileAnalysis, false);
                buttonProfileAnalysis.addEventListener('touchstart', handleProfileAnalysis, false);
            }


            //End PROFILE ANALYSIS






            // -- Water Waste - Statistic ---------------------------------------------------------
            //let hasWaterWasteStatistic = visibleOperations.Water && visibleOperations.Water.WaterWaste && (visibleOperations.Water.WaterWaste.Statistic || visibleOperations.Water.WaterWaste.StatisticByDdccff);
            let hasWaterWasteStatistic = visibleOperations.WaterWasteStatistic || visibleOperations.WaterWasteStatisticByDdccff;
            var buttonWaterWasteStatistic;
            if (hasWaterWasteStatistic) {
                buttonWaterWasteStatistic = document.createElement('li');

                const buttonWaterWasteStatisticContainer = document.createElement('a');

                const buttonWaterWasteStatisticContent = document.createElement('div');
                buttonWaterWasteStatisticContent.className = 'menu-icon refresh ajust-button-icon';
                buttonWaterWasteStatisticContent.innerHTML = '<i class="gpi gpi-elemento-caraterizacao" style="line-height: 30px" title="Estatísticas"></i>';

                buttonWaterWasteStatisticContainer.appendChild(buttonWaterWasteStatisticContent);
                buttonWaterWasteStatistic.appendChild(buttonWaterWasteStatisticContainer);

                /**
                 * Get Statistic waste water
                 */
                const handleWaterWasteStatistic = function () {

                    // ShowWait
                    myMapSgs._utility.ShowWait('offcanvas-map-spinner', true);

                    // Clean table
                    myMapSgs._waterWaste.datatableWaterWasteStatistic.clear().draw();

                    // Call UpStream analysis
                    $.ajax({
                        type: 'GET',
                        url: '/rest/app/WaterWaste/GetStatisticWaterWaste',
                        async: true,
                        success: function (data) {
                            if (data.error) {
                                toastr["error"]("Erro obtenção de estatísticas");
                            }
                            else {
                                switch (data.result.status) {
                                    case "SUCCESS":
                                        // Fill statistic
                                        for (let i = 0; i < data.result.list_statistic.length; i++) {
                                            var statisticObj = data.result.list_statistic[i];

                                            // Put in table
                                            myMapSgs._waterWaste.datatableWaterWasteStatistic.row.add({
                                                cod_type: statisticObj.cod_type,
                                                type_description: statisticObj.type_description,
                                                cod_value: statisticObj.cod_value,
                                                value_description: statisticObj.value_description,
                                                value: statisticObj.value
                                            });
                                        }

                                        // Refreh table
                                        myMapSgs._waterWaste.datatableWaterWasteStatistic.draw();

                                        // Alter title of map list
                                        $('#offcanvas-map-list-title')[0].innerHTML = "Estatísticas";

                                        // Show canvas map list statistic result
                                        myMapSgs._utility.ShowOpenCanvas3('offcanvas-map-list', true);
                                        $('a[href="#offcanvas-map-list-statistic"]').click();

                                        toastr["success"]("Sucesso na criação das estísticas");
                                        break;
                                    default:
                                        toastr["error"]("Erro obtenção de estatísticas");
                                }
                            }
                            // ShowWait
                            myMapSgs._utility.ShowWait('offcanvas-map-spinner', false);
                        },
                        error: function (request, status, error) {
                            toastr["error"]("Erro obtenção de estatísticas");
                            // ShowWait
                            myMapSgs._utility.ShowWait('offcanvas-map-spinner', false);
                        }
                    });
                }

                buttonWaterWasteStatistic.addEventListener('click', handleWaterWasteStatistic, false);
                buttonWaterWasteStatistic.addEventListener('touchstart', handleWaterWasteStatistic, false);
            }

            // -- Separator 3 -------------------------------------------------------------------------
            var d3;
            d3 = document.createElement('li');
            d3.className = 'divider';

            // -- PDM ---------------------------------------------------------------------------------
            var buttonPDM;
            if (visibleOperations.PDM) {
                buttonPDM = document.createElement('li');

                const buttonPDMContainer = document.createElement('a');
                buttonPDMContainer.setAttribute('href', '#offcanvas-pdm');
                buttonPDMContainer.setAttribute('data-toggle', 'offcanvas');
                buttonPDMContainer.setAttribute('data-backdrop', 'false');

                const buttonPDMContent = document.createElement('div');
                buttonPDMContent.className = 'menu-icon refresh';
                buttonPDMContent.innerHTML = '<i class="gpi gpi-sem-dados" title="PDM"></i>';

                buttonPDMContainer.appendChild(buttonPDMContent);
                buttonPDM.appendChild(buttonPDMContainer);
            }

            // -- Print ---------------------------------------------------------------------------
            const buttonprint = document.createElement('li');
            const buttonprintContainer = document.createElement('a');
            buttonprintContainer.className = 'menu-icon';
            buttonprintContainer.setAttribute('data-backdrop', 'false');
            buttonprintContainer.setAttribute('title', 'Imprimir');

            const buttonPrintContent = document.createElement('div');
            buttonPrintContent.className = 'menu-icon';
            buttonPrintContent.innerHTML = '<i class="gpi gpi-imprimir" style="line-height: 60px"></i>';

            buttonprintContainer.appendChild(buttonPrintContent);
            buttonprint.appendChild(buttonprintContainer);

            // Event button print click
            buttonprint.addEventListener('click', function () {
                ////////////////////////////////////////////////////////// Codigo Original ////////////////////////////////////////////////////////////////////////////////////////////////////////////

                //// Set chosen template value
                //myMapSgs.currentTemplateSize = "A4v"; // Default template A4 Vertical
                //// Set the template sizes and validate screen sizes
                //myMapSgs.templateManager.setSizes();
                //// Update screen for map export
                //myMapSgs.templateManager.prepareExport($('.ol-viewport'), myMapSgs.currentTemplateSize);
                //// Activate visible layers on template
                //myMapSgs.templateLayers = true;
                //// Activate Route report mode
                //myMapSgs.templateRoute = false;
                //// Mark template for direct download
                //myMapSgs.templateDownload = true;

                ////////////////////////////////////////////////////////// FIM Codigo Original ////////////////////////////////////////////////////////////////////////////////////////////////////////

                $.ajax({
                    type: 'GET',
                    url: '/rest/app/Service/GetAllGroupstemplates?idMap=' + myMapSgs._settings._mapSettings.map_info.id,
                    xhrFields: {
                        withCredentials: true
                    },
                    async: true,
                    dataType: "json",
                    contentType: "application/json;",
                    success: function (data) {
                        if (data.error) {
                            toastr["error"]("Erro a carregar os grupos");
                            $('#id-modal-Group-template-print').prop('disabled', true);
                        }
                        else {

                            $('#id-modal-Group-template-print').prop('disabled', true);

                            myMapSgs.hashGroupTemplates = data.result;

                            myMapSgs._utility.FillSelect('id-select-group-template', myMapSgs.hashGroupTemplates, 'name', 'id', true);

                            $('#id-select-group-template').trigger('change');

                            $('#id-modal-Group-template').modal('show');
                        }
                    },
                    error: function (request, status, error) {
                        $('#id-modal-Group-template-print').prop('disabled', true);
                    }
                });
            });


            /**
            * Control menu for map view export
            * @param {any} opt_options, option control
            */
            myMapSgs._exportControlBarCenterBottom = null;
            myMapSgs._exportControlBarCenterBottom = function (opt_options) {

                const options = opt_options || {};

                // -- Submit --------------------------------------------------------------------------
                const buttonSubmit = document.createElement('li');

                const buttonSubmitContainer = document.createElement('a');
                buttonSubmitContainer.setAttribute('title', 'Submeter pedido');

                const buttonSubmitContent = document.createElement('div');
                buttonSubmitContent.className = 'menu-icon refresh';
                buttonSubmitContent.innerHTML = '<i class="fa fa-check modal-map-export-button"></i>';

                buttonSubmitContainer.appendChild(buttonSubmitContent);
                buttonSubmit.appendChild(buttonSubmitContainer);


                buttonSubmit.addEventListener('click', myMapSgs._printComponent.handleSubmit, false);
                buttonSubmit.addEventListener('touchstart', myMapSgs._printComponent.handleSubmit, false);

                // -- Close ---------------------------------------------------------------------------
                const buttonClose = document.createElement('li');

                const buttonCloseContainer = document.createElement('a');
                buttonCloseContainer.setAttribute('title', 'Fechar');

                const buttonCloseContent = document.createElement('div');
                buttonCloseContent.className = 'menu-icon refresh';
                buttonCloseContent.innerHTML = '<i class="fa fa-times modal-map-export-button-close"></i>';

                buttonCloseContainer.appendChild(buttonCloseContent);
                buttonClose.appendChild(buttonCloseContainer);

                buttonClose.addEventListener('click', myMapSgs._printComponent.handleClose, false);
                buttonClose.addEventListener('touchstart', myMapSgs._printComponent.handleClose, false);

                // -- Main menu -----------------------------------------------------------------------
                const mainMenu = document.createElement('ul');
                mainMenu.id = 'main-export-menu-pl';
                mainMenu.className = 'map-controls menubar-bottom';

                mainMenu.appendChild(buttonSubmit);
                mainMenu.appendChild(buttonClose);

                // -- Menu panel ----------------------------------------------------------------------
                const menuPanel = document.createElement('div');
                //menuPanel.className = 'menubar-scroll-panel';

                menuPanel.appendChild(mainMenu);

                // -- Main element menu bar bottom ----------------------------------------------------
                const element = document.createElement('div');
                element.id = 'menubar-export-bottom-pl';
                element.className = 'menubar-bottom';
                element.setAttribute('style', 'display: none;');

                element.appendChild(menuPanel);

                Control.call(this, {
                    element: element,
                    target: options.target
                });
            };
            inherits(myMapSgs._exportControlBarCenterBottom, Control);




            // -- Save image ----------------------------------------------------------------------
            const buttonsaveimage = document.createElement('li');

            const buttonsaveimageContainer = document.createElement('a');
            buttonsaveimageContainer.className = 'menu-icon';
            buttonsaveimageContainer.setAttribute('data-toggle', 'offcanvas');
            buttonsaveimageContainer.setAttribute('data-backdrop', 'false');
            buttonsaveimageContainer.setAttribute('title', 'Guardar imagem');

            const buttonsaveimageContent = document.createElement('i');
            buttonsaveimageContent.className = 'menu-icon';
            buttonsaveimageContent.innerHTML = '<i class="gpi gpi-snapshot" style="line-height: 60px"></i>';

            buttonsaveimageContainer.appendChild(buttonsaveimageContent);
            buttonsaveimage.appendChild(buttonsaveimageContainer);

            // Event button save image click
            buttonsaveimage.addEventListener('click', function () {
                //$('#map .ol-overlaycontainer-stopevent').children().not('.ol-overlay-container.ol-selectable').hide();

                var overlayVisible = $('#map .ol-overlaycontainer-stopevent').children().not(':hidden, .ol-overlay-container.ol-selectable')

                overlayVisible.hide();

                myMapSgs._utility.ShowWait('offcanvas-map-spinner', true);
                html2canvas(document.querySelector("#map .ol-viewport")).then(canvasHTML2 => {

                    if ($('#layer-tree-external').children().length > 0) {

                        var ctx = canvasHTML2.getContext("2d");
                        var context = canvasHTML2.getContext('2d');

                        // Draw the Watermark
                        context.id = "h2canvas";
                        context.font = '48px sans-serif';

                        context.backgroundColor = 'ff0000';
                    }

                    var img = document.createElement('a');
                    img.href = canvasHTML2.toDataURL("image/jpeg").replace("image/jpeg", "image/octet-stream");
                    img.download = 'Mapa.jpg';
                    img.click();

                    myMapSgs._utility.ShowWait('offcanvas-map-spinner', false);
                });

                overlayVisible.show();

            });

            // -- Draw Point --------------------------------------------------------------------------
            const buttonPoint = document.createElement('li');

            const buttonPointContainer = document.createElement('a');
            buttonPointContainer.setAttribute('href', '#target-gpi-point');
            buttonPointContainer.id = 'target-gpi-point';
            buttonPointContainer.className = 'target';

            if (mapSettings.operation_visible.Anacom != null) {
                buttonPointContainer.className = "measurement-button-option";
                buttonPointContainer.setAttribute("style", 'display: none;');
                buttonPointContainer.setAttribute('title', 'Ponto');
            }

            const buttonPointContent = document.createElement('div');
            buttonPointContent.className = 'menu-icon';
            buttonPointContent.innerHTML = '<i class="gpi gpi-ponto"></i>';

            buttonPointContainer.appendChild(buttonPointContent);
            buttonPoint.appendChild(buttonPointContainer);

            /**
             * Draw point handle
             */
            const handleDrawPoint = function () {

                //Clean all Inputs on create occurrence 
                $("#form-creation-occurrence")[0].reset();

                //Clean dropdown Type
                $('#creation-occurrence-type-select').val('').change();

                //Clean dropdown Subtype
                $('#creation-occurrence-subtype-select').val('').change();

                myMapSgs._utility.HoldButtonEffect('main-menu', 'target-gpi-point');
                myMapSgs._utility.RemoveActiveButton('target-gpi-point');
                app.layerDrawLine.getSource().clear();
                app.layerDraw.getSource().clear();
                app.Select.setActive(false);
                app.DrawLine.setActive(false);
                app.Draw.setActive(false);

                if ($(this).hasClass('active')) {
                    $(this).removeClass('active');
                    app.DrawPoint.setActive(false);
                    myMapSgs.map.getTargetElement().style.cursor = 'auto';
                }
                else {
                    $(this).addClass('active');
                    app.DrawPoint.setActive(true);
                    myMapSgs.map.getTargetElement().style.cursor = 'crosshair';
                }
            };

            buttonPoint.addEventListener('click', handleDrawPoint, false);
            buttonPoint.addEventListener('touchstart', handleDrawPoint, false);

            // -- Draw Line ---------------------------------------------------------------------------
            const buttonLine = document.createElement('li');

            const buttonLineContainer = document.createElement('a');
            //buttonLineContainer.setAttribute('href', '#target-gpi-linha');
            buttonLineContainer.id = 'target-gpi-linha';
            buttonLineContainer.className = 'target';
            buttonLineContainer.setAttribute('title', 'Calcular distância');

            const buttonLineContent = document.createElement('div');
            buttonLineContent.className = 'menu-icon';
            buttonLineContent.innerHTML = '<i class="gpi gpi-linha"></i>';

            buttonLineContainer.appendChild(buttonLineContent);
            buttonLine.appendChild(buttonLineContainer);

            /**
             * Draw line Handle
             */
            const handleDrawLine = function () {
                myMapSgs._utility.HoldButtonEffect('main-menu', 'target-gpi-linha');
                myMapSgs._utility.RemoveActiveButton('target-gpi-linha');
                app.layerDraw.getSource().clear();
                app.layerDrawPoint.getSource().clear();
                app.Select.setActive(false);
                app.Draw.setActive(false);
                app.DrawPoint.setActive(false);

                if ($(this).hasClass('active')) {
                    $(this).removeClass('active');
                    app.DrawLine.setActive(false);
                    myMapSgs.map.getTargetElement().style.cursor = 'auto';

                    // Active tooltip
                    if (myMapSgs.tooltips)
                        myMapSgs.map.on('singleclick', async (e) => { await myMapSgs.tooltips.BuildInfoTooltips(e); });
                }
                else {
                    $(this).addClass('active');
                    app.DrawLine.setActive(true);
                    myMapSgs.map.getTargetElement().style.cursor = 'crosshair';

                    // Desactive interaction
                    if (myMapSgs.tooltips)
                        myMapSgs.map.un('singleclick', myMapSgs.tooltips.BuildInfoTooltips);
                }
            };

            buttonLine.addEventListener('click', handleDrawLine, false);
            buttonLine.addEventListener('touchstart', handleDrawLine, false);

            // -- Draw Polygon ------------------------------------------------------------------------
            const buttonPolygon = document.createElement('li');
            const buttonPolygonContainer = document.createElement('a');
            buttonPolygonContainer.setAttribute('href', '#target-gpi-polygon');
            buttonPolygonContainer.id = 'target-gpi-polygon';
            //Restore area calculation feature
            //buttonPolygonContainer.setAttribute("style", 'display: none;');
            buttonPolygonContainer.className = 'target';
            buttonPolygonContainer.setAttribute('title', 'Calcular Área');

            const buttonPolygonContent = document.createElement('div');
            buttonPolygonContent.className = 'menu-icon';
            buttonPolygonContent.innerHTML = '<i class="gpi gpi-poligono"></i>';

            buttonPolygonContainer.appendChild(buttonPolygonContent);
            buttonPolygon.appendChild(buttonPolygonContainer);

            /**
             * Draw polygon handle
             */
            const handleDrawPolygon = function () {
                myMapSgs._utility.HoldButtonEffect('main-menu', 'target-gpi-polygon');
                myMapSgs._utility.RemoveActiveButton('target-gpi-polygon');
                app.layerDrawLine.getSource().clear();
                app.layerDrawPoint.getSource().clear();
                app.Select.setActive(false);
                app.DrawLine.setActive(false);
                app.DrawPoint.setActive(false);

                if ($(this).hasClass('active')) {
                    $(this).removeClass('active');
                    app.Draw.setActive(false);
                    myMapSgs.map.getTargetElement().style.cursor = 'auto';

                    // Active tooltip
                    if (myMapSgs.tooltips)
                        myMapSgs.map.on('singleclick', async (e) => { await myMapSgs.tooltips.BuildInfoTooltips(e); });
                }
                else {
                    $(this).addClass('active');
                    app.Draw.setActive(true);
                    myMapSgs.map.getTargetElement().style.cursor = 'crosshair';

                    // Desactive interaction
                    if (myMapSgs.tooltips)
                        myMapSgs.map.un('singleclick', myMapSgs.tooltips.BuildInfoTooltips);
                }
            };

            buttonPolygon.addEventListener('click', handleDrawPolygon, false);
            buttonPolygon.addEventListener('touchstart', handleDrawPolygon, false);
            // -- Select ----------------------------------------------------------------------------------
            const buttonSelect = document.createElement('li');
            const buttonSelectContainer = document.createElement('a');
            buttonSelectContainer.setAttribute('href', '#target-gpi-select');
            buttonSelectContainer.id = 'target-gpi-select';
            buttonSelectContainer.className = 'target';
            buttonSelectContainer.setAttribute('title', 'Selecionar');

            const buttonSelectContent = document.createElement('div');
            buttonSelectContent.className = 'menu-icon';
            buttonSelectContent.innerHTML = '<i class="gpi gpi-selecionar"></i>';

            buttonSelectContainer.appendChild(buttonSelectContent);
            buttonSelect.appendChild(buttonSelectContainer);

            /**
             * Select Handle
             */
            const handleSelect = function () {
                myMapSgs._utility.HoldButtonEffect('main-menu', 'target-gpi-select');
                myMapSgs._utility.RemoveActiveButton('target-gpi-select-pl');
                //app.Draw.setActive(false);
                //app.DrawLine.setActive(false);

                if ($(this).hasClass('active')) {
                    $(this).removeClass('active');
                    app.Select.setActive(false);
                    // Reset event layer tooltips
                    if (myMapSgs.tooltips)
                        myMapSgs.map.on('singleclick', async (e) => { await myMapSgs.tooltips.BuildInfoTooltips(e); });
                    // Reset selection with modify
                    app._useSelectModify = false;
                    // Reset cursor
                    document.body.style.cursor = 'default';
                }
                else {
                    $(this).addClass('active');
                    app.Select.setActive(true);
                    // Block selection with modify
                    app._useSelectModify = false;
                    // Remove event layer tooltips
                    if (myMapSgs.tooltips)
                        myMapSgs.map.un('singleclick', myMapSgs.tooltips.BuildInfoTooltips);
                    // Change cursor
                    document.body.style.cursor = 'crosshair';
                }
            };

            buttonSelect.addEventListener('click', handleSelect, false);
            buttonSelect.addEventListener('touchstart', handleSelect, false);

            // -- Snapping ----------------------------------------------------------------------------------
            const buttonSnapping = document.createElement('li');

            const buttonSnappingContainer = document.createElement('a');
            buttonSnappingContainer.id = 'target-gpi-snapping';
            buttonSnappingContainer.className = 'menu-icon';
            buttonSnappingContainer.setAttribute('title', 'Snapping');

            const buttonSnappingContent = document.createElement('i');
            buttonSnappingContent.className = 'menu-icon';
            buttonSnappingContent.innerHTML = '<i class="gpi gpi-snapping" style="line-height: 60px"></i>';

            buttonSnappingContainer.appendChild(buttonSnappingContent);
            buttonSnapping.appendChild(buttonSnappingContainer);

            /**
             * Snapping Handle
             */
            const handleSnapping = function () {

                // Set snapping button as active on menu
                $('#target-gpi-snapping').toggleClass('hold-single-button');

                // Update snapping status
                myMapSgs._snappingTool.update(!myMapSgs._snappingTool._isActive);


            };
            buttonSnapping.addEventListener('click', handleSnapping, false);
            buttonSnapping.addEventListener('touchstart', handleSnapping, false);

            // -- Clean ----------------------------------------------------------------------------------
            const buttonClean = document.createElement('li');

            const buttonCleanContainer = document.createElement('a');
            buttonCleanContainer.setAttribute('title', 'Limpar Seleção');

            const buttonCleanContent = document.createElement('div');
            buttonCleanContent.className = 'menu-icon refresh';
            buttonCleanContent.innerHTML = '<i class="gpi gpi-apagar"></i>';

            buttonCleanContainer.appendChild(buttonCleanContent);
            buttonClean.appendChild(buttonCleanContainer);

            /**
             * Clean handle
             */
            const handleClean = function () {
                // Clear draw point
                if (app.layerDrawPoint.getSource()) app.layerDrawPoint.getSource().clear();
                // Clear draw polygon
                if (app.layerDraw.getSource()) app.layerDraw.getSource().clear();
                // Clear draw line
                if (app.layerDrawLine.getSource()) app.layerDrawLine.getSource().clear();
                // Clear tooltip measure element
                $(app.measureTooltipElement).addClass('hidden');
                app.measureTooltip.setVisible(false);
                // Clear identify tooltipElement
                $(app.identifyTooltipElement).addClass('hidden');
                app.identifyTooltip.setVisible(false);
                // Clear select element
                app.Select.getFeatures().clear();
                // Clear highlight
                if (app.featureToHighLight.getLength() > 0) app.featureToHighLight.clear();
                if (myMapSgs.featureToHighLight.getLength() > 0) myMapSgs.featureToHighLight.clear();
                // Clear overlay element
                app.featureHighlightOverlay.getSource().clear();
                myMapSgs.layerHighlightOverlay.getSource().clear();
                // Clear Info feature
                $('#offcanvas-info').removeClass('show');
                myMapSgs.handleEditButtonsVisibility();
                myMapSgs._CloseSaveFeature();
                // Clear overlay shorcut POI
                app.layerDrawPointPOI.getSource().clear();
                app.layerDrawPointPOIShow.getSource().clear();
                // Clean goto waterwaste
                if (hasWaterWasteUpStreamAnalysis || hasWaterWasteDownStreamAnalysis)
                    myMapSgs._waterWaste._sourceGoto.clear();
                if (typeof myMapSgs.avimVectorPoint != "undefined")
                    myMapSgs.avimVectorPoint.setVisible(false);

                if (myMapSgs._geometryEditorTool) {

                    var features = myMapSgs._geometryEditorTool.layer.getSource().getFeatures();
                    features.forEach((feature) => {
                        myMapSgs._geometryEditorTool.layer.getSource().removeFeature(feature);
                    });
                }

                if (myMapSgs.identify.VectorPointIdentify) {

                    myMapSgs.map.removeLayer(myMapSgs.identify.VectorPointIdentify);

                }

                if (ddccffToShowBase != "" && seccaocadastralToSearch != "") {

                    // Set invisible last layer base
                    var layer = null;
                    var idLayerArray = 'base_' + ddccffToShowBase + '_' + seccaocadastralToSearch;
                    layer = myMapSgs._utility.GetLayerById(myMapSgs.map, idLayerArray);

                    layer.setVisible(false);

                    myMapSgs.map.renderSync();

                }


                if (ddccffToShowBase != "" && seccaocadastralToSearch != "") {

                    // Set invisible last layer base
                    var layer = null;
                    var idLayerArray = 'base_' + ddccffToShowBase + '_' + seccaocadastralToSearch;
                    layer = myMapSgs._utility.GetLayerById(myMapSgs.map, idLayerArray);

                    layer.setVisible(false);

                    myMapSgs.map.renderSync();

                }

            };

            buttonClean.addEventListener('click', handleClean, false);
            buttonClean.addEventListener('touchstart', handleClean, false);

            // -- Occurrence report ---------------------------------------------------------------
            var buttonOccurrenceReport = undefined;
            if (visibleOperations.Occurrence && visibleOperations.Occurrence.reportOccurrenceGlobal) {
                buttonOccurrenceReport = document.createElement('li');

                const buttonOccurrenceReportContainer = document.createElement('a');
                buttonOccurrenceReportContainer.setAttribute('href', '#offcanvas-occurrence-report-config');
                buttonOccurrenceReportContainer.setAttribute('data-toggle', 'offcanvas');
                buttonOccurrenceReportContainer.setAttribute('data-backdrop', 'false');
                buttonOccurrenceReportContainer.setAttribute('title', 'Relatório de ocorrências');

                const buttonOccurrenceReportContent = document.createElement('div');
                buttonOccurrenceReportContent.className = 'menu-icon';
                buttonOccurrenceReportContent.innerHTML = '<i class="gpi gpi-editar-camada"></i>';
                buttonOccurrenceReportContainer.appendChild(buttonOccurrenceReportContent);
                buttonOccurrenceReport.appendChild(buttonOccurrenceReportContainer);
            }

            // -- GET Quota ----------------------------------------------------------------------------------
            const buttonGetQuota = document.createElement('li');

            const buttonGetQuotaContainer = document.createElement('a');
            buttonGetQuotaContainer.id = 'id-button-cota';
            buttonGetQuotaContainer.className = 'menu-icon';
            buttonGetQuotaContainer.setAttribute('title', 'Cota');

            const buttonGetQuotaContent = document.createElement('i');
            buttonGetQuotaContent.className = 'menu-icon';
            buttonGetQuotaContent.innerHTML = '<i class="fa fa-map-marker" style="line-height: 60px"></i>';

            buttonGetQuotaContainer.appendChild(buttonGetQuotaContent);
            buttonGetQuota.appendChild(buttonGetQuotaContainer);

            /**
             * Get Quota
             */
            const handleQuota = function () {
                if ($('#id-button-cota').hasClass('toolbar-selected-button')) {

                    myMapSgs.map.removeInteraction(myMapSgs._drawPointQuota);

                    $('#id-button-cota').removeClass('toolbar-selected-button');

                    myMapSgs.VectorPointCota.getSource().clear();

                    $('#offcanvas-info').removeClass('expand');
                    $('#offcanvas-info').removeClass('show');

                    // Enable tooltip
                    if (myMapSgs.tooltips)
                        myMapSgs.map.on('singleclick', async (e) => { await myMapSgs.tooltips.BuildInfoTooltips(e); });
                }
                else {
                    $('#id-button-cota').addClass('toolbar-selected-button');
                    var flatCoordinates;
                    var source = new VectorSource({ wrapX: false });

                    myMapSgs.VectorPointCota = new VectorLayer({
                        source: source
                    });
                    myMapSgs.map.addLayer(myMapSgs.VectorPointCota);

                    myMapSgs._drawPointQuota = new Draw({
                        source: source,
                        type: 'Point'
                    });

                    myMapSgs.map.addInteraction(myMapSgs._drawPointQuota);

                    //On drawend fill
                    myMapSgs._drawPointQuota.on('drawend', function (evt) {
                        myMapSgs.VectorPointCota.getSource().clear();
                        flatCoordinates = evt.target.sketchCoords_;

                        var LayerMdtName = myMapSgs._utility.GetPropertyInfoInConfigArray(myMapSgs._settings.configurationInfo.propertyInfo, "CAL_MDT", "LAYER_MDT", "LAYER_NAME")
                        var LayerMdtWorkspace = myMapSgs._utility.GetPropertyInfoInConfigArray(myMapSgs._settings.configurationInfo.propertyInfo, "CAL_MDT", "LAYER_MDT", "WORKSPACE")
                        var LayerMdtGeoserver = myMapSgs._utility.GetPropertyInfoInConfigArray(myMapSgs._settings.configurationInfo.propertyInfo, "CAL_MDT", "LAYER_MDT", "EXTERNAL_GEOSERVER_URL")

                        if (!LayerMdtName || !LayerMdtWorkspace || !LayerMdtGeoserver) {
                            return toastr["warning"]("MDT não configurado");
                        }

                        myMapSgs.GetQuotaByCoord(LayerMdtWorkspace, LayerMdtName, LayerMdtGeoserver, flatCoordinates);

                        $('#offcanvas-info header')[0].innerHTML = 'Cota';
                        //$('#id-quota-info-height').html('Cota altimétrica: ' + data.features[0].properties.GRAY_INDEX);
                        $('#sgs-measure-input-m').html('<p style="padding-bottom: 8px;">Cota altimétrica: ' + myMapSgs._quotaValueFill.features[0].properties.GRAY_INDEX + '</p><p>Coordenada X: ' + flatCoordinates[0] + '</p>');
                        $('#sgs-measure-input-ha').html('Coordenada Y: ' + flatCoordinates[1]);
                        $('#offcanvas-info').addClass('expand');
                        $('#offcanvas-info').addClass('show');
                        $('#id-quota-info').removeClass('ol-hidden');
                    });

                    // Disable tooltip
                    if (myMapSgs.tooltips)
                        myMapSgs.map.un('singleclick', myMapSgs.tooltips.BuildInfoTooltips);
                }
            };
            buttonGetQuota.addEventListener('click', handleQuota, false);

            // -- Help ------------------------------------------------------------------------------------
            //const buttonHelp = document.createElement('li');

            //const buttonHelpContainer = document.createElement('a');
            //buttonHelpContainer.setAttribute('href', '#offcanvas-help');
            //buttonHelpContainer.setAttribute('data-toggle', 'offcanvas');
            //buttonHelpContainer.setAttribute('data-backdrop', 'false');
            //buttonHelpContainer.id = "buttonhelp-id";
            //buttonHelpContainer.setAttribute('title', 'Ajuda');

            //const buttonHelpContent = document.createElement('div');
            //buttonHelpContent.className = 'menu-icon';
            //buttonHelpContent.innerHTML = '<i class="gpi gpi-help"></i>';

            //buttonHelpContainer.appendChild(buttonHelpContent);
            //buttonHelp.appendChild(buttonHelpContainer);

            // -- Scroll up button --------------------------------------------------------------------
            const buttonScrollUP = document.createElement('li');

            const buttonScrollUPContainer = document.createElement('a');

            const buttonScrollUPContent = document.createElement('div');
            buttonScrollUPContent.className = 'menu-icon';
            buttonScrollUPContent.innerHTML = '<i class="gpi gpi-scroll-up"></i>';

            buttonScrollUPContainer.appendChild(buttonScrollUPContent);
            buttonScrollUP.appendChild(buttonScrollUPContainer);

            // -- Scroll down button ------------------------------------------------------------------
            const buttonScrollDown = document.createElement('li');

            const buttonScrollDownContainer = document.createElement('a');

            const buttonScrollDownContent = document.createElement('div');
            buttonScrollDownContent.className = 'menu-icon';
            buttonScrollDownContent.innerHTML = '<i class="gpi gpi-scroll-down"></i>';

            buttonScrollDownContainer.appendChild(buttonScrollDownContent);
            buttonScrollDown.appendChild(buttonScrollDownContainer);

            // -- Main menu ---------------------------------------------------------------------------
            const mainMenu = document.createElement('ul');
            mainMenu.id = 'main-menu';
            mainMenu.className = 'map-controls';

            // tool for avim public map
            if (myMapSgs._settings.operationVisible.AvimTool != undefined &&
                myMapSgs._settings.operationVisible.AvimTool &&
                myMapSgs._settings._mapSettings.map_info.is_public) {
                mainMenu.appendChild(buttonZoomIn);
                mainMenu.appendChild(buttonZoomOut);
                mainMenu.appendChild(d2);
                mainMenu.appendChild(buttonsaveimage);
                mainMenu.appendChild(buttonPoint);
                mainMenu.appendChild(buttonLine);
                mainMenu.appendChild(buttonPolygon);
                mainMenu.appendChild(buttonClean);
            }
            else if (myMapSgs._settings.operationVisible.ControlBarSimplify) {
                mainMenu.appendChild(buttonBaseTheme);
                mainMenu.appendChild(buttonTheme);
                myMapSgs._existLayerTree = true;
                mainMenu.appendChild(d1);
                mainMenu.appendChild(buttonZoomExtend);
                mainMenu.appendChild(buttonZoomIn);
                mainMenu.appendChild(buttonZoomOut);
                mainMenu.appendChild(d2);
            }
            else // Normal menu
            {
                mainMenu.appendChild(buttonServices);
                mainMenu.appendChild(buttonBaseTheme);

                mainMenu.appendChild(buttonTheme);
                myMapSgs._existLayerTree = true;
                if (buttonThemeEdit)
                    mainMenu.appendChild(buttonThemeEdit);

                // Search button
                if (visibleOperations.Search) {
                    mainMenu.appendChild(buttonMapList);
                }

                // View result water waste
                if (hasWaterWasteUpStreamAnalysis) {
                    mainMenu.appendChild(buttonMapListExpand);
                }

                // Separator
                mainMenu.appendChild(d1);

                // Zoom extend
                mainMenu.appendChild(buttonZoomExtend);

                // Button access backoffice
                if (visibleOperations.BtnAccessBackoffice) {
                    mainMenu.appendChild(buttonBackOffice);
                }

                // Acess button identify
                if (visibleOperations.BtnAccessBackoffice) {
                    mainMenu.appendChild(buttonInfo);
                }

                //mainMenu.appendChild(buttonIdentifierPoint);
                //mainMenu.appendChild(buttonIdentifierLine);
                //mainMenu.appendChild(buttonIdentifierCircle);
                //mainMenu.appendChild(buttonIdentifierPolygon);
                // Separator
                //mainMenu.appendChild(sepatorIdentifier);

                // Statistic button
                if (visibleOperations.Statistics) {
                    mainMenu.appendChild(buttonStatistics);
                }

                mainMenu.appendChild(buttonZoomIn);
                mainMenu.appendChild(buttonZoomOut);
                //mainMenu.appendChild(buttonRefresh);
                //mainMenu.appendChild(buttonUndo);
                //mainMenu.appendChild(buttonRedo);

                if (visibleOperations.Anacom == null) {
                    mainMenu.appendChild(d2);
                }

                mainMenu.appendChild(buttonsaveimage);
                mainMenu.appendChild(buttonprint);
                mainMenu.appendChild(buttonPoint);
                mainMenu.appendChild(buttonLine);
                mainMenu.appendChild(buttonPolygon);
                mainMenu.appendChild(buttonSelect); // Temporário

                // Access snapping button
                if (visibleOperations.ButtonSnapping) {
                    mainMenu.appendChild(buttonSnapping);
                }

                // Access quota button
                if (visibleOperations.ButtonQuota) {
                    mainMenu.appendChild(buttonGetQuota);
                }
                mainMenu.appendChild(buttonClean);

                // Add separation operation
                if (hasWaterSupplyCutSimulation || hasWaterWasteUpStreamAnalysis || visibleOperations.PDM ||
                    (visibleOperations.Occurrence && visibleOperations.Occurrence.reportOccurrenceGlobal && visibleOperations.Anacom == null)
                ) {
                    mainMenu.appendChild(d3);
                }

                // Add Water cut simulation button
                if (hasWaterSupplyCutSimulation) {
                    mainMenu.appendChild(buttonCutSimulation);
                }

                // Add water waste upstream
                if (hasWaterWasteUpStreamAnalysis) {
                    mainMenu.appendChild(buttonUpStreamAnalysis);
                }

                // Add water waste downstream
                if (hasWaterWasteDownStreamAnalysis) {
                    mainMenu.appendChild(buttonDownStreamAnalysis);
                }

                // Add water waste profile
                if (hasWaterWasteProfileAnalysis) {
                    mainMenu.appendChild(buttonProfileAnalysis);
                }

                // Add water waste statistic
                if (hasWaterWasteStatistic) {
                    mainMenu.appendChild(buttonWaterWasteStatistic);
                }

                // Add PDM button
                if (visibleOperations.PDM) {
                    mainMenu.appendChild(buttonPDM);
                }

                // Add occurrence report
                if (visibleOperations.Occurrence && visibleOperations.Occurrence.reportOccurrenceGlobal) {
                    mainMenu.appendChild(buttonOccurrenceReport);
                }

                mainMenu.appendChild(buttonAnacomHeatMap);
            }

            // -- Footer panel ------------------------------------------------------------------------
            const menuFooterPanel = document.createElement('div');
            menuFooterPanel.className = 'menubar-foot-panel';

            const footerMenu = document.createElement('ul');
            footerMenu.id = 'alt-menu';
            footerMenu.className = 'map-controls';

            //footerMenu.appendChild(buttonHelp);
            menuFooterPanel.appendChild(footerMenu);

            // -- Menu panel --------------------------------------------------------------------------
            const menuPanel = document.createElement('div');
            menuPanel.className = 'menubar-scroll-panel';

            menuPanel.appendChild(mainMenu);
            menuPanel.appendChild(menuFooterPanel);

            // -- Main element menu bar ---------------------------------------------------------------
            const element = document.createElement('div');
            element.id = 'menubar';
            element.className = 'menubar';

            element.appendChild(menuPanel);

            Control.call(this, {
                element: element,
                target: options.target
            });
        };
        inherits(this._ControlBar, Control);
    }

    /**
     * Control menu for road builder tool
     * @param {any} opt_options, option control
     */
    this._controlBarCenterBottomRoadBuilderTool = null;
    if (mapSettings.operation_visible.RoadBuilderTool) {
        this._controlBarCenterBottomRoadBuilderTool = function (opt_options) {
            const options = opt_options || {};

            const menuPanelRoadBuilderTool = myMapSgs._roadBuilderTool.BuildMenuBar()

            // -- Main element menu bar bottom road builder tool ----------------------------------
            const element = document.createElement('div');
            element.id = 'id-menubar-bottom-road-builder-tool';
            element.className = 'menubar-bottom menubar-road-builder-tool';
            element.setAttribute('style', 'display: none;');

            element.appendChild(menuPanelRoadBuilderTool);

            Control.call(this, {
                element: element,
                target: options.target
            });
        }
        inherits(this._controlBarCenterBottomRoadBuilderTool, Control);
    }

    /**
     * Control menu for road builder tool
     * @param {any} opt_options, option control
     */
    this._controlBarCenterBottomGeometryEditorTool = null;
    if (mapSettings.operation_visible.GeometryEditorTool) {
        this._controlBarCenterBottomGeometryEditorTool = function (opt_options) {
            const options = opt_options || {};

            const menuPanelGeometryEditorTool = myMapSgs._geometryEditorTool.BuildMenuBar()

            // -- Main element menu bar bottom road builder tool ----------------------------------
            const element = document.createElement('div');
            element.id = 'id-menubar-bottom-geometry-editor-tool';

            if (myMapSgs._utility.mobilecheck()) {
                element.className = 'menubar-bottom menubar-geometry-editor-tool, mobile-geometry-editor';
            } else {
                element.className = 'menubar-bottom menubar-geometry-editor-tool';
            }


            element.setAttribute('style', 'display: none;');

            element.appendChild(menuPanelGeometryEditorTool);

            Control.call(this, {
                element: element,
                target: options.target
            });
        }
        inherits(this._controlBarCenterBottomGeometryEditorTool, Control);
    }

    /**
     * Control menu for network simulation tool
     * @param {any} opt_options, option control
     */
    this._controlBarCenterBottomNetworkSimulationTool = null;
    if (mapSettings.operation_visible.NetworkSimulationTool) {
        this._controlBarCenterBottomNetworkSimulationTool = function (opt_options) {
            const options = opt_options || {};

            const menuPanelNetworkSimulationTool = myMapSgs._networkSimulationTool.BuildMenuBar()

            // -- Main element menu bar bottom road builder tool ----------------------------------
            const element = document.createElement('div');
            element.id = 'id-menubar-bottom-network-simulation-tool';
            element.className = 'menubar-bottom menubar-network-simulation-tool';
            element.setAttribute('style', 'display: none;');

            element.appendChild(menuPanelNetworkSimulationTool);

            Control.call(this, {
                element: element,
                target: options.target
            });
        }
        inherits(this._controlBarCenterBottomNetworkSimulationTool, Control);
    }

    /**
     * Control menu for network budget tool
     * @param {any} opt_options, option control
     */
    this._controlBarCenterBottomNetworkBudgetTool = null;
    if (mapSettings.operation_visible.NetworkBudgetTool) {
        this._controlBarCenterBottomNetworkBudgetTool = function (opt_options) {
            const options = opt_options || {};

            const menuPanelNetworkBudgetTool = myMapSgs._networkBudgetTool.BuildMenuBar()

            // -- Main element menu bar bottom road builder tool ----------------------------------
            const element = document.createElement('div');
            element.id = 'id-menubar-bottom-network-budget-tool';
            element.className = 'menubar-bottom menubar-network-budget-tool';
            element.setAttribute('style', 'display: none;');

            element.appendChild(menuPanelNetworkBudgetTool);

            Control.call(this, {
                element: element,
                target: options.target
            });
        }
        inherits(this._controlBarCenterBottomNetworkBudgetTool, Control);
    }

    /**
     * Control menu for railway tool
     * @param {any} opt_options, option control
     */
    this._controlBarRailwayTool = null;
    if (mapSettings.operation_visible.RailwayTool) {
        this._controlBarRailwayTool = function (opt_options) {
            const options = opt_options || {};

            const menuPanelRailwayTool = myMapSgs._railwayTool.BuildMenuBar()

            // -- Main element menu bar bottom road builder tool ----------------------------------
            const element = document.createElement('div');
            element.id = 'id-menubar-bottom-railway-tool';
            element.className = 'menubar-bottom menubar-railway-tool';
            element.setAttribute('style', 'display: none;');

            element.appendChild(menuPanelRailwayTool);

            Control.call(this, {
                element: element,
                target: options.target
            });
        }
        inherits(this._controlBarRailwayTool, Control);
    }

    /**
     * Control menu for search entity address tool
     * @param {any} opt_options, option control
     */
    this._controlBarSearchEntityAddressTool = null;
    if (mapSettings.operation_visible.SearchEntityAddress) {
        this._controlBarSearchEntityAddressTool = function (opt_options) {
            const options = opt_options || {};

            const menuPanelSearchEntityAddress = myMapSgs._searchEntityTool.BuildSearchAddressInterface(myMapSgs)

            // -- Main element menu bar bottom road builder tool ----------------------------------
            const element = document.createElement('div');
            element.id = 'id-menubar-search-entity-address';
            element.className = 'menubar-search-entity-address';
            //element.setAttribute('style', 'display: none;');

            element.appendChild(menuPanelSearchEntityAddress);

            Control.call(this, {
                element: element,
                target: options.target
            });
        }
        inherits(this._controlBarSearchEntityAddressTool, Control);
    }

    /**
     * Control menu for location plant or extract cartography
     * @param {any} opt_options, option control
     */
    this._controlBarCenterBottom = null;
    if (mapSettings.operation_visible.LocationPlant || mapSettings.operation_visible.CartographyExtract || mapSettings.operation_visible.PDMAnalyze) {

        this._controlBarCenterBottom = function (opt_options) {
            const options = opt_options || {};

            // -- Draw Polygon --------------------------------------------------------------------
            const buttonPolygon = document.createElement('li');

            const buttonPolygonContainer = document.createElement('a');
            buttonPolygonContainer.setAttribute('href', '#target-gpi-polygon-pl');
            buttonPolygonContainer.id = 'target-gpi-polygon-pl';
            buttonPolygonContainer.className = 'target';
            buttonPolygonContainer.setAttribute('title', 'Desenhar polígno');

            const buttonPolygonContent = document.createElement('div');
            buttonPolygonContent.className = 'menu-icon';
            buttonPolygonContent.innerHTML = '<i class="gpi gpi-poligono"></i>';

            buttonPolygonContainer.appendChild(buttonPolygonContent);
            buttonPolygon.appendChild(buttonPolygonContainer);

            /**
             * Draw polygon handle
             */
            const handleDrawPlantPolygon = function () {
                myMapSgs._utility.HoldButtonEffect('main-menu-pl', 'target-gpi-polygon-pl');
                myMapSgs._utility.RemoveActiveButton('target-gpi-polygon-pl');
                if (typeof app.layerDraw != "undefined" && app.layerDraw.getSource()) app.layerDrawLine.getSource().clear();
                if (typeof app.layerDrawPoint != "undefined" && app.layerDrawPoint.getSource()) app.layerDrawPoint.getSource().clear();
                app.Select.setActive(false);
                app.DrawLine.setActive(false);
                app.DrawPoint.setActive(false);

                if ($(this).hasClass('active')) {
                    $(this).removeClass('active');
                    app.Draw.setActive(false);
                    document.body.style.cursor = 'default';
                    if (myMapSgs.tooltips)
                        myMapSgs.map.on('singleclick', async (e) => { await myMapSgs.tooltips.BuildInfoTooltips(e); });
                }
                else {
                    $(this).addClass('active');
                    app.Draw.setActive(true);
                    document.body.style.cursor = 'crosshair';
                    if (myMapSgs.tooltips)
                        myMapSgs.map.un('singleclick', myMapSgs.tooltips.BuildInfoTooltips);
                }
            };

            buttonPolygon.addEventListener('click', handleDrawPlantPolygon, false);
            buttonPolygon.addEventListener('touchstart', handleDrawPlantPolygon, false);

            // -- Select --------------------------------------------------------------------------
            const buttonSelect = document.createElement('li');

            const buttonSelectContainer = document.createElement('a');
            buttonSelectContainer.setAttribute('href', '#target-gpi-select-pl');
            buttonSelectContainer.id = 'target-gpi-select-pl';
            buttonSelectContainer.className = 'target';
            buttonSelectContainer.setAttribute('title', 'Selecionar');

            const buttonSelectContent = document.createElement('div');
            buttonSelectContent.className = 'menu-icon';
            buttonSelectContent.innerHTML = '<i class="gpi gpi-selecionar"></i>';

            buttonSelectContainer.appendChild(buttonSelectContent);
            buttonSelect.appendChild(buttonSelectContainer);

            /**
             * Select Handle
             */
            const handleSelect = function () {
                myMapSgs._utility.HoldButtonEffect('main-menu-pl', 'target-gpi-select-pl');
                myMapSgs._utility.RemoveActiveButton('target-gpi-select-pl');
                app.Draw.setActive(false);
                app.DrawLine.setActive(false);

                if ($(this).hasClass('active')) {
                    $(this).removeClass('active');
                    app.Select.setActive(false);
                    // Reset event layer tooltips
                    if (myMapSgs.tooltips)
                        myMapSgs.map.on('singleclick', async (e) => { await myMapSgs.tooltips.BuildInfoTooltips(e); });
                    // Reset selection with modify
                    app._useSelectModify = false;
                    // Clear select element
                    app.Select.getFeatures().clear();
                    // Reset cursor
                    document.body.style.cursor = 'default';
                }
                else {
                    $(this).addClass('active');
                    app.Select.setActive(true);
                    // Block selection with modify
                    app._useSelectModify = true;
                    // Remove event layer tooltips
                    if (myMapSgs.tooltips)
                        myMapSgs.map.un('singleclick', myMapSgs.tooltips.BuildInfoTooltips);
                    // Change cursor
                    document.body.style.cursor = 'crosshair';
                }
            };

            buttonSelect.addEventListener('click', handleSelect, false);
            buttonSelect.addEventListener('touchstart', handleSelect, false);

            // -- Clean ---------------------------------------------------------------------------
            const buttonClean = document.createElement('li');
            buttonClean.className = "border-right";

            const buttonCleanContainer = document.createElement('a');
            buttonCleanContainer.className = 'modal-location-plant-button-cursor';
            buttonCleanContainer.setAttribute('title', 'Remover polígono');

            const buttonCleanContent = document.createElement('div');
            buttonCleanContent.className = 'menu-icon refresh';
            buttonCleanContent.innerHTML = '<i class="gpi gpi-apagar"></i>';

            buttonCleanContainer.appendChild(buttonCleanContent);
            buttonClean.appendChild(buttonCleanContainer);

            /**
             * Clean handle
             */
            const handleClean = function () {
                // Clear draw polygon
                if (app.layerDraw.getSource()) app.layerDraw.getSource().clear();
                // Clear identify tooltipElement
                $(app.identifyTooltipElement).addClass('hidden');
                app.identifyTooltip.setVisible(false);
                // Clear select element
                app.Select.getFeatures().clear();
                // Clear highlight
                if (app.featureToHighLight.getLength() > 0) app.featureToHighLight.clear();
                if (myMapSgs.featureToHighLight.getLength() > 0) myMapSgs.featureToHighLight.clear();
                // Clear overlay element
                app.featureHighlightOverlay.getSource().clear();
                myMapSgs.layerHighlightOverlay.getSource().clear();
                // Clear Info feature
                $('#offcanvas-info').removeClass('show');
                myMapSgs.handleEditButtonsVisibility();
                myMapSgs._CloseSaveFeature();
            };

            buttonClean.addEventListener('click', handleClean, false);
            buttonClean.addEventListener('touchstart', handleClean, false);

            // -- Goto data alpha -----------------------------------------------------------------
            const buttonDataAlpha = document.createElement('li');

            const buttonDataAlphaContainer = document.createElement('a');
            buttonDataAlphaContainer.className = 'modal-location-plant-button-cursor';
            buttonDataAlphaContainer.setAttribute('title', 'Voltar para o preenchimento da informação');

            const buttonDataAlphaContent = document.createElement('div');
            buttonDataAlphaContent.className = 'menu-icon refresh';
            buttonDataAlphaContent.innerHTML = '<i class="fa fa-list modal-location-plant-button"></i>';

            buttonDataAlphaContainer.appendChild(buttonDataAlphaContent);
            buttonDataAlpha.appendChild(buttonDataAlphaContainer);

            /**
             * Data alpha handle
             */
            const handleDataAlpha = function () {
                $('#id-modal-location-plant').toggle('ol-hidden');
                app.Select.setActive(false);
                app.DrawLine.setActive(false);
                app.DrawPoint.setActive(false);
                app.Draw.setActive(false);
                document.body.style.cursor = 'default';

                // Check if select polygon is active
                if ($('#target-gpi-select-pl').parent().has('active')) {
                    $('#target-gpi-select-pl').parent().removeClass('active');
                    $('#target-gpi-select-pl').removeClass('hold-button');
                    // Reset selection with modify
                    app._useSelectModify = false;
                }

                // Check if draw polygon is active
                if ($('#target-gpi-polygon-pl').parent().has('active')) {
                    $('#target-gpi-polygon-pl').parent().removeClass('active');
                    $('#target-gpi-polygon-pl').removeClass('hold-button');
                }

                // Reset tooltips
                if (myMapSgs.tooltips) {
                    if (!myMapSgs.map.hasListener('singleclick', myMapSgs.tooltips.BuildInfoTooltips))
                        myMapSgs.map.on('singleclick', async (e) => { await myMapSgs.tooltips.BuildInfoTooltips(e); });
                }
            };

            buttonDataAlpha.addEventListener('click', handleDataAlpha, false);
            buttonDataAlpha.addEventListener('touchstart', handleDataAlpha, false);

            // -- Submit --------------------------------------------------------------------------
            const buttonSubmit = document.createElement('li');

            const buttonSubmitContainer = document.createElement('a');
            buttonSubmitContainer.className = 'modal-location-plant-button-cursor';
            buttonSubmitContainer.setAttribute('title', 'Submeter pedido');

            const buttonSubmitContent = document.createElement('div');
            buttonSubmitContent.className = 'menu-icon refresh';
            buttonSubmitContent.innerHTML = '<i class="fa fa-check modal-location-plant-button"></i>';

            buttonSubmitContainer.appendChild(buttonSubmitContent);
            buttonSubmit.appendChild(buttonSubmitContainer);

            /**
             * Submit handle location plant
             */
            const handleSubmitLocationPlant = function () {
                if (app.layerDraw.getSource()) app.layerDrawLine.getSource().clear();
                if (app.layerDrawPoint.getSource()) app.layerDrawPoint.getSource().clear();
                app.Select.setActive(false);
                app.DrawLine.setActive(false);
                app.DrawPoint.setActive(false);
                app.Draw.setActive(false);
                document.body.style.cursor = 'default';

                // Check if select polygon is active
                if ($('#target-gpi-select-pl').parent().has('active')) {
                    $('#target-gpi-select-pl').parent().removeClass('active');
                    $('#target-gpi-select-pl').removeClass('hold-button');
                    // Reset selection with modify
                    app._useSelectModify = false;
                }

                // Check if draw polygon is active
                if ($('#target-gpi-polygon-pl').parent().has('active')) {
                    $('#target-gpi-polygon-pl').parent().removeClass('active');
                    $('#target-gpi-polygon-pl').removeClass('hold-button');
                }

                myMapSgs._territorialManagement.CreateLocationPlant();

                // Reset tooltips
                if (myMapSgs.tooltips) {
                    if (!myMapSgs.map.hasListener('singleclick', myMapSgs.tooltips.BuildInfoTooltips))
                        myMapSgs.map.on('singleclick', async (e) => { await myMapSgs.tooltips.BuildInfoTooltips(e); });
                }
            };

            /**
             * Submit handle pdm analyze
             */
            const handleSubmitPDMAnalyze = function () {
                if (app.layerDraw.getSource()) app.layerDrawLine.getSource().clear();
                if (app.layerDrawPoint.getSource()) app.layerDrawPoint.getSource().clear();
                app.Select.setActive(false);
                app.DrawLine.setActive(false);
                app.DrawPoint.setActive(false);
                app.Draw.setActive(false);
                document.body.style.cursor = 'default';

                // Check if select polygon is active
                if ($('#target-gpi-select-pl').parent().has('active')) {
                    $('#target-gpi-select-pl').parent().removeClass('active');
                    $('#target-gpi-select-pl').removeClass('hold-button');
                    // Reset selection with modify
                    app._useSelectModify = false;
                }

                // Check if draw polygon is active
                if ($('#target-gpi-polygon-pl').parent().has('active')) {
                    $('#target-gpi-polygon-pl').parent().removeClass('active');
                    $('#target-gpi-polygon-pl').removeClass('hold-button');
                }

                // Execute Pdm Analyze
                myMapSgs._territorialManagement.ExecutePdmAnalyze();

                // Reset tooltips
                if (myMapSgs.tooltips) {
                    if (!myMapSgs.map.hasListener('singleclick', myMapSgs.tooltips.BuildInfoTooltips))
                        myMapSgs.map.on('singleclick', async (e) => { await myMapSgs.tooltips.BuildInfoTooltips(e); });
                }
            };


            if (mapSettings.operation_visible.PDMAnalyze) {
                buttonSubmit.addEventListener('click', handleSubmitPDMAnalyze, false);
                buttonSubmit.addEventListener('touchstart', handleSubmitPDMAnalyze, false);
            }
            else {
                buttonSubmit.addEventListener('click', handleSubmitLocationPlant, false);
                buttonSubmit.addEventListener('touchstart', handleSubmitLocationPlant, false);
            }

            // -- Close ---------------------------------------------------------------------------
            const buttonClose = document.createElement('li');

            const buttonCloseContainer = document.createElement('a');
            buttonCloseContainer.className = 'modal-location-plant-button-cursor';
            buttonCloseContainer.setAttribute('title', 'Fechar');

            const buttonCloseContent = document.createElement('div');
            buttonCloseContent.className = 'menu-icon refresh';
            buttonCloseContent.innerHTML = '<i class="fa fa-times modal-location-plant-button"></i>';

            buttonCloseContainer.appendChild(buttonCloseContent);
            buttonClose.appendChild(buttonCloseContainer);

            /**
             * close handle
             */
            const handleClose = function () {
                $('#menubar-bottom-pl').toggle('ol-hidden');
                if (app.layerDraw.getSource()) app.layerDraw.getSource().clear();
                app.Select.setActive(false);
                app.DrawLine.setActive(false);
                app.DrawPoint.setActive(false);
                app.Draw.setActive(false);
                document.body.style.cursor = 'default';
                // Clear Info feature
                $('#offcanvas-info').removeClass('show');

                // Check if select polygon is active
                if ($('#target-gpi-select-pl').parent().has('active')) {
                    $('#target-gpi-select-pl').parent().removeClass('active');
                    $('#target-gpi-select-pl').removeClass('hold-button');
                    // Reset selection with modify
                    app._useSelectModify = false;
                }

                // Check if draw polygon is active
                if ($('#target-gpi-polygon-pl').parent().has('active')) {
                    $('#target-gpi-polygon-pl').parent().removeClass('active');
                    $('#target-gpi-polygon-pl').removeClass('hold-button');
                }

                // Reset tooltips
                if (myMapSgs.tooltips) {
                    if (!myMapSgs.map.hasListener('singleclick', myMapSgs.tooltips.BuildInfoTooltips))
                        myMapSgs.map.on('singleclick', async (e) => { await myMapSgs.tooltips.BuildInfoTooltips(e); });
                }
            };

            buttonClose.addEventListener('click', handleClose, false);
            buttonClose.addEventListener('touchstart', handleClose, false);

            // -- Main menu -----------------------------------------------------------------------
            const mainMenu = document.createElement('ul');
            mainMenu.id = 'main-menu-pl';
            mainMenu.className = 'map-controls menubar-bottom';

            mainMenu.appendChild(buttonPolygon);
            mainMenu.appendChild(buttonSelect);
            mainMenu.appendChild(buttonClean);
            if (!mapSettings.operation_visible.PDMAnalyze)
                mainMenu.appendChild(buttonDataAlpha);
            mainMenu.appendChild(buttonSubmit);
            mainMenu.appendChild(buttonClose);

            // -- Menu panel ----------------------------------------------------------------------
            const menuPanel = document.createElement('div');
            //menuPanel.className = 'menubar-scroll-panel';

            menuPanel.appendChild(mainMenu);

            // -- Main element menu bar bottom ----------------------------------------------------
            const element = document.createElement('div');
            element.id = 'menubar-bottom-pl';
            element.className = 'menubar-bottom';
            element.setAttribute('style', 'display: none;');

            element.appendChild(menuPanel);

            Control.call(this, {
                element: element,
                target: options.target
            });
        };
        inherits(this._controlBarCenterBottom, Control);
    };

    /**
    * Get all layer reference values
    */
    this._GetAllLayerReferences = function (type) {
        //var type = typeof type != 'undefined' ? type : 'LayerRef';

        // Get all layer references
        $.ajax({
            type: 'GET',
            //url: '/rest/app/' + type + '/GetAssetLayerRef',
            url: '/rest/app/LayerRef/GetAssetLayerRef',
            xhrFields: {
                withCredentials: true
            },
            async: true,
            success: function (data) {
                if (data.error) {
                    toastr["error"]("Erro de carregamento da informação de referências de camada");
                }
                else {
                    if (data.success) {

                        myMapSgs._layerReferences = data.result;

                    } else {
                        toastr["error"]("Erro de carregamento da informação de referências de camada");
                    }
                }
            },
            error: function (request, status, error) {
                toastr["error"]("Erro de carregamento da informação de referências de camada");
            }
        });
    };

    /**
    * Get Layer Ref Info
    */
    this._GetLayerRefInfo = function (refName, repository) {

        // Get all layer reference rows
        $.ajax({
            type: 'GET',
            url: '/rest/app/LayerRef/GetRefColumn?refName=' + refName,
            xhrFields: {
                withCredentials: true
            },
            async: true,
            success: function (data) {
                if (data.error) {
                    toastr["error"]("Erro de carregamento da informação de referência.");
                }
                else {
                    if (data.success) {
                        myMapSgs[repository] = data.result.map(a => a.description);

                    } else {
                        toastr["error"]("Erro de carregamento da informação de referência.");
                    }
                }
            },
            error: function (request, status, error) {
                toastr["error"]("Erro de carregamento da informação de referência.");
            }
        });
    };

    /**
     * Get all references
     */
    this._GetAllReference = function () {
        let visibleOperations = myMapSgs.getSettings().getVisibleOperations();

        // -- Distrito reference --
        if (visibleOperations.Search && visibleOperations.SearchDistrito) {
            if (myMapSgs._hashReference['distrito'] === undefined) {
                myMapSgs.hashDistritoInfo = {
                    layer_name: myMapSgs._utility.GetPropertyInfoInConfigArray(myMapSgs._settings.configurationInfo.propertyInfo, "DISTRITO_INFO", "LAYER_INFO", "LAYER_NAME").value,
                    all_column: myMapSgs._utility.GetPropertyInfoInConfigArray(myMapSgs._settings.configurationInfo.propertyInfo, "DISTRITO_INFO", "LAYER_INFO", "ALL_COLUMN").value,
                    id_column: myMapSgs._utility.GetPropertyInfoInConfigArray(myMapSgs._settings.configurationInfo.propertyInfo, "DISTRITO_INFO", "LAYER_INFO", "ID_COLUMN").value,
                    dd_column: myMapSgs._utility.GetPropertyInfoInConfigArray(myMapSgs._settings.configurationInfo.propertyInfo, "DISTRITO_INFO", "LAYER_INFO", "DD_COLUMN").value,
                    desc_column: myMapSgs._utility.GetPropertyInfoInConfigArray(myMapSgs._settings.configurationInfo.propertyInfo, "DISTRITO_INFO", "LAYER_INFO", "DESC_COLUMN").value,
                    geom_column: myMapSgs._utility.GetPropertyInfoInConfigArray(myMapSgs._settings.configurationInfo.propertyInfo, "DISTRITO_INFO", "LAYER_INFO", "GEOM_COLUMN").value
                };

                // Avim tool
                if (mapSettings.operation_visible.AvimTool) {
                    myMapSgs._avimTool.SelectSearchDistritoWait(true);
                }

                var layerInfo = myMapSgs.layerTree.FindLayerInfoOnListLayer(myMapSgs.hashDistritoInfo.layer_name);

                // Start wait
                myMapSgs.SelectSearchDistritoWait(true);

                let Feature = $.ajax({
                    method: "GET",
                    async: true,
                    url: layerInfo.geoserver + "/wfs",
                    data: {
                        "service": 'wfs',
                        "version": '2.0.0',
                        "request": 'GetFeature ',
                        "typeNames": layerInfo.workspace + ':' + layerInfo.layerName,
                        "propertyName": myMapSgs.hashDistritoInfo.all_column + "," + layerInfo.geomColumnName,
                        'srsName': myMapSgs._settings.projection.code_,
                        "outputFormat": 'application/json'
                    }
                });

                Feature.done(function (data) {
                    var distritoData = [];
                    var hashDistritoFeature = {};
                    for (var i = 0; i < data.features.length; i++) {
                        var propertyData = data.features[i].properties;
                        var feature = (new GeoJSON()).readFeatures(data.features[i])[0];
                        distritoData.push(propertyData);
                        hashDistritoFeature[propertyData[myMapSgs.hashDistritoInfo.id_column]] = feature;
                    }
                    myMapSgs._utility.FillSelect('id-toponymy-search-select-distrito', distritoData, myMapSgs.hashDistritoInfo.desc_column, myMapSgs.hashDistritoInfo.id_column, true);
                    // Avim tool
                    if (mapSettings.operation_visible.AvimTool) {
                        myMapSgs._utility.FillSelect('id-avim-search-select-distrito', distritoData, myMapSgs.hashDistritoInfo.desc_column, myMapSgs.hashDistritoInfo.id_column, true);
                    }
                    myMapSgs._hashReference['distrito'] = distritoData;
                    myMapSgs._hashReferenceFeature['distrito'] = hashDistritoFeature;
                });

                // On error
                Feature.fail(function (jqXHR, textStatus, errorThrown) {
                    // Stop wait
                    myMapSgs.SelectSearchDistritoWait(false);
                    toastr["error"]("Erro na obtenção dos distritos");
                });
            }
        }

        // -- Concelho reference --
        if (visibleOperations.Search && visibleOperations.SearchConcelho) {
            if (myMapSgs._hashReference['concelho'] === undefined) {
                var hasDistrito = myMapSgs._utility.GetPropertyInfoInConfigArray(myMapSgs._settings.configurationInfo.propertyInfo, "CONCELHO_INFO", "DISTRITO_INFO", "HAS_DISTRITO").value;

                myMapSgs.hashConcelhoInfo = {
                    has_distrito: (hasDistrito === "true") ? true : false,
                    id_distrito: myMapSgs._utility.GetPropertyInfoInConfigArray(myMapSgs._settings.configurationInfo.propertyInfo, "CONCELHO_INFO", "DISTRITO_INFO", "ID_COLUMN_DISTRITO").value,
                    layer_name: myMapSgs._utility.GetPropertyInfoInConfigArray(myMapSgs._settings.configurationInfo.propertyInfo, "CONCELHO_INFO", "LAYER_INFO", "LAYER_NAME").value,
                    all_column: myMapSgs._utility.GetPropertyInfoInConfigArray(myMapSgs._settings.configurationInfo.propertyInfo, "CONCELHO_INFO", "LAYER_INFO", "ALL_COLUMN").value,
                    id_column: myMapSgs._utility.GetPropertyInfoInConfigArray(myMapSgs._settings.configurationInfo.propertyInfo, "CONCELHO_INFO", "LAYER_INFO", "ID_COLUMN").value,
                    ddcc_column: myMapSgs._utility.GetPropertyInfoInConfigArray(myMapSgs._settings.configurationInfo.propertyInfo, "CONCELHO_INFO", "LAYER_INFO", "DDCC_COLUMN").value,
                    desc_column: myMapSgs._utility.GetPropertyInfoInConfigArray(myMapSgs._settings.configurationInfo.propertyInfo, "CONCELHO_INFO", "LAYER_INFO", "DESC_COLUMN").value,
                    geom_column: myMapSgs._utility.GetPropertyInfoInConfigArray(myMapSgs._settings.configurationInfo.propertyInfo, "CONCELHO_INFO", "LAYER_INFO", "GEOM_COLUMN").value
                };

                // Avim tool
                if (mapSettings.operation_visible.AvimTool) {
                    myMapSgs._avimTool.SelectSearchConcelhoWait(true);
                }

                // Start wait
                myMapSgs.SelectSearchConcelhoWait(true);

                var layerInfo = myMapSgs.layerTree.FindLayerInfoOnListLayer(myMapSgs.hashConcelhoInfo.layer_name);

                let Feature = $.ajax({
                    method: "GET",
                    async: true,
                    url: layerInfo.geoserver + "/wfs",
                    data: {
                        "service": 'wfs',
                        "version": '2.0.0',
                        "request": 'GetFeature ',
                        "typeNames": layerInfo.workspace + ':' + layerInfo.layerName,
                        "propertyName": myMapSgs.hashConcelhoInfo.all_column + "," + layerInfo.geomColumnName,
                        'srsName': myMapSgs._settings.projection.code_,
                        "outputFormat": 'application/json'
                    }
                });

                Feature.done(function (data) {
                    if (myMapSgs.hashConcelhoInfo.has_distrito) {
                        myMapSgs._hashReference['concelho'] = {};
                        myMapSgs._hashReferenceFeature['concelho'] = {};
                        for (var i = 0; i < data.features.length; i++) {
                            var objConcelho = data.features[i].properties;
                            var feature = (new GeoJSON()).readFeatures(data.features[i])[0];
                            myMapSgs._hashReferenceFeature['concelho'][objConcelho[myMapSgs.hashConcelhoInfo.ddcc_column]] = feature;
                            if (myMapSgs._hashReference['concelho'][objConcelho[myMapSgs.hashConcelhoInfo.id_distrito]])
                                myMapSgs._hashReference['concelho'][objConcelho[myMapSgs.hashConcelhoInfo.id_distrito]].push(objConcelho);
                            else
                                myMapSgs._hashReference['concelho'][objConcelho[myMapSgs.hashConcelhoInfo.id_distrito]] = [objConcelho];
                        }

                        // Event to change distrito
                        $('#id-toponymy-search-select-distrito').on('change.bs.select', function () {
                            var idDistrito = $('#id-toponymy-search-select-distrito').val();
                            if (idDistrito === undefined || idDistrito === "") {
                                $('#id-toponymy-search-select-concelho').find('option[value]').remove();
                                $('#id-toponymy-search-select-concelho').selectpicker("refresh");
                                $('#id-toponymy-search-select-freguesia').find('option[value]').remove();
                                $('#id-toponymy-search-select-freguesia').selectpicker("refresh");
                            }
                            else {
                                $('#id-toponymy-search-select-freguesia').find('option[value]').remove();
                                $('#id-toponymy-search-select-freguesia').selectpicker("refresh");
                                var arrayConcelho = myMapSgs._hashReference['concelho'][idDistrito];
                                myMapSgs._utility.FillSelect('id-toponymy-search-select-concelho', arrayConcelho, myMapSgs.hashConcelhoInfo.desc_column, myMapSgs.hashConcelhoInfo.id_column, true);
                            }
                        });

                    }
                    else {
                        var concelhoData = [];
                        for (var i = 0; i < data.features.length; i++) {
                            concelhoData.push(data.features[i].properties);
                        }
                        myMapSgs._utility.FillSelect('id-toponymy-search-select-concelho', concelhoData, myMapSgs.hashConcelhoInfo.desc_column, myMapSgs.hashConcelhoInfo.id_column, true);
                        myMapSgs._hashReference['concelho'] = concelhoData;
                    }

                    // Avim tool
                    if (mapSettings.operation_visible.AvimTool) {
                        myMapSgs._avimTool.SelectSearchConcelhoWait(false);
                        myMapSgs._avimTool.SelectSearchDistritoWait(false);
                        $('.avim-search-map').removeClass('disabled');
                    }

                    // Stop wait
                    myMapSgs.SelectSearchConcelhoWait(false);
                    myMapSgs.SelectSearchDistritoWait(false);
                });

                // On error
                Feature.fail(function (jqXHR, textStatus, errorThrown) {
                    // Stop wait
                    myMapSgs.SelectSearchConcelhoWait(false);
                    myMapSgs.SelectSearchDistritoWait(false);
                    toastr["error"]("Erro na obtenção dos concelho");
                });
            }
        }

        // -- freguesia reference --
        if (visibleOperations.Search ||
            visibleOperations.SearchFreguesia ||
            visibleOperations.LocationPlant ||
            visibleOperations.LocationPlantPdm ||
            visibleOperations.LocationPlantPdmRuido ||
            visibleOperations.CartographyExtract ||
            visibleOperations.SearchLugar ||
            visibleOperations.SearchSeccao
        ) {
            // Use reference freguesia for location plant
            var fillLocationPlantFreguesia = false;
            if (visibleOperations.LocationPlant ||
                visibleOperations.LocationPlantPdm ||
                visibleOperations.LocationPlantPdmRuido) {
                var useLocationPlantFreguesiaObj = myMapSgs._utility.GetPropertyInfoInConfigArray(myMapSgs._settings.configurationInfo.propertyInfo, "PLANTA_LOCALIZACAO", "TEMPLATE_INFO", "PL_FREGUESIA_USE");
                var idReferenceLocationPlantFreguesiaObj = myMapSgs._utility.GetPropertyInfoInConfigArray(myMapSgs._settings.configurationInfo.propertyInfo, "PLANTA_LOCALIZACAO", "TEMPLATE_INFO", "PL_FREGUESIA_ID_REFERENCE");
                if (useLocationPlantFreguesiaObj && useLocationPlantFreguesiaObj.value == 'true' && idReferenceLocationPlantFreguesiaObj && idReferenceLocationPlantFreguesiaObj.value != "") {
                    const idReferenceLocationPlantFreguesia = idReferenceLocationPlantFreguesiaObj.value;
                    const arrayFreguesiaLocationPlant = myMapSgs._settings.columnTableReferenceData.table_reference_data[idReferenceLocationPlantFreguesia]
                    myMapSgs._utility.FillSelect('id-modal-location-plant-body-select-freguesia', arrayFreguesiaLocationPlant, "value", "id", true);
                    fillLocationPlantFreguesia = true;
                }
            }

            var hasConcelho = myMapSgs._utility.GetPropertyInfoInConfigArray(myMapSgs._settings.configurationInfo.propertyInfo, "FREGUESIA_INFO", "CONCELHO_INFO", "HAS_CONCELHO").value;
            myMapSgs.hashFreguesiaInfo = {
                has_concelho: (hasConcelho && hasConcelho === "true") ? true : false,
                layer_name: _freguesiaLayer,
                all_column: _freguesiaLayerAllColumn,
                id_column: _freguesiaToponymyColumnId,
                ddccff_column: _freguesiaLayerddccff,
                desc_column: _freguesiaLayerDescricao,
                geom_column: _freguesiaLayerGeomColumn
            };

            if (!myMapSgs.hashFreguesiaInfo.has_concelho) {
                if (myMapSgs._hashReference['freguesia'] === undefined) {

                    var layerInfo = myMapSgs.layerTree.FindLayerInfoOnListLayer(_freguesiaLayer);
                    let urlString = layerInfo.geoserver + "/wfs";
                    let layerString = layerInfo.workspace + ':' + layerInfo.layerName;
                    var freguesiasData = [];

                    // Set data get feature
                    var dataGetFeature = {
                        "service": 'wfs',
                        "version": '2.0.0',
                        "request": 'GetFeature ',
                        "typeNames": layerString,
                        "propertyName": _freguesiaLayerAllColumn,
                        "outputFormat": 'application/json'
                    }

                    // Set cql filter if exists
                    var cqlFilterFreguesiaConfigObj = myMapSgs._utility.GetPropertyInfoInConfigArray(myMapSgs._settings.configurationInfo.propertyInfo, "FREGUESIA_INFO", "FILTER", "CQL_FILTER");

                    if (cqlFilterFreguesiaConfigObj) {
                        dataGetFeature["cql_filter"] = cqlFilterFreguesiaConfigObj.value;
                    }

                    // Start wait
                    myMapSgs.SelectSearchFreguesiaWait(true);

                    let Feature = $.ajax({
                        method: "GET",
                        async: true,
                        url: urlString,
                        data: dataGetFeature
                    });

                    Feature.done(function (data) {
                        for (var i = 0; i < data.features.length; i++) {
                            freguesiasData.push(data.features[i].properties);
                        }
                        myMapSgs._utility.FillSelect('id-toponymy-search-select-freguesia', freguesiasData, _freguesiaLayerDescricao, _freguesiaToponymyColumnId, true);
                        if (!fillLocationPlantFreguesia)
                            myMapSgs._utility.FillSelect('id-modal-location-plant-body-select-freguesia', freguesiasData, _freguesiaLayerDescricao, _freguesiaLayerddccff, true);
                        myMapSgs._utility.FillSelect('id-SeccaoCadastralSearch', freguesiasData, _freguesiaLayerDescricao, _freguesiaLayerddccff, true);
                        if (mapSettings.operation_visible.PubTool) {
                            myMapSgs._pubTool.FillFreguesiaList(freguesiasData);
                        }
                        if (mapSettings.operation_visible.GreenAreaTool) {
                            myMapSgs._greenAreaTool.FillFreguesiaList(freguesiasData);
                        }
                        if (mapSettings.operation_visible.CivilProtectionTool) {
                            myMapSgs._civilProtectionTool.FillFreguesiaList(freguesiasData);
                        }
                        if (mapSettings.operation_visible.DepositionPointTool) {
                            myMapSgs._depositionPointTool.FillFreguesiaList(freguesiasData);
                        }
                        if (mapSettings.operation_visible.TrafficSignTool) {
                            myMapSgs._utility.FillSelect('id-freguesia', freguesiasData, _freguesiaLayerDescricao, _freguesiaLayerddccff, true);
                        }
                        if (mapSettings.operation_visible.ManagerTrafficSignTool) {
                            myMapSgs._managerTrafficSignTool._freguesiaData = freguesiasData;
                            myMapSgs._utility.FillSelect('id-freguesia', freguesiasData, _freguesiaLayerDescricao, _freguesiaLayerddccff, true);
                        }
                        myMapSgs._hashReference['freguesia'] = freguesiasData;

                        // Stop wait
                        myMapSgs.SelectSearchFreguesiaWait(false);
                    });

                    // On error
                    Feature.fail(function (jqXHR, textStatus, errorThrown) {
                        // Stop wait
                        myMapSgs.SelectSearchFreguesiaWait(false);
                        toastr["error"]("Erro na obtenção das freguesias");
                    });
                }
                else {
                    myMapSgs._utility.FillSelect('id-toponymy-search-select-freguesia', myMapSgs._hashReference['freguesia'], _freguesiaLayerDescricao, _freguesiaToponymyColumnId, true);
                    if (!fillLocationPlantFreguesia)
                        myMapSgs._utility.FillSelect('id-modal-location-plant-body-select-freguesia', myMapSgs._hashReference['freguesia'], _freguesiaLayerDescricao, _freguesiaLayerddccff, true);
                    myMapSgs._utility.FillSelect('id-SeccaoCadastralSearch', myMapSgs._hashReference['freguesia'], _freguesiaLayerDescricao, _freguesiaLayerddccff, true);
                }
            }
            else {
                // Event to change concelho
                $('#id-toponymy-search-select-concelho').on('change.bs.select', function () {
                    var idConcelho = $('#id-toponymy-search-select-concelho').val();

                    if (idConcelho === undefined || idConcelho === "") {
                        $('#id-toponymy-search-select-freguesia').find('option[value]').remove();
                        $('#id-toponymy-search-select-freguesia').selectpicker("refresh");
                        return;
                    }

                    var layerInfo = myMapSgs.layerTree.FindLayerInfoOnListLayer(myMapSgs.hashFreguesiaInfo.layer_name);

                    // Start wait
                    myMapSgs.SelectSearchFreguesiaWait(true);

                    let Feature = $.ajax({
                        method: "GET",
                        async: true,
                        url: layerInfo.geoserver + "/wfs",
                        data: {
                            "service": 'wfs',
                            "version": '2.0.0',
                            "request": 'GetFeature ',
                            "typeNames": layerInfo.workspace + ':' + layerInfo.layerName,
                            "cql_filter": myMapSgs.hashFreguesiaInfo.ddccff_column + " like '" + idConcelho + "%'",
                            "propertyName": myMapSgs.hashFreguesiaInfo.all_column,
                            "outputFormat": 'application/json'
                        }
                    });

                    Feature.done(function (data) {
                        myMapSgs._hashReference['freguesia'] = {};
                        for (var i = 0; i < data.features.length; i++) {
                            var objFreguesia = data.features[i].properties;
                            var idConcelhoFreg = objFreguesia[myMapSgs.hashFreguesiaInfo.ddccff_column].substr(0, 4);
                            if (myMapSgs._hashReference['freguesia'][idConcelhoFreg])
                                myMapSgs._hashReference['freguesia'][idConcelhoFreg].push(objFreguesia);
                            else
                                myMapSgs._hashReference['freguesia'][idConcelhoFreg] = [objFreguesia];
                        }

                        var arrayFreguesia = myMapSgs._hashReference['freguesia'][idConcelho];
                        myMapSgs._utility.FillSelect('id-toponymy-search-select-freguesia', arrayFreguesia, myMapSgs.hashFreguesiaInfo.desc_column, myMapSgs.hashFreguesiaInfo.id_column, true);

                        // Stop wait
                        myMapSgs.SelectSearchFreguesiaWait(false);
                    });

                    // On error
                    Feature.fail(function (jqXHR, textStatus, errorThrown) {
                        // Stop wait
                        myMapSgs.SelectSearchFreguesiaWait(false);
                        toastr["error"]("Erro na obtenção das freguesias");
                    });
                });
            }
        }
    };

    /**
     * Get all references for Airc
     */
    this._GetAircReferences = function () {

        $.ajax({
            type: 'GET',
            url: '/rest/app/AIRC/GetWebServiceAction',
            async: true,
            success: function (data) {
                if (data.error) {
                    toastr["error"]("Erro de carregamento da informação de referência");
                }
                else {
                    myMapSgs._utility.FillSelect('id-aircAction', data.result, 'description', 'cod_webservice_action');
                }
            },
            error: function (request, status, error) {
                toastr["error"]("Erro de carregamento da informação de referência");
            }
        });

    };

    /**
     * Get projection from server
     */
    this._FillArrayProjection = function () {
        $("#projectionchoise").html(myMapSgs._settings.hashProj4[myMapSgs._projectionArray[myMapSgs._projectionindex].getCode()].name);
    };

    /**
     * Init mouse position display
     */
    this._InitMousePositionControl = function () {

        // Fill projection array
        this._projectionArray = [this._settings.projection, this._settings.projectionWgs84]//, this._settings.projection3035];

        // Fill projection array
        this._FillArrayProjection();

        /**
         * Event change projection display
         */
        $("#scale-line-projection, #projectionchoise").click(function () {
            myMapSgs._projectionindex++;
            if (myMapSgs._projectionindex + 1 > myMapSgs._projectionArray.length)
                myMapSgs._projectionindex = 0;
            myMapSgs._mousePositionControl.setProjection(myMapSgs._projectionArray[myMapSgs._projectionindex]);
            $("#projectionchoise").html(myMapSgs._settings.hashProj4[myMapSgs._projectionArray[myMapSgs._projectionindex].getCode()].name);
        });

        // Declare Mouse position object
        var templates = ['X: {x} &nbsp; Y: {y}', 'Lat: {y} &nbsp; Long: {x}']//, 'Lat: {y} &nbsp; Long: {x}'];
        myMapSgs._mousePositionControl = new MousePosition({
            coordinateFormat: function (coordinate) {
                return CoordinateFormat(coordinate, templates[myMapSgs._projectionindex], 4),
                    myMapSgs._lastPositionCoordinate = CoordinateFormat(coordinate, templates[myMapSgs._projectionindex], 4);
            },
            projection: myMapSgs._settings.projection.getCode(),
            className: 'custom-mouse-position',
            target: document.getElementById('mouse-position'),
            undefinedHTML: myMapSgs._lastPositionCoordinate
        });
    };

    /**
     *  Change css of ScaleLine
     * */
    this._CreateScaline = function () {
        // Add unit line to ol
        $(".ol-scale-line-inner").prependTo("#unitscaleline-id");

        // Add scale line to make overlay 
        $("#unitscaleline-id").prependTo(".ol-overlaycontainer");

        // Define array of coordinate format type
        const units = ["metric", "imperial", "us", "nautical", "degrees"];
        var _unitsindex = 0;

        $(".ol-scale-line-inner").click(function () {
            _unitsindex++;
            if (_unitsindex + 1 > units.length)
                _unitsindex = 0;
            myMapSgs._scaleLineControl.setUnits(units[_unitsindex]);
        });
    };

    /**
     * Define Menu Bar Control
     * @param {any} buttonId, button id
     */
    this._HandlePositionForPopupOnClick = function (buttonId) {
        var buttonNode = $("#" + buttonId);
        var position = buttonNode.offset();
        var canvas = $("#" + buttonId + "_offcanvas");
        canvas.css('marginTop', position.top - canvas.height() / 2 + buttonNode.height() / 2);
    };

    /**
     * Close save feature
     */
    this._CloseSaveFeature = function () {
        $('#offcanvas-save-feature').removeClass('show');
        $('#save-feature-form-container').empty();
    };

    /**
     * Toggles visibility of the ok button
     * @param {string} geomType 'point', 'line' or 'polygon'
     * @param {string} mode, indicate mode call
     */
    this.handleEditButtonsVisibility = function (geomType, mode) {

        // Remove button layer edition if deselected layer in layertree
        if (!geomType) {
            $('#geometry-buttons-div').addClass('ol-hidden');
            $('#offcanvas-info').removeClass('expand');
            return;
        }

        // Check mode call
        switch (mode) {
            case "edit":
                // Check if traffice tool is on and get the subroad nearest
                if (myMapSgs._settings._mapSettings.operation_visible.TrafficSignTool) {
                    let layerInfo = myMapSgs.layerTree.layerInfo.dict_layer_info[myMapSgs.layerTree.selectedLayer].layer_info;
                    if (layerInfo.layerName === myMapSgs._trafficSignTool.layerNameTrafficSign) {
                        var feature = app.Select.getFeatures().getArray()[0];
                        myMapSgs._trafficSignTool.IdentifySubRoadNearest(feature, mode);
                    }
                }
                // Check if manager traffice tool is on and get the subroad nearest
                if (myMapSgs._settings._mapSettings.operation_visible.ManagerTrafficSignTool) {
                    let layerInfo = myMapSgs.layerTree.layerInfo.dict_layer_info[myMapSgs.layerTree.selectedLayer].layer_info;
                    if (layerInfo.layerName == myMapSgs._managerTrafficSignTool.prumoInfo.layerName) {
                        var feature = app.Select.getFeatures().getArray()[0];
                        myMapSgs._managerTrafficSignTool.IdentifySubRoadNearest(feature, mode);
                    }
                }
                break;
            case "create":
                // Check if traffice tool is on and get the subroad nearest
                if (myMapSgs._settings._mapSettings.operation_visible.TrafficSignTool) {
                    let layerInfo = myMapSgs.layerTree.layerInfo.dict_layer_info[myMapSgs.layerTree.selectedLayer].layer_info;
                    if (layerInfo.layerName === myMapSgs._trafficSignTool.layerNameTrafficSign) {
                        var feature = app.layerDrawPoint.getSource().getFeatures()[0];
                        myMapSgs._trafficSignTool.IdentifySubRoadNearest(feature, mode);
                    }
                }
                // Check if manager traffice tool is on and get the subroad nearest
                if (myMapSgs._settings._mapSettings.operation_visible.ManagerTrafficSignTool) {
                    let layerInfo = myMapSgs.layerTree.layerInfo.dict_layer_info[myMapSgs.layerTree.selectedLayer].layer_info;
                    if (layerInfo.layerName == myMapSgs._managerTrafficSignTool.prumoInfo.layerName) {
                        var feature = app.layerDrawPoint.getSource().getFeatures()[0];
                        myMapSgs._managerTrafficSignTool.IdentifySubRoadNearest(feature, mode);
                    }
                }
                break;
            default:
            // do nothing
        }

        // Is update or delete
        if (myMapSgs.layerTree.selectedLayer !== null && app.Select.getFeatures().getLength() === 1) {
            let layerInfo = myMapSgs.layerTree.layerInfo.dict_layer_info[myMapSgs.layerTree.selectedLayer].layer_info;
            let currZoom = app.sgs.Map.map.getView().getZoom();
            if (layerInfo && (layerInfo.kind === 'WFS' || layerInfo.kind === 'WMS_ST' || layerInfo.kind === 'WMS')
                && layerInfo.editable
                //&& (!layerInfo.minScale || layerInfo.minScale <= myMapSgs._settings.scales[currZoom])
                //&& (!layerInfo.maxScale || layerInfo.maxScale >= myMapSgs._settings.scales[currZoom])
            ) {

                if (layerInfo.kind != 'WFS') {

                    $('#layer-edit-edit').hide();

                } else {

                    $('#layer-edit-edit').show();

                }

                $('#geometry-buttons-div').removeClass('ol-hidden');
                $('#offcanvas-info').addClass('expand');
                $('#geometry-del').show();
                $('#geometry-cancel').show();
                $('#geometry-cancel')[0].setAttribute('title', 'Cancelar a edição');
                $('#geometry-ok').show();
                return;
            } else {
                $('#geometry-del').hide();
                $('#geometry-ok').hide();
                $('#geometry-cancel').hide();
                $('#geometry-buttons-div').addClass('ol-hidden');
                $('#offcanvas-info').removeClass('expand');
                return;
            }

        } else {
            $('#geometry-del').hide();
            $('#geometry-ok').hide();
            $('#geometry-cancel').hide();
            $('#geometry-buttons-div').addClass('ol-hidden');
            $('#offcanvas-info').removeClass('expand');
        }

        // Is create
        if (myMapSgs.layerTree.selectedLayer !== null && app.Select.getFeatures().getLength() === 0) {

            var layerDraw = geomType === 'line' ? app.layerDrawLine : geomType === 'point' ? app.layerDrawPoint : app.layerDraw;
            if (layerDraw
                && layerDraw.getSource()
                && layerDraw.getSource().getFeatures()
                && layerDraw.getSource().getFeatures().length === 1) {
                let layerInfo = myMapSgs.layerTree.layerInfo.dict_layer_info[myMapSgs.layerTree.selectedLayer].layer_info;
                let currZoom = app.sgs.Map.map.getView().getZoom();
                if (layerInfo && (layerInfo.kind === 'WFS' || layerInfo.codServerType == 'GEOSERVER')
                    && geomType === layerInfo.geomType
                    && layerInfo.editable
                    //&& (!layerInfo.minScale || layerInfo.minScale <= myMapSgs._settings.scales[currZoom])
                    //&& (!layerInfo.maxScale || layerInfo.maxScale >= myMapSgs._settings.scales[currZoom])
                ) {
                    $('#geometry-buttons-div').removeClass('ol-hidden');
                    $('#offcanvas-info').addClass('expand');
                    $('#geometry-ok').show();
                    $('#geometry-cancel').show();
                    $('#geometry-cancel')[0].setAttribute('title', 'Cancelar a criação');
                    $('#geometry-del').hide();
                } else {
                    $('#geometry-ok').hide();
                    $('#geometry-del').hide();
                    $('#geometry-buttons-div').addClass('ol-hidden');
                    $('#offcanvas-info').removeClass('expand');
                    myMapSgs._CloseSaveFeature();
                }
            } else {
                $('#geometry-ok').hide();
                $('#geometry-del').hide();
                $('#geometry-buttons-div').addClass('ol-hidden');
                $('#offcanvas-info').removeClass('expand');
                myMapSgs._CloseSaveFeature();
            }
        } else {
            $('#geometry-ok').hide();
            $('#geometry-del').hide();
            $('#geometry-cancel').hide();
            $('#geometry-buttons-div').addClass('ol-hidden');
            $('#offcanvas-info').removeClass('expand');
            myMapSgs._CloseSaveFeature();
        }
    };

    /**
     * Toggles visibility of the ok button
     * @param {string} geomType 'point', 'line' or 'polygon'
     * @param {string} mode, indicate mode call
     */
    this.handleEditButtonsVisibility2 = function (geomType, mode) {

        // Remove button layer edition if deselected layer in layertree
        if (!geomType) {
            $('#geometry-buttons-div').addClass('ol-hidden');
            $('#offcanvas-info').removeClass('expand');
            return;
        }


        // Is create
        if (app.Select.getFeatures().getLength() === 0) {

            var layerDraw = geomType === 'line' ? app.layerDrawLine : geomType === 'point' ? app.layerDrawPoint : app.layerDraw;
            if (layerDraw
                && layerDraw.getSource()
                && layerDraw.getSource().getFeatures()
                && layerDraw.getSource().getFeatures().length === 1) {
                let layerInfo = myMapSgs.layerTree.layerInfo.dict_layer_info[2828].layer_info;
                let currZoom = app.sgs.Map.map.getView().getZoom();
                if (layerInfo && layerInfo.kind === 'WFS'
                    && geomType === layerInfo.geomType
                    //&& layerInfo.editable
                    //&& (!layerInfo.minScale || layerInfo.minScale <= myMapSgs._settings.scales[currZoom])
                    //&& (!layerInfo.maxScale || layerInfo.maxScale >= myMapSgs._settings.scales[currZoom])
                ) {
                    $('#geometry-buttons-div').removeClass('ol-hidden');
                    $('#offcanvas-info').addClass('expand');
                    $('#geometry-ok').show();
                    $('#geometry-cancel').show();
                    $('#geometry-cancel')[0].setAttribute('title', 'Cancelar a criação');
                    $('#geometry-del').hide();
                } else {
                    $('#geometry-ok').hide();
                    $('#geometry-del').hide();
                    $('#geometry-buttons-div').addClass('ol-hidden');
                    $('#offcanvas-info').removeClass('expand');
                    myMapSgs._CloseSaveFeature();
                }
            } else {
                $('#geometry-ok').hide();
                $('#geometry-del').hide();
                $('#geometry-buttons-div').addClass('ol-hidden');
                $('#offcanvas-info').removeClass('expand');
                myMapSgs._CloseSaveFeature();
            }
        } else {
            $('#geometry-ok').hide();
            $('#geometry-del').hide();
            $('#geometry-cancel').hide();
            $('#geometry-buttons-div').addClass('ol-hidden');
            $('#offcanvas-info').removeClass('expand');
            myMapSgs._CloseSaveFeature();
        }
    };

    /**
     * Action edition feature
     */
    this._ActionEditionFeature = function () {

        // Update
        if (myMapSgs.layerTree.selectedLayer !== null && app.Select.getFeatures().getLength() === 1) {
            myMapSgs._ShowFormForUpdate();
        }

        // Creation
        if (myMapSgs.layerTree.selectedLayer !== null && app.Select.getFeatures().getLength() === 0) {
            $('.hide-on-creation').hide();
            var geomType = myMapSgs.layerTree.layerInfo.dict_layer_info[myMapSgs.layerTree.selectedLayer].layer_info.geomType;
            var layerDraw = geomType === 'line' ? app.layerDrawLine : geomType === 'point' ? app.layerDrawPoint : app.layerDraw;
            myMapSgs._ShowFormForCreation(layerDraw);

        } else {
            $('.hide-on-creation').show();
        }

        if (myMapSgs._settings._mapSettings.operation_visible.LocationPlantConsultaPublica) {
            if (app.Select.getFeatures().getLength() === 0) {
                $('.hide-on-creation').hide();
                var geomType = myMapSgs.layerTree.layerInfo.dict_layer_info[2828].layer_info.geomType;
                var layerDraw = geomType === 'line' ? app.layerDrawLine : geomType === 'point' ? app.layerDrawPoint : app.layerDraw;
                myMapSgs._ShowFormForCreationConsultaPublica(layerDraw);

            } else {
                $('.hide-on-creation').show();
            }
        }
    };

    /**
     * Action edition feature for cancel
     */
    this._ActionEditionFeatureCancel = function () {
        // Update
        if (myMapSgs.layerTree.selectedLayer !== null && app.Select.getFeatures().getLength() === 1) {
            myMapSgs._CancelEdition();
        }

        // Creation
        if (myMapSgs.layerTree.selectedLayer !== null && app.Select.getFeatures().getLength() === 0) {
            var geomType = myMapSgs.layerTree.layerInfo.dict_layer_info[myMapSgs.layerTree.selectedLayer].layer_info.geomType;
            var layerDraw = geomType === 'line' ? app.layerDrawLine : geomType === 'point' ? app.layerDrawPoint : app.layerDraw;
            myMapSgs._CancelCreation(layerDraw);
        }

        // Creation consulta publica
        if (myMapSgs._settings._mapSettings.operation_visible.LocationPlantConsultaPublica) {
            var geomType = myMapSgs.layerTree.layerInfo.dict_layer_info[2828].layer_info.geomType;
            var layerDraw = geomType === 'line' ? app.layerDrawLine : geomType === 'point' ? app.layerDrawPoint : app.layerDraw;
            myMapSgs._CancelCreation(layerDraw);
        }

        // Check if traffice tool is on clean info
        if (myMapSgs._settings._mapSettings.operation_visible.TrafficSignTool) {
            myMapSgs._trafficSignTool.Clean();
        }

        // Check if manager traffice tool is on clean info
        if (myMapSgs._settings._mapSettings.operation_visible.ManagerTrafficSignTool) {
            myMapSgs._managerTrafficSignTool.Clean();
        }

        // Remove event
        if (myMapSgs.layerTree.keyLayerDrawAddFeatureEvent)
            ol.Observable.unByKey(myMapSgs.layerTree.keyLayerDrawAddFeatureEvent);
    };

    /**
     * Shows a form for adding a new feature to the selected layer
     * @param {ol.layer.Vector} layerDraw A vector layer containg the new feature (geometry)
     */
    this._ShowFormForCreation = function (layerDraw) {
        // Expand fill form if not expanded
        if ($('div[target-id="id-offcanvas-body-layer-detail-field"] > i.fa-chevron-down').length == 1)
            $('div[target-id="id-offcanvas-body-layer-detail-field"]').trigger('click');

        //$.ajax({
        //    url: layerInfo.geoserver + '/' + layerInfo.workspace + '/ows?service=WFS&version=1.1.0&request=DescribeFeatureType&typename=' + layerInfo.workspace + ':' + layerInfo.layerName + '&outputFormat=application/json',
        //    dataType: 'json',
        //    success: function (data) {

        // Manager traffic sign - Road id
        var idRoad = -1;
        var roadName = null;
        if (mapSettings.operation_visible.ManagerTrafficSignTool) {
            if (myMapSgs._managerTrafficSignTool._layerSubRoadCloser.getSource().getFeatures().length > 0) {
                var layerObj = myMapSgs.layerTree.layerInfo.dict_layer_info[myMapSgs.layerTree.selectedLayer];
                var layerInfo = (layerObj) ? layerObj.layer_info : null;
                if (layerInfo) {
                    var featureRoad = myMapSgs._managerTrafficSignTool._layerSubRoadCloser.getSource().getFeatures()[0];
                    idRoad = featureRoad.getProperties()[myMapSgs._managerTrafficSignTool.roadInfo.columnNameIdRoad];
                    roadName = featureRoad.getProperties()[myMapSgs._managerTrafficSignTool.roadInfo.columnNameRoadName];
                }
            }
        }

        var featureInfo = {
            id: layerDraw.getSource().getFeatures()[0].getId(),
            feature: layerDraw.getSource().getFeatures()[0],
            idLayer: myMapSgs.layerTree.selectedLayer,
            mode: 'create',
            fromMap: true,
            idRoad: idRoad,
            roadName: roadName
        };
        $('#id-offcanvas-layer-detail').attr("mode", "create");

        var layerInfo = myMapSgs.layerTree.layerInfo.dict_layer_info[myMapSgs.layerTree.selectedLayer].layer_info;
        if (layerInfo) {
            // Call specific detail
            switch (layerInfo.layerName) {
                case "PUBPAINEL":
                    if (mapSettings.operation_visible.PubTool) {
                        myMapSgs._pubTool.DetailElement(featureInfo);
                        return;
                    }
                    break;
                case "GEVESPACOVERDE":
                    if (mapSettings.operation_visible.GreenAreaTool) {
                        myMapSgs._greenAreaTool.DetailElement(featureInfo);
                        return;
                    }
                    break;
                case "VW_PCOCORRENCIA":
                    if (mapSettings.operation_visible.CivilProtectionTool) {
                        myMapSgs._civilProtectionTool.DetailElement(featureInfo);
                        return;
                    }
                    break;
                case "VW_PONTODEPOSICAO":
                    if (mapSettings.operation_visible.DepositionPointTool) {
                        myMapSgs._depositionPointTool.DetailElement(featureInfo);
                        return;
                    }
                    break;
                case "TERRENOS":
                case "EDIFICIOS":
                case "TERRENOSALIENADOS":
                case "EDIFICIOSALIENADOS":
                    if (mapSettings.operation_visible.PatrimonyTool) {
                        featureInfo["layerName"] = layerInfo.layerName;
                        myMapSgs._patrimonyTool.DetailElement(featureInfo);
                        return;
                    }
                    break;
                case "VW_NPOLICIA_III":
                    if (mapSettings.operation_visible.RoadBuilderTool) {
                        featureInfo.mode = 'update';
                        hasButtonDelete = false;
                    }
                    break;
                default:
                    myMapSgs._GetColumnValueIntersectFromFeature(featureInfo.feature);
                    myMapSgs.DetailElement(featureInfo);
            }

            // Manager traffic sign
            if (mapSettings.operation_visible.ManagerTrafficSignTool) {
                // From prumo
                if (layerInfo.layerName == myMapSgs._managerTrafficSignTool.prumoInfo.layerName) {
                    $('#id-offcanvas-body-manager-traffice-sign-add-type-sign').hide();
                }
            }
        }

        //var offcanvas = $('#offcanvas-save-feature');
        //var layerInfo = myMapSgs.layerTree.layerInfo.dict_layer_info[myMapSgs.layerTree.selectedLayer].layer_info;
        //$('header.save-feature', offcanvas).html('Criar - ' + layerInfo.pretty_name);

        //$('#save-feature-form-container').empty();

        //var props = data.featureTypes[0].properties;
        //for (var p in props) {
        //    if (props[p].name !== 'geom' && props[p].name !== 'dt_process') {
        //        $('#save-feature-form-container').append($(
        //            '<div class="form-group">'
        //            + '<label for="prop_' + props[p].name + '">' + props[p].name + '</label>'
        //            + '<input class=" feature-field form-control ' + props[p].localType + '" data-name="' + props[p].name + '" type="text" id="prop_' + props[p].name + '"/>'
        //            + '</div > '
        //        ));
        //    }
        //}
        //$('#save-feature-submit').on('click', function () { myMapSgs._SaveFeature('insert', layerDraw.getSource().getFeatures()[0]); });
        //$('#save-feature-submit').on('touchstart', function () { myMapSgs._SaveFeature('insert', layerDraw.getSource().getFeatures()[0]); });
        //offcanvas.addClass('show');
        //}
        //});
    };

    /**
     * Shows a form for adding a new feature to the consulta publica
     * @param {ol.layer.Vector} layerDraw A vector layer containg the new feature (geometry)
     */
    this._ShowFormForCreationConsultaPublica = function (layerDraw) {

        //$.ajax({
        //    url: layerInfo.geoserver + '/' + layerInfo.workspace + '/ows?service=WFS&version=1.1.0&request=DescribeFeatureType&typename=' + layerInfo.workspace + ':' + layerInfo.layerName + '&outputFormat=application/json',
        //    dataType: 'json',
        //    success: function (data) {
        var featureInfo = {
            id: layerDraw.getSource().getFeatures()[0].getId(),
            feature: layerDraw.getSource().getFeatures()[0],
            idLayer: 2828,
            mode: 'create',
            fromMap: true
        };
        $('#id-offcanvas-layer-detail').attr("mode", "create");

        var layerInfo = myMapSgs.layerTree.layerInfo.dict_layer_info[2828].layer_info;
        if (layerInfo) {
            // Call specific detail
            switch (layerInfo.layerName) {
                case "PUBPAINEL":
                    if (mapSettings.operation_visible.PubTool) {
                        myMapSgs._pubTool.DetailElement(featureInfo);
                        return;
                    }
                    break;
                case "GEVESPACOVERDE":
                    if (mapSettings.operation_visible.GreenAreaTool) {
                        myMapSgs._greenAreaTool.DetailElement(featureInfo);
                        return;
                    }
                    break;
                case "VW_PCOCORRENCIA":
                    if (mapSettings.operation_visible.CivilProtectionTool) {
                        myMapSgs._civilProtectionTool.DetailElement(featureInfo);
                        return;
                    }
                    break;
                case "VW_PONTODEPOSICAO":
                    if (mapSettings.operation_visible.DepositionPointTool) {
                        myMapSgs._depositionPointTool.DetailElement(featureInfo);
                        return;
                    }
                    break;
                case "TERRENOS":
                case "EDIFICIOS":
                case "TERRENOSALIENADOS":
                case "EDIFICIOSALIENADOS":
                    if (mapSettings.operation_visible.PatrimonyTool) {
                        myMapSgs._patrimonyTool.DetailElement(featureInfo);
                        return;
                    }
                    break;
                case "VW_NPOLICIA_III":
                    if (mapSettings.operation_visible.RoadBuilderTool) {
                        featureInfo.mode = 'update';
                        hasButtonDelete = false;
                    }
                    break;
                default:
                    myMapSgs._GetColumnValueIntersectFromFeature2(featureInfo.feature, 2828);
                    myMapSgs.DetailElement(featureInfo);
            }
        }
    };

    /**
     * Shows a form for updating an existing feature on the selected layer
     */
    this._ShowFormForUpdate = function () {
        var layerInfo = myMapSgs.layerTree.layerInfo.dict_layer_info[myMapSgs.layerTree.selectedLayer].layer_info;
        $.ajax({
            url: layerInfo.geoserver + '/' + layerInfo.workspace + '/ows?service=WFS&version=1.1.0&request=DescribeFeatureType&typename=' + layerInfo.workspace + ':' + layerInfo.layerName + '&outputFormat=application/json',
            dataType: 'json',
            success: function (data) {
                var layerObj = myMapSgs.layerTree.layerInfo.dict_layer_info[myMapSgs.layerTree.selectedLayer];
                var layerInfo = (layerObj) ? layerObj.layer_info : null;

                // Manager traffic sign - Road id
                var idRoad = -1;
                var roadName = null;
                if (mapSettings.operation_visible.ManagerTrafficSignTool) {
                    if (myMapSgs._managerTrafficSignTool._layerSubRoadCloser.getSource().getFeatures().length > 0) {
                        if (layerInfo) {
                            var featureRoad = myMapSgs._managerTrafficSignTool._layerSubRoadCloser.getSource().getFeatures()[0];
                            idRoad = featureRoad.getProperties()[myMapSgs._managerTrafficSignTool.roadInfo.columnNameIdRoad];
                            roadName = featureRoad.getProperties()[myMapSgs._managerTrafficSignTool.roadInfo.columnNameRoadName];
                        }
                    }
                }

                var featureInfo = {
                    id: app.Select.getFeatures().getArray()[0].getId(),
                    feature: app.Select.getFeatures().getArray()[0],
                    idLayer: myMapSgs.layerTree.selectedLayer,
                    mode: 'update',
                    fromMap: true,
                    idRoad: idRoad,
                    roadName: roadName
                };
                $('#id-offcanvas-layer-detail').attr("mode", "update");

                if (layerInfo) {
                    // Call specific detail
                    switch (layerInfo.layerName) {
                        case "PUBPAINEL":
                            if (mapSettings.operation_visible.PubTool) {
                                myMapSgs._pubTool.DetailElement(featureInfo);
                                return;
                            }
                            break;
                        case "GEVESPACOVERDE":
                            if (mapSettings.operation_visible.GreenAreaTool) {
                                myMapSgs._greenAreaTool.DetailElement(featureInfo);
                                return;
                            }
                            break;
                        case "VW_PCOCORRENCIA":
                            if (mapSettings.operation_visible.CivilProtectionTool) {
                                myMapSgs._civilProtectionTool.DetailElement(featureInfo);
                                return;
                            }
                            break;
                        case "VW_PONTODEPOSICAO":
                            if (mapSettings.operation_visible.DepositionPointTool) {
                                myMapSgs._depositionPointTool.DetailElement(featureInfo);
                                return;
                            }
                            break;
                        case "TERRENOS":
                        case "EDIFICIOS":
                        case "TERRENOSALIENADOS":
                        case "EDIFICIOSALIENADOS":
                            if (mapSettings.operation_visible.PatrimonyTool) {
                                myMapSgs._patrimonyTool.DetailElement(featureInfo);
                                return;
                            }
                            break;
                        case "VW_NPOLICIA_III":
                            if (mapSettings.operation_visible.RoadBuilderTool) {
                                featureInfo.mode = 'update';
                                hasButtonDelete = false;
                            }
                            break;
                        default:
                            myMapSgs._GetColumnValueIntersectFromFeature(featureInfo.feature);
                            myMapSgs.DetailElement(featureInfo);
                    }
                }

                //var offcanvas = $('#offcanvas-save-feature');
                //var layerInfo = myMapSgs.layerTree.layerInfo.dict_layer_info[myMapSgs.layerTree.selectedLayer].layer_info;
                //$('header.save-feature', offcanvas).html('Alterar - ' + layerInfo.pretty_name);

                //$('#save-feature-form-container').empty();

                //var props = data.featureTypes[0].properties;
                //for (var p in props) {
                //    if (props[p].name !== 'geom' && props[p].name !== 'dt_process') {
                //        let val = app.Select.getFeatures().getArray()[0].getProperties()[props[p].name];
                //        if (val === null || val === undefined)
                //            val = '';
                //        $('#save-feature-form-container').append($(
                //            '<div class="form-group">'
                //            + '<label for="prop_' + props[p].name + '">' + props[p].name + '</label>'
                //            + '<input class=" feature-field form-control ' + props[p].localType + '" data-name="' + props[p].name + '" type="text" id="prop_' + props[p].name + '" value="' + val + '"/>'
                //            + '</div > '
                //        ));
                //    }
                //}
                //$('#save-feature-submit').on('click', function () { myMapSgs._SaveFeature('update', app.Select.getFeatures().getArray()[0]); });
                //$('#save-feature-submit').on('touchstart', function () { myMapSgs._SaveFeature('update', app.Select.getFeatures().getArray()[0]); });
                //offcanvas.addClass('show');
            }
        });
    };

    /**
     * Shows a confirmation box for deleting an existing feature on the selected layer
     */
    this._ShowConfirmationForDelete = function () {
        if (confirm('Deseja realmente apagar o elemento selecionado?')) {
            var feature = app.Select.getFeatures().getArray()[0];
            if (mapSettings.operation_visible.DepositionPointTool) {
                var idDepositionPoint = feature.getProperties()[myMapSgs._depositionPointTool._depositionPointIdColumnName];
                myMapSgs._depositionPointTool.DeleteDepositionPoint(idDepositionPoint);
            }
            else
                myMapSgs._SaveFeature('delete', feature);
        }
    };

    /**
     * Shows a confirmation box for deleting an existing feature on the selected layer
     * @param {ol.feature} featureInput, feature to delete
     * @param {int} idLayer, layer id of the feature
     */
    this._ShowConfirmationForDeleteFromForms = function (featureInput, idLayer) {
        if (confirm('Deseja realmente apagar o elemento selecionado?')) {
            var feature = (featureInput === undefined) ? app.Select.getFeatures().getArray()[0] : featureInput;
            if (mapSettings.operation_visible.DepositionPointTool) {
                var idDepositionPoint = feature.getProperties()[myMapSgs._depositionPointTool._depositionPointIdColumnName];
                myMapSgs._depositionPointTool.DeleteDepositionPoint(idDepositionPoint);
            }
            else
                myMapSgs._SaveFeature('delete', feature, idLayer);
        }
    };

    /**
     * Cancel edition feature
     */
    this._CancelEdition = function () {
        myMapSgs.layerTree.CloseEdition(true);
    }

    /**
     * Cancel creation feature
     * @param {ol.layer} layerDraw, layer draw
     */
    this._CancelCreation = function (layerDraw) {
        myMapSgs.layerTree.CloseCreation(layerDraw);
    }

    /**
     * Save a feature via WFS-T
     * @param {String} mode the save mode: insert, update or delete
     * @param {ol.Feature} feature, A feature (geometry)
     * @param {int} idLayer, layer id in layer tree
     */
    this._SaveFeature = function (mode, feature, idLayer, suffix) {
        var addSuffix = (suffix) ? suffix : "";
        var idLayerResult = (idLayer) ? idLayer : myMapSgs.layerTree.selectedLayer;
        var layerInfoFeature = myMapSgs.layerTree.layerInfo.dict_layer_info[idLayerResult].layer_info;

        // Start wait
        myMapSgs._utility.ShowWait('id-offcanvas-layer-detail-spinner', true);

        var props = {};
        for (var i = 0; i < $('.feature-field', $('#id-offcanvas-body-layer-detail-field' + addSuffix)).length; i++) {
            var node = $('.feature-field', $('#id-offcanvas-body-layer-detail-field' + addSuffix))[i];
            let fieldName = node.name;

            if (fieldName) {
                let val = $(node).val();

                if ($(node).attr("type") == "checkbox") {
                    val = $(node).prop('checked')
                }

                if (!$(node).is('[readonly]') || mode === 'insert') {
                    props[fieldName] = val;
                }
                else if (mapSettings.operation_visible.ManagerTrafficSignTool) { // Manager traffic tool - Add properties on readonly mode
                    if (layerInfoFeature.layerName == myMapSgs._managerTrafficSignTool.prumoInfo.layerName)
                        props[fieldName] = val;
                }
            }
        };

        // Add extra information for specific layer
        switch (layerInfoFeature.layerName) {
            case "PRETENSOES":
                if (feature.values_.geometry) {
                    var area = myMapSgs._utility.AreaFunction(feature.values_.geometry);
                    props["AREA"] = parseInt(area);
                }
                props["UTILIZADOR"] = myMapSgs._settings.userInfo.userName;
                break;
            case "VW_NPOLICIA_III":
                if (mapSettings.operation_visible.RoadBuilderTool) {
                    var id = feature.getId().split(".")[1];
                    myMapSgs._roadBuilderTool.SaveAlfaPoliceNumber(id);
                }
                return;
                break;
            case "g_valvulas":
                props["usr_validacao"] = myMapSgs._settings.userInfo.userName;
                break;
            default:
                break;
        }

        // Geometry column
        props[layerInfoFeature.geomColumnName] = feature.getGeometry();

        // Add properties to feature
        feature.setProperties(props);

        // Manager traffic tool - Remove properties
        if (mapSettings.operation_visible.ManagerTrafficSignTool) {
            // For prumo
            if (layerInfoFeature.layerName == myMapSgs._managerTrafficSignTool.prumoInfo.layerName) {
                // Check if installed = false and has sign associated
                if (!props["installed"] && myMapSgs._managerTrafficSignTool._positionSuffix > 0) {
                    toastr["warning"]('Atenção: para desinstalar o prumo, é necessário primeiro desinstalar os sinais associados.');

                    // Stop wait
                    myMapSgs._utility.ShowWait('id-offcanvas-layer-detail-spinner', false);

                    return;
                }

                // Remove properties
                switch (mode) {
                    case "update":
                        // Remove id property on update
                        feature.unset(myMapSgs._managerTrafficSignTool.prumoInfo.prumoInfoConfig.column_name_id);
                        break;
                    default:
                    // do nothing
                }
            }
        }

        // Save feature
        myMapSgs._TransactWFS(mode, feature, layerInfoFeature, suffix);
    };

    /**
     * Execute a WFS transaction
     * @param {String} mode the save mode: insert, update or delete
     * @param {ol.layer.Vector} feature, A vector layer containg the new feature (geometry)
     * @param {object} layerInfoInput, layer info input
     */
    this._TransactWFS = function (mode, featureIn, layerInfoInput, suffix) {
        var formatWFS = new WFSFormat();
        var feature = featureIn.clone();
        feature.setId(featureIn.getId());

        var layerInfo = layerInfoInput;
        if (!layerInfo)
            layerInfo = myMapSgs.layerTree.layerInfo.dict_layer_info[myMapSgs.layerTree.selectedLayer].layer_info;

        var layerName = layerInfo.layerName;
        if (myMapSgs._settings._mapSettings.operation_visible.TrafficSignTool) {
            if (layerInfo.layerName === myMapSgs._trafficSignTool.layerNameTrafficSign) {
                layerName = layerName.replace("VW_", "");
                if (feature.getId() && typeof feature.getId() === "string")
                    feature.setId(feature.getId().replace("VW_", ""));
                feature.unset("IDTROCO");
                feature.unset("FREGUESIA");
                feature.unset("T_SISUBTIPO");
                feature.unset("T_SITIPO");
                feature.unset("RRVDIMENSAO");
                feature.unset("RRVESTADOCONSERVACAO");
                feature.unset("RRVBORDADURAREGULAR");
                feature.unset("RRVSIMULTANEO");
                feature.unset("T_SIIMAGEM");
                feature.unset("GP_GEOMETRYWKB");
                feature.unset("SHP_DATA");
            }
        }

        // Manager traffic sign
        if (mapSettings.operation_visible.ManagerTrafficSignTool) {
            // Change prumo info
            if (layerName == myMapSgs._managerTrafficSignTool.prumoInfo.layerName) {
                // Change layer name
                layerName = myMapSgs._managerTrafficSignTool.prumoInfo.layerNameSave;
                // Remove in traffic sign label
                var arrayColumnToUnset = eval(myMapSgs._managerTrafficSignTool.prumoInfo.prumoInfoConfig.list_column_to_unset);
                for (var p = 0; p < arrayColumnToUnset.length; p++) {
                    feature.unset(arrayColumnToUnset[p]);
                }
                // Set id
                if (mode != 'insert')
                    feature.setId(layerName + "." + featureIn.getId().split(".")[1]);
            }
        }

        var formatGML = new GMLFormat({
            featureNS: layerInfo.workspace,
            featureType: layerName,
            srsName: myMapSgs._settings.projection.getCode()
        });

        var node;

        // Prevent varbinary null geoserver error
        if (!feature.values_.GDB_GEOMATTR_DATA)
            delete feature.values_.GDB_GEOMATTR_DATA;

        switch (mode) {
            case 'insert':
                node = formatWFS.writeTransaction([feature], null, null, formatGML);

                // Remove all element empty
                $(node).find('*:empty').remove();
                break;
            case 'update':
                node = formatWFS.writeTransaction(null, [feature], null, formatGML);
                // Remove all property with null value
                $(node).find("Property:not(:has(Value))").remove();

                // Remove geometry if layer is not instance of VectorSource (WFS)
                if (!(myMapSgs._utility.GetLayerById(myMapSgs.map, 'T' + ((myMapSgs.layerTree.selectedLayer === null) ? layerInfo.id : myMapSgs.layerTree.selectedLayer)).getSource() instanceof VectorSource)) {
                    $(node).find("Property").find('Name:contains("geometry")').parent().remove();
                    $(node).find("Property").find('Name:contains("' + layerInfo.geomColumnName + '")').parent().remove();
                }
                break;
            case 'delete':
                node = formatWFS.writeTransaction(null, null, [feature], formatGML);
                break;
        }

        var xs = new XMLSerializer();
        $(node).find('geometry').remove();
        var payload = xs.serializeToString(node);
        $.ajax(layerInfo.geoserver + '/' + layerInfo.workspace + '/ows?',
            {
                type: 'POST',
                dataType: 'application/xml',
                processData: false,
                contentType: 'application/xml',
                data: payload,
                success: function (data) {
                    var closeSpinner = true;

                    switch (mode) {
                        case 'update':
                            if (feature.getId()) {
                                var idFeature = (feature.getId().split(".")[1] !== undefined) ? layerInfo.layerName + "." + feature.getId().split(".")[1] : feature.getId();
                                delete myMapSgs.layerTree._cacheStyleFeature[idFeature]; // Remove from cache to refresh style again
                            }
                            break;
                        default:
                        // do nothing
                    }
                    // Clear the layer if vector layer
                    var idLayer = (myMapSgs.layerTree.selectedLayer === null) ? layerInfo.id : myMapSgs.layerTree.selectedLayer;
                    var layerTransact = myMapSgs._utility.GetLayerById(myMapSgs.map, 'T' + idLayer);
                    if (layerTransact && layerTransact.getSource() instanceof VectorSource)
                        layerTransact.getSource().clear();

                    var close = true;
                    switch (mode) {
                        case "delete":
                            toastr["success"]('Elemento removido com sucesso');
                            app.Select.getFeatures().clear();
                            myMapSgs.handleEditButtonsVisibility();
                            break;
                        case "insert":
                            //if (mapSettings.operation_visible.ManagerTrafficSignTool) {
                            //    // -- Build qrcode information ----------------------------------------
                            //    var qrCodeId = feature.getProperties().qrcode;

                            //    myMapSgs._managerTrafficSignTool.BuildQrCode(qrCodeId, suffix);

                            //    closeSpinner = false;
                            //    if (suffix)
                            //        close = false;
                            //}
                            if (myMapSgs._settings._mapSettings.operation_visible.LocationPlantConsultaPublica) {
                                toastr["success"]('Consulta pública registada com sucesso');
                            }
                            else {
                                toastr["success"]('Elemento criado com sucesso');
                            }
                            break;
                        case "update":
                            // Manager traffic sign
                            if (mapSettings.operation_visible.ManagerTrafficSignTool) {
                                // If prumo update geometry info and arruamento of all sign in this prumo
                                if (layerName == myMapSgs._managerTrafficSignTool.prumoInfo.layerNameSave) {
                                    myMapSgs._managerTrafficSignTool.UpdateSignInfoFromPrumo(feature);
                                    closeSpinner = false;
                                }

                                if (suffix)
                                    close = false;
                            }
                            toastr["success"]('Elemento gravado com sucesso');
                            break;
                        default:
                    }

                    // Close edition
                    if (close) {
                        if (myMapSgs._settings._mapSettings.operation_visible.LocationPlantConsultaPublica) {
                            myMapSgs.layerTree.CloseEdition2(false, 2828);
                        }
                        else {
                            myMapSgs.layerTree.CloseEdition(false);
                        }
                    }

                    // Stop wait
                    if (closeSpinner) myMapSgs._utility.ShowWait('id-offcanvas-layer-detail-spinner', false);
                },
                error: function (data) {
                    var parser = new DOMParser();
                    var xmlDoc = parser.parseFromString(data.responseText, "text/xml");
                    let errorData = $(xmlDoc.getElementsByTagName('ows:ExceptionText')).html();
                    let errorDetail = $(xmlDoc.getElementsByTagName('ows:Exception')).attr('exceptionCode');
                    let errorMessage = 'Erro gravação do elemento.';
                    if (errorDetail == 'InvalidParameterValue') errorMessage += ' Campo com dados inválidos.';
                    if (errorDetail == 'InvalidValue') errorMessage += ' Campo com dados inválidos.';

                    if (errorData) {
                        toastr["error"](errorMessage);

                        // Stop wait
                        myMapSgs._utility.ShowWait('id-offcanvas-layer-detail-spinner', false);
                    } else this.success(data);
                }
            });
    };

    /**
     * Execute a WFS transaction isolate
     * @param {String} mode the save mode: insert, update or delete
     * @param {ol.layer.Vector} feature, A vector layer containg the new feature (geometry)
     * @param {object} layerInfoInput, layer info input
     */
    this._TransactWFS2 = function (mode, feature, layerInfo) {
        var formatWFS = new WFSFormat();

        var formatGML = new GMLFormat({
            featureNS: layerInfo.workspace,
            featureType: layerInfo.layerName,
            srsName: myMapSgs._settings.projection.getCode()
        });

        var node;
        switch (mode) {
            case 'insert':
                node = formatWFS.writeTransaction([feature], null, null, formatGML);
                break;
            case 'update':
                node = formatWFS.writeTransaction(null, [feature], null, formatGML);
                break;
            case 'delete':
                node = formatWFS.writeTransaction(null, null, [feature], formatGML);
                break;
        }

        var xs = new XMLSerializer();
        $(node).find('geometry').remove();
        var payload = xs.serializeToString(node);
        $.ajax(layerInfo.geoserver + '/' + layerInfo.workspace + '/ows?', {
            type: 'POST',
            dataType: 'application/xml',
            processData: false,
            contentType: 'application/xml',
            data: payload,
            success: function (data) {
                myMapSgs._utility.GetLayerById(myMapSgs.map, 'T' + layerInfo.id).getSource().clear();
            },
            error: function (data) {
                var parser = new DOMParser();
                var xmlDoc = parser.parseFromString(data.responseText, "text/xml");
                let errorData = $(xmlDoc.getElementsByTagName('ows:ExceptionText')).html();
                let errorDetail = $(xmlDoc.getElementsByTagName('ows:Exception')).attr('exceptionCode');
                let errorMessage = 'Erro gravação do elemento.';
                if (errorDetail == 'InvalidParameterValue') errorMessage += ' Campo com dados inválidos.';
                if (errorDetail == 'InvalidValue') errorMessage += ' Campo com dados inválidos.';

                if (errorData) {
                    toastr["error"](errorMessage);
                }
                else {
                    myMapSgs._utility.GetLayerById(myMapSgs.map, 'T' + layerInfo.id).getSource().clear();
                }
            }
        });
    };

    /**
    * Create Overlay Pin on map event Occurrence
    * @param {any} container
    * @param {any} PinCoordinates
    * @param {any} pixel
    */
    this._CreateOverlayPinOccurrence = function (container, PinCoordinates, pixel) {
        // Create overlay pin
        myMapSgs._overlayPinOccurrence = new Overlay({
            element: container,
            autoPan: true,
            autoPanAnimation: {
                duration: 250
            }
        });

        myMapSgs._overlayPinOccurrence.setPosition(PinCoordinates);

        $('#creation-occurrence-event-X').val(PinCoordinates[0]);

        $('#creation-occurrence-event-Y').val(PinCoordinates[1]);

        $(myMapSgs._overlayPinOccurrence).popover('destroy');

    };

    // -- Begin Geo Location ----------------------------------------------------------------------

    /**
     * Geo location, event function for accuracy change geometry 
     */
    this._GeoLocationChangeAccuracyGeometry = function (e) {
        e.preventDefault();
        console.info('coordinates Accuracy calculate');
        var coordinates = myMapSgs._geoLocationObj.getAccuracyGeometry();
        console.info('coordinates Accuracy Position:', coordinates);
        myMapSgs._geoLocationAccuracyFeature.setGeometry(coordinates);
    }

    /**
     * Geo location, event function for change position
     */
    this._GeoLocationChangePosition = function (e) {
        e.preventDefault();
        console.info('coordinates calculate');
        var coordinates = myMapSgs._geoLocationObj.getPosition();
        console.info('coordinates Position:', coordinates);
        myMapSgs._geoLocationPositionFeature.setGeometry(coordinates ? new Point(coordinates) : null);

        //if (myMapSgs._zoomGPS == false) {
        myMapSgs.map.getView().animate({
            center: [coordinates[0], coordinates[1]],
            zoom: 13,
            duration: 1000
        });
        myMapSgs._zoomGPS = true;
        //}
    }

    /**
     * Init geo location
     */
    this._InitGeoLocation = function () {
        // Create object geo location
        myMapSgs._geoLocationObj = new Geolocation({
            // enableHighAccuracy must be set to true to have the heading value.
            tracking: false,
            trackingOptions: {
                enableHighAccuracy: false
            },
            timeout: 10000, // 10s
            maximumAge: 0,
            projection: myMapSgs._settings.projection
        });

        // Event on error set geo location
        myMapSgs._geoLocationObj.on('error', function (error) {
            switch (error.code) {
                case 1:
                    toastr["error"]('Erro no acesso a localização actual. Por favor, permita o acesso a sua localização');
                    break;
                case 2:
                    toastr["error"]('Error: Position unavailable. Check GPS or network settings.');
                    break;
                case 3:
                    toastr["error"]('Erro no acesso a localização actual. Tempo esgotado');
                    break;
                default:
                    toastr["error"](`Erro: ${error.message}`);
            }

        });

        // Event on change accuracy geometry
        myMapSgs._geoLocationAccuracyFeature = new Feature();
        myMapSgs._geoLocationObj.on('change:accuracyGeometry', myMapSgs._GeoLocationChangeAccuracyGeometry);

        // Event on change position
        myMapSgs._geoLocationPositionFeature = new Feature();
        myMapSgs._geoLocationPositionFeature.setStyle(new Style({
            image: new CircleStyle({
                radius: 6,
                fill: new Fill({
                    color: '#3399CC'
                }),
                stroke: new Stroke({
                    color: '#fff',
                    width: 2
                })
            })
        }));
        myMapSgs._geoLocationObj.on('change:position', myMapSgs._GeoLocationChangePosition);

        // Set geo location source
        myMapSgs._geoLocationVectorGPSSource = new VectorSource({
            features: [myMapSgs._geoLocationAccuracyFeature, myMapSgs._geoLocationPositionFeature]
        });

        // Set layer geo location
        myMapSgs._geoLocationVectorGPS = new VectorLayer({
            map: myMapSgs.map
        });
    }

    /**
     * Get location GPS browser location from openlayer
     */
    this._GetLocationGps = function () {
        if ($('#id-gps-geoportal').hasClass('ol-hidden')) {
            // Set tracking
            myMapSgs._geoLocationObj.setTracking(true);

            // Set layer geo location source
            myMapSgs._geoLocationVectorGPS.setSource(myMapSgs._geoLocationVectorGPSSource);

            // Set class node
            $('#id-gps-geoportal').removeClass('ol-hidden');
            $('.gps-map-location').addClass('hold');
        }
        else {
            // Empty layer geo location source
            myMapSgs._geoLocationVectorGPS.setSource(null);

            // Remove tracker
            myMapSgs._geoLocationObj.setTracking(false);

            // Set class node
            $('#id-gps-geoportal').addClass('ol-hidden');
            $('.gps-map-location').removeClass('hold');
        }
    }

    /**
     * Get location GPS using navigator
     */
    this._GetLocationGps2 = function () {
        if ("geolocation" in navigator) {
            navigator.geolocation.getCurrentPosition(
                (position) => {
                    const { latitude, longitude } = position.coords;
                    const coordsWgs84 = fromLonLat([longitude, latitude]);
                    const coords = transform(coordsWgs84, "EPSG:3857", myMapSgs._settings.projection.getCode());
                    myMapSgs.map.getView().animate({
                        center: coords,
                        zoom: 13,
                        duration: 1000
                    });
                },
                (error) => {
                    switch (error.code) {
                        case error.PERMISSION_DENIED:
                            toastr["warning"]("Acesso a localização actual não permitida pelo browser. Por favor active o acesso a localização");
                            break;
                        case error.POSITION_UNAVAILABLE:
                            toastr["warning"]("Informação da Localização não disponível");
                            break;
                        case error.TIMEOUT:
                            toastr["warning"]("Tempo esgotado no acesso à informação da localização");
                            break;
                        default:
                            toastr["error"]("Erro no acesso à informação da localização");
                    }
                }
            );
        } else {
            toastr["warning"]("Informação da localização não disponível a partir deste browser");
        }
    }

    // -- End Geo Location ------------------------------------------------------------------------

    /**
     * Get map url
     * @param {array} arrayLayer, array of layer information 
     * @param {int} idPolygon, polygon draw identifier
     * @param {int} idPolygonFieldName, polygon id field name
     * @param {string} layerPolygonName, polygon draw layer name
     * @param {string} sridMap, srid of the map
     * @param {string} scale, scale to be apply
     * @param {array} center, center of the map
     * @param {float} displayMapWidth, with image
     * @param {float} displayMapHeight, height image
     */
    this._GetMapDataString = function () {

        return new Promise((resolve, reject) => {

            try {

                $('#print_canvas').remove();

                // register all the layers of the template that were not visible
                const noVisibleLayers = {};

                // show all layers of the template
                if ($('#id-modal-Group-template-config-content input[type=checkbox]')[0].checked) {
                    myMapSgs.map.getLayers().array_.map((layer) => {

                        if (layer.getProperties().id && !layer.getProperties().id.includes('base_')) {

                            const idLayer = layer.getProperties().gpId;
                            const isLayerTemplate = myMapSgs._layersTemplateSelectedDatatable.some((layerTemplate) => layerTemplate.id_layer == idLayer);

                            if (isLayerTemplate) {
                                if (!layer.getVisible()) {
                                    // register layer change visible
                                    noVisibleLayers[idLayer] = {
                                        layer: layer,
                                        state: false
                                    };
                                    layer.setVisible(true);
                                }
                            } else {
                                if (layer.getVisible()) {
                                    // register layer change visible
                                    noVisibleLayers[idLayer] = {
                                        layer: layer,
                                        state: true
                                    };
                                    layer.setVisible(false);
                                }
                            }
                        }
                    });

                    // After render complete return canvas image
                    myMapSgs.map.once('rendercomplete', function () {
                        resolve(myMapSgs.GetPrintImageFromCanvas(noVisibleLayers));
                    });
                    myMapSgs.map.renderSync();
                }
                else {
                    // Return canvas image
                    resolve(myMapSgs.GetPrintImageFromCanvas(noVisibleLayers));
                }
            } catch (error) {
                reject(error);
            }
        });
    }

    /**
     * Get image for print directly from canvas
     */
    this.GetPrintImageFromCanvas = function (noVisibleLayers) {
        // full map canvas
        var mainCanvas = document.querySelector("#map canvas");

        // canvas to copy the partial printable map
        var hidden_canv = document.createElement('canvas');
        hidden_canv.style.display = 'none';
        hidden_canv.id = 'print_canvas';

        document.body.appendChild(hidden_canv);

        // Calculate the factor between the width/height of the canvas on css values and the width/height of the canvas on real values
        var factorWidth = mainCanvas.width / mainCanvas.clientWidth;
        var factorHeight = mainCanvas.height / mainCanvas.clientHeight;

        var leftBorder = $('.map-highlight-left').width() * factorWidth;
        var rightBorder = $('.map-highlight-right').width() * factorWidth;
        var topBorder = $('.map-highlight-top').height() * factorHeight;
        var bottomBorder = $('.map-highlight-bottom').height() * factorHeight;

        hidden_canv.width = mainCanvas.width - rightBorder - leftBorder;
        hidden_canv.height = mainCanvas.height - bottomBorder - topBorder;

        var hidden_ctx = hidden_canv.getContext('2d');

        // paint the background of the canvas white
        hidden_ctx.fillStyle = '#ffffff';
        hidden_ctx.fillRect(0, 0, hidden_canv.width, hidden_canv.height);

        hidden_ctx.drawImage(
            mainCanvas,
            leftBorder,
            topBorder,
            hidden_canv.width,
            hidden_canv.height,
            0,
            0,
            hidden_canv.width,
            hidden_canv.height
        );

        // return the template layers to their initial visibility state
        if (Object.keys(noVisibleLayers).length > 0) {
            for (const key in noVisibleLayers) {
                if (noVisibleLayers.hasOwnProperty(key)) {
                    noVisibleLayers[key].layer.setVisible(noVisibleLayers[key].state);
                }
            }
            // render map
            myMapSgs.map.renderSync();
        }

        return hidden_canv.toDataURL("image/jpeg").replace("image/jpeg", "image/octet-stream");
    }

    /**
     * Show Position GPS on Occurrence Map
     * @param {ol.coordinate} position, coordinate of the event occurrence
     */
    this.showPosition = function (position) {

        var projectionMap = mapSettings.map_info.srs_srid.toString();

        const positionXY = transform([position.coords.longitude, position.coords.latitude], 'EPSG:4326', 'EPSG:' + projectionMap);

        app.sgs.Map.map.getView().animate({
            center: [positionXY[0], positionXY[1]],
            zoom: 11,
            duration: 1000
        });
        showPos();
        function showPos() {

            let marker = new Feature({
                geometry: new Point([positionXY[0], positionXY[1]]),
            });

            app.DrawPointPOIShow.setActive(true);
            app.layerDrawPointPOI.getSource().clear();
            app.layerDrawPointPOIShow.getSource().clear();
            app.layerDrawPointPOIShow.getSource().addFeature(marker);
            app.layerDrawPointPOIShow.getSource().getFeatures().push(marker);
        };
    }

    /**
     * Create measure tooltip
     */
    this._CreateMeasureTooltip = function () {
        if (myMapSgs.measureTooltipElement) {
            myMapSgs.measureTooltipElement.parentNode.removeChild(myMapSgs.measureTooltipElement);
        }
        myMapSgs.measureTooltipElement = document.createElement('div');
        myMapSgs.measureTooltipElement.className = 'tooltip tooltip-measure';
        myMapSgs.measureTooltip = new Overlay({
            element: myMapSgs.measureTooltipElement,
            offset: [0, -15],
            positioning: 'bottom-center',
            id: 0
        });

        myMapSgs.map.addOverlay(myMapSgs.measureTooltip);
    };

    /**
     * Get all column of the feature to fill automaticly
     * @param {ol.feature} feature
     */
    this._GetColumnValueIntersectFromFeature = function (feature) {
        var layerInfo = myMapSgs.layerTree.layerInfo.dict_layer_info[myMapSgs.layerTree.selectedLayer].layer_info;
        var Column_Fill = null;

        myMapSgs._hashColumnsReferences = {};

        $.ajax({
            type: 'GET',
            url: '/rest/app/Layer/GetColumnLayerFill?idLayerSource=' + layerInfo.id_source,
            xhrFields: {
                withCredentials: true
            },
            async: false,
            success: function (dataColumn) {
                if (dataColumn.error) {
                    toastr["error"]("Erro de carregamento da informação de referência ");
                }
                else {
                    if (dataColumn.result != null && dataColumn.result.length > 0) {
                        myMapSgs._geomEditCreateNewFeature = feature.getGeometry().getCoordinates();

                        Column_Fill = dataColumn;

                        var GeomTypeCql = "";

                        if (layerInfo.geomType.toUpperCase() == 'LINE') {
                            GeomTypeCql = 'linestring';
                        }
                        else {
                            GeomTypeCql = layerInfo.geomType.toUpperCase();
                        }

                        var cql_filterIntersect = 'DWITHIN(geom, ' + GeomTypeCql + '(';

                        for (var t = 0; t < myMapSgs._geomEditCreateNewFeature.length; t++) {
                            cql_filterIntersect += myMapSgs._geomEditCreateNewFeature[t][0] + ' ' + myMapSgs._geomEditCreateNewFeature[t][1] + ',';
                        }

                        cql_filterIntersect = cql_filterIntersect.slice(0, -1);
                        cql_filterIntersect += '),' + 0.00010 + ', meters);';

                        var cql_layer = "";
                        // url
                        var getFeatureUrl = layerInfo.geoserver;
                        var typename = "";

                        for (var i = 0; i < dataColumn.result.length; i++) {
                            if (dataColumn.result[i].cod_operation == "INTERSECT") {
                                typename += '(' + layerInfo.workspace + ':' + dataColumn.result[i].name_layer_source + ')';
                                cql_layer += cql_filterIntersect;
                            }
                        }

                        cql_layer = cql_layer.slice(0, -1);

                        // Call geoserver to get the feature of the layer
                        var getFeature = $.ajax({
                            method: "GET",
                            async: false,
                            url: getFeatureUrl + '/wfs',
                            data: {
                                "service": 'wfs',
                                "version": '2.0.0',
                                "request": 'GetFeature',
                                "typeNames": typename,
                                "cql_filter": cql_layer,
                                //"propertyName": 'geom',
                                "outputFormat": 'application/json'
                            }
                        });

                        // Response from the server
                        getFeature.done(function (data, textStatus, jqXHR) {
                            if (data.features.length > 0) {
                                for (var i = 0; i < Column_Fill.result.length; i++) {
                                    if (Column_Fill.result[i].cod_operation == "INTERSECT") {
                                        var dataColumn = data.features.filter(c => c.id.split('.')[0] == Column_Fill.result[i].name_layer_source);

                                        if (dataColumn.length > 0) {
                                            var propertyData = $(dataColumn).map(function () { return this.properties; });;
                                            myMapSgs._hashColumnsReferences[Column_Fill.result[i].column_name_to_fill] = propertyData;
                                            myMapSgs._hashColumnsReferencesToFill[Column_Fill.result[i].column_name_to_fill] = Column_Fill.result[i];
                                        }
                                    }
                                    else if (Column_Fill.result[i].cod_operation == "MDT") {
                                        var LayerMdtName = myMapSgs._utility.GetPropertyInfoInConfigArray(myMapSgs._settings.configurationInfo.propertyInfo, "CAL_MDT", "LAYER_MDT", "LAYER_NAME");
                                        var LayerMdtWorkspace = myMapSgs._utility.GetPropertyInfoInConfigArray(myMapSgs._settings.configurationInfo.propertyInfo, "CAL_MDT", "LAYER_MDT", "WORKSPACE");
                                        var LayerMdtGeoserver = myMapSgs._utility.GetPropertyInfoInConfigArray(myMapSgs._settings.configurationInfo.propertyInfo, "CAL_MDT", "LAYER_MDT", "EXTERNAL_GEOSERVER_URL");

                                        myMapSgs._quotaValueFill = false;
                                        myMapSgs.GetQuotaByCoord(LayerMdtWorkspace, LayerMdtName, LayerMdtGeoserver, myMapSgs._geomEditCreateNewFeature[0]);
                                        myMapSgs._hashColumnsReferences[Column_Fill.result[i].column_name_to_fill] = myMapSgs._quotaValueFill.features[0].properties.GRAY_INDEX;
                                    }
                                };

                            }
                            else {
                                toastr["warning"]("Nenhum objeto encontrado");
                                myMapSgs._utility.ShowWait('spinner-search-anacom', false);
                            }
                        });
                    }
                }
            },
            error: function (request, status, error) {
                toastr["error"]("Erro de carregamento da informação de referência");
            }
        });
    }

    /**
     * Get all column of the feature to fill automaticly
     * @param {ol.feature} feature
     */
    this._GetColumnValueIntersectFromFeature2 = function (feature, idLayer) {
        var layerInfo = myMapSgs.layerTree.layerInfo.dict_layer_info[idLayer].layer_info;
        var Column_Fill = null;

        myMapSgs._hashColumnsReferences = {};

        $.ajax({
            type: 'GET',
            url: '/rest/app/Layer/GetColumnLayerFill?idLayerSource=' + layerInfo.id_source,
            xhrFields: {
                withCredentials: true
            },
            async: false,
            success: function (dataColumn) {
                if (dataColumn.error) {
                    toastr["error"]("Erro de carregamento da informação de referência ");
                }
                else {
                    if (dataColumn.result != null && dataColumn.result.length > 0) {
                        myMapSgs._geomEditCreateNewFeature = feature.getGeometry().getCoordinates();

                        Column_Fill = dataColumn;

                        var GeomTypeCql = "";

                        if (layerInfo.geomType.toUpperCase() == 'LINE') {
                            GeomTypeCql = 'linestring';
                        }
                        else {
                            GeomTypeCql = layerInfo.geomType.toUpperCase();
                        }

                        var cql_filterIntersect = 'DWITHIN(geom, ' + GeomTypeCql + '(';

                        for (var t = 0; t < myMapSgs._geomEditCreateNewFeature.length; t++) {
                            cql_filterIntersect += myMapSgs._geomEditCreateNewFeature[t][0] + ' ' + myMapSgs._geomEditCreateNewFeature[t][1] + ',';
                        }

                        cql_filterIntersect = cql_filterIntersect.slice(0, -1);
                        cql_filterIntersect += '),' + 0.00010 + ', meters);';

                        var cql_layer = "";
                        // url
                        var getFeatureUrl = layerInfo.geoserver;
                        var typename = "";

                        for (var i = 0; i < dataColumn.result.length; i++) {
                            if (dataColumn.result[i].cod_operation == "INTERSECT") {
                                typename += '(' + layerInfo.workspace + ':' + dataColumn.result[i].name_layer_source + ')';
                                cql_layer += cql_filterIntersect;
                            }
                        }

                        cql_layer = cql_layer.slice(0, -1);

                        // Call geoserver to get the feature of the layer
                        var getFeature = $.ajax({
                            method: "GET",
                            async: false,
                            url: getFeatureUrl + '/wfs',
                            data: {
                                "service": 'wfs',
                                "version": '2.0.0',
                                "request": 'GetFeature',
                                "typeNames": typename,
                                "cql_filter": cql_layer,
                                //"propertyName": 'geom',
                                "outputFormat": 'application/json'
                            }
                        });

                        // Response from the server
                        getFeature.done(function (data, textStatus, jqXHR) {
                            if (data.features.length > 0) {
                                for (var i = 0; i < Column_Fill.result.length; i++) {
                                    if (Column_Fill.result[i].cod_operation == "INTERSECT") {
                                        var dataColumn = data.features.filter(c => c.id.split('.')[0] == Column_Fill.result[i].name_layer_source);

                                        if (dataColumn.length > 0) {
                                            var propertyData = $(dataColumn).map(function () { return this.properties; });;
                                            myMapSgs._hashColumnsReferences[Column_Fill.result[i].column_name_to_fill] = propertyData;
                                            myMapSgs._hashColumnsReferencesToFill[Column_Fill.result[i].column_name_to_fill] = Column_Fill.result[i];
                                        }
                                    }
                                    else if (Column_Fill.result[i].cod_operation == "MDT") {
                                        var LayerMdtName = myMapSgs._utility.GetPropertyInfoInConfigArray(myMapSgs._settings.configurationInfo.propertyInfo, "CAL_MDT", "LAYER_MDT", "LAYER_NAME");
                                        var LayerMdtWorkspace = myMapSgs._utility.GetPropertyInfoInConfigArray(myMapSgs._settings.configurationInfo.propertyInfo, "CAL_MDT", "LAYER_MDT", "WORKSPACE");
                                        var LayerMdtGeoserver = myMapSgs._utility.GetPropertyInfoInConfigArray(myMapSgs._settings.configurationInfo.propertyInfo, "CAL_MDT", "LAYER_MDT", "EXTERNAL_GEOSERVER_URL");

                                        myMapSgs._quotaValueFill = false;
                                        myMapSgs.GetQuotaByCoord(LayerMdtWorkspace, LayerMdtName, LayerMdtGeoserver, myMapSgs._geomEditCreateNewFeature[0]);
                                        myMapSgs._hashColumnsReferences[Column_Fill.result[i].column_name_to_fill] = myMapSgs._quotaValueFill.features[0].properties.GRAY_INDEX;
                                    }
                                };

                            }
                            else {
                                toastr["warning"]("Nenhum objeto encontrado");
                                myMapSgs._utility.ShowWait('spinner-search-anacom', false);
                            }
                        });
                    }
                }
            },
            error: function (request, status, error) {
                toastr["error"]("Erro de carregamento da informação de referência");
            }
        });
    }

    /**
     * Resize left, drag process
     * @param {any} e, event
     */
    this._ResizeLeftDoDrag = function (e) {
        myMapSgs.resizeLeftNode.style.width = (myMapSgs.resizeLeftStartWidth - e.clientX + myMapSgs.resizeLeftStartX) + 'px';
    }

    /**
     * Resize left, stop drag process
     * @param {any} e, event
     */
    this._ResizeLeftStopDrag = function (e) {
        document.documentElement.removeEventListener('mousemove', myMapSgs._ResizeLeftDoDrag, false);
        document.documentElement.removeEventListener('mouseup', myMapSgs._ResizeLeftStopDrag, false);
        if (myMapSgs._layerbase._legendCanvasHasCanvasActive) {
            myMapSgs._layerbase._ReLoadCanvas(myMapSgs._layerbase._imageLegendCanvas.src);
        };
    }

    /**
     * Resize left, start drag process
     * @param {any} e, event
     */
    this._ResizeLeftStartDrag = function (e) {
        var idTarget = $(this).attr("id-target");
        myMapSgs.resizeLeftNode = document.querySelector('#' + idTarget);

        myMapSgs.resizeLeftStartX = e.clientX; // horixontal cordinate
        myMapSgs.resizeLeftStartWidth = parseInt(document.defaultView.getComputedStyle(myMapSgs.resizeLeftNode).width, 10);
        document.documentElement.addEventListener('mousemove', myMapSgs._ResizeLeftDoDrag, false);
        document.documentElement.addEventListener('mouseup', myMapSgs._ResizeLeftStopDrag, false);
    }

    /**
     * Statistic in real time
     * Init information
     */
    this._InitStatisticRealTime = function () {

        // Load all feature of the layer
        const wfsUrl = 'http://localhost:50487/geoserver/2/GP_BRAGA/ows?service=WFS&version=1.1.0&request=GetFeature&typename=GP_BRAGA:arborea_ponto&outputFormat=application/json&srsname=EPSG:3763';

        fetch(wfsUrl)
            .then(response => response.json())
            .then(json => {
                const format = new GeoJSON();
                myMapSgs._statisticRealTimeAllFeature = format.readFeatures(json, {
                    dataProjection: 'EPSG:3763',
                    featureProjection: 'EPSG:3763'
                });
                //$('#id-statistic-real-time-count').html(myMapSgs._statisticRealTimeAllFeature.length);
                console.info((myMapSgs._statisticRealTimeAllFeature.length));
            })
            .catch(error => console.error('Error fetching features:', error));
    }

    /**
     * Statistic in real time
     * Count visible feature on extent
     * @param {any} extent
     */
    this._StatisticRealTimeCount = function () {
        const extent = myMapSgs.map.getView().calculateExtent(myMapSgs.map.getSize());
        const filteredFeatures = myMapSgs._statisticRealTimeAllFeature.filter(feature => {
            const coords = feature.getGeometry().getExtent(); // Get feature bounds
            return ol.extent.intersects(extent, coords); // Check if in extent
        });

        console.info(filteredFeatures.length);
        //$('#id-statistic-real-time-count').html(filteredFeatures.length);
    }

    // -- end private method ----------------------------------------------------------------------

    // -- begin event -----------------------------------------------------------------------------

    $('#id-button-hide-seccao').on('click', function () {

        if ($(this).hasClass('fa-eye')) {

            $(this).removeClass('fa-eye').addClass('fa-eye-slash').prop('title', 'Ligar visualização');

            var index = 0;

            for (var i = 0; i < myMapSgs.featureToHighLight.getArray().length; i++) {

                if (myMapSgs.featureToHighLight.getArray()[i].id_ == myMapSgs._featureSeccao[index].id)
                    index++;
                myMapSgs.featureToHighLight.getArray()[i].setStyle(new Style({}));

            }

            var layer = null;
            var idLayerArray = 'base_' + ddccffToShowBase + '_' + seccaocadastralToSearch;
            layer = myMapSgs._utility.GetLayerById(myMapSgs.map, idLayerArray);

            layer.setVisible(false);

            myMapSgs.map.renderSync();

            idLayerArray = $('#base-layer-theme :checked')[0].id;

        } else {

            $(this).removeClass('fa-eye-slash').addClass('fa-eye').prop('title', 'Desligar visualização');

            var index = 0;

            for (var i = 0; i < myMapSgs.featureToHighLight.getArray().length; i++) {

                if (myMapSgs.featureToHighLight.getArray()[i].id_ == myMapSgs._featureSeccao[index].id)
                    index++;
                myMapSgs.featureToHighLight.getArray()[i].setStyle(myMapSgs._defaultHighlighStyles);

            }

            var layer = null;
            var idLayerArray = 'base_' + ddccffToShowBase + '_' + seccaocadastralToSearch;
            layer = myMapSgs._utility.GetLayerById(myMapSgs.map, idLayerArray);

            layer.setVisible(true);

            myMapSgs.map.renderSync();

            idLayerArray = $('#base-layer-theme :checked')[0].id;
        }
    });

    /**
     * Evento on key press in toponymy input
     */
    $("#id-toponymy-search-place").keypress(function (event) {

        var topo = $("#id-toponymy-search-place").val();

        if (event.keyCode == 13) {
            event.preventDefault();
            return false;
        }
        if (topo.length >= 3) {
            myMapSgs.searchToponymyMap.CreateSearchToponymy(false);
        }
    });

    /**
     * Event on key press in toponymy input for manager traffic sign
     */
    $("#id-traffic-sign-quick-search-address").keypress(function (event) {

        var topo = $("#id-traffic-sign-quick-search-address").val();

        if (event.keyCode == 13) {
            event.preventDefault();
            return false;
        }
        if (topo.length >= 3) {
            myMapSgs._searchManagerTrafficSignAddress.CreateSearchToponymy2(false);
        }
    });

    /**
     * Evento on key press in nPolice input
     */
    $("#id-toponymy-search-npolicia").keyup(function (event) {

        var topo = $("#id-toponymy-search-npolicia").val();

        if (event.keyCode == 13) {
            event.preventDefault();
            return false;
        }
        if (topo.length > 0) {
            myMapSgs.searchToponymyMap.CreateSearchNPolice();
        }
    });

    /**
     * Map orientation - North button - event click reset rotation
     */
    $("#north-arrow-button").click(function (evt) {
        myMapSgs.map.getView().setRotation(0);
    });

    /**
     * Event on close save feature
     */
    $('.close-offcanvas-save-feature').on('click', myMapSgs._CloseSaveFeature).on('touchstart', myMapSgs._CloseSaveFeature);

    /**
     * Responsive Map Occurrence
     */
    $(window).resize(function () {

        $('#scalezoom').html('1 : ' + myMapSgs._settings.scales[Math.round(myMapSgs.map.getView().getZoom())]);

        if (myMapSgs._utility.mobilecheck() && mapSettings.map_info.name === 'MapOccurrence') {
            $('.canvasShow').each(function () {
                $('#' + this.id).css({
                    'width': $(window).width() + 'px'
                });
            });
            $('#offcanvas-event-occurrence-menu .base-layer-group').css({ 'position': 'absolute' })
            $('.content').css({ 'margin-left': '0px' })
            $('#EventMapSearch').addClass('searchBarEventBodyResponsive');
            $('#ButtonSubmiteSearch').css({ 'width': '15%;' });
            $('.description-event-occurrence').css({ 'max-width': '100%' });
            $('#north-arrow-button').addClass('fixedNorthArrowButtonResponsive');
            $('.offcanvas-body-creat-event-occurrence-margin .col-md-12').css({ 'padding-right': '0px' })
            if ($(window).width() < 361)
                $('.searchBarEventBodyResponsive').css({ 'width': '190px' })
            else
                $('.searchBarEventBodyResponsive').css({ 'width': $(window).width() / 1.5 + 'px' })

            //CSS to move pin to 0,0 position
            $('#pinCreateEventOccurrence').css({ 'top': '0px' });
            $('#pinCreateEventOccurrence').css({ 'left': '0px' });
            //Draw Pin event Occurrence
            //$('.PinOnMoveStyle').css({ 'display': 'initial' });
            var SizeScreenLeft = $('#map').width()
            SizeScreenLeft = SizeScreenLeft / 2;
            var SizePinLeft = $('#pinCreateEventOccurrence').width() / 2;
            var pinOnMove = 7;
            var SizePinOnMoveLeft = SizeScreenLeft - pinOnMove;
            var SizeScreenTop = $('#map').height() / 2 - $('#pinCreateEventOccurrence').height() - 10;
            SizeScreenLeft = SizeScreenLeft - SizePinLeft;
            $('#pinOnMove').css({ 'left': SizePinOnMoveLeft - 1 + 'px' });
            $('#pinOnMove').css({ 'top': SizeScreenTop + 7 + 'px' });
            $('#pinCreateEventOccurrence').css({ 'top': SizeScreenTop + 'px' });
            $('#pinCreateEventOccurrence').css({ 'left': SizeScreenLeft + 'px' });
            $('#pinCreateEventOccurrence').removeClass('pinBody');
            $('#pinCreateEventOccurrence').addClass('pinBodyResponsive');
            $('.offcanvas-camada-event-occurrence .mCustomScrollBox').append($('#offcanvas-theme-MapOccurrence-footer'));
            //$('.occurrence-detail-label-theme').css({ 'font-size': '21px' });
            $('#layer-tree').addClass('layertreeSizeMobile');
            $('.offcanvas-head header').css({ 'font-size': '31px' })
            $('#ButtonStartCreationEvent').css({ 'font-size': '21px' });
            $('#base-layer-theme label').css({ 'font-size': '21px', 'margin-top': '20px' });

            var layertreeLength = $('#layer-tree li').length;
            for (var i = 0; i < layertreeLength; i++) {
                if ($('#layer-tree li')[i].attributes[0].nodeValue === "297") {
                    var HtmlTree = $('#layer-tree li')[i];
                    $(HtmlTree).addClass('layertreeHide');
                };
            };
        };

        if (myMapSgs._utility.mobilecheck() && mapSettings.map_info.name !== 'MapOccurrence') {
            $('#offcanvas-search-result').css({ 'width': '100vw' });
            $('#menubar').css({ 'right': '-60px' });
            $('.offcanvas').css({ 'right': '0px' });
            $('.map').css({ 'padding-right': '0px' });
            $('#offcanvas-services .mCSB_scrollTools').css({ 'position': 'absolute' });
            $('#offcanvas-detail-occurrence').css({ 'width': $(window).width() + 'px' });
            $('.occurrence-detail-info-box-col').css({ 'float': 'left' });
            $('.offcanvas-body-detail-occurrence .mCustomScrollBox').css({ 'width': '95%' });
            $('.offcanvas-body-detail-occurrence').css({ 'min-height': '82%' });
            $('#offcanvas-favs').css({ 'width': $(window).width() + 'px' });
            $(mapSettings.map).trigger('resize');
            $('#north-arrow-button').addClass('fixedNorthArrowButtonResponsive');
            $('#buttonsMap').css({ 'width': '44px', 'top': '0px', 'left': '10px' });
            $('#buttonsMap .floating-action').css({ 'margin-top': '10px', 'margin-left': '0px' });
            $('.unit-scale-line').css({ 'width': '200px', 'display': 'inherit', 'padding-right': '0px', 'padding-left': '10px' });
            $('#offcanvas-favs .mCustomScrollBox').css({ 'width': '99%' });
            $('#menubar').css({ 'z-index': '999' });
            $('#id-offcanvas-layer-detail').css({ 'width': $(window).width() + 'px' });
            $('#id-offcanvas-layer-detail .offcanvas-body-layer-detail').css({ 'width': '100%' });
            $('.content').css({ 'margin-left': '0px' })
            for (var i = 0; i < $('#map-search .card-head a').length; i++) {
                var a = $('#map-search .card-head a')[i];
                $(a).css({ 'height': '56px' })
                var li = a.parentElement;
                $(li).css({ 'width': 100 / $('#map-search .card-head a').length + '%', 'float': 'left' });
            }
            $('#layer-search-form .col-md-11').css({ 'float': 'left', 'width': '87%' });
            $('.unit-scale-line').css({ 'bottom': '50px' });

            //Css Modal to responsive
            $('#modal-shortcut-content').removeClass('modal-content-shortcut');
            $('#modal-shortcut-content').addClass('modal-responsive-content');

            $('.modal-content-responsive').removeClass('modal-content');
            $('.modal-content-responsive').addClass('modal-responsive-content');

            $('.modal-content-responsive textarea').css({ 'min-width': '0px' })

            $('.modal-content-responsive').css({ 'top': '0px' }),
                $('.modal-content-responsive').css('cssText', 'width: 100 % !important;');

            $('.offcanvas-pane .show').css({ 'right': '0px;' });

            $('.anacom-close-search-button').css({ 'right': '-8px', 'position': 'absolute' })

            //Área de seleção
            //$('#offcanvas-info').css({ 'right': $('#map').width() - $('#offcanvas-info').width()+'px'});


            /**
             * Event to open/close ToolBar 
             */
            $('#tools-Bar-Mobile').on('click', function () {
                if (!$('#menubar').hasClass('active')) {
                    $('#menubar').css({ 'transform': 'translate(-60px , 0px)' });
                    $('#menubar').addClass('active');
                } else {
                    $('#menubar').css({ 'transform': 'translate(60px , 0px)' });
                    $('#menubar').removeClass('active');
                }
                //$('#menubar').
            })

            $('#menubar').on('click', function () {
                $('.canvasShow').each(function () {
                    if ($('#' + this.id).hasClass('active')) {
                        $('#' + this.id).css({ 'width': $(window).width() + 'px' });
                        myMapSgs._utility.ShowOpenCanvas3(this.id, true);
                    }
                });
            });
        }

    });

    // TODO: A REVER
    $(".tooltip-active").change(function () {
        if (this.checked) {
            myMapSgs.map.on('singleclick', async (e) => { await myMapSgs.tooltips.BuildInfoTooltips(e); });
            $('#pinCreateEventOccurrence').css({ 'display': 'none' })
        }
        else {
            myMapSgs.map.un('singleclick', myMapSgs.tooltips.BuildInfoTooltips);
            myMapSgs.tooltipCheck = false;
        }
    });

    /**
     * Collapse/open info in element detail
     */
    $('.offcanvas-collapse').on('click', function () {
        var idNodeToCollapse = this.getAttribute('target-id');
        $(this).find('i').toggleClass('fa-chevron-down fa-chevron-up');
        // Close all other info

        $('#' + idNodeToCollapse).toggle('ol-hidden');
    });

    /**
     * Event on click add filter
     */
    $('#layer-search-filter-add-button').on('click', function () {
        var indexColumn = myMapSgs._columnFilterAdvancedSearchIndex++;

        // Get filter element
        var filterZoneElement = $('#layer-search-filter-zone')[0];

        // If nothing selected then leave
        if (!$('#layer-search-select-column').val()) {
            toastr["warning"]("Selectione primeiro uma coluna");

            return;
        }

        // If already selected then leave
        if ($('#layer-search-filter-zone input[column_name="' + $('#layer-search-select-column').val() + '"]').length > 0) {
            toastr["warning"]("Coluna já adicionada");

            return;
        }

        // Get column info
        var idLayer = myMapSgs.layerTree.selectedLayerSearch;
        var layerName = myMapSgs._settings.treeMap.dict_layer_info[idLayer].layer_info.layerName;
        var columnName = $('#layer-search-select-column').val();
        var columnPrettyName = $('#layer-search-select-column option:selected').text();
        var columnInfo = myMapSgs._settings.treeMap.dict_layer_info[idLayer].list_column.find(c => c.column_name === columnName);
        var columnType = myMapSgs._settings.treeMap.dict_layer_info[idLayer].list_column.find(c => c.column_name === columnName).column_type;
        var placeholder = "Introduza um valor";

        // Adjust for reference columns
        let isRefCol = (columnName ? columnName.substr(0, 6).toUpperCase() === 'ID_REF' : false) || columnInfo.id_rel_layer_column_ref_metadata != null;
        // Manager traffic sign - prumo array sinal
        if (mapSettings.operation_visible.ManagerTrafficSignTool && myMapSgs._managerTrafficSignTool.prumoInfo.layerName == layerName && myMapSgs._managerTrafficSignTool.prumoInfo.prumoInfoConfig.column_name_array_type_sign == columnName) {
            isRefCol = true;
        }
        let isIdCol = columnName && !isRefCol ? columnName.substr(0, 2).toUpperCase() === 'ID' : false;
        var mainFieldType = isRefCol ? "xsd:string" : columnInfo.column_type;

        var arrayOperador = [];
        switch (columnInfo.column_type) {
            case "xsd:number":
            case "xsd:int":
            case "xsd:double":
            case "xsd:bigint":
                placeholder = "Introduza um número";
                arrayOperador = [
                    {
                        ref: '=',
                        description: '='
                    },
                    {
                        ref: '<>',
                        description: '<>'
                    },
                    {
                        ref: '>',
                        description: '>'
                    },
                    {
                        ref: '>=',
                        description: '>='
                    },
                    {
                        ref: '<',
                        description: '<'
                    },
                    {
                        ref: '<=',
                        description: '<='
                    }
                ];
                break;
            case "xsd:date-time":
            case "xsd:date":
                placeholder = "seleccione uma data";
                arrayOperador = [
                    {
                        ref: '=',
                        description: '='
                    },
                    {
                        ref: '<>',
                        description: '<>'
                    },
                    {
                        ref: '>',
                        description: '>'
                    },
                    {
                        ref: '>=',
                        description: '>='
                    },
                    {
                        ref: '<',
                        description: '<'
                    },
                    {
                        ref: '<=',
                        description: '<='
                    }
                ];
                break;
            default:
                arrayOperador = [
                    {
                        ref: '=',
                        description: '='
                    },
                    {
                        ref: 'ilike',
                        description: 'contido'
                    }
                ];
        }

        // Id
        var idColumn = "id-layer-search-input-column-" + columnName + "-" + indexColumn;
        var idDivColumn = "id-layer-search-div-column-" + columnName + "-" + indexColumn;
        var idOperator = "id-layer-search-operator-column-" + columnName + "-" + indexColumn;
        var nameColumnIndex = columnName + "-" + indexColumn;
        // Filter
        var filterElement = document.createElement('div');
        filterElement.id = idDivColumn;
        filterElement.className = "form-group";
        filterElement.setAttribute('name-column-index', nameColumnIndex);
        filterElement.setAttribute('column_name', columnName);
        filterZoneElement.appendChild(filterElement);
        // Remove column select
        var removeFilterElement = document.createElement('a');
        removeFilterElement.className = "layer-search-filter-remove";
        removeFilterElement.setAttribute('title', 'Remover filtro');
        filterElement.appendChild(removeFilterElement);
        var removeFilterIconElement = document.createElement('i');
        removeFilterIconElement.className = "fa fa-trash";
        removeFilterElement.appendChild(removeFilterIconElement);
        // Title column
        var labelFilterElement = document.createElement('label');
        labelFilterElement.innerHTML = columnPrettyName;
        filterElement.appendChild(labelFilterElement);
        // Value
        var divFilterElement = document.createElement('div');
        divFilterElement.className = "row";
        filterElement.appendChild(divFilterElement);
        // Input value
        if (isRefCol) {
            // Manager traffic sign tool for type of element column
            var done = false;
            if (mapSettings.operation_visible.ManagerTrafficSignTool) {
                if (myMapSgs._managerTrafficSignTool.signInfo.layerName == layerName && myMapSgs._managerTrafficSignTool.signInfo.signInfoConfig.column_name_type_sign == columnName) {
                    // Add combo box type sign
                    myMapSgs._managerTrafficSignTool.BuildTypeSignSelection(idDivColumn, idColumn, nameColumnIndex + "[]", "", "", 'multiple="multiple"', "", 'column-type="' + columnInfo.column_type + '"column_type="' + columnInfo.column_type + '" column_name="' + columnName + '" column_pretty_name="' + columnPrettyName + '" column_valid="1"');
                    done = true;
                }
                if (myMapSgs._managerTrafficSignTool.prumoInfo.layerName == layerName && myMapSgs._managerTrafficSignTool.prumoInfo.prumoInfoConfig.column_name_array_type_sign == columnName) {
                    // Add combo box type sign
                    myMapSgs._managerTrafficSignTool.BuildTypeSignSelection(idDivColumn, idColumn, nameColumnIndex + "[]", "", "", 'multiple="multiple"', "", 'column-type="' + columnInfo.column_type + '"column_type="' + columnInfo.column_type + '" column_name="' + columnName + '" column_pretty_name="' + columnPrettyName + '" column_valid="1"');
                    done = true;
                }
            }

            if (!done) {
                // Create html select2
                var $select = $('<select id="' + idColumn + '" name="' + nameColumnIndex + '"multiple="multiple" class="form-control feature-field" title="Nenhum sinal escolhido" style="width: 100%" column_type="' + columnInfo.column_type + '" column_name="' + columnName + '" column_pretty_name="' + columnPrettyName + '" column_valid="1" index="' + indexColumn + '"></select>');
                var $option = $("<option></option>");

                // Create array with value
                var gpName = myMapSgs.getSettings()._mapSettings.search_toponymy.workspaceSearchToponymy;
                var gpSigredes = gpName == 'GP_MEALHADA' || gpName == 'GP_PONTA_DELGADA';
                var layerRef = myMapSgs._settings.columnTableReferenceData.table_reference_data[columnInfo.id_rel_layer_column_ref_metadata];;
                if (gpSigredes && myMapSgs._layerReferences) {
                    var layer_references = myMapSgs._layerReferences[layerName];

                    if (layer_references && (layer_references['id_' + columnName] || layer_references[columnName])) {
                        layerRef = !isIdCol ? layer_references['id_' + columnName] : layer_references[columnName];
                    }
                    var prefix = "id_";
                    if (gpSigredes && isRefCol) {
                        if (gpName == 'GP_PONTA_DELGADA')
                            layerRef = myMapSgs.typeList;
                        else
                            layerRef = layer_references[columnName];
                        prefix = "";
                    }
                }
                var comboArray = [];
                if (gpName == 'GP_PONTA_DELGADA') {
                    for (var k = 0; k < layerRef.length; k++) comboArray.push({ 'id': layerRef[k], 'value': layerRef[k] });
                } else {
                    comboArray.push({ 'id': '', 'value': '' });
                    for (let [key, row] of Object.entries(layerRef)) {
                        comboArray.push({ 'id': row.id, 'value': row.value });
                    }
                }

                // Fill select2 array
                for (var u = 0; u < comboArray.length; u++) {
                    var elementObj = comboArray[u];
                    var $option = $("<option></option>", {
                        "text": elementObj.value,
                        "value": elementObj.id
                    });
                    $select.append($option);
                }
                $('#' + idDivColumn).append($select);
                $('#' + idColumn).select2({
                    width: 'resolve'
                });
            }
        }
        else {
            var divColInputFilterElement = document.createElement('div');
            divColInputFilterElement.className = "col col-md-9 field";
            divFilterElement.appendChild(divColInputFilterElement);
            //var idInput = "layer-search-input-column-" + columnName;
            var inputFilterElement = document.createElement('input');
            inputFilterElement.id = idColumn;
            inputFilterElement.setAttribute('type', 'text');
            inputFilterElement.className = 'form-control search-input';
            inputFilterElement.setAttribute('placeholder', placeholder);
            inputFilterElement.setAttribute('column_name', columnName);
            inputFilterElement.setAttribute('column_pretty_name', columnPrettyName);
            inputFilterElement.setAttribute('column_type', columnInfo.column_type);
            inputFilterElement.setAttribute('column_valid', "1");
            inputFilterElement.setAttribute('index', indexColumn);
            divColInputFilterElement.appendChild(inputFilterElement);

            // Operator Select
            var divColSelectOperatorFilterElement = document.createElement('div');
            divColSelectOperatorFilterElement.className = "col col-md-3 operator-select";
            divFilterElement.appendChild(divColSelectOperatorFilterElement);
            var selectOperatorFilterElement = document.createElement('select');
            selectOperatorFilterElement.id = idOperator;
            selectOperatorFilterElement.className = "form-control operator-select";
            selectOperatorFilterElement.setAttribute('data-container', "body");
            divColSelectOperatorFilterElement.appendChild(selectOperatorFilterElement);

            // Fill operator select
            myMapSgs._utility.FillSelect(idOperator, arrayOperador, 'description', 'ref');

            //$('#' + idOperator).attr('' + 'body');

            // Transform input if that the case
            switch (columnInfo.column_type) {
                case "xsd:date-time":
                case "xsd:date":
                    $('#' + idColumn).datepicker({ uiLibrary: 'bootstrap', format: 'yyyy-mm-dd' });
                    break;
                default:
                // do nothing
            }
        }

        // Event remove filter
        $('.layer-search-filter-remove').on('click', function () {
            $(this).parent().remove();
        });

        // Event valid search layer filter value on key up
        $('#layer-search-filter-zone input').on('keyup', function () {
            var columnType = this.getAttribute('column_type');
            var value = $(this).val();

            switch (columnType) {
                case "xsd:number":
                case "xsd:int":
                    if (!myMapSgs._utility.ValidNumber(value)) {
                        $(this).addClass("invalid");
                        this.setAttribute("column_valid", "0")
                    }
                    else {
                        $(this).removeClass("invalid");
                        this.setAttribute("column_valid", "1")
                    }
                    break;
                default:
                // Do nothing
            }
        });
    });

    /**
     * Event search layer filter
     */
    $('#layer-search-btn-search').on('click', function () {

        // Get max feature number result search
        var hasMaxFeatureConfig = false;
        var maxFeatureSearch = 200;
        var maxFeatureSearchConfig = myMapSgs._utility.GetPropertyInfoInConfigArray(myMapSgs._settings.configurationInfo.propertyInfo, "CONFIG_SEARCH", "ADVANCED_SEARCH", "MAX_FEATURE");
        if (maxFeatureSearchConfig) {
            if (maxFeatureSearchConfig.value != 'MAX') {
                maxFeatureSearch = parseInt(maxFeatureSearchConfig.value);
            }
        }

        //Clean search network
        $('#id-offcanvas-search-result-expand').css('display', 'block');
        $('#id-offcanvas-search-result-expand-zone').css('display', 'block');
        $('#id-offcanvas-search-result-goto-zone')[0].className = "col col-md-3 col-xs-3";
        $('#id-offcanvas-search-result-clean-zone')[0].className = "col col-md-2 col-xs-2";
        $('#id-offcanvas-search-result-body').css("display", "block");
        $('#offcanvas-search-result-table-zone').css('display', 'block');
        $('#offcanvas-search-result-network-table-zone div').remove();
        $('#offcanvas-search-result-network-doc-zone').css({ 'display': 'none' });

        // Widthout filer
        if ((!$('#layer-search-filter-zone input').length || $('#layer-search-filter-zone input').val() === "") && $('#layer-search-filter-zone select').length === 0) {
            toastr["warning"]("Nehum filtro configurado");

            return;
        }

        // Start wait
        myMapSgs._utility.ShowWait('offcanvas-map-spinner', true);

        var getFeatureUrl = myMapSgs.layerTree.layerInfo.dict_layer_info[myMapSgs.layerTree.selectedLayerSearch].layer_info.geoserver + "/wfs";
        var workspace = myMapSgs.layerTree.layerInfo.dict_layer_info[myMapSgs.layerTree.selectedLayerSearch].layer_info.workspace;
        var layerName = myMapSgs.layerTree.layerInfo.dict_layer_info[myMapSgs.layerTree.selectedLayerSearch].layer_info.layerName;
        var cqlFilterLayer = myMapSgs.layerTree.layerInfo.dict_layer_info[myMapSgs.layerTree.selectedLayerSearch].layer_info.cqlFilter;
        var listColumn = myMapSgs.layerTree.layerInfo.dict_layer_info[myMapSgs.layerTree.selectedLayerSearch].list_column;

        // Build Filter
        var cqlFilter = "";
        var cqlFilterField = "";

        // Input filter
        var $inputFilter = $('#layer-search-filter-zone input:not([class="select2-search__field"])');
        for (var i = 0; i < $inputFilter.length; i++) {
            var value = $inputFilter[i].value;
            var columnName = $inputFilter[i].getAttribute('column_name');
            var columnValid = $inputFilter[i].getAttribute('column_valid');
            var columnType = $inputFilter[i].getAttribute('column_type');
            var indexColumn = $inputFilter[i].getAttribute('index');
            switch (columnType) {
                case "xsd:number":
                    Number.isFinite(parseInt(value)) ? columnValid = "1" : columnValid = "0";
                    break;
                case "xsd:double":
                    Number.isFinite(parseFloat(value)) ? columnValid = "1" : columnValid = "0";
                    break;
                case "xsd:int":
                    Number.isFinite(parseInt(value)) ? columnValid = "1" : columnValid = "0";
                    break;
                case "xsd:date-time":
                    !isNaN(new Date(value).getTime()) ? columnValid = "1" : columnValid = "0";
                    break;
                case "xsd:date":
                    !isNaN(new Date(value).getTime()) ? columnValid = "1" : columnValid = "0";
                    break;

            }
            if (columnValid === "0") {
                var columnPrettyName = $inputFilter[i].getAttribute('column_pretty_name');
                toastr["error"]("Atenção, campo '" + columnPrettyName + "' Inválido");
                // Stop wait
                myMapSgs._utility.ShowWait('offcanvas-map-spinner', false);

                return;
            }
            if (value === "") {
                var columnPrettyName = $inputFilter[i].getAttribute('column_pretty_name');
                toastr["error"]("Atenção, campo '" + columnPrettyName + "' vazio");
                // Stop wait
                myMapSgs._utility.ShowWait('offcanvas-map-spinner', false);

                return;
            }
            //var columnType = $inputFilter[i].getAttribute('column_type');
            var operator = $("#id-layer-search-operator-column-" + columnName + "-" + indexColumn).val();
            switch (columnType) {
                case "xsd:number":
                case "xsd:int":
                case "xsd:double":
                    cqlFilterField = columnName + "  " + operator + " " + value;
                    break;
                case "xsd:date-time":
                case "xsd:date":
                    cqlFilterField = columnName + "  " + operator + " '" + value + "'";
                    break;
                default:
                    if (operator === "ilike")
                        //cqlFilterField = "strToLowerCase(" + columnName + ") " + operator + " '%" + value.toLowerCase() + "%'";
                        cqlFilterField = columnName + " " + operator + " '%" + value.toLowerCase() + "%'";
                    else
                        cqlFilterField = "strToLowerCase(" + columnName + ")  " + operator + " '" + value.toLowerCase() + "'";
            }

            if (i === 0)
                cqlFilter = cqlFilterField
            else
                cqlFilter += " And " + cqlFilterField
        }

        // Select2 filter
        var $select2Filter = $('#layer-search-filter-zone select:not(.operator-select)');
        for (var j = 0; j < $select2Filter.length; j++) {
            var valueArray = $($select2Filter[j]).val();
            var value = $($select2Filter[j]).val().toString();
            var columnName = $select2Filter[j].getAttribute('column_name');
            var columnValid = $select2Filter[j].getAttribute('column_valid');
            var columnInfo = listColumn.find(c => c.column_name == columnName);
            if (columnValid === "0") {
                var columnPrettyName = $select2Filter[j].getAttribute('column_pretty_name');
                toastr["error"]("Atenção, campo '" + columnPrettyName + "' Inválido");
                // Stop wait
                myMapSgs._utility.ShowWait('offcanvas-map-spinner', false);

                return;
            }
            if (value === "") {
                var columnPrettyName = $select2Filter[j].getAttribute('column_pretty_name');
                toastr["error"]("Atenção, campo '" + columnPrettyName + "' vazio");
                // Stop wait
                myMapSgs._utility.ShowWait('offcanvas-map-spinner', false);

                return;
            }

            if (mapSettings.operation_visible.ManagerTrafficSignTool && myMapSgs._managerTrafficSignTool.prumoInfo.layerName == layerName && myMapSgs._managerTrafficSignTool.prumoInfo.prumoInfoConfig.column_name_array_type_sign == columnName) {
                var cqlFilterTypeSign = "";
                var arrayTypeSignSelected = $($select2Filter[j]).val();
                for (var i = 0; i < arrayTypeSignSelected.length; i++) {
                    var idTypeSign = arrayTypeSignSelected[i];
                    if (i != 0)
                        cqlFilterTypeSign += ' and ';
                    cqlFilterTypeSign += columnName + " ilike '%[" + idTypeSign + "]%'";
                }
                cqlFilterField = cqlFilterTypeSign;
            }
            else {
                if (columnInfo) {
                    switch (columnInfo.column_type) {
                        case "xsd:text":
                        case "xsd:string":
                            var newValue = "";
                            if (value.split(",").length == 1) {
                                newValue = "'" + value + "'";
                            }
                            else {
                                newValue = `'${valueArray.join("', '")}'`;
                            }
                            cqlFilterField = columnName + "  in (" + newValue + ")";
                            break;
                        default:
                            cqlFilterField = columnName + "  in (" + value + ")";
                    }
                }
                else
                    cqlFilterField = columnName + "  in (" + value + ")";
            }

            var columnType = $select2Filter[j].getAttribute('column_type');
            if (j === 0)
                cqlFilter += cqlFilterField
            else
                cqlFilter += " And " + cqlFilterField
        }

        // Get features
        //var layerName = myMapSgs._utility.GetPropertyInfoInConfigArray(_configurationInfo.propertyInfo, "TRAFFIC_SIGN_TOOL", "LAYER_TRAFFIC_SIGN", "LAYER_NAME").value;
        //var layerInfo = myMapSgs.layerTree.FindLayerInfo(layerName);
        //var getFeatureUrl = layerInfo.geoserver + "/wfs";
        //var workspace = layerInfo.workspace;
        //var cqlFilterLayer = layerInfo.cqlFilter;
        //var cqlFilterResult = cqlFilter;
        //if (cqlFilterLayer)
        //    cqlFilterResult += " And " + cqlFilterLayer;

        var cqlFilterResult = cqlFilter;
        if (cqlFilterLayer)
            cqlFilterResult += " And " + cqlFilterLayer;

        // If manager traffic sign, layer prumo or sign add class to table zone
        if (mapSettings.operation_visible.ManagerTrafficSignTool && (myMapSgs._managerTrafficSignTool.prumoInfo.layerName == layerName || myMapSgs._managerTrafficSignTool.signInfo.layerName == layerName)) {
            $('#offcanvas-search-result-table-zone').addClass("traffic-sign");
        }
        else {
            $('#offcanvas-search-result-table-zone').removeClass("traffic-sign");
        }

        // Config parameter
        var getFeatureData = {
            "service": 'wfs',
            "version": '2.0.0',
            "request": 'GetFeature',
            "typeNames": workspace + ':' + layerName,
            "cql_filter": cqlFilterResult,
            'srsName': myMapSgs._settings.projection.getCode(),
            "outputFormat": 'application/json',
            "maxFeatures": maxFeatureSearch
        }
        if (!hasMaxFeatureConfig) {
            delete getFeatureData.maxFeatures;
        }

        // Call geoserver to get the feature of the layer
        var getFeature = $.ajax({
            method: "GET",
            async: true,
            url: getFeatureUrl,
            data: getFeatureData
        });

        // Response from the server
        getFeature.done(function (data, textStatus, jqXHR) {
            if (data.features) {
                if (data.features.length > 0) {
                    if (myMapSgs.featureToHighLight.getLength() > 0) myMapSgs.featureToHighLight.clear();
                    myMapSgs._arraySearchLayerFeatureActive = [];
                    var feature = null;
                    var idLayer = myMapSgs.layerTree.selectedLayerSearch;
                    var layerName = myMapSgs._settings.treeMap.dict_layer_info[idLayer].layer_info.layerName;
                    var workspace = myMapSgs._settings.treeMap.dict_layer_info[idLayer].layer_info.workspace;
                    var columnDefArray = [];
                    var columDefArrayExpand = [];
                    var columDefArrayExpandSize = [];
                    var columnValueArray = [];
                    var idPrimaryKey = null;
                    var featureHash = {};
                    var numFeatures = data.features.length;

                    for (let i = 0; i < numFeatures; i++) {
                        feature = (new GeoJSON()).readFeatures(data)[i];

                        if (feature.getGeometry() !== null) {
                            idPrimaryKey = feature.getId().split(".")[1];
                            featureHash[idPrimaryKey] = feature;

                            // Save feature Search
                            myMapSgs._arraySearchLayerFeatureActive.push(feature);

                            // Build column info
                            var objRow = {};
                            for (var j = 0; j < Object.keys(feature.getProperties()).length; j++) {
                                var columnName = Object.keys(feature.getProperties())[j];
                                if (columnName === "geometry")
                                    continue;
                                var value = feature.getProperties()[columnName];
                                var columnProperties = myMapSgs.layerTree.layerInfo.dict_layer_info[myMapSgs.layerTree.selectedLayerSearch].list_column.filter(obj => {
                                    return obj.column_name === columnName
                                })[0];


                                // If value is a system date, format string
                                //if (new Date(value) != 'Invalid Date' && isNaN(value))
                                if (columnProperties) {
                                    if (columnProperties.column_type == 'xsd:date-time')
                                        value = app.sgs._utility.TransformDateServerInDateTime(value);

                                    objRow[columnName] = value;
                                    if (columDefArrayExpandSize[columnName]) {
                                        if (value) {
                                            var valueSize = value.toString().length;
                                            columDefArrayExpandSize[columnName] = (valueSize > columDefArrayExpandSize[columnName]) ? valueSize : columDefArrayExpandSize[columnName];
                                        }
                                    }
                                    else {
                                        if (value)
                                            columDefArrayExpandSize[columnName] = value.toString().length;
                                        else
                                            columDefArrayExpandSize[columnName] = 30; // If fist empty
                                    }
                                    if (i === 0) {
                                        var columnSearchResult = myMapSgs._settings.treeMap.dict_layer_info[idLayer].list_column.find(c => c.column_name === columnName).search_result;
                                        var visible = myMapSgs._settings.treeMap.dict_layer_info[idLayer].list_column.find(c => c.column_name === columnName).visible;
                                        var columnPrettyName = myMapSgs._settings.treeMap.dict_layer_info[idLayer].list_column.find(c => c.column_name === columnName).pretty_name;
                                        var searchResultOrder = myMapSgs._settings.treeMap.dict_layer_info[idLayer].list_column.find(c => c.column_name === columnName).search_result_order;

                                        if (columnSearchResult) {
                                            if (mapSettings.operation_visible.ManagerTrafficSignTool) {
                                                // Manager Traffice Sign - layer name sign - Specific column type sign
                                                var columnSearchCreate = false;
                                                if (myMapSgs._managerTrafficSignTool.signInfo.layerName == layerName && myMapSgs._managerTrafficSignTool.signInfo.signInfoConfig.column_name_type_sign == columnName) {
                                                    columnDefArray.push({
                                                        'data': columnName,
                                                        'orderable': false,
                                                        'width': '30px',
                                                        'search_order': searchResultOrder,
                                                        'render': function (data, type, row) {
                                                            var idLayerSign = myMapSgs.layerTree.FindLayerInfo(myMapSgs._managerTrafficSignTool.signInfo.layerName).id;
                                                            var idLayerReference = myMapSgs._settings.treeMap.dict_layer_info[idLayerSign].list_column.find(c => c.column_name === myMapSgs._managerTrafficSignTool.signInfo.signInfoConfig.column_name_type_sign).id_rel_layer_column_ref_metadata;
                                                            var typeSignDesc = myMapSgs._settings.columnTableReferenceData.table_reference_data[idLayerReference].find(c => c.id == row[myMapSgs._managerTrafficSignTool.signInfo.signInfoConfig.column_name_type_sign]).value;
                                                            var streetName = (row[myMapSgs._managerTrafficSignTool.signInfo.signInfoConfig.column_name_street] == null) ? "<br/>" : '<label style="font-weight: 100;margin-bottom: 0px;font-size: 10px;">' + row[myMapSgs._managerTrafficSignTool.signInfo.signInfoConfig.column_name_street] + '</label><br/>';

                                                            return '<div><div class="col-md-1" style="text-align: left;padding: 0px 30px 0px 0px;position: relative;top: 5px;"><img src="' + row.file_img_name_sinal + '" width="30" height="30"/></div><div class="col-md-8" style="position: relative;top: 3px;padding: 0px 0px 0px 5px;text-align: left;font-size: 10px;text-wrap: wrap;"><label style="font-weight: 100;margin-bottom: 0px;">' + typeSignDesc + '</label>' + streetName + '<label>' + row.id.toString().padStart(5, '0') + '</label></div></div>'
                                                        }
                                                    });
                                                    columnSearchCreate = true;
                                                }
                                                // Manager Traffice Sign - layer name prumo - Specific column street
                                                if (myMapSgs._managerTrafficSignTool.prumoInfo.layerName == layerName && myMapSgs._managerTrafficSignTool.prumoInfo.prumoInfoConfig.column_name_street == columnName) {
                                                    columnDefArray.push({
                                                        'data': columnName,
                                                        'orderable': false,
                                                        'width': '30px',
                                                        'search_order': searchResultOrder,
                                                        'render': function (data, type, row) {
                                                            var streetName = (row[myMapSgs._managerTrafficSignTool.prumoInfo.prumoInfoConfig.column_name_street] == null) ? "<br/>" : '<label style="font-weight: 100;margin-bottom: 0px;font-size: 10px;">' + row[myMapSgs._managerTrafficSignTool.prumoInfo.prumoInfoConfig.column_name_street] + '</label><br/>';

                                                            return '<div style="padding-left: 5px;">' + streetName + '<label style="font-size: 10px;">' + row.id + '</label></div></div>'
                                                        }
                                                    });
                                                    columnSearchCreate = true;
                                                }

                                                // For all other column in traffic manager
                                                if (!columnSearchCreate) {
                                                    columnDefArray.push({
                                                        'data': columnName,
                                                        'title': columnPrettyName,
                                                        'name': columnPrettyName,
                                                        'label': columnPrettyName,
                                                        'type': columnPrettyName,
                                                        'orderable': false,
                                                        'width': '30px',
                                                        'search_order': searchResultOrder
                                                    });
                                                }
                                            }
                                            else {
                                                columnDefArray.push({
                                                    'data': columnName,
                                                    'title': columnPrettyName,
                                                    'name': columnPrettyName,
                                                    'label': columnPrettyName,
                                                    'type': columnPrettyName,
                                                    'orderable': false,
                                                    'width': '30px',
                                                    'search_order': searchResultOrder
                                                });
                                            }
                                        } else {
                                            columnDefArray.push({
                                                'data': columnName,
                                                'type': 'readonly',
                                                'visible': false,
                                                'search_order': 0
                                            });
                                        }
                                        if (visible) {
                                            columDefArrayExpand.push({
                                                'data': columnName,
                                                'title': columnPrettyName,
                                                'name': columnPrettyName,
                                                'label': columnPrettyName,
                                                'type': columnPrettyName,
                                                'orderable': false,
                                                'width': '30px'
                                            });
                                        }
                                        else {
                                            columDefArrayExpand.push({
                                                'data': columnName,
                                                'type': 'readonly',
                                                'visible': false
                                            });
                                        }
                                    }
                                }
                            }

                            // Order columns by search order
                            columnDefArray = columnDefArray.sort((a, b) => (a.search_order > b.search_order) ? 1 : -1);

                            // Add primary key value
                            objRow["id_primary_key"] = idPrimaryKey;

                            // Add array row
                            columnValueArray.push(objRow);

                            // Put in feature highlight
                            //console.log(Date());
                            myMapSgs.featureToHighLight.push(feature);
                            var styleElement = myMapSgs._defaultHighlighStyles;
                            myMapSgs.featureToHighLight.getArray()[myMapSgs.featureToHighLight.getArray().length - 1].setStyle(styleElement);
                        }
                    }
                    // Add primary key to array
                    columnDefArray.push({
                        'data': "id_primary_key",
                        'type': 'readonly',
                        'visible': false
                    });
                    columDefArrayExpand.push({
                        'data': "id_primary_key",
                        'type': 'readonly',
                        'visible': false
                    });

                    // Add size to column in array expand
                    for (let i = 0; i < columDefArrayExpand.length; i++) {
                        var objDef = columDefArrayExpand[i];
                        if (objDef.width) {
                            if (columDefArrayExpandSize[objDef.data] > 50)
                                objDef.width = columDefArrayExpandSize[objDef.data].toString() + "px";
                            else
                                objDef.width = "50px";
                            columDefArrayExpand[i] = objDef;
                        }
                    };

                    // Write title
                    $('#offcanvas-search-result .offcanvas-head header span').html("Resultado da Pesquisa");

                    // Show canvas search result
                    myMapSgs._utility.ShowOpenCanvas3('offcanvas-search-result', true);

                    // Make datatable list
                    myMapSgs.InitSearchResultTable(workspace, layerName, myMapSgs.layerTree.selectedLayerSearch, featureHash, columnDefArray, columDefArrayExpand, columnValueArray, myMapSgs.DetailElement);

                    if (columnValueArray.length > 0) {
                        // Go to Feature
                        myMapSgs.map.getView().fit(myMapSgs.layerHighlightOverlay.getSource().getExtent(), { size: myMapSgs.map.getSize() });

                    } else {
                        toastr["warning"]("Não foi encontrado nenhum elemento");
                    }

                    // Remove hide in offcanvas search result information
                    $('#id-offcanvas-search-result-zone').removeClass('ol-hidden');
                    $('#id-offcanvas-search-result-body').removeClass('ol-hidden');
                }
                else {
                    toastr["warning"]("Não foi encontrado nenhum elemento");
                }
            }
            else {
                toastr["warning"]("Não foi encontrada, nenhuma camada");
            }

            // Start wait
            myMapSgs._utility.ShowWait('offcanvas-map-spinner', false);
        });

    });

    /**
     * Event Search Airc
     */
    $('#id-buttonsearchairc').click(function () {

        myMapSgs._utility.ShowWait('offcanvas-entity-form-spinner', true);

        $('.aircRemove').remove();

        var view = $('#id-aircAction').val();

        var idProcess = $('#id-worknumber').val();

        if ($.isNumeric(idProcess)) {
            $.ajax({
                type: 'GET',
                url: '/rest/app/AIRC/GetServices?idProcess=' + idProcess + "&view=" + view,
                contentType: "application/json",
                success: function (data) {
                    if (data.result != null) {
                        for (i = 0; i < data.result.length; i++) {
                            var info = data.result[i];
                            var item = Object.keys(data.result[i]);
                            item = item[0];
                            if (info[item].Value !== null && info[item].Value !== "") {
                                $('#id-aircresult').append(' <div class="form-group aircRemove"><label for="">' + info[item].Pretty_name + '</label><input name="id" value="' + info[item].Value + '" type="text" id="id-worknumber" class="form-control" placeholder="Sem dados" disabled></div>');
                            }
                        }
                        myMapSgs._utility.ShowOpenCanvas3('offcanvas-search-result', true);
                        myMapSgs._utility.ShowWait('offcanvas-entity-form-spinner', false);
                    } else {
                        toastr["warning"]("Não foi encontrado nenhuma obra com esse ID");
                    }
                },
                error: function (request, status, error) {
                    toastr["error"]("");
                    myMapSgs._utility.ShowWait('offcanvas-entity-form-spinner', false);
                }
            });
        } else {
            toastr["error"]("Número de Obra");
        }
    })

    $('#map-search [type=submit]').click(function () {
        switch (this.id) {
            case "id-buttonsearchairc":
                $('#OccurrenceSearchResult').css({ "display": "none" });
                $('#AircSearchResult').css({ "display": "initial" });
                break;
            case "id-toponymy-search-submit-btn":
                break;
            default:
                $('#AircSearchResult').css({ "display": "none" });
                $('#OccurrenceSearchResult').css({ "display": "initial" });
                break;
        }
    })

    if (mapSettings.map_info.name !== 'MapOccurrence')
        $(document).ready(function () {
            //Trigger resize to start responsive on the map Occurrence
            $(window).trigger('resize');
            myMapSgs.map.updateSize();

        });

    //Expand Canvas for search Layers
    $('#layer-search-active-tree').on('click', function () {

        if (!$('#map-search .mCustomScrollbar').hasClass('active')) {
            $('#map-search .mCustomScrollbar').addClass('active');
            var heightlayersearch = $('#layer-search-layer-tree ul')[0].childNodes.length * 37.5;
            var canvasHeight = $('#map-search').height() + heightlayersearch + 100;
            var heightWindowMap = $('#map').height();
            if (canvasHeight < heightWindowMap) {
                $('#map-search .mCustomScrollbar').css({ 'height': heightlayersearch + 'px' })
            }
            else {
                $('#map-search .mCustomScrollbar').css({ 'height': heightWindowMap - $('#map-search').height() - 100 + 'px' })
            }
        } else {
            $('#map-search .mCustomScrollbar').removeClass('active');
            $('#map-search .mCustomScrollbar').css({ 'height': ' 250px' })
        }

        //Expand layerTree childs only if screen have space
        $('.gj-tree-material-icons-expander').on('click', function () {
            var heightlayersearch = $('#layer-search-layer-tree .gj-list-md').height();
            var divMapSearch = $('#map-search').height();
            var heightWindowMap = $('#map').height();
            var layersearchMapSearch = heightlayersearch + divMapSearch;
            if (layersearchMapSearch < heightWindowMap)
                $('#map-search .mCustomScrollbar').css({ 'height': heightlayersearch + 10 + 'px' })
        })
    });

    /**
     * Event search result show/hide highlight
     */
    $('#id-search-result-detail-info-number-result').on('click', function () {
        if (myMapSgs._arraySearchLayerFeatureActive.length > 0) {
            if ($(this).hasClass('hide-highlight')) {
                $(this).removeClass('hide-highlight');
                myMapSgs.SetFeaturesHighlightByFeatureCol(myMapSgs._arraySearchLayerFeatureActive, true);
            }
            else {
                $(this).addClass('hide-highlight');
                myMapSgs.layerHighlightOverlay.getSource().clear();
            }
        }
    });

    /**
     * Event search result go to extent
     */
    $('#id-offcanvas-search-result-goto').on('click', function () {
        if (myMapSgs._arraySearchLayerFeatureActive.length > 0) {
            myMapSgs.layerHighlightOverlay.getSource().clear();
            myMapSgs.SetFeaturesHighlightByFeatureCol(myMapSgs._arraySearchLayerFeatureActive, true);
            myMapSgs.map.getView().fit(myMapSgs.layerHighlightOverlay.getSource().getExtent(), { size: myMapSgs.map.getSize() });
        }
    });

    /**
     * Event search result go to expand result
     */
    $('#id-offcanvas-search-result-expand').on('click', function () {
        // Show canvas search result
        myMapSgs._utility.ShowOpenCanvas3('offcanvas-map-list', true);
        $($.fn.dataTable.tables(true)).DataTable().columns.adjust();
    });

    /**
     * Event clean search result
     */
    $('#id-offcanvas-search-result-clean').on('click', function () {
        // Destroy search table if exists
        if (myMapSgs.datatableSearchResult != null) {
            // Destroy mCustomScrollbar
            $('#offcanvas-search-result-table-zone.mCustomScrollbar').mCustomScrollbar('destroy');

            // Destroy table
            myMapSgs.datatableSearchResult.destroy();

            // Empty table zone
            $('#offcanvas-search-result-table-zone').empty();

            // Recreate table node
            var tableSearch = $('<table id="offcanvas-search-result-table" cellspacing="0" width="100%"></table>');
            tableSearch.appendTo($('#offcanvas-search-result-table-zone'));
        };

        // Clean higlight
        app.sgs.Map.featureToHighLight.clear();

        // hide result button
        $('#id-offcanvas-search-result-zone').addClass('ol-hidden');
        $('#id-offcanvas-search-result-body').addClass('ol-hidden');

        // Clean simulation result
        if ($(this).attr("mode") == "simul") {
            // Clean simulation result
            myMapSgs._networkSimulationTool._CleanSimulationResult(true);

            // Clean simulation
            myMapSgs._networkSimulationTool._CleanSimulation(true);

            // Close btn selection cut
            myMapSgs._networkSimulationTool._CloseSelectionCut();
        }
    });

    /**
    * Event click button execute search event occurrence
    */
    $('#id-toponymy-search-submit-btn').on('click', myMapSgs.SearchToponymy);

    /**
    * Event click button execute search event occurrence
    */
    $('#id-button-search-seccao-cadastral').on('click', myMapSgs.SearchSeccao);

    /**
    * Event click button execute search imoveis
    */
    $('#id-button-registo-imoveis').on('click', myMapSgs.SearchRegistosImoveis);

    /*
     * Event button click feature for update or creation
     */
    $('#geometry-ok').on('click', myMapSgs._ActionEditionFeature).on('touchstart', myMapSgs._ActionEditionFeature);

    /**
     * Event button click feature confirmation for delete
     */
    $('#geometry-del').on('click', myMapSgs._ShowConfirmationForDelete).on('touchstart', myMapSgs._ShowConfirmationForDelete);

    /**
     * Event button click feature cancel edit
     */
    $('#geometry-cancel').on('click', myMapSgs._ActionEditionFeatureCancel).on('touchstart', myMapSgs._ActionEditionFeatureCancel);

    /**
     * Event On click to send email to OccurrenceEvent
     */
    $('#id-modal-email-send').click(function () {

        var EmailData = $('#formEntityEmail').serializeJSON();
        EmailData.IdUserSend = mapSettings.user_info.id_user;
        EmailData.EmailInfo = $('#formSendEmail').serializeJSON();
        myMapSgs._utility.SendEmail(EmailData);

    });

    /**
     * Close modal help plant
     */
    $('#close-modal-help-plant').on('click', function () {
        $('#id-modal-help-plant').modal('hide');
    });

    $('#id-select-group-template').on('change', function (e) {

        $('#id-offcanvas-body-modal-Group-template-spinner').removeClass('ol-hidden');

        $('#id-modal-Group-template-print').prop('disabled', true);

        $.ajax({
            type: 'GET',
            url: '/rest/app/Service/GetGroupstemplateByID?idGroup=' + $('#id-select-group-template').val(),
            xhrFields: {
                withCredentials: true
            },
            async: true,
            dataType: "json",
            contentType: "application/json;",
            success: function (data) {
                if (data.error) {
                    toastr["error"]("Erro na realização da pesquisa");

                    $('#id-offcanvas-body-modal-Group-template-spinner').addClass('ol-hidden');

                }
                else {

                    myMapSgs._datatablegrouptemplate.clear();

                    myMapSgs._datatablegrouptemplate.rows.add(data.result);

                    myMapSgs._datatablegrouptemplate.draw();

                    $('#id-offcanvas-body-modal-Group-template-spinner').addClass('ol-hidden');

                    myMapSgs._datatablegrouptemplate.on('select', function () {
                        $('#id-modal-Group-template-print').prop('disabled', false);
                    });

                    myMapSgs._datatablegrouptemplate.on('deselect', function () {
                        $('#id-modal-Group-template-print').prop('disabled', true);
                    });


                }
            },
            error: function (request, status, error) {

                $('#id-offcanvas-body-modal-Group-template-spinner').addClass('ol-hidden');

            }
        });
    });

    $('.cancel-map-search').on('click', function () {

        $('#map-search').removeClass('active');
        $('#map-search').css({ 'transform': 'none' })

    });

    //$('#map-search [type="text"]').on('keypress', function (e) {
    //    if (e.which == 13) {
    //        alert('You pressed enter!');
    //    }
    //});

    /**
     * Event collapse list base layer
     */
    $('#id-base-map-legend-img-button-collapse').on('click', function () {

        if ($('#id-base-map-legend-img-button-collapse').hasClass('full')) {
            $('#id-base-map-legend-img-button-collapse').removeClass('full');
            $('#id-base-map-list').removeClass('ol-hidden');
        }
        else {
            $('#id-base-map-legend-img-button-collapse').addClass('full');
            $('#id-base-map-list').addClass('ol-hidden');
        }

        $('#id-base-map-legend-img-button-collapse i').toggleClass('chevron-up chevron-down');
    })

    /**
     * Event reset size of canvas
     */
    $('.reset-size-off-canvas').on("click", function (e) {
        var idTarget = $(this).attr("id-target");
        $('#' + idTarget).css("width", "");
        if (myMapSgs._layerbase._legendCanvasHasCanvasActive) {
            myMapSgs._layerbase._ReLoadCanvas(myMapSgs._layerbase._imageLegendCanvas.src);
        };
    });

    /**
     * Event on close offcanvas detail
     */
    $('#id-offcanvas-layer-detail-close').on("click", function (e) {
        var mode = $('#id-offcanvas-layer-detail').attr("mode");

        if (mode) {
            switch (mode) {
                case "create":
                    myMapSgs._ActionEditionFeatureCancel();
                    break;
                case "update":
                    myMapSgs._ActionEditionFeatureCancel
                    break;
                default:
                // do nothing
            }
        }
    });

    // -- end event -------------------------------------------------------------------------------

    // Geo JSON File Automatic Display
    $(document).ready(function () {

        var urlParams = new URLSearchParams(window.location.search);

        // If there is a file parameter, trigger functionality
        if (urlParams.has('file')) {

            var file = urlParams.get('file'); // File to download from uploads folder

            $.ajax({
                url: "/uploads/" + file + ".geojson",
                success: function (data) {
                    var obj = { data: data, file: file }; // Download file and file name
                    myMapSgs.layerTree.loadTempGeom(obj);
                },
                error: function (request, status, error) {
                    toastr["error"]("Erro ao carregar camada temporaria");
                }
            });
        }
    });
};

/**
 * Prototype create map
 */
MapSgs.prototype.CreateMap = function (opts) {

    var myprotoMap = this;

    //const _opts = opts || {};

    // Get Settings from map
    this._settings.Init();

    // Get visible operation
    let visibleOperations = this.getSettings().getVisibleOperations();

    // Get map option
    var _opts = this._settings.operationVisible || {};

    // Init mouse position control display
    if (visibleOperations.Scale)
        this._InitMousePositionControl();

    // -- Add extend --
    var extendArray = [];

    // Left button
    extendArray.push(new this._ControlOffCanvas());

    // Menu bar right
    if (this._ControlBar)
        extendArray.push(new this._ControlBar(_opts));
    else {
        // No control bar
        $('#map').addClass('map-full');
        $('.offcanvas-pane:not(#offcanvas-map-list)').addClass('offcanvas-no-control-bar');
        $('.offcanvas-pane:not(#offcanvas-map-list)').addClass('offcanvas-no-control-bar-init');
        $('#offcanvas-map-list').addClass('offcanvas-not-show');
    }

    // Scale control
    if (this._scaleLineControl) {
        extendArray.push(this._mousePositionControl);
        extendArray.push(this._scaleLineControl);
    };

    // Menu bar bottom road builder tool
    if (this._controlBarCenterBottomRoadBuilderTool)
        extendArray.push(new this._controlBarCenterBottomRoadBuilderTool(_opts));

    // Menu bar bottom road builder tool
    if (this._controlBarCenterBottomGeometryEditorTool)
        extendArray.push(new this._controlBarCenterBottomGeometryEditorTool(_opts));

    // Menu bar bottom network simulation tool
    if (this._controlBarCenterBottomNetworkSimulationTool)
        extendArray.push(new this._controlBarCenterBottomNetworkSimulationTool(_opts));

    // Menu bar bottom network budget tool
    if (this._controlBarCenterBottomNetworkBudgetTool)
        extendArray.push(new this._controlBarCenterBottomNetworkBudgetTool(_opts));

    // Menu bar bottom
    if (this._exportControlBarCenterBottom)
        extendArray.push(new this._exportControlBarCenterBottom(_opts));

    // Menu bar bottom railway tool
    if (this._controlBarRailwayTool)
        extendArray.push(new this._controlBarRailwayTool(_opts));

    // Interface for search entity address
    if (this._controlBarSearchEntityAddressTool)
        extendArray.push(new this._controlBarSearchEntityAddressTool(_opts));

    // Menu bar bottom
    if (this._controlBarCenterBottom)
        extendArray.push(new this._controlBarCenterBottom(_opts));

    // Create map ol
    this.map = new Map({
        interactions: defaultInteractions({ constrainResolution: true }),
        controls: defaultControls({
            attributionOptions: {
                collapsible: false
            },
            zoom: false,
            rotate: false
        }).extend(extendArray),
        layers: [],
        target: 'map',
        view: new View({
            projection: this._settings.projection,
            //extent: this._settings.extent,
            center: this._settings.center,
            zoom: this._settings.zoom,
            resolutions: this._settings.resolutions
        })
    });

    // Creation Scaleline map canvas
    this._CreateScaline();

    // Init Territorial Management
    if (mapSettings.operation_visible.LocationPlant ||
        mapSettings.operation_visible.CartographyExtract ||
        mapSettings.operation_visible.LocationPlantPdm ||
        mapSettings.operation_visible.LocationPlantPdmRuido ||
        mapSettings.operation_visible.LocationPlantPdmPp ||
        mapSettings.operation_visible.PDMAnalyze) {
        this._territorialManagement.InitTerritorialManagement(this);
    }

    // Create search toponomy
    this.searchToponymyMap = new search('#id-toponymy-search-place', this, this._settings._mapSettings.search_toponymy, 'id-toponymy-search-npolicia', _nPoliciaInfo, true, 'id-toponymy-search-select-distrito', true, 'id-toponymy-search-select-concelho', true, 'id-toponymy-search-select-freguesia');

    // Add Base layer
    if (visibleOperations.OccurrenceEvent)
        this._layerbase.AddLayerbaseImg(this, this._settings.baseMap);
    else
        this._layerbase.AddLayerbase(this, this._settings.baseMap);

    // Init manager traffic sign tool
    if (visibleOperations.ManagerTrafficSignTool) {
        this._managerTrafficSignTool.Init(this);
        this._managerTrafficSignTool.ExecuteAdicionalParameter();
        this._searchManagerTrafficSignAddress = new search('#id-traffic-sign-quick-search-address', this, this._settings._mapSettings.search_toponymy, null, null, false, '', false, '', false, '');
    }

    // Init Water waste
    if (visibleOperations.WaterWasteUpstream ||
        visibleOperations.WaterWasteDownstream ||
        visibleOperations.WaterWasteStatistic ||
        visibleOperations.WaterWasteStatisticByDdccff) {
        this._waterWaste.Init(this);
    }

    // Init citizen report
    if (visibleOperations.CitizenReport) {
        this._citizenReport.Init(this);
    }

    // Init technician report
    if (visibleOperations.TechnicianReport) {
        this._technicianReport.Init(this);
    }

    // Create Layer Tree (add layer)
    this.layerTree.CreateLayerTree(this, this._settings.treeMap);

    // Init Statistic
    if (visibleOperations.Statistics)
        this._statistics.Init(this.layerTree.layerTreeJson, this.layerTree.layerInfo);

    // Init Shortcuts
    if (visibleOperations.Shortcuts)
        this._shortcuts.Init(this);

    // Define water entity type
    if (visibleOperations.Water && visibleOperations.Water.WaterSupply)
        this._codWaterEntityType = 'AA';

    if (visibleOperations.Water && visibleOperations.Water.WaterWaste)
        this._codWaterEntityType = 'AR';

    // Tooltips
    if (visibleOperations.Tooltips) {
        // Init Tooltips
        this.tooltips.InitTooltips(this, this._settings._mapSettings.tree_map.dict_layer_info);

        // Add event layer tooltips
        this.map.on('singleclick', async (e) => { await this.tooltips.BuildInfoTooltips(e); });
    }

    // Search Location
    if (visibleOperations.SearchLocationApiGoogle) {

        const codGroup = "GEOPORTAL_TOOLS_CONFIG";
        const codContext = "MAP";
        const codProperty = "SEARCH_LOCATION_API";

        const activeSearchLocationApi = this._utility.GetPropertyInfoInConfigArray(this._settings.configurationInfo.propertyInfo, codGroup, codContext, codProperty)

        if (activeSearchLocationApi) {
            const apiConfigs = this._utility.GetPropertyInfoInConfigArray(this._settings.configurationInfo.propertyInfo, codGroup, codContext, `${codProperty}_${activeSearchLocationApi.value}`)

            if (apiConfigs) {
                // Init Search Location
                this.searchLocation.InitSearchLocation('id-search-location-api-google-input', this, JSON.parse(apiConfigs.value));

                $('#button-localtion-api-google').on('click', this.searchLocation.ToogleSearchLocation);
            }
        }
    }

    // Identify
    this.identify.InitIdentify(this);

    /**
     * Event on feature wfs pointer
     */
    this.map.on('pointermove', function (evt) {
        evt.target.getTargetElement().style.cursor = evt.target.hasFeatureAtPixel(evt.pixel) ? 'pointer' : '';
    });

    /**
     * Map orientation - North button - event change rotation
     */
    this.map.getView().on('change:rotation', function (evt) {
        $('#north-arrow-button').css('transform', 'rotate(' + evt.target.getRotation() + 'rad)');
    });

    // Add highlight layer vector to map
    this.layerHighlightOverlay.setMap(this.map);

    // When resolution change
    this.map.getView().on('change:resolution', function (evt) {
        // call function to hide/show layers visible - Atention: performance decrease!
        //myprotoMap.layerTree.layerTreeVisible(myprotoMap.map)

        // Set scale zoom information
        $('#scalezoom').html('1 : ' + myprotoMap._settings.scales[Math.round(myprotoMap.map.getView().getZoom())]);

        // Reset label vector soource
        myprotoMap.layerTree._hashLabelVisible = {};

        // Statistic in real time
        if (myprotoMap._settings._mapSettings.operation_visible.StatisticsRealTime) {
            myprotoMap._StatisticRealTimeCount();
        }
    });

    // When pan change
    this.map.on('moveend', function (evt) {

        // Pause interaction - Atention: performance decrease!
        //myprotoMap._snappingTool.updatePauseStatus();

        // Reset label vector soource
        myprotoMap.layerTree._hashLabelVisible = {};

        // Statistic in real time
        if (myprotoMap._settings._mapSettings.operation_visible.StatisticsRealTime) {
            myprotoMap._StatisticRealTimeCount();
        }
    });

    //Init LayerTreeVisible
    //myprotoMap.layerTree.layerTreeVisible(myprotoMap.map);

    // Add layer to map buffer
    this.map.addLayer(this._layerBuffer);

    // Create measure tooltip;
    this._CreateMeasureTooltip();

    // Init railway tool object
    if (visibleOperations.RailwayTool) {
        this._railwayTool.Init(this);
    }

    // Init entity search tool object
    if (visibleOperations.SearchEntityAddress) {
        this._searchEntityTool.Init(this);
    }

    // Init traffic sign tool
    if (visibleOperations.TrafficSignTool) {
        this._trafficSignTool.Init(this);
    }

    // Init pub tool
    if (visibleOperations.PubTool) {
        this._pubTool.Init(this);
    }

    // Init green area tool
    if (visibleOperations.GreenAreaTool) {
        this._greenAreaTool.Init(this);
    }

    // Init civil protection tool
    if (visibleOperations.CivilProtectionTool) {
        this._civilProtectionTool.Init(this);
    }

    // Init deposition point tool
    if (visibleOperations.DepositionPointTool || mapSettings.operation_visible.PubTool || mapSettings.operation_visible.UrbanismTool) {
        this._depositionPointTool.Init(this);
        this._depositionPointTool.ExecuteAdicionalParameter();
    }

    // Init deposition point tool
    if (visibleOperations.PatrimonyTool) {
        this._patrimonyTool.Init(this);
    }

    // Init urbanism tool
    if (visibleOperations.UrbanismTool) {
        this._urbanismTool.Init(this);
        this._urbanismTool.ExecuteAdicionalParameter();
    }

    // Init urbanism tool
    if (visibleOperations.GoToCodObraCadastro) {
        this._ContractorPoloTool.Init(this);
        this._ContractorPoloTool.ExecuteAdicionalParameter(mapSettings.additional_params.cod_obra);
    }

    // Init network simulation tool
    if (visibleOperations.NetworkSimulationTool) {
        this._networkSimulationTool.Init(this);
        this._searchNetworkTool.Init(this);
    }

    // Init network budget tool
    if (visibleOperations.NetworkBudgetTool) {
        this._networkBudgetTool.Init(this);
    }

    // Init map street view
    if (visibleOperations.StreetMapView) {
        this._mapStreetView.Init(this);
    }

    // Init map avim tool
    if (visibleOperations.AvimTool) {
        this._avimTool.Init(this);
        this._avimTool.ExecuteAdicionalParameter();
    }

    // Init ogc layer tool
    if (visibleOperations.OgcLayer) {
        this._ogcLayerTool.Init(this);
    }

    // Search network tool
    if (mapSettings.operation_visible.SearchNetwork) {
        this._searchNetworkTool.Init(this);
    }

    // Search network tool
    if (mapSettings.operation_visible.NetworkIndicatorTool) {
        this._networkIndicatorTool.Init(this);
    }

    // Geometry Editor tool
    if (mapSettings.operation_visible.GeometryEditorTool) {
        this._geometryEditorTool.Init(this);
    }

    // Road builder tool
    if (mapSettings.operation_visible.RoadBuilderTool) {
        // Init Road build tool object
        this._roadBuilderTool.Init(this);
    }

    // Init geo location
    if (mapSettings.operation_visible.ButtonGPS) {
        this._InitGeoLocation();
    }

    // Init Statistic in real time
    if (mapSettings.operation_visible.StatisticsRealTime) {
        this._InitStatisticRealTime();
    }

    // Goto index if exists index in addicional parameters
    var addicionalParams = this._settings._mapSettings.additional_params;
    if (addicionalParams && addicionalParams.context === "GotoCoordinate" && addicionalParams.epsg && addicionalParams.latitude && addicionalParams.longitude) {
        // Transform coordinate to map coordinate
        var coordinate = transform([parseFloat(addicionalParams.longitude), parseFloat(addicionalParams.latitude)], 'EPSG:' + addicionalParams.epsg, 'EPSG:' + this._settings._mapSettings.map_info.srs_srid);
        var featureLocation = new Feature({
            geometry: new Point(coordinate),
            name: 'Location'
        });

        // Localize position
        this.SetFeaturesHighlightByArray3(featureLocation, true, this._styleLocalization);
    }

    // Map Title
    if (visibleOperations.MapTitle) {
        $('#id-map-title').html(this._settings._mapSettings.map_info.name);
        $('#id-map-title').removeClass("ol-hidden");
    }

    // Set if layer tree is open by default
    var openLayerTreeInfo = this._utility.GetPropertyInfoInConfigArray(this._settings.configurationInfo.propertyInfo, "MAP_COMPONENT", "LAYER_TREE", "OPEN");
    if (openLayerTreeInfo !== undefined && eval(openLayerTreeInfo.value)) {
        myMapSgs._utility.ShowOpenCanvas3('offcanvas-theme', true);
    }

    // Set place toponymy config
    if (this._hasSearchPlaceToponymyConfigInfo) {
        this._searchPlaceToponymyConfigInfo = {
            workspace: myprotoMap._utility.GetPropertyInfoInConfigArray(myprotoMap._settings.configurationInfo.propertyInfo, "LAYER_TOPONYMY", "TOPONYMY_PLACE", "WORKSPACE").value,
            geoserver: myprotoMap._utility.GetPropertyInfoInConfigArray(myprotoMap._settings.configurationInfo.propertyInfo, "LAYER_TOPONYMY", "TOPONYMY_PLACE", "GEOSERVER").value,
            layerName: myprotoMap._utility.GetPropertyInfoInConfigArray(myprotoMap._settings.configurationInfo.propertyInfo, "LAYER_TOPONYMY", "TOPONYMY_PLACE", "LAYER_NAME").value,
            geomColumn: myprotoMap._utility.GetPropertyInfoInConfigArray(myprotoMap._settings.configurationInfo.propertyInfo, "LAYER_TOPONYMY", "TOPONYMY_PLACE", "LAYER_COLUMN_NAME_GEOM").value,
            searchColumn: myprotoMap._utility.GetPropertyInfoInConfigArray(myprotoMap._settings.configurationInfo.propertyInfo, "LAYER_TOPONYMY", "TOPONYMY_PLACE", "LAYER_COLUMN_NAME_SEARCH").value,
            idColumn: myprotoMap._utility.GetPropertyInfoInConfigArray(myprotoMap._settings.configurationInfo.propertyInfo, "LAYER_TOPONYMY", "TOPONYMY_PLACE", "LAYER_COLUMN_NAME_ID").value,
            freguesiaColumn: myprotoMap._utility.GetPropertyInfoInConfigArray(myprotoMap._settings.configurationInfo.propertyInfo, "LAYER_TOPONYMY", "TOPONYMY_PLACE", "LAYER_COLUMN_NAME_FREGUESIA").value,
        };
    }

    // Create select2 search place toponymy
    if (myprotoMap._hasSearchPlaceToponymyConfigInfo) { // Fill select2 search place toponymy using geoserver layer
        $('#id-search-toponymy-place').select2(
            {
                ajax:
                {
                    method: "GET",
                    async: true,
                    url: myprotoMap._searchPlaceToponymyConfigInfo.geoserver + "/wfs",
                    data: function (term) {
                        let dicofre = $('#id-toponymy-search-select-freguesia').val();
                        let freguesia = (dicofre && dicofre != "") ? $('#id-toponymy-search-select-freguesia').find(':selected').text() : "";
                        let cql = myprotoMap._searchPlaceToponymyConfigInfo.searchColumn + " ilike '" + term.term + "%'" + ((freguesia && freguesia != '') ? " AND " + myprotoMap._searchPlaceToponymyConfigInfo.freguesiaColumn + " = '" + freguesia + "'" : "");
                        return {
                            "service": 'wfs',
                            "version": '2.0.0',
                            "request": 'GetFeature',
                            "typeNames": myprotoMap._searchPlaceToponymyConfigInfo.workspace + ':' + myprotoMap._searchPlaceToponymyConfigInfo.layerName,
                            "cql_filter": cql,
                            "srsName": myprotoMap._settings.projection.getCode(),
                            "propertyName": myprotoMap._searchPlaceToponymyConfigInfo.idColumn + "," + myprotoMap._searchPlaceToponymyConfigInfo.searchColumn + "," + myprotoMap._searchPlaceToponymyConfigInfo.freguesiaColumn,
                            "outputFormat": 'application/json',
                            "maxFeatures": 500
                        };
                    },
                    dataType: 'json',
                    delay: 250,
                    processResults: function (data) {
                        if (data.features) {
                            if (data.features.length > 0) {
                                var resultArray = [];
                                for (var i = 0; i < data.features.length; i++) {
                                    var feature = (new GeoJSON()).readFeatures(data)[i];
                                    resultArray.push({
                                        "text": feature.getProperties()[myprotoMap._searchPlaceToponymyConfigInfo.searchColumn] + ", " + feature.getProperties()[myprotoMap._searchPlaceToponymyConfigInfo.freguesiaColumn],
                                        "id": feature.getProperties()[myprotoMap._searchPlaceToponymyConfigInfo.idColumn],
                                    });
                                }

                                return {
                                    "results": resultArray,
                                    "pagination": {
                                        "more": false
                                    }
                                }
                            }
                            else {
                                return {
                                    "results": [],
                                    "pagination": {
                                        "more": false
                                    }
                                };
                            }
                        }
                        else {
                            return {
                                "results": [],
                                "pagination": {
                                    "more": false
                                }
                            };
                        }
                    }
                },
                minimumInputLength: 2,
                language: "pt",
                dropdownParent: $('#toponymy-search')
            });
    }
    else { // Fill select2 search place toponymy in named_plc table
        $('#id-search-toponymy-place').select2(
            {
                ajax:
                {
                    type: 'GET',
                    url: '/rest/app/Service/GetPlacesPointBeginWith',
                    dataType: 'json',
                    delay: 250,
                    data: function (term) {
                        return term;
                    },
                    processResults: function (data) {
                        var listDepositionPoint = data.result;
                        if (listDepositionPoint === null)
                            return {
                                "results": [],
                                "pagination": {
                                    "more": false
                                }
                            }

                        var resultArray = [];
                        for (var i = 0; i < listDepositionPoint.length; i++) {
                            var depositionPointObj = listDepositionPoint[i];
                            resultArray.push({
                                "text": depositionPointObj.depositionPoint,
                                "id": depositionPointObj.idDepositionPoint
                            })
                        }

                        return {
                            "results": resultArray,
                            "pagination": {
                                "more": false
                            }
                        }
                    }
                },
                minimumInputLength: 2,
                language: "pt",
                dropdownParent: $('#toponymy-search')
            });
    }

    // Index column filter advanced search
    this._columnFilterAdvancedSearchIndex = 0;

    // Set event on all resize button
    this.resizerLeft = document.querySelectorAll('.offcanvas-resizable-handle');
    for (var h = 0; h < this.resizerLeft.length; h++) {
        this.resizerLeft[h].addEventListener('mousedown', this._ResizeLeftStartDrag, false);
    }
};